/* tslint:disable */

/**
 * Identity and Access Management Service API
 * APIs for managing users, groups, compartments, and policies.
 *
 * OpenAPI spec version: 20160918
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import * as base from "./lib/base-api";

/**
 * The basic information for an account object. 
 */
export interface Account {
    /**
     * The OCID of the tenancy.
     */
    "tenancyOcid"?: string;
    /**
     * The name of the tenant.
     */
    "accountName": string;
    /**
     * The lifecycle state of the tenant.
     */
    "state": string;
    /**
     * The tenant home region.
     */
    "homeRegion": string;
    /**
     * The tenant active regions.
     */
    "activeRegions": Array<string>;
}

export interface AddUserToGroupDetails {
    /**
     * The OCID of the user.
     */
    "userId": string;
    /**
     * The OCID of the group.
     */
    "groupId": string;
}

export interface AddUserToIdpGroupDetails {
    /**
     * The id of the user.
     */
    "userId": string;
}

/**
 * The address information about new OnPremSite.
 */
export interface Address {
    /**
     * Address line 1
     */
    "line1": string;
    /**
     * Address line 2
     */
    "line2"?: string;
    /**
     * City name
     */
    "city": string;
    /**
     * State name
     */
    "state"?: string;
    /**
     * Postal Code
     */
    "postalCode": string;
    /**
     * Country name
     */
    "country": string;
}

/**
 * Affix-based registered redirect URI value.
 */
export interface AffixBasedUri {
    /**
     * Prefix-based registered redirect URI value.
     */
    "prefix"?: string;
    /**
     * Suffix-based registered redirect URI value.
     */
    "suffix"?: string;
}

/**
 * The 'AllowedDomainLicenseTypeSummary' object contains information about the 'Domain License type'. 
 */
export interface AllowedDomainLicenseTypeSummary {
    /**
     * The license type name.  Example: \"Oracle Apps Premium\" 
     */
    "name": string;
    /**
     * The license type identifier.  Example: \"oracle-apps-premium\" 
     */
    "licenseType": string;
    /**
     * The license type description.
     */
    "description": string;
}

/**
 * A PEM-format RSA credential for securing requests to the Oracle Cloud Infrastructure REST API. Also known as an *API signing key*. Specifically, this is the public key from the key pair. The private key remains with the user calling the API. For information about generating a key pair in the required PEM format, see [Required Keys and OCIDs](/Content/API/Concepts/apisigningkey.htm).  **Important:** This is **not** the SSH key for accessing compute instances.  Each user can have a maximum of three API signing keys.  For more information about user credentials, see [User Credentials](/Content/Identity/Concepts/usercredentials.htm). 
 */
export interface ApiKey {
    /**
     * An Oracle-assigned identifier for the key, in this format: TENANCY_OCID/USER_OCID/KEY_FINGERPRINT. 
     */
    "keyId"?: string;
    /**
     * The key's value.
     */
    "keyValue"?: string;
    /**
     * The key's fingerprint (e.g., 12:34:56:78:90:ab:cd:ef:12:34:56:78:90:ab:cd:ef).
     */
    "fingerprint"?: string;
    /**
     * The OCID of the user the key belongs to.
     */
    "userId"?: string;
    /**
     * Date and time the `ApiKey` object was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated"?: Date;
    /**
     * The API key's current state. After creating an `ApiKey` object, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState"?: ApiKeyLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "inactiveStatus"?: number;
}

export type ApiKeyLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * An `AuthToken` is an Oracle-generated token string that you can use to authenticate with third-party APIs that do not support Oracle Cloud Infrastructure's signature-based authentication. For example, use an `AuthToken` to authenticate with a Swift client with the Object Storage Service.  The auth token is associated with the user's Console login. Auth tokens never expire. A user can have up to two auth tokens at a time.  **Note:** The token is always an Oracle-generated string; you can't change it to a string of your choice.  For more information, see [Managing User Credentials](/Content/Identity/Tasks/managingcredentials.htm). 
 */
export interface AuthToken {
    /**
     * The auth token. The value is available only in the response for `CreateAuthToken`, and not for `ListAuthTokens` or `UpdateAuthToken`. 
     */
    "token"?: string;
    /**
     * The OCID of the auth token.
     */
    "id"?: string;
    /**
     * The OCID of the user the auth token belongs to.
     */
    "userId"?: string;
    /**
     * The description you assign to the auth token. Does not have to be unique, and it's changeable.
     */
    "description"?: string;
    /**
     * Date and time the `AuthToken` object was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated"?: Date;
    /**
     * Date and time when this auth token will expire, in the format defined by RFC3339. Null if it never expires.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeExpires"?: Date;
    /**
     * The token's current state. After creating an auth token, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState"?: AuthTokenLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "inactiveStatus"?: number;
}

export type AuthTokenLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * Authentication policy, currently set for the given compartment 
 */
export interface AuthenticationPolicy {
    "passwordPolicy"?: PasswordPolicy;
    /**
     * Compartment OCID.
     */
    "compartmentId"?: string;
    "networkPolicy"?: NetworkPolicy;
}

/**
 * One or more isolated, fault-tolerant Oracle data centers that host cloud resources such as instances, volumes, and subnets. A region contains several Availability Domains. For more information, see [Regions and Availability Domains](/Content/General/Concepts/regions.htm). 
 */
export interface AvailabilityDomain {
    /**
     * The name of the Availability Domain.
     */
    "name"?: string;
    /**
     * The OCID of the Availability Domain.
     */
    "id"?: string;
    /**
     * The OCID of the tenancy.
     */
    "compartmentId"?: string;
}

/**
 * Validates a definedTag value. Each validator performs validation steps in addition to the standard validation for definedTag values. For more information, see [Limits on Tags](/Content/Identity/Concepts/taggingoverview.htm#Limits).  If you define a validator after a value has been set for a defined tag, then any updates that attempt to change the value must pass the additional validation defined by the current rule. Previously set values (even those that would fail the current validation) are not updated. You can still update other attributes to resources that contain a non-valid defined tag.  To clear the validator call UpdateTag with [DefaultTagDefinitionValidator](/api/#/en/identity/latest/datatypes/DefaultTagDefinitionValidator). 
 */
export interface BaseTagDefinitionValidator {
    /**
     * Specifies the type of validation: a static value (no validation) or a list. 
     */
    "validatorType": BaseTagDefinitionValidatorValidatorTypeEnum;
}

export type BaseTagDefinitionValidatorValidatorTypeEnum = "ENUM" | "DEFAULT";
/**
 * Bootstrap domain details needed to create admin user/group/default policies/default domain
 */
export interface BootstrapDefaultDomainDetails {
    /**
     * The OCID of the root compartment where domain is created. MUST be tenancy OCID.
     */
    "tenantId": string;
    /**
     * The home region for domain. It MUST be same as tenancy's home region. MUST be in public region name identifier. See [Regions and Availability Domains](/Content/General/Concepts/regions.htm) for the full list of supported region names.  Example: `us-phoenix-1` 
     */
    "homeRegion": string;
    /**
     * The admin user first name
     */
    "adminFirstName"?: string;
    /**
     * The admin user last name
     */
    "adminLastName"?: string;
    /**
     * The admin user name
     */
    "adminUserName"?: string;
    /**
     * The admin user email address
     */
    "adminEmail"?: string;
    /**
     * The admin user password
     */
    "adminPassword"?: string;
    /**
     * The name of the primordial stripe that needs to be claimed for this Default domain request
     */
    "primordialStripeName"?: string;
    /**
     * The cloud infra url that needs to be used to claim the stripe. Eg- https://idcs-cloudinfra-eu-frankfurt-idcs-2.identity.oraclecloud.com
     */
    "idcsCloudInfraBaseUrl"?: string;
    /**
     * For Integration test only: Public pem string passed to IDCS stripe for admin user api key creation. Example: \"-----BEGIN PUBLIC KEY-----\\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBC...\\n-----END PUBLIC KEY-----\" 
     */
    "adminUserKey"?: string;
    /**
     * Determines IDCS environment where the stripe will be created in. Expected values - default, pool2, miglab, pintlab, preprod Reference: Look for TAS_POOL_CONFIG_NAME_LOOKUP map keys for supported taspool names. https://bitbucket.oci.oraclecorp.com/projects/IDENT/repos/common/browse/src/main/java/com/oracle/pic/identity/common/idcs/IdcsConstants.java 
     */
    "tasPoolName"?: string;
    /**
     * Determines if identity resources (admin user and admin group) are to be created in kiev vs in IDCS stripe If set to true, it will create lightweight domain with no IDCS stripe. otherwise, it will create regular domain 
     */
    "isInternalDomain"?: boolean;
    /**
     * Optional field to indicate whether users in the domain are required to have a primary email address or not Defaults to true 
     */
    "isPrimaryEmailRequired"?: boolean;
    /**
     * List of service principal names that need admin policy to manage all-resources. 
     */
    "servicePrincipalAdmins"?: Array<string>;
}

/**
 * Bootstrap domain response while asynchronously domain and associated stripe is being provisioned.
 */
export interface BootstrapDomainResponse {
    /**
     * The OCID of the domain
     */
    "domainId": string;
}

/**
 * Bootstrap domain details needed to create admin user/group/default policies/default domain
 */
export interface BootstrapLightweightDomainDetails {
    /**
     * The OCID of the root compartment where domain is created. MUST be tenancy OCID.
     */
    "tenantId": string;
    /**
     * The home region for domain. It MUST be same as tenancy's home region.
     */
    "homeRegion": string;
    /**
     * The admin user key
     */
    "adminUserkey": string;
    /**
     * The admin user name
     */
    "adminUserName": string;
    /**
     * The admin user description
     */
    "adminUserDescription": string;
    /**
     * The admin email address
     */
    "adminEmail": string;
    /**
     * The admin password
     */
    "adminPassword": string;
    /**
     * Password expiry disabled
     */
    "isPasswordExpiryDisabled": boolean;
}

export interface BootstrapTagsDetails {
    /**
     * The [OCID](/Content/General/Concepts/identifiers.htm) of the tenant into which tagging resources would be bootstrapped. 
     */
    "tenantId": string;
}

/**
 * The bulk action resource entity. 
 */
export interface BulkActionResource {
    /**
     * The resource OCID.
     */
    "identifier": string;
    /**
     * The resource-type. To get the list of supported resource-types use [ListBulkActionResourceTypes API](#/en/identity/20160918/BulkActionResourceTypeCollection/ListBulkActionResourceTypes/). 
     */
    "entityType": string;
    /**
     * Additional information that helps to identity the resource for bulk action.  The APIs to delete and move most resource types only require the resource identifier (ocid). But some resource-types require additional identifying information.  This information is provided in the resource's public API document. It is also available through the [ListBulkActionResourceTypes API](#/en/identity/20160918/BulkActionResourceTypeCollection/ListBulkActionResourceTypes/).  **Example**: The APIs to delete or move the `buckets` resource-type require `namespaceName` and `bucketName` to identify the resource, as shown in the APIs, [DeleteBucket](#/en/objectstorage/20160918/Bucket/DeleteBucket) and [UpdateBucket](#/en/objectstorage/20160918/Bucket/UpdateBucket).  To add a bucket for bulk actions, specify `namespaceName` and `bucketName` in the metadata property as shown in this example      {       \"identifier\": \"<OCID_of_bucket>\"       \"entityType\": \"bucket\",       \"metadata\":       {         \"namespaceName\": \"sampleNamespace\",         \"bucketName\": \"sampleBucket\"       }     } 
     */
    "metadata"?: { [key: string]: string; };
}

export interface BulkActionResourceType {
    /**
     * The unique name of the resource-type. 
     */
    "name": string;
    /**
     * List of metadata keys required to identify a specific resource. Some resource-types require information besides an OCID to identify a specific resource. For example, the resource-type `buckets` requires metadataKeys [\"namespaceName\", \"bucketName\"] to identify a specific bucket. The required information to identify a resource is in the API documentation for the resource-type. For example, the required information for `buckets` is found in the [DeleteBucket API](#/en/objectstorage/20160918/Bucket/DeleteBucket). 
     */
    "metadataKeys"?: Array<string>;
}

/**
 * Collection of resource-types supported by a compartment bulk action. 
 */
export interface BulkActionResourceTypeCollection {
    /**
     * Collection of the resource-types supported by a compartment bulk action.
     */
    "items": Array<BulkActionResourceType>;
}

export interface BulkDeleteResourcesDetails {
    /**
     * The resources to be deleted. 
     */
    "resources": Array<BulkActionResource>;
}

/**
 * Properties for deleting tags in bulk
 */
export interface BulkDeleteTagsDetails {
    /**
     * The OCIDs of the tag definitions to delete
     */
    "tagDefinitionIds": Array<string>;
}

export interface BulkEditOperationDetails {
    /**
     * An enum-like description of the type of operation.  * `ADD_WHERE_ABSENT` adds a defined tag only if the tag does not already exist on the resource. * `SET_WHERE_PRESENT` updates the value for a defined tag only if the tag is present on the resource. * `ADD_OR_SET` combines the first two operations to add a defined tag if it does not already exist on the resource  or update the value for a defined tag only if the tag is present on the resource. * `REMOVE` removes the defined tag from the resource. The tag is removed from the resource regardless of the tag value. 
     */
    "operationType": BulkEditOperationDetailsOperationTypeEnum;
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags": { [key: string]: { [key: string]: any; }; };
}

export type BulkEditOperationDetailsOperationTypeEnum = "ADD_WHERE_ABSENT" | "SET_WHERE_PRESENT" | "ADD_OR_SET" | "REMOVE";
export interface BulkEditResource {
    /**
     * The unique OCID of the resource.
     */
    "id": string;
    /**
     * The type of resource. See [BulkEditResourceTypes](#/en/identity/latest/Tags/BulkEditResourceTypes).
     */
    "resourceType": string;
    /**
     * Additional information that identifies the resource for bulk editing of tags. This information is provided in the resource's API documentation. 
     */
    "metadata"?: { [key: string]: string; };
}

export interface BulkEditTagsDetails {
    /**
     * The OCID of the compartment where the bulk tag edit request is submitted. 
     */
    "compartmentId": string;
    /**
     * The resources to be updated. 
     */
    "resources": Array<BulkEditResource>;
    /**
     * The operations associated with the request to bulk edit tags. 
     */
    "bulkEditOperations": Array<BulkEditOperationDetails>;
}

export interface BulkEditTagsResourceType {
    /**
     * The unique name of the resource type. 
     */
    "resourceType": string;
    /**
     * The metadata keys required to identify the resource.  For example, for a bucket, the value of `metadataKeys` will be [\"namespaceName\", \"bucketName\"]. This information will match the API documentation.  See [UpdateBucket](/api/#/en/objectstorage/latest/Bucket/UpdateBucket) and [DeleteBucket](/api/#/en/objectstorage/latest/Bucket/DeleteBucket). 
     */
    "metadataKeys"?: Array<string>;
}

/**
 * The list of resource types that support bulk editing of tags. 
 */
export interface BulkEditTagsResourceTypeCollection {
    /**
     * The collection of resource types that support bulk editing of tags.
     */
    "items": Array<BulkEditTagsResourceType>;
}

export interface BulkMoveResourcesDetails {
    /**
     * The resources to be moved. 
     */
    "resources": Array<BulkActionResource>;
    /**
     * The [OCID](/Content/General/Concepts/identifiers.htm) of the destination compartment into which to move the resources. 
     */
    "targetCompartmentId": string;
}

export interface ChangeDomainCompartmentDetails {
    /**
     * The [OCID](/Content/General/Concepts/identifiers.htm) of the destination compartment into which to move the domain. 
     */
    "compartmentId": string;
}

/**
 * Update domain license type
 */
export interface ChangeDomainLicenseTypeDetails {
    /**
     * The License type of Domain
     */
    "licenseType"?: string;
}

/**
 * Details of the compartment the resource is being moved to. 
 */
export interface ChangeTagNamespaceCompartmentDetail {
    /**
     * The Oracle Cloud ID (OCID) of the destination compartment.
     */
    "compartmentId": string;
}

/**
 * Update domain license type
 */
export interface ChangeTasDomainLicenseTypeDetails {
    /**
     * The License type of Domain
     */
    "licenseType"?: string;
}

/**
 * Claim a stripe details
 */
export interface ClaimStripeDetails {
    /**
     * The OCID of the Compartment where domain is created
     */
    "compartmentId": string;
    /**
     * The stripe name that exists and needs to be claimed
     */
    "stripeName": string;
    /**
     * The mutable display name of the domain.
     */
    "domainDisplayName": string;
    /**
     * Domain entity description
     */
    "domainDescription": string;
    /**
     * The region's name. See [Regions and Availability Domains](/Content/General/Concepts/regions.htm) for the full list of supported region names.  Example: `us-phoenix-1` 
     */
    "domainHomeRegion": string;
    /**
     * The License type of Domain
     */
    "domainLicenseType": string;
    /**
     * The OCID of the identity provider that is getting migrated
     */
    "migratedIdentityProviderId"?: string;
}

/**
 * /claimStripe API response while asynchronously associated stripe is being mapped to the created domain. 
 */
export interface ClaimStripeDomainResponse {
    /**
     * The OCID of the domain
     */
    "domainId": string;
}

/**
 * A collection of related resources. Compartments are a fundamental component of Oracle Cloud Infrastructure for organizing and isolating your cloud resources. You use them to clearly separate resources for the purposes of measuring usage and billing, access (through the use of IAM Service policies), and isolation (separating the resources for one project or business unit from another). A common approach is to create a compartment for each major part of your organization. For more information, see [Overview of the IAM Service](/Content/Identity/Concepts/overview.htm) and also [Setting Up Your Tenancy](/Content/GSG/Concepts/settinguptenancy.htm).  To place a resource in a compartment, simply specify the compartment ID in the \"Create\" request object when initially creating the resource. For example, to launch an instance into a particular compartment, specify that compartment's OCID in the `LaunchInstance` request. You can't move an existing resource from one compartment to another.  To use any of the API operations, you must be authorized in an IAM policy. If you're not authorized, talk to an administrator. If you're an administrator who needs to write policies to give users access, see [Getting Started with Policies](/Content/Identity/Concepts/policygetstarted.htm).  **Warning:** Oracle recommends that you avoid using any confidential information when you supply string values using the API. 
 */
export interface Compartment {
    /**
     * The OCID of the compartment.
     */
    "id": string;
    /**
     * The OCID of the parent compartment containing the compartment.
     */
    "compartmentId": string;
    /**
     * The name you assign to the compartment during creation. The name must be unique across all compartments in the parent. Avoid entering confidential information. 
     */
    "name": string;
    /**
     * The description you assign to the compartment. Does not have to be unique, and it's changeable.
     */
    "description": string;
    /**
     * Date and time the compartment was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
    /**
     * The compartment's current state. After creating a compartment, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState": CompartmentLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "inactiveStatus"?: number;
    /**
     * Indicates whether or not the compartment is accessible for the user making the request. Returns true when the user has INSPECT permissions directly on a resource in the compartment or indirectly (permissions can be on a resource in a subcompartment). 
     */
    "isAccessible"?: boolean;
    /**
     * The OCID of the Security Zone this compartment is associated with.
     */
    "securityZoneId"?: string;
    /**
     * Flag indicate whether this compartment has Security Zone enabled.
     */
    "isMaximumSecurityZone"?: boolean;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export type CompartmentLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * The contact information about new OnPremSite.
 */
export interface Contact {
    /**
     * Contact name
     */
    "name": string;
    /**
     * Contact phone number
     */
    "phone": string;
    /**
     * Contact email address
     */
    "email": string;
    /**
     * Indicate the contact is primary. Default is false
     */
    "isPrimary"?: boolean;
}

export interface CreateApiKeyDetails {
    /**
     * The public key.  Must be an RSA key in PEM format.
     */
    "key": string;
}

export interface CreateAuthTokenDetails {
    /**
     * The description you assign to the auth token during creation. Does not have to be unique, and it's changeable. 
     */
    "description": string;
}

export interface CreateAuthenticationRecordDetails {
    /**
     * The OCID of the user. Either userId must be set or both userName and tenantName.
     */
    "userId": string;
    /**
     * The name of the user. Either userId must be set or both userName and tenantName.
     */
    "userName"?: string;
    /**
     * The name of the tenant the user belongs to. Either userId must be set or both userName and tenantName.
     */
    "tenantName"?: string;
    /**
     * Authentication type (SOUP_LOGIN, SWIFT_LOGIN, API_LOGIN, DB_LOGIN)
     */
    "authenticationType": string;
    /**
     * Is authentication success
     */
    "authenticationSuccess": boolean;
    /**
     * Last successful login timestamp.
     */
    "lastSuccessfulLoginTimestamp": number;
}

export interface CreateCompartmentDetails {
    /**
     * The OCID of the parent compartment containing the compartment.
     */
    "compartmentId": string;
    /**
     * The name you assign to the compartment during creation. The name must be unique across all compartments in the parent compartment. Avoid entering confidential information. 
     */
    "name": string;
    /**
     * The description you assign to the compartment during creation. Does not have to be unique, and it's changeable. 
     */
    "description": string;
    /**
     * The OCID of the Security Zone to associate this compartment with.
     */
    "securityZoneId"?: string;
    /**
     * Flag indicate whether this compartment has Security Zone enabled.
     */
    "isMaximumSecurityZone"?: boolean;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export interface CreateCustomerSecretKeyDetails {
    /**
     * The name you assign to the secret key during creation. Does not have to be unique, and it's changeable. 
     */
    "displayName": string;
}

export interface CreateDbCredentialDetails {
    /**
     * The password for the DB credentials during creation. 
     */
    "password": string;
    /**
     * The description you assign to the DB credentials during creation. 
     */
    "description": string;
}

/**
 * Create a domain details
 */
export interface CreateDomainDetails {
    /**
     * The OCID of the Compartment where domain is created
     */
    "compartmentId": string;
    /**
     * The mutable display name of the domain.
     */
    "displayName": string;
    /**
     * Domain entity description
     */
    "description": string;
    /**
     * The region's name identifier. See [Regions and Availability Domains](/Content/General/Concepts/regions.htm) for the full list of supported region names.  Example: `us-phoenix-1` 
     */
    "homeRegion": string;
    /**
     * The License type of Domain
     */
    "licenseType": string;
    /**
     * Indicates whether domain is hidden on login screen or not. 
     */
    "isHiddenOnLogin"?: boolean;
    /**
     * The admin first name
     */
    "adminFirstName"?: string;
    /**
     * The admin last name
     */
    "adminLastName"?: string;
    /**
     * The admin user name
     */
    "adminUserName"?: string;
    /**
     * The admin email address
     */
    "adminEmail"?: string;
    /**
     * Indicates if admin user created in IDCS stripe would like to receive notification like welcome email or not. Required field only if admin information is provided, otherwise optional. 
     */
    "isNotificationBypassed"?: boolean;
    /**
     * Optional field to indicate whether users in the domain are required to have a primary email address or not Defaults to true 
     */
    "isPrimaryEmailRequired"?: boolean;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

/**
 * Properties for creating a dynamic group.
 */
export interface CreateDynamicGroupDetails {
    /**
     * The OCID of the tenancy containing the group.
     */
    "compartmentId": string;
    /**
     * The name you assign to the group during creation. The name must be unique across all groups in the tenancy and cannot be changed. 
     */
    "name": string;
    /**
     * The matching rule to dynamically match an instance certificate to this dynamic group. For rule syntax, see [Managing Dynamic Groups](/Content/Identity/Tasks/managingdynamicgroups.htm). 
     */
    "matchingRule": string;
    /**
     * The description you assign to the group during creation. Does not have to be unique, and it's changeable.
     */
    "description": string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export interface CreateGroupDetails {
    /**
     * The OCID of the tenancy containing the group.
     */
    "compartmentId": string;
    /**
     * The name you assign to the group during creation. The name must be unique across all groups in the tenancy and cannot be changed. 
     */
    "name": string;
    /**
     * The description you assign to the group during creation. Does not have to be unique, and it's changeable.
     */
    "description": string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export interface CreateIdentityProviderDetails {
    /**
     * The OCID of your tenancy.
     */
    "compartmentId": string;
    /**
     * The name you assign to the `IdentityProvider` during creation. The name must be unique across all `IdentityProvider` objects in the tenancy and cannot be changed. 
     */
    "name": string;
    /**
     * The description you assign to the `IdentityProvider` during creation. Does not have to be unique, and it's changeable. 
     */
    "description": string;
    /**
     * The identity provider service or product. Supported identity providers are Oracle Identity Cloud Service (IDCS) and Microsoft Active Directory Federation Services (ADFS).  Example: `IDCS` 
     */
    "productType": CreateIdentityProviderDetailsProductTypeEnum;
    /**
     * The protocol used for federation.  Example: `SAML2` 
     */
    "protocol": CreateIdentityProviderDetailsProtocolEnum;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export type CreateIdentityProviderDetailsProductTypeEnum = "IDCS" | "ADFS";
export type CreateIdentityProviderDetailsProtocolEnum = "SAML2" | "ADFS";
export interface CreateIdpGroupDetails {
    /**
     * The name you assign to the identity provider group during creation.
     */
    "name": string;
    /**
     * The description you assign to the group during creation. Does not have to be unique, and it's changeable.
     */
    "description": string;
    /**
     * The id of a user in the identity provider.
     */
    "externalIdentifier": string;
}

export interface CreateIdpGroupMappingDetails {
    /**
     * The name of the IdP group you want to map.
     */
    "idpGroupName": string;
    /**
     * The OCID of the IAM Service [group](#/en/identity/20160918/Group/) you want to map to the IdP group. 
     */
    "groupId": string;
}

export interface CreateIdpUserDetails {
    /**
     * The name you assign to the identity provider group during creation.
     */
    "name": string;
    /**
     * The description you assign to the group during creation. Does not have to be unique, and it's changeable.
     */
    "description": string;
    /**
     * The email you assign to the user. Has to be unique across the tenancy.
     */
    "email"?: string;
    /**
     * The id of a user in the identity provider.
     */
    "externalIdentifier": string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export interface CreateManagedCompartmentDetails {
    /**
     * The OCID of the tenancy containing the compartment.
     */
    "compartmentId": string;
    /**
     * The name you assign to the compartment during creation. The name must be unique across all compartments in the tenancy and cannot be changed. 
     */
    "name": string;
    /**
     * The description you assign to the compartment during creation. Does not have to be unique, and it's changeable. 
     */
    "description": string;
    /**
     * The name of the internal service caller. 
     */
    "serviceName": string;
    /**
     * The service entitlement Id. 
     */
    "serviceEntitlementId": string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

/**
 * Properties for creating a network source object.
 */
export interface CreateNetworkSourceDetails {
    /**
     * The OCID of the tenancy (root compartment) containing the network source object.
     */
    "compartmentId": string;
    /**
     * The name you assign to the network source during creation. The name must be unique across all groups in the tenancy and cannot be changed. 
     */
    "name": string;
    /**
     * A list of allowed public IP addresses and CIDR ranges. 
     */
    "publicSourceList"?: Array<string>;
    /**
     * A list of allowed VCN OCID and IP range pairs. Example:`\"vcnId\": \"ocid1.vcn.oc1.iad.aaaaaaaaexampleuniqueID\", \"ipRanges\": [ \"129.213.39.0/24\" ]` 
     */
    "virtualSourceList"?: Array<NetworkSourcesVirtualSourceList>;
    /**
     * A list of services allowed to make on-behalf-of requests. These requests can have different source IP addresses than those listed in the network source. Currently, only `all` and `none` are supported. The default is `all`. 
     */
    "services"?: Array<string>;
    /**
     * The description you assign to the network source during creation. Does not have to be unique, and it's changeable.
     */
    "description": string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export interface CreateOAuth2ClientCredentialDetails {
    /**
     * Name of the oauth credential to help user differentiate them.
     */
    "name": string;
    /**
     * Description of the oauth credential to help user differentiate them.
     */
    "description": string;
    /**
     * Allowed scopes for the given oauth credential.
     */
    "scopes": Array<FullyQualifiedScope>;
}

/**
 * Metadata to create OpenID Connect client. 
 */
export interface CreateOidcClientDetails {
    /**
     * Human-readable OpenID Connect client display name.
     */
    "name": string;
    /**
     * Array of response types the OpenID Connect client is restricted to use.
     */
    "responseTypes": Array<string>;
    /**
     * Name of the service principal used for signing requests.
     */
    "servicePrincipalName": string;
    /**
     * Array of URIs where SOUP will redirect a user after successful authentication to tha app.
     */
    "redirectUris": Array<string>;
    /**
     * Array of domains where SOUP will redirect a user after successful authentication to the app.
     */
    "redirectDomains": Array<string>;
    /**
     * URI for a user to log out of the app.
     */
    "frontChannelLogoutUri": string;
    /**
     * Array of URIs where SOUP will redirect a user after logging out of the app.
     */
    "postLogoutRedirectUris": Array<string>;
    /**
     * Array of resources the access tokens grant access to.
     */
    "resources": Array<string>;
    /**
     * Array of affix-based registered redirect URI values.
     */
    "affixes"?: Array<AffixBasedUri>;
}

/**
 * The information about new OnPremSite.
 */
export interface CreateOnPremSiteDetails {
    /**
     * OnPremSite name
     */
    "name": string;
    /**
     * Compartment Identifier
     */
    "compartmentId": string;
    "address": Address;
    /**
     * The contact information about the OnPremSite.
     */
    "contacts": Array<Contact>;
    /**
     * The description you assign to the OnPremSite during creation
     */
    "description": string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export interface CreatePolicyDetails {
    /**
     * The OCID of the compartment containing the policy (either the tenancy or another compartment).
     */
    "compartmentId": string;
    /**
     * The name you assign to the policy during creation. The name must be unique across all policies in the tenancy and cannot be changed. 
     */
    "name": string;
    /**
     * An array of policy statements written in the policy language. See [How Policies Work](/Content/Identity/Concepts/policies.htm) and [Common Policies](/Content/Identity/Concepts/commonpolicies.htm). 
     */
    "statements": Array<string>;
    /**
     * The description you assign to the policy during creation. Does not have to be unique, and it's changeable. 
     */
    "description": string;
    /**
     * The version of the policy. If null or set to an empty string, when a request comes in for authorization, the policy will be evaluated according to the current behavior of the services at that moment. If set to a particular date (YYYY-MM-DD), the policy will be evaluated according to the behavior of the services on that date. 
     */
    "versionDate"?: Date;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export interface CreateRegionSubscriptionDetails {
    /**
     * The regions's key. See [Regions and Availability Domains](/Content/General/Concepts/regions.htm) for the full list of supported 3-letter region codes.  Example: `PHX` 
     */
    "regionKey": string;
}

/**
 * Metadata to create service manager. 
 */
export interface CreateServiceManagerDetails {
    /**
     * The name of the service manager.
     */
    "serviceName": string;
    /**
     * The OCID of the tenant used to create service manager.
     */
    "tenantId": string;
    /**
     * The CM link for creating service manager.
     */
    "cmLink": string;
    /**
     * The team's alias email.
     */
    "ownerEmail": string;
    /**
     * The tenancy id physically hosting your service manager.
     */
    "hostingTenantId"?: string;
    /**
     * The OCID of the tenant that is already associated with your service name.
     */
    "associatedTenantId"?: string;
    /**
     * Override duplicate.
     */
    "overrideDuplicate"?: boolean;
    /**
     * key-value pair of the service manager.
     */
    "properties"?: { [key: string]: string; };
}

export interface CreateSmtpCredentialDetails {
    /**
     * The description you assign to the SMTP credentials during creation. Does not have to be unique, and it's changeable. 
     */
    "description": string;
}

export interface CreateStripeDetails {
    /**
     * The OCID of the tenancy containing the stripe.
     */
    "compartmentId": string;
    /**
     * The region of the stripe.
     */
    "region": string;
}

export interface CreateSwiftPasswordDetails {
    /**
     * The description you assign to the Swift password during creation. Does not have to be unique, and it's changeable. 
     */
    "description": string;
}

export interface CreateTagDefaultDetails {
    /**
     * The OCID of the compartment. The tag default will be applied to all new resources created in this compartment. 
     */
    "compartmentId": string;
    /**
     * The OCID of the tag definition. The tag default will always assign a default value for this tag definition. 
     */
    "tagDefinitionId": string;
    /**
     * The default value for the tag definition. This will be applied to all new resources created in the compartment. 
     */
    "value": string;
    /**
     * If you specify that a value is required, a value is set during resource creation (either by the user creating the resource or another tag defualt). If no value is set, resource creation is blocked.  * If the `isRequired` flag is set to \"true\", the value is set during resource creation. * If the `isRequired` flag is set to \"false\", the value you enter is set during resource creation.  Example: `false` 
     */
    "isRequired"?: boolean;
}

export interface CreateTagDetails {
    /**
     * The name you assign to the tag during creation. This is the tag key definition. The name must be unique within the tag namespace and cannot be changed. 
     */
    "name": string;
    /**
     * The description you assign to the tag during creation.
     */
    "description": string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm).  Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm).  Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
    /**
     * Indicates whether the tag is enabled for cost tracking. 
     */
    "isCostTracking"?: boolean;
    "validator"?: BaseTagDefinitionValidator;
}

export interface CreateTagNamespaceDetails {
    /**
     * The OCID of the tenancy containing the tag namespace.
     */
    "compartmentId": string;
    /**
     * The name you assign to the tag namespace during creation. It must be unique across all tag namespaces in the tenancy and cannot be changed. 
     */
    "name": string;
    /**
     * The description you assign to the tag namespace during creation.
     */
    "description": string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm).  Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm).  Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

/**
 * Create a Tas domain details
 */
export interface CreateTasDomainDetails {
    /**
     * The OCID of the Compartment where domain is created
     */
    "compartmentId": string;
    /**
     * The mutable display name of the domain.
     */
    "displayName": string;
    /**
     * Domain entity description
     */
    "description": string;
    /**
     * The region's name. See [Regions and Availability Domains](/Content/General/Concepts/regions.htm) for the full list of supported region names.  Example: `us-phoenix-1` 
     */
    "homeRegion": string;
    /**
     * The License type of Domain
     */
    "licenseType": string;
    /**
     * Indicates whether domain is hidden on login screen or not. 
     */
    "isHiddenOnLogin"?: boolean;
    /**
     * The admin first name
     */
    "adminFirstName": string;
    /**
     * The admin last name
     */
    "adminLastName": string;
    /**
     * The admin user name
     */
    "adminUserName": string;
    /**
     * The admin email address
     */
    "adminEmail"?: string;
    /**
     * Indicates if admin user created in IDCS stripe would like to receive notification like welcome email or not. Required field only if admin information is provided, otherwise optional. 
     */
    "isNotificationBypassed": boolean;
    /**
     * My Services URL
     */
    "myServicesUrl"?: string;
    /**
     * The admin password
     */
    "adminPassword"?: string;
    /**
     * Base64 encoded keystore of tenant
     */
    "keyStore"?: string;
    /**
     * To decrypt the keystore passed in the payload
     */
    "keyStorePassword"?: string;
    /**
     * Base64 encoded signingKey of tenant in JWK format
     */
    "signingKeyAsJwk"?: string;
    /**
     * Admin User Prompt Password Change Flag
     */
    "isPromptPasswordChange": boolean;
    /**
     * To identify if the order is promotional or not
     */
    "isPromotion"?: string;
    /**
     * The source of the order Eg- GSI, CLOUD_PORTAL etc
     */
    "orderSource"?: string;
    /**
     * To identify if it's a Fusion Apps order type
     */
    "purpose"?: string;
    /**
     * entitlement Id of the service
     */
    "opcServiceEntitlementId"?: string;
    /**
     * Optional field to indicate whether users in the domain are required to have a primary email address or not Defaults to true 
     */
    "isPrimaryEmailRequired"?: boolean;
    /**
     * Cloud Account id
     */
    "tasAccountGuid"?: string;
    /**
     * If the domain creation request is for fusion apps service. If false, license type validation needs to be skipped as non-FA service calls will have pre-henosis license types which are not longer supported. In FA service scenario license type will be henosis supported one. because FA service will be using pre-henosis license types which are no longer supported in other scenario except for FA scenario (backward compatibility). 
     */
    "isFa"?: boolean;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: any;
    /**
     * Key-value pair representing a defined tag key and value, scoped to a namespace. Example: `{\"CostCenter\": \"42\"}` 
     */
    "additionalProperties"?: { [key: string]: any; };
}

export interface CreateUpiGroupDetails {
    /**
     * The compartmentId id of the group.
     */
    "compartmentId"?: string;
    /**
     * DESCRIPTION
     */
    "displayName"?: string;
    "idcsCreatedBy"?: IdcsCreatedBy;
    "idcsLastModifiedBy"?: IdcsLastModifiedBy;
    /**
     * DESCRIPTION
     */
    "tags"?: Array<UpiTags>;
}

export interface CreateUpiUserDetails {
    /**
     * The compartment id of the user.
     */
    "compartmentId"?: string;
    /**
     * The name you assign to the user during creation. This is the user's login for the Console. The name must be unique across all users in the tenancy and cannot be changed. 
     */
    "userName"?: string;
    /**
     * The description you assign to the user. Does not have to be unique, and it's changeable.
     */
    "displayName"?: string;
    /**
     * DESCRIPTION
     */
    "password"?: string;
    /**
     * DESCRIPTION
     */
    "active"?: boolean;
    "idcsCreatedBy"?: IdcsCreatedBy;
    "idcsLastModifiedBy"?: IdcsLastModifiedBy;
    "name"?: UpiName;
    /**
     * DESCRIPTION
     */
    "title"?: string;
    /**
     * DESCRIPTION
     */
    "locale"?: string;
    /**
     * DESCRIPTION
     */
    "preferredLanguage"?: string;
    /**
     * DESCRIPTION
     */
    "timezone"?: string;
    /**
     * DESCRIPTION
     */
    "tags"?: Array<UpiTags>;
    "email"?: UpiEmail;
    /**
     * DESCRIPTION
     */
    "phoneNumbers"?: Array<UpiPhoneNumbers>;
    /**
     * DESCRIPTION
     */
    "photos"?: Array<UpiPhotos>;
    /**
     * DESCRIPTION
     */
    "addresses"?: Array<UpiAddresses>;
    /**
     * DESCRIPTION
     */
    "manager"?: string;
}

export interface CreateUserDetails {
    /**
     * The OCID of the tenancy containing the user.
     */
    "compartmentId": string;
    /**
     * The name you assign to the user during creation. This is the user's login for the Console. The name must be unique across all users in the tenancy and cannot be changed. 
     */
    "name": string;
    /**
     * The description you assign to the user during creation. Does not have to be unique, and it's changeable.
     */
    "description": string;
    /**
     * The email you assign to the user. Has to be unique across the tenancy.
     */
    "email"?: string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export interface CreateWorkflowTaskDetails {
    /**
     * The type of workflow task.  Example: `MigrationWorkflow` 
     */
    "workflowType": string;
}

/**
 * A `CustomerSecretKey` is an Oracle-provided key for using the Object Storage Service's [Amazon S3 compatible API](/Content/Object/Tasks/s3compatibleapi.htm). The key consists of a secret key/access key pair. A user can have up to two secret keys at a time.  **Note:** The secret key is always an Oracle-generated string; you can't change it to a string of your choice.  For more information, see [Managing User Credentials](/Content/Identity/Tasks/managingcredentials.htm). 
 */
export interface CustomerSecretKey {
    /**
     * The secret key. 
     */
    "key"?: string;
    /**
     * The access key portion of the key pair.
     */
    "id"?: string;
    /**
     * The OCID of the user the password belongs to.
     */
    "userId"?: string;
    /**
     * The display name you assign to the secret key. Does not have to be unique, and it's changeable.
     */
    "displayName"?: string;
    /**
     * Date and time the `CustomerSecretKey` object was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated"?: Date;
    /**
     * Date and time when this password will expire, in the format defined by RFC3339. Null if it never expires.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeExpires"?: Date;
    /**
     * The secret key's current state. After creating a secret key, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState"?: CustomerSecretKeyLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "inactiveStatus"?: number;
}

export type CustomerSecretKeyLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * As the name suggests, a `CustomerSecretKeySummary` object contains information about a `CustomerSecretKey`. A `CustomerSecretKey` is an Oracle-provided key for using the Object Storage Service's Amazon S3 compatible API. 
 */
export interface CustomerSecretKeySummary {
    /**
     * The OCID of the secret key.
     */
    "id"?: string;
    /**
     * The OCID of the user the password belongs to.
     */
    "userId"?: string;
    /**
     * The displayName you assign to the secret key. Does not have to be unique, and it's changeable.
     */
    "displayName"?: string;
    /**
     * Date and time the `CustomerSecretKey` object was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated"?: Date;
    /**
     * Date and time when this password will expire, in the format defined by RFC3339. Null if it never expires.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeExpires"?: Date;
    /**
     * The secret key's current state. After creating a secret key, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState"?: CustomerSecretKeySummaryLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "inactiveStatus"?: number;
}

export type CustomerSecretKeySummaryLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * Database credentials are needed for onboarding cloud database to identity. The DB credentials are used for DB authentication with the service. 
 */
export interface DbCredential {
    /**
     * The OCID of the DB credential.
     */
    "id"?: string;
    /**
     * The OCID of the user the DB credential belongs to.
     */
    "userId"?: string;
    /**
     * Date and time the `DbCredential` object was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated"?: Date;
    /**
     * Date and time when this credential will expire, in the format defined by RFC3339. Null if it never expires.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeExpires"?: Date;
    /**
     * The credential's current state. After creating a DB credential, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState"?: DbCredentialLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "lifecycleDetails"?: number;
}

export type DbCredentialLifecycleStateEnum = "CREATING" | "ACTIVE" | "DELETING" | "DELETED";
/**
 * As the name suggests, an `DbCredentialSummary` object contains information about an `DbCredential`. The DB credential is used for DB authentication with the [DB Service]. 
 */
export interface DbCredentialSummary {
    /**
     * The OCID of the DB credential.
     */
    "id"?: string;
    /**
     * The OCID of the user the DB credential belongs to.
     */
    "userId"?: string;
    /**
     * The description you assign to the DB credential. Does not have to be unique, and it's changeable.
     */
    "description"?: string;
    /**
     * Date and time the `DbCredential` object was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated"?: Date;
    /**
     * Date and time when this credential will expire, in the format defined by RFC3339. Null if it never expires.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeExpires"?: Date;
    /**
     * The credential's current state. After creating a DB credential, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState"?: string;
}

/**
 * Properties for a Domain
 */
export interface Domain {
    /**
     * The OCID of the domain
     */
    "id": string;
    /**
     * The OCID of the compartment containing the domain.
     */
    "compartmentId": string;
    /**
     * The mutable display name of the domain
     */
    "displayName": string;
    /**
     * The domain descripition
     */
    "description": string;
    /**
     * Region agnostic domain URL.
     */
    "url": string;
    /**
     * Region specific domain URL.
     */
    "homeRegionUrl": string;
    /**
     * The home region for the domain. See [Regions and Availability Domains](/Content/General/Concepts/regions.htm) for the full list of supported region names.  Example: `us-phoenix-1` 
     */
    "homeRegion": string;
    /**
     * The regions domain is replication to.
     */
    "replicaRegions": Array<ReplicatedRegionDetails>;
    /**
     * The type of the domain. 
     */
    "type": DomainTypeEnum;
    /**
     * The License type of Domain
     */
    "licenseType": string;
    /**
     * Indicates whether domain is hidden on login screen or not. 
     */
    "isHiddenOnLogin": boolean;
    /**
     * The OCID of the identity provider. Only applies to migrated domain with federation.
     */
    "identityProviderId"?: string;
    /**
     * Date and time the domain was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
    /**
     * The current state. 
     */
    "lifecycleState": DomainLifecycleStateEnum;
    /**
     * Any additional details about the current state of the Domain. 
     */
    "lifecycleDetails"?: DomainLifecycleDetailsEnum;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export type DomainTypeEnum = "DEFAULT" | "SECONDARY" | "DEFAULT_LIGHTWEIGHT";
export type DomainLifecycleStateEnum = "CREATING" | "ACTIVE" | "DELETING" | "INACTIVE";
export type DomainLifecycleDetailsEnum = "READY_FOR_LOGIN" | "DEACTIVATING" | "ACTIVATING" | "UPDATING";
/**
 * Domain Migration details 
 */
export interface DomainMigration {
    /**
     * The type of this migration.
     */
    "type": DomainMigrationTypeEnum;
    /**
     * The state of this migration.
     */
    "state": DomainMigrationStateEnum;
    "targetDomainId": KievPersistentId;
    /**
     * The OCID of the Identity Provider this mapping belongs to.
     */
    "idpId": string;
    /**
     * The sequence number of the last processed batch record.
     */
    "lastSequenceNumber": number;
    /**
     * JSON object metadata about the progress status of this domain migration.
     */
    "progressMetadata": string;
}

export type DomainMigrationTypeEnum = "NATIVE" | "FEDERATED_STRIPE" | "FEDERATIONS" | "UNCLAIMED_STRIPES";
export type DomainMigrationStateEnum = "QUEUED" | "MIGRATING_SNAPSHOT" | "SNAPSHOT_MIGRATED" | "MIGRATING_BUFFER" | "BUFFER_MIGRATED" | "LOCKED" | "COMPLETE" | "ROLLED_BACK";
/**
 * Domain replication states.
 */
export interface DomainReplication {
    /**
     * Version number indicating the value of kievTxnId, starting from which, the domain replication events need to be returned.
     */
    "opcWaterMark": number;
    /**
     * Custom value defining the order of records with same kievTxnId
     */
    "txnSeqNumber": number;
    /**
     * The domain's replication state
     */
    "domainReplicationStates": Array<DomainReplicationStates>;
}

/**
 * Domain replication replication log for all domains for a given region
 */
export interface DomainReplicationStates {
    /**
     * The OCID of the domain
     */
    "domainId": string;
    /**
     * The IDCS replicated region state 
     */
    "state": DomainReplicationStatesStateEnum;
    /**
     * The replica region for domain.
     */
    "replicaRegion": string;
}

export type DomainReplicationStatesStateEnum = "ENABLING_REPLICATION" | "REPLICATION_ENABLED" | "DISABLING_REPLICATION" | "REPLICATION_DISABLED" | "DELETED";
/**
 * As the name suggests, a `DomainSummary` object contains information about a `Domain`. 
 */
export interface DomainSummary {
    /**
     * The OCID of the domain
     */
    "id": string;
    /**
     * The OCID of the comparment containing the domain.
     */
    "compartmentId": string;
    /**
     * The mutable display name of the domain
     */
    "displayName": string;
    /**
     * The domain descripition
     */
    "description": string;
    /**
     * Region agnostic domain URL.
     */
    "url": string;
    /**
     * Region specific domain URL.
     */
    "homeRegionUrl": string;
    /**
     * The home region for the domain.
     */
    "homeRegion": string;
    /**
     * The regions domain is replicated to.
     */
    "replicaRegions": Array<ReplicatedRegionDetails>;
    /**
     * The type of the domain. 
     */
    "type": DomainSummaryTypeEnum;
    /**
     * The License type of Domain
     */
    "licenseType": string;
    /**
     * Indicates whether domain is hidden on login screen or not. 
     */
    "isHiddenOnLogin": boolean;
    /**
     * Date and time the domain was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
    /**
     * The current state. 
     */
    "lifecycleState": DomainSummaryLifecycleStateEnum;
    /**
     * Any additional details about the current state of the Domain. 
     */
    "lifecycleDetails"?: DomainSummaryLifecycleDetailsEnum;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export type DomainSummaryTypeEnum = "DEFAULT" | "SECONDARY" | "DEFAULT_LIGHTWEIGHT";
export type DomainSummaryLifecycleStateEnum = "CREATING" | "ACTIVE" | "DELETING" | "INACTIVE";
export type DomainSummaryLifecycleDetailsEnum = "READY_FOR_LOGIN" | "DEACTIVATING" | "ACTIVATING" | "UPDATING";
/**
 * A dynamic group defines a matching rule. Every bare metal or virtual machine instance is deployed with an instance certificate. The certificate contains metadata about the instance. This includes the instance OCID and the compartment OCID, along with a few other optional properties. When an API call is made using this instance certificate as the authenticator, the certificate can be matched to one or multiple dynamic groups. The instance can then get access to the API based on the permissions granted in policies written for the dynamic groups.  This works like regular user/group membership. But in that case, the membership is a static relationship, whereas in a dynamic group, the membership of an instance certificate to a dynamic group is determined during runtime. For more information, see [Managing Dynamic Groups](/Content/Identity/Tasks/managingdynamicgroups.htm).  **Warning:** Oracle recommends that you avoid using any confidential information when you supply string values using the API. 
 */
export interface DynamicGroup {
    /**
     * The OCID of the group.
     */
    "id": string;
    /**
     * The OCID of the tenancy containing the group.
     */
    "compartmentId": string;
    /**
     * The name you assign to the group during creation. The name must be unique across all groups in the tenancy and cannot be changed. 
     */
    "name": string;
    /**
     * The description you assign to the group. Does not have to be unique, and it's changeable.
     */
    "description": string;
    /**
     * A rule string that defines which instance certificates will be matched. For syntax, see [Managing Dynamic Groups](/Content/Identity/Tasks/managingdynamicgroups.htm). 
     */
    "matchingRule": string;
    /**
     * Date and time the group was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
    /**
     * The group's current state. After creating a group, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState": DynamicGroupLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "inactiveStatus"?: number;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export type DynamicGroupLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * Email verification tokens are used for email verification/account recovery. 
 */
export interface EmailVerificationToken {
    /**
     * The OCID of the Email Verification Token.
     */
    "id": string;
    "type"?: EmailVerificationTokenTypeEnum;
    /**
     * The OCID of the tenancy the email verification token belongs to.
     */
    "tenantId"?: string;
    /**
     * The OCID of the user the email verification token belongs to.
     */
    "userId"?: string;
    /**
     * Epoch time the `Email Verification Token` object was created. 
     */
    "creationTime"?: number;
}

export type EmailVerificationTokenTypeEnum = "UNKNOWN" | "VERIFY_EMAIL" | "RESET_PASSWORD";
export interface EmailVerificationTokenDetails {
    /**
     * The email verification token.
     */
    "emailVerificationToken": string;
}

/**
 * Domain replication request packet
 */
export interface EnableReplicationToRegionDetails {
    /**
     * A region for which domain replication is requested for. See [Regions and Availability Domains](/Content/General/Concepts/regions.htm) for the full list of supported region names.  Example: `us-phoenix-1` 
     */
    "replicaRegion"?: string;
}

/**
 * A Fault Domain is a logical grouping of hardware and infrastructure within an Availability Domain that can become unavailable in its entirety either due to hardware failure such as Top-of-rack (TOR) switch failure or due to planned software maintenance such as security updates that reboot your instances. 
 */
export interface FaultDomain {
    /**
     * The name of the Fault Domain.
     */
    "name"?: string;
    /**
     * The OCID of the Fault Domain.
     */
    "id"?: string;
    /**
     * The OCID of the compartment. Currently only tenancy (root) compartment can be provided.
     */
    "compartmentId"?: string;
    /**
     * The name of the availabilityDomain where the Fault Domain belongs.
     */
    "availabilityDomain"?: string;
}

export interface FullyQualifiedScope {
    /**
     * Audience for the given scope context.
     */
    "audience": string;
    /**
     * Allowed permission scope for the given context.
     */
    "scope": string;
}

/**
 * A collection of users who all need the same type of access to a particular set of resources or compartment. For conceptual information about groups and other IAM Service components, see [Overview of the IAM Service](/Content/Identity/Concepts/overview.htm).  If you're federating with an identity provider (IdP), you need to create mappings between the groups defined in the IdP and groups you define in the IAM service. For more information, see [Identity Providers and Federation](/Content/Identity/Concepts/federation.htm). Also see [IdentityProvider](#/en/identity/20160918/IdentityProvider/) and [IdpGroupMapping](#/en/identity/20160918/IdpGroupMapping/).  To use any of the API operations, you must be authorized in an IAM policy. If you're not authorized, talk to an administrator. If you're an administrator who needs to write policies to give users access, see [Getting Started with Policies](/Content/Identity/Concepts/policygetstarted.htm).  **Warning:** Oracle recommends that you avoid using any confidential information when you supply string values using the API. 
 */
export interface Group {
    /**
     * The OCID of the group.
     */
    "id": string;
    /**
     * The OCID of the tenancy containing the group.
     */
    "compartmentId": string;
    /**
     * The name you assign to the group during creation. The name must be unique across all groups in the tenancy and cannot be changed. 
     */
    "name": string;
    /**
     * The description you assign to the group. Does not have to be unique, and it's changeable.
     */
    "description": string;
    /**
     * Date and time the group was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
    /**
     * The group's current state. After creating a group, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState": GroupLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "inactiveStatus"?: number;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export type GroupLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * A IAM work request object that allows users to track Asynchronous API status.
 */
export interface IamWorkRequest {
    /**
     * The OCID of the work request.
     */
    "id": string;
    /**
     * The asynchronous operation tracked by this IAM work request.
     */
    "operationType": IamWorkRequestOperationTypeEnum;
    /**
     * Status of the work request
     */
    "status": IamWorkRequestStatusEnum;
    /**
     * The OCID of the compartment containing this IAM work request.
     */
    "compartmentId"?: string;
    /**
     * The resources this work request affects.
     */
    "resources"?: Array<IamWorkRequestResource>;
    /**
     * How much progress the operation has made. 
     */
    "percentComplete"?: number;
    /**
     * Date and time the work was accepted, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeAccepted"?: Date;
    /**
     * Date and time the work started, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeStarted"?: Date;
    /**
     * Date and time the work completed, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeFinished"?: Date;
}

export type IamWorkRequestOperationTypeEnum = "CREATE_DOMAIN" | "REPLICATE_DOMAIN_TO_REGION" | "UPDATE_DOMAIN" | "ACTIVATE_DOMAIN" | "DEACTIVATE_DOMAIN" | "DELETE_DOMAIN" | "CHANGE_COMPARTMENT_FOR_DOMAIN" | "CHANGE_LICENSE_TYPE_FOR_DOMAIN" | "CREATE_DEFAULT_DOMAIN" | "CLAIM_STRIPE_FOR_DOMAIN" | "REPLICATE_DEFAULT_DOMAIN_TO_REGION" | "UPDATE_TAS_DOMAIN" | "CREATE_TAS_DOMAIN" | "DELETE_TAS_DOMAIN";
export type IamWorkRequestStatusEnum = "ACCEPTED" | "IN_PROGRESS" | "FAILED" | "SUCCEEDED" | "CANCELING" | "CANCELED";
/**
 * An error encountered while executing an operation that is tracked by a IAM work request.
 */
export interface IamWorkRequestErrorSummary {
    /**
     * A machine-usable code for the error that occured.
     */
    "code": string;
    /**
     * A human-readable error string.
     */
    "message": string;
    /**
     * The date and time the error occurred.
     */
    "timestamp": Date;
}

/**
 * The log entity for a IAM work request. 
 */
export interface IamWorkRequestLogSummary {
    /**
     * A human-readable error string.
     */
    "message": string;
    /**
     * Date and time the log was written, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timestamp"?: Date;
}

/**
 * A IAM work request resource entry
 */
export interface IamWorkRequestResource {
    /**
     * The way in which this resource is affected by the work tracked in the work request. A resource being created, updated, or deleted will remain in the IN_PROGRESS state until work is complete for that resource at which point it will transition to CREATED, UPDATED, or DELETED, respectively. 
     */
    "actionType": IamWorkRequestResourceActionTypeEnum;
    /**
     * The resource type the work request is affects.
     */
    "entityType": string;
    /**
     * An OCID of the resource that the work request affects.
     */
    "identifier": string;
    /**
     * The URI path that the user can do a GET on to access the resource metadata.
     */
    "entityUri"?: string;
    /**
     * Additional information that helps to explain the resource. The metadata map should really only be used to avoid having to parse the entityUri or identifier. 
     */
    "metadata"?: { [key: string]: string; };
}

export type IamWorkRequestResourceActionTypeEnum = "CREATED" | "UPDATED" | "DELETED" | "RELATED" | "IN_PROGRESS";
/**
 * The IAM work request summary. Tracks the status of the asynchronous operations. 
 */
export interface IamWorkRequestSummary {
    /**
     * The OCID of the work request.
     */
    "id": string;
    /**
     * The asynchronous operation tracked by this IAM work request.
     */
    "operationType": IamWorkRequestSummaryOperationTypeEnum;
    /**
     * Status of the work request
     */
    "status": IamWorkRequestSummaryStatusEnum;
    /**
     * The OCID of the compartment containing this IAM work request.
     */
    "compartmentId"?: string;
    /**
     * The resources this work request affects.
     */
    "resources"?: Array<IamWorkRequestResource>;
    /**
     * How much progress the operation has made. 
     */
    "percentComplete"?: number;
    /**
     * Date and time the work was accepted, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeAccepted"?: Date;
    /**
     * Date and time the work started, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeStarted"?: Date;
    /**
     * Date and time the work completed, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeFinished"?: Date;
}

export type IamWorkRequestSummaryOperationTypeEnum = "CREATE_DOMAIN" | "REPLICATE_DOMAIN_TO_REGION" | "UPDATE_DOMAIN" | "ACTIVATE_DOMAIN" | "DEACTIVATE_DOMAIN" | "DELETE_DOMAIN" | "CHANGE_COMPARTMENT_FOR_DOMAIN" | "CHANGE_LICENSE_TYPE_FOR_DOMAIN" | "CREATE_DEFAULT_DOMAIN" | "CLAIM_STRIPE_FOR_DOMAIN" | "REPLICATE_DEFAULT_DOMAIN_TO_REGION" | "UPDATE_TAS_DOMAIN" | "CREATE_TAS_DOMAIN" | "DELETE_TAS_DOMAIN";
export type IamWorkRequestSummaryStatusEnum = "ACCEPTED" | "IN_PROGRESS" | "FAILED" | "SUCCEEDED" | "CANCELING" | "CANCELED";
export interface IdcsCreatedBy {
    /**
     * DESCRIPTION
     */
    "value"?: string;
    /**
     * DESCRIPTION
     */
    "type"?: string;
    /**
     * DESCRIPTION
     */
    "display"?: string;
}

export interface IdcsLastModifiedBy {
    /**
     * DESCRIPTION
     */
    "value"?: string;
    /**
     * DESCRIPTION
     */
    "type"?: string;
    /**
     * DESCRIPTION
     */
    "display"?: string;
}

/**
 * The resulting base object when you add an identity provider to your tenancy. A [Saml2IdentityProvider](#/en/identity/20160918/Saml2IdentityProvider/) is a specific type of `IdentityProvider` that supports the SAML 2.0 protocol. Each `IdentityProvider` object has its own OCID. For more information, see [Identity Providers and Federation](/Content/Identity/Concepts/federation.htm).  To use any of the API operations, you must be authorized in an IAM policy. If you're not authorized, talk to an administrator. If you're an administrator who needs to write policies to give users access, see [Getting Started with Policies](/Content/Identity/Concepts/policygetstarted.htm).  **Warning:** Oracle recommends that you avoid using any confidential information when you supply string values using the API. 
 */
export interface IdentityProvider {
    /**
     * The OCID of the `IdentityProvider`.
     */
    "id": string;
    /**
     * The OCID of the tenancy containing the `IdentityProvider`.
     */
    "compartmentId": string;
    /**
     * The name you assign to the `IdentityProvider` during creation. The name must be unique across all `IdentityProvider` objects in the tenancy and cannot be changed. This is the name federated users see when choosing which identity provider to use when signing in to the Oracle Cloud Infrastructure Console. 
     */
    "name": string;
    /**
     * The description you assign to the `IdentityProvider` during creation. Does not have to be unique, and it's changeable. 
     */
    "description": string;
    /**
     * The identity provider service or product. Supported identity providers are Oracle Identity Cloud Service (IDCS) and Microsoft Active Directory Federation Services (ADFS).  Allowed values are: - `ADFS` - `IDCS`  Example: `IDCS` 
     */
    "productType": string;
    /**
     * Date and time the `IdentityProvider` was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
    /**
     * The current state. After creating an `IdentityProvider`, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState": IdentityProviderLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "inactiveStatus"?: number;
    /**
     * The protocol used for federation. Allowed value: `SAML2`.  Example: `SAML2` 
     */
    "protocol": string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
    /**
     * The OCID of the domain that corresponds to this Identity Provider.
     */
    "domainId"?: string;
}

export type IdentityProviderLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * A group created in an identity provider that can be mapped to a group in OCI 
 */
export interface IdentityProviderGroupSummary {
    /**
     * The OCID of the `IdentityProviderGroup`.
     */
    "id"?: string;
    /**
     * The OCID of the `IdentityProvider` this group belongs to.
     */
    "identityProviderId"?: string;
    /**
     * Display name of the group
     */
    "displayName"?: string;
    /**
     * Display name of the group
     */
    "name"?: string;
    /**
     * Identifier of the group in the identity provider
     */
    "externalIdentifier"?: string;
    /**
     * Date and time the `IdentityProviderGroup` was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated"?: Date;
    /**
     * Date and time the `IdentityProviderGroup` was last modified, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeModified"?: Date;
}

/**
 * A mapping between a single group defined by the identity provider (IdP) you're federating with and a single IAM Service [group](#/en/identity/20160918/Group/) in Oracle Cloud Infrastructure. For more information about group mappings and what they're for, see [Identity Providers and Federation](/Content/Identity/Concepts/federation.htm).  A given IdP group can be mapped to zero, one, or multiple IAM Service groups, and vice versa. But each `IdPGroupMapping` object is between only a single IdP group and IAM Service group. Each `IdPGroupMapping` object has its own OCID.  **Note:** Any users who are in more than 50 IdP groups cannot be authenticated to use the Oracle Cloud Infrastructure Console. 
 */
export interface IdpGroupMapping {
    /**
     * The OCID of the `IdpGroupMapping`.
     */
    "id": string;
    /**
     * The OCID of the `IdentityProvider` this mapping belongs to.
     */
    "idpId": string;
    /**
     * The name of the IdP group that is mapped to the IAM Service group.
     */
    "idpGroupName": string;
    /**
     * The OCID of the IAM Service group that is mapped to the IdP group.
     */
    "groupId": string;
    /**
     * The OCID of the tenancy containing the `IdentityProvider`.
     */
    "compartmentId": string;
    /**
     * Date and time the mapping was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
    /**
     * The mapping's current state.  After creating a mapping object, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState": IdpGroupMappingLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "inactiveStatus"?: number;
}

export type IdpGroupMappingLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
export interface ImportStandardTagsDetails {
    /**
     * The OCID of the compartment where the bulk create request is submitted and where the tag namespaces will be created. 
     */
    "compartmentId": string;
    /**
     * The name of standard tag namespace that will be imported in bulk 
     */
    "standardTagNamespaceName": string;
}

/**
 * The persistent identifier for finding objects in Kiev. 
 */
export interface KievPersistentId {
    /**
     * The persistent identifier as a string.
     */
    "id": string;
}

/**
 * The response object for replication/lastProcessedInboxSequenceNumber
 */
export interface LastProcessedSequenceNumberResult {
    /**
     * If Identity enables catchup mode, this value will be assgined for the last processed catchup sequence number.
     */
    "lastProcessedSequenceNumberInCatchup": number;
    /**
     * Current last processed inbox sequence number.
     */
    "lastProcessedSequenceNumber": number;
}

/**
 * Limits service group information 
 */
export interface LimitGroup {
    /**
     * Limits group  name 
     */
    "name"?: string;
    /**
     * Limits group description 
     */
    "label"?: string;
}

/**
 * Request object to link a support account. 
 */
export interface LinkSupportAccountDetails {
    /**
     * The token from support account IdP provider containing the support account user id
     */
    "supportAccountToken"?: string;
    /**
     * The name of the support provider 
     */
    "supportProvider"?: string;
}

/**
 * Users can enable multi-factor authentication (MFA) for their own user accounts. After MFA is enabled, the user is prompted for a time-based one-time password (TOTP) to authenticate before they can sign in to the Console. To enable multi-factor authentication, the user must register a mobile device with a TOTP authenticator app installed. The registration process creates the `MfaTotpDevice` object. The registration process requires interaction with the Console and cannot be completed programmatically. For more information, see [Managing Multi-Factor Authentication](/Content/Identity/Tasks/usingmfa.htm). 
 */
export interface MfaTotpDevice {
    /**
     * The OCID of the MFA TOTP device.
     */
    "id": string;
    /**
     * The seed for the MFA TOTP device (Base32 encoded). 
     */
    "seed": string;
    /**
     * The OCID of the user the MFA TOTP device belongs to.
     */
    "userId": string;
    /**
     * Date and time the `MfaTotpDevice` object was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
    /**
     * Date and time when this MFA TOTP device will expire, in the format defined by RFC3339. Null if it never expires.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeExpires"?: Date;
    /**
     * The MFA TOTP device's current state. After creating the MFA TOTP device, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState": MfaTotpDeviceLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState. Allowed values are:  - 1 - SUSPENDED  - 2 - DISABLED  - 4 - BLOCKED  - 8 - LOCKED 
     */
    "inactiveStatus"?: number;
    /**
     * Flag to indicate if the MFA TOTP device has been activated.
     */
    "isActivated": boolean;
}

export type MfaTotpDeviceLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * As the name suggests, a `MfaTotpDeviceSummary` object contains information about a `MfaTotpDevice`. 
 */
export interface MfaTotpDeviceSummary {
    /**
     * The OCID of the MFA TOTP Device.
     */
    "id": string;
    /**
     * The OCID of the user the MFA TOTP device belongs to.
     */
    "userId": string;
    /**
     * Date and time the `MfaTotpDevice` object was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
    /**
     * Date and time when this MFA TOTP device will expire, in the format defined by RFC3339. Null if it never expires.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeExpires"?: Date;
    /**
     * The MFA TOTP device's current state. 
     */
    "lifecycleState": MfaTotpDeviceSummaryLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState. Allowed values are:  - 1 - SUSPENDED  - 2 - DISABLED  - 4 - BLOCKED  - 8 - LOCKED 
     */
    "inactiveStatus"?: number;
    /**
     * Flag to indicate if the MFA TOTP device has been activated
     */
    "isActivated": boolean;
}

export type MfaTotpDeviceSummaryLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * Totp token for MFA 
 */
export interface MfaTotpToken {
    /**
     * The Totp token for MFA. 
     */
    "totpToken"?: string;
}

export interface ModelError {
    /**
     * A short error code that defines the error, meant for programmatic parsing. See [API Errors](/Content/API/References/apierrors.htm). 
     */
    "code": string;
    /**
     * A human-readable error string.
     */
    "message": string;
}

export interface MoveCompartmentDetails {
    /**
     * The [OCID](/Content/General/Concepts/identifiers.htm) of the destination compartment into which to move the compartment. 
     */
    "targetCompartmentId": string;
}

/**
 * Network policy, Consists of a list of Network Source ids. 
 */
export interface NetworkPolicy {
    /**
     * Network Source ids 
     */
    "networkSourceIds"?: Array<string>;
}

/**
 * A network source specifies a list of source IP addresses that are allowed to make authorization requests. Use the network source in policy statements to restrict access to only requests that come from the specified IPs. For more information, see [Managing Network Sources](/Content/Identity/Tasks/managingnetworksources.htm). 
 */
export interface NetworkSources {
    /**
     * The OCID of the network source.
     */
    "id": string;
    /**
     * The OCID of the tenancy containing the network source. The tenancy is the root compartment.
     */
    "compartmentId": string;
    /**
     * The name you assign to the network source during creation. The name must be unique across the tenancy and cannot be changed. 
     */
    "name": string;
    /**
     * The description you assign to the network source. Does not have to be unique, and it's changeable.
     */
    "description": string;
    /**
     * A list of allowed public IPs and CIDR ranges. 
     */
    "publicSourceList"?: Array<string>;
    /**
     * A list of allowed VCN OCID and IP range pairs. Example:`\"vcnId\": \"ocid1.vcn.oc1.iad.aaaaaaaaexampleuniqueID\", \"ipRanges\": [ \"129.213.39.0/24\" ]` 
     */
    "virtualSourceList"?: Array<NetworkSourcesVirtualSourceList>;
    /**
     * A list of services allowed to make on-behalf-of requests. These requests can have different source IPs than those specified in the network source. Currently, only `all` and `none` are supported. The default is `all`. 
     */
    "services"?: Array<string>;
    /**
     * Date and time the group was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
    /**
     * The network source object's current state. After creating a network source, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState": NetworkSourcesLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "inactiveStatus"?: number;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export type NetworkSourcesLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * A network source specifies a list of source IP addresses that are allowed to make authorization requests. Use the network source in policy statements to restrict access to only requests that come from the specified IPs. For more information, see [Managing Network Sources](/Content/Identity/Tasks/managingnetworksources.htm). 
 */
export interface NetworkSourcesSummary {
    /**
     * The OCID of the network source.
     */
    "id"?: string;
    /**
     * The OCID of the tenancy (root compartment) containing the network source.
     */
    "compartmentId"?: string;
    /**
     * The name you assign to the network source during creation. The name must be unique across the tenancy and cannot be changed. 
     */
    "name"?: string;
    /**
     * The description you assign to the network source. Does not have to be unique, and it's changeable.
     */
    "description"?: string;
    /**
     * A list of allowed public IP addresses and CIDR ranges. 
     */
    "publicSourceList"?: Array<string>;
    /**
     * A list of allowed VCN OCID and IP range pairs. Example:`\"vcnId\": \"ocid1.vcn.oc1.iad.aaaaaaaaexampleuniqueID\", \"ipRanges\": [ \"129.213.39.0/24\" ]` 
     */
    "virtualSourceList"?: Array<NetworkSourcesVirtualSourceList>;
    /**
     * A list of services allowed to make on-behalf-of requests. These requests can have different source IPs than those specified in the network source. Currently, only `all` and `none` are supported. The default is `all`. 
     */
    "services"?: Array<string>;
    /**
     * Date and time the group was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated"?: Date;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export interface NetworkSourcesVirtualSourceList {
    "vcnId"?: string;
    "ipRanges"?: Array<string>;
}

/**
 * User can define Oauth clients in IAM, then use it to generate a token to grant access to app resources. 
 */
export interface OAuth2ClientCredential {
    /**
     * Allowed scopes for the given oauth credential.
     */
    "scopes"?: Array<FullyQualifiedScope>;
    /**
     * Returned during create and update with password reset requests.
     */
    "password"?: string;
    /**
     * The OCID of the user the Oauth credential belongs to.
     */
    "userId"?: string;
    /**
     * Date and time when this credential will expire, in the format defined by RFC3339. Null if it never expires.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "expiresOn"?: Date;
    /**
     * The OCID of the Oauth credential.
     */
    "id"?: string;
    /**
     * The OCID of the compartment containing the Oauth credential.
     */
    "compartmentId"?: string;
    /**
     * The name of the Oauth credential.
     */
    "name"?: string;
    /**
     * The description of the Oauth credential.
     */
    "description"?: string;
    /**
     * The credential's current state. After creating a Oauth credential, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState"?: OAuth2ClientCredentialLifecycleStateEnum;
    /**
     * Date and time the `OAuth2ClientCredential` object was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated"?: Date;
}

export type OAuth2ClientCredentialLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * User can define Oauth clients in IAM, then use it to generate a token to grant access to app resources. 
 */
export interface OAuth2ClientCredentialSummary {
    /**
     * Allowed scopes for the given oauth credential.
     */
    "scopes"?: Array<FullyQualifiedScope>;
    /**
     * The OCID of the user the Oauth credential belongs to.
     */
    "userId"?: string;
    /**
     * Date and time when this credential will expire, in the format defined by RFC3339. Null if it never expires.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "expiresOn"?: Date;
    /**
     * The OCID of the Oauth credential.
     */
    "id"?: string;
    /**
     * The OCID of the compartment containing the Oauth credential.
     */
    "compartmentId"?: string;
    /**
     * The name of the Oauth credential.
     */
    "name"?: string;
    /**
     * The description of the Oauth credential.
     */
    "description"?: string;
    /**
     * The credential's current state. After creating a Oauth credential, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState"?: OAuth2ClientCredentialSummaryLifecycleStateEnum;
    /**
     * Date and time the `OAuth2ClientCredential` object was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated"?: Date;
}

export type OAuth2ClientCredentialSummaryLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * Identity OpenID Connect client which grants redirect URI whitelisting to an application 
 */
export interface OidcClient {
    /**
     * Unique identifier of the OIDC clent.
     */
    "id": string;
    /**
     * Human-readable OpenID Connect client display name.
     */
    "name": string;
    /**
     * Array of response types the OpenID Connect client is restricted to use.
     */
    "responseTypes": Array<string>;
    /**
     * Name of the service principal used for signing requests.
     */
    "servicePrincipalName": string;
    /**
     * Array of URIs where SOUP will redirect a user after successful authentication to tha app.
     */
    "redirectUris": Array<string>;
    /**
     * Array of domains where SOUP will redirect a user after successful authentication to the app.
     */
    "redirectDomains": Array<string>;
    /**
     * URI for a user to log out of the app.
     */
    "frontChannelLogoutUri": string;
    /**
     * Array of URIs where SOUP will redirect a user after logging out of the app.
     */
    "postLogoutRedirectUris": Array<string>;
    /**
     * Array of resources the access tokens grant access to.
     */
    "resources": Array<string>;
    /**
     * Array of affix-based registered redirect URI values.
     */
    "affixes"?: Array<AffixBasedUri>;
    /**
     * The OpenID Connect client object's current state. After creating a clent, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState": OidcClientLifecycleStateEnum;
}

export type OidcClientLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * Description of OnPremSite.
 */
export interface OnPremSite {
    /**
     * Unique OCID that is immutable on creation
     */
    "id": string;
    /**
     * OnPremSite name. It is unique and can not be renamed
     */
    "name"?: string;
    /**
     * Compartment OCID
     */
    "compartmentId": string;
    /**
     * OnPremSite description
     */
    "description"?: string;
    /**
     * The time when the OnPremSite was created. An RFC3339 formatted datetime string
     */
    "timeCreated"?: Date;
    /**
     * The time when OnPremSite was updated. An RFC3339 formatted datetime string
     */
    "timeUpdated"?: Date;
    /**
     * The OnPremSite's current state. 
     */
    "lifecycleState"?: OnPremSiteLifecycleStateEnum;
    "address"?: Address;
    /**
     * The contact information about the OnPremSite.
     */
    "contacts"?: Array<Contact>;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export type OnPremSiteLifecycleStateEnum = "ACTIVE" | "DELETING" | "DELETED";
/**
 * Collection of OnPremSite Summaries. 
 */
export interface OnPremSiteCollection {
    /**
     * Collection of OnPremSite Summaries.
     */
    "items": Array<OnPremSiteSummary>;
}

/**
 * Summary of the OnPremSite.
 */
export interface OnPremSiteSummary {
    /**
     * Unique identifier that is immutable on creation
     */
    "id": string;
    /**
     * OnPremSite name. It is unique and can not be renamed
     */
    "name"?: string;
    /**
     * Describe the OnPremSite
     */
    "description"?: string;
    /**
     * Compartment Identifier
     */
    "compartmentId": string;
    /**
     * The time the the OnPremSite was created. An RFC3339 formatted datetime string
     */
    "timeCreated"?: Date;
    /**
     * The time the OnPremSite was updated. An RFC3339 formatted datetime string
     */
    "timeUpdated"?: Date;
    /**
     * The current state of the OnPremSite
     */
    "lifecycleState"?: string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

/**
 * Password policy, currently set for the given compartment. 
 */
export interface PasswordPolicy {
    /**
     * Minimum password length required.
     */
    "minimumPasswordLength"?: number;
    /**
     * At least one uppercase character required.
     */
    "isUppercaseCharactersRequired"?: boolean;
    /**
     * At least one lower case character required.
     */
    "isLowercaseCharactersRequired"?: boolean;
    /**
     * At least one numeric character required.
     */
    "isNumericCharactersRequired"?: boolean;
    /**
     * At least one special character required.
     */
    "isSpecialCharactersRequired"?: boolean;
    /**
     * User name is allowed to be part of the password.
     */
    "isUsernameContainmentAllowed"?: boolean;
}

export interface PatchUpiGroupDetails {
    "idcsLastModifiedBy"?: IdcsLastModifiedBy;
    /**
     * DESCRIPTION
     */
    "tags"?: Array<UpiTags>;
}

export interface PatchUpiUserDetails {
    /**
     * The description you assign to the user. Does not have to be unique, and it's changeable.
     */
    "displayName"?: string;
    /**
     * DESCRIPTION
     */
    "password"?: string;
    /**
     * DESCRIPTION
     */
    "active"?: boolean;
    "idcsLastModifiedBy"?: IdcsLastModifiedBy;
    "name"?: UpiName;
    /**
     * DESCRIPTION
     */
    "title"?: string;
    /**
     * DESCRIPTION
     */
    "locale"?: string;
    /**
     * DESCRIPTION
     */
    "preferredLanguage"?: string;
    /**
     * DESCRIPTION
     */
    "timezone"?: string;
    /**
     * DESCRIPTION
     */
    "tags"?: Array<UpiTags>;
    "email"?: UpiEmail;
    /**
     * DESCRIPTION
     */
    "phoneNumbers"?: Array<UpiPhoneNumbers>;
    /**
     * DESCRIPTION
     */
    "photos"?: Array<UpiPhotos>;
    /**
     * DESCRIPTION
     */
    "addresses"?: Array<UpiAddresses>;
    /**
     * DESCRIPTION
     */
    "manager"?: string;
}

/**
 * If {@code metaverb} and {@code resourceKindName} are provided, an entry of all permission strings for the given resource for the given metaverb is returned as a list. If {@code resourceKindName} is provided, if a resource kind of that name exists, entries for that resource kind for all metaverbs are returned with permission strings grouped by metaverb. If {@code serviceName} is provided, if a service of that name exists, entries for all resource kinds that belong to that service for all metaverbs are returned with permission strings grouped by metaverb. If a {@code permissionString} is provided, entries that contain said permission string for any resource are returned. If no query parameter is provided or an unknown value for a parameter is provided, an empty list is returned. 
 */
export interface Permission {
    /**
     * The name of the resource.
     */
    "resourceKindName"?: string;
    /**
     * The permission for the resource.
     */
    "permissionString"?: string;
    /**
     * The metaverb for the resource.
     */
    "metaverb"?: string;
    /**
     * The name of the service.
     */
    "serviceName"?: string;
    /**
     * The metanoun for the resource.
     */
    "metanoun"?: string;
}

/**
 * A document that specifies the type of access a group has to the resources in a compartment. For information about policies and other IAM Service components, see [Overview of the IAM Service](/Content/Identity/Concepts/overview.htm). If you're new to policies, see [Getting Started with Policies](/Content/Identity/Concepts/policygetstarted.htm).  The word \"policy\" is used by people in different ways:    * An individual statement written in the policy language   * A collection of statements in a single, named \"policy\" document (which has an Oracle Cloud ID (OCID) assigned to it)   * The overall body of policies your organization uses to control access to resources  To use any of the API operations, you must be authorized in an IAM policy. If you're not authorized, talk to an administrator.  **Warning:** Oracle recommends that you avoid using any confidential information when you supply string values using the API. 
 */
export interface Policy {
    /**
     * The OCID of the policy.
     */
    "id": string;
    /**
     * The OCID of the compartment containing the policy (either the tenancy or another compartment). 
     */
    "compartmentId": string;
    /**
     * The name you assign to the policy during creation. The name must be unique across all policies in the tenancy and cannot be changed. 
     */
    "name": string;
    /**
     * An array of one or more policy statements written in the policy language.
     */
    "statements": Array<string>;
    /**
     * The description you assign to the policy. Does not have to be unique, and it's changeable.
     */
    "description": string;
    /**
     * Date and time the policy was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
    /**
     * The policy's current state. After creating a policy, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState": PolicyLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "inactiveStatus"?: number;
    /**
     * The version of the policy. If null or set to an empty string, when a request comes in for authorization, the policy will be evaluated according to the current behavior of the services at that moment. If set to a particular date (YYYY-MM-DD), the policy will be evaluated according to the behavior of the services on that date. 
     */
    "versionDate"?: Date;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export type PolicyLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * A localized geographic area, such as Phoenix, AZ. Oracle Cloud Infrastructure is hosted in regions and Availability Domains. A region is composed of several Availability Domains. An Availability Domain is one or more data centers located within a region. For more information, see [Regions and Availability Domains](/Content/General/Concepts/regions.htm).  To use any of the API operations, you must be authorized in an IAM policy. If you're not authorized, talk to an administrator. If you're an administrator who needs to write policies to give users access, see [Getting Started with Policies](/Content/Identity/Concepts/policygetstarted.htm). 
 */
export interface Region {
    /**
     * The key of the region. See [Regions and Availability Domains](/Content/General/Concepts/regions.htm) for the full list of supported 3-letter region codes.  Example: `PHX` 
     */
    "key"?: string;
    /**
     * The name of the region. See [Regions and Availability Domains](/Content/General/Concepts/regions.htm) for the full list of supported region names.  Example: `us-phoenix-1` 
     */
    "name"?: string;
}

/**
 * An object that represents your tenancy's access to a particular region (i.e., a subscription), the status of that access, and whether that region is the home region. For more information, see [Managing Regions](/Content/Identity/Tasks/managingregions.htm).  To use any of the API operations, you must be authorized in an IAM policy. If you're not authorized, talk to an administrator. If you're an administrator who needs to write policies to give users access, see [Getting Started with Policies](/Content/Identity/Concepts/policygetstarted.htm). 
 */
export interface RegionSubscription {
    /**
     * The region's key. See [Regions and Availability Domains](/Content/General/Concepts/regions.htm) for the full list of supported 3-letter region codes.  Example: `PHX` 
     */
    "regionKey": string;
    /**
     * The region's name. See [Regions and Availability Domains](/Content/General/Concepts/regions.htm) for the full list of supported region names.  Example: `us-phoenix-1` 
     */
    "regionName": string;
    /**
     * The region subscription status.
     */
    "status": RegionSubscriptionStatusEnum;
    /**
     * Indicates if the region is the home region or not.
     */
    "isHomeRegion": boolean;
}

export type RegionSubscriptionStatusEnum = "READY" | "IN_PROGRESS";
export interface RemoveUserFromIdpGroupDetails {
    /**
     * The id of the user.
     */
    "userId": string;
}

/**
 * Details for replicated default domain state to a region
 */
export interface ReplicateDefaultDomainToRegionDetails {
    /**
     * The replica region airport code. See [Regions and Availability Domains](/Content/General/Concepts/regions.htm) for the full list of supported region names.  Example: `phx`, `iad` 
     */
    "region": string;
    /**
     * The OCID of the root compartment where domain is created. MUST be tenancy OCID.
     */
    "tenantId": string;
}

/**
 * Properties for a region where a domain is replicated too.
 */
export interface ReplicatedRegionDetails {
    /**
     * A REPLICATION_ENABLED region, e.g. us-ashburn-1. See [Regions and Availability Domains](/Content/General/Concepts/regions.htm) for the full list of supported region names. 
     */
    "region"?: string;
    /**
     * Region agnostic domain URL.
     */
    "url"?: string;
    /**
     * The IDCS replicated region state 
     */
    "state"?: ReplicatedRegionDetailsStateEnum;
}

export type ReplicatedRegionDetailsStateEnum = "ENABLING_REPLICATION" | "REPLICATION_ENABLED" | "DISABLING_REPLICATION" | "REPLICATION_DISABLED" | "DELETED";
/**
 * The Internal representation of a Replication Log
 */
export interface ReplicationLog {
    /**
     * Key of replication Log.
     */
    "key"?: any;
    /**
     * Tenancy id.
     */
    "tenancyId"?: string;
    /**
     * Tenancy sequence number.
     */
    "tenancySequenceNumber"?: number;
    /**
     * Service name
     */
    "service"?: string;
    /**
     * Backfill flag for replication log
     */
    "backFill"?: string;
    /**
     * Row checksum
     */
    "rowChecksum"?: number;
    /**
     * Sequence checksum
     */
    "sequenceChecksum"?: number;
    /**
     * Action of replication log
     */
    "action"?: string;
    /**
     * Created On
     */
    "createdOn"?: number;
    /**
     * Transaction Id
     */
    "txnId"?: number;
    /**
     * Data checksum
     */
    "dataChecksum"?: number;
    /**
     * Data of the replication log
     */
    "data"?: string;
}

/**
 * The response object for replication/replicationLogs
 */
export interface ReplicationLogResult {
    /**
     * First sequence number of replication logs result being returned.
     */
    "firstSequenceNumberOnResult": number;
    /**
     * Last sequence number of replication logs result being returned.
     */
    "lastSequenceNumberOnResult": number;
    /**
     * Last sequence number in replication logs bucket.
     */
    "lastSequenceNumberInReplicationLogBucket": number;
    /**
     * List of replication log objects
     */
    "replicationLogs"?: Array<ReplicationLog>;
}

/**
 * Request to reset administrator password. 
 */
export interface ResetAdminPasswordDetails {
    /**
     * The name of the tenancy the administrator belongs to.
     */
    "tenantName": string;
    /**
     * The admin user name.
     */
    "userName": string;
    /**
     * The admin user email address.
     */
    "userEmail"?: string;
    /**
     * Whether to unblock a user who was locked out due to too many login failures. Defaults to `SKIP`. 
     */
    "unblock"?: ResetAdminPasswordDetailsUnblockEnum;
}

export type ResetAdminPasswordDetailsUnblockEnum = "SKIP" | "UNBLOCK_ONLY" | "ALWAYS_UNBLOCK";
/**
 * If {@code resourceKindName} is provided and a resource kind of that name exists, entries for that resource kind are returned. If {@code serviceName} is provided, if a service of that name exists, entries for all resource kinds are returned. If no query parameter is provided or an unknown value for a parameter is provided, an empty list is returned. 
 */
export interface ResourceKindSummary {
    /**
     * Flag to indicate if the service has been claimed.
     */
    "claimed"?: boolean;
    /**
     * The OCID of the compartment claiming the service.
     */
    "compartmentId"?: string;
    /**
     * List of metanouns for the resource.
     */
    "metaNouns"?: Array<string>;
    /**
     * The name of the resource.
     */
    "resourceKind"?: string;
    /**
     * The name of the service.
     */
    "service"?: string;
    /**
     * List of service name aliases.
     */
    "spellings"?: Array<string>;
}

/**
 * The OAuth2 client credentials. 
 */
export interface ScimClientCredentials {
    /**
     * The client identifier.
     */
    "clientId"?: string;
    /**
     * The client secret.
     */
    "clientSecret"?: string;
}

export interface SendPasswordResetRequest {
    /**
     * The validated email assigned to the user.
     */
    "email": string;
    /**
     * The name of the tenant the user belongs to.
     */
    "tenantName": string;
}

/**
 * Limit value in specific scope 
 */
export interface ServiceLimit {
    /**
     * Limit scope 
     */
    "scope"?: string;
    /**
     * Limit value 
     */
    "value"?: string;
}

/**
 * Regional and AD specific limit values 
 */
export interface ServiceLimits {
    /**
     * Limit label 
     */
    "label"?: string;
    /**
     * Limit name 
     */
    "name"?: string;
    /**
     * Scope type 
     */
    "limitScope"?: ServiceLimitsLimitScopeEnum;
    /**
     * List of limit values 
     */
    "limits"?: Array<ServiceLimit>;
}

export type ServiceLimitsLimitScopeEnum = "REGION" | "AVAILABILITY_DOMAIN";
/**
 * A service manager is a special type of principal to be used by a service. The original intended use case was to enable a service to call restricted APIs and access the customer tenancies where the customer explicitly allowed them via the cross-tenancy policy language. 
 */
export interface ServiceManager {
    /**
     * The name you assign to the service manager during creation. The name must be corresponded to your service name. Ensure this name matches the regex [0-9a-zA-Z_\\@\\-:\\.]+, Service names are realm-wide unique. 
     */
    "serviceName": string;
    /**
     * The OCID of the tenancy owns service manager 
     */
    "tenantId": string;
    /**
     * The key-value pair you assign to the service manager. A whitelisted service principal can have certain properties: - allowed_dg_for_s2s: This field is required if you are using instance certificates to get your S2S token of \"your service is located in the overlay or customer enclave.\" This is a dynamic group OCID in your service tenancy. - header_exempt: If you are going to make cross-tenancy calls, then set this property to True. - header_two_tenancy: Set this to True if you make cross-tenancy calls to an API that does resource association. - resource_types_allowed: Set this property if you are using your service principal to create resource principals. Multiple resource types should be delimited by a colon (:). 
     */
    "properties": { [key: string]: string; };
    /**
     * Set this if your service is in the Customer Enclave (CE) \"overlay\" and the tenancy physically hosting your service of \"your compute instances\" is different from your service tenancy. You may not set the hosting tenant ID if the allowed_dg_for_s2s property is not also set. Additionally, the corresponding tenancy of the hosting tenant ID must have the same cross-tenancy policy 
     */
    "hostingTenantId"?: string;
}

/**
 * Details for marking domain state as replicated
 */
export interface SetReplicationEnabledDetails {
    /**
     * The replica region name. See [Regions and Availability Domains](/Content/General/Concepts/regions.htm) for the full list of supported region names.  Example: `us-phoenix-1` 
     */
    "region": string;
}

/**
 * Simple Mail Transfer Protocol (SMTP) credentials are needed to send email through Email Delivery. The SMTP credentials are used for SMTP authentication with the service. The credentials never expire. A user can have up to 2 SMTP credentials at a time.  **Note:** The credential set is always an Oracle-generated SMTP user name and password pair; you cannot designate the SMTP user name or the SMTP password.  For more information, see [Managing User Credentials](/Content/Identity/Tasks/managingcredentials.htm#SMTP). 
 */
export interface SmtpCredential {
    /**
     * The SMTP user name. 
     */
    "username"?: string;
    /**
     * The SMTP password. 
     */
    "password"?: string;
    /**
     * The OCID of the SMTP credential.
     */
    "id"?: string;
    /**
     * The OCID of the user the SMTP credential belongs to.
     */
    "userId"?: string;
    /**
     * The description you assign to the SMTP credential. Does not have to be unique, and it's changeable.
     */
    "description"?: string;
    /**
     * Date and time the `SmtpCredential` object was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated"?: Date;
    /**
     * Date and time when this credential will expire, in the format defined by RFC3339. Null if it never expires.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeExpires"?: Date;
    /**
     * The credential's current state. After creating a SMTP credential, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState"?: SmtpCredentialLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "inactiveStatus"?: number;
}

export type SmtpCredentialLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * As the name suggests, an `SmtpCredentialSummary` object contains information about an `SmtpCredential`. The SMTP credential is used for SMTP authentication with the [Email Delivery Service](/Content/Email/Concepts/overview.htm). 
 */
export interface SmtpCredentialSummary {
    /**
     * The SMTP user name. 
     */
    "username"?: string;
    /**
     * The OCID of the SMTP credential.
     */
    "id"?: string;
    /**
     * The OCID of the user the SMTP credential belongs to.
     */
    "userId"?: string;
    /**
     * The description you assign to the SMTP credential. Does not have to be unique, and it's changeable.
     */
    "description"?: string;
    /**
     * Date and time the `SmtpCredential` object was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated"?: Date;
    /**
     * Date and time when this credential will expire, in the format defined by RFC3339. Null if it never expires.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeExpires"?: Date;
    /**
     * The credential's current state. After creating a SMTP credential, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState"?: SmtpCredentialSummaryLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "inactiveStatus"?: number;
}

export type SmtpCredentialSummaryLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * The template of the tag definition. This object includes necessary details to create the provided standard tag definition.
 */
export interface StandardTagDefinitionTemplate {
    /**
     * The default description of the tag namespace that users can use to create the tag definition
     */
    "description": string;
    /**
     * The name of this standard tag definition
     */
    "tagDefinitionName": string;
    /**
     * The type of tag definition. Enum or string.
     */
    "type": StandardTagDefinitionTemplateTypeEnum;
    /**
     * List of possible values. An optional parameter that will be present if the type of definition is enum.
     */
    "possibleValues"?: Array<string>;
    /**
     * Is the tag a cost tracking tag. Default will be false as cost tracking tags have been deprecated
     */
    "isCostTracking": boolean;
    /**
     * The mutability of the possible values list for enum tags. This will default to IMMUTABLE for string value tags
     */
    "enumMutability"?: StandardTagDefinitionTemplateEnumMutabilityEnum;
}

export type StandardTagDefinitionTemplateTypeEnum = "ENUM" | "STRING";
export type StandardTagDefinitionTemplateEnumMutabilityEnum = "IMMUTABLE" | "MUTABLE" | "APPENDABLE";
/**
 * The template of the standard tag namespace. This object includes necessary details to create the provided standard tag namespace.
 */
export interface StandardTagNamespaceTemplate {
    /**
     * The default description of the tag namespace that users can use to create the tag namespace
     */
    "description": string;
    /**
     * The reserved name of this standard tag namespace
     */
    "standardTagNamespaceName": string;
    /**
     * The template of the tag definition. This object includes necessary details to create the provided standard tag definition.
     */
    "tagDefinitionTemplates": Array<StandardTagDefinitionTemplate>;
    /**
     * The status of the standard tag namespace
     */
    "status": string;
}

/**
 * The template of the standard tag namespace. This object includes necessary details to create the provided standard tag namespace.
 */
export interface StandardTagNamespaceTemplateSummary {
    /**
     * The default description of the tag namespace that users can use to create the tag namespace
     */
    "description": string;
    /**
     * The reserved name of this standard tag namespace
     */
    "standardTagNamespaceName": string;
    /**
     * The status of the standard tag namespace
     */
    "status": string;
}

/**
 * IDCS Compatibility Layer context for a given region.  As part of the migration to a unified cloud platform identity system, this IDCS Compatibility Layer will support SAAS and PAAS services that have a reliance on IDCS.  Until all the services migrated to native OCI IAM, this will ensure compatibility by implementing the IDCS SCIM APIs and translating those requests into OCI IAM native requests. 
 */
export interface Stripe {
    /**
     * The region of the stripe.
     */
    "region": string;
    /**
     * Unique url for the stripe context of the Tenant using the Tenant's name.
     */
    "friendlyUrl": string;
    /**
     * Unique url for the stripe context of the Tenant using the Tenant's service instance GUID.
     */
    "instanceUrl": string;
    /**
     * Url for the regional IDCS compatibility layer.
     */
    "permanentUrl": string;
    /**
     * Unique GUID for identifying this stripe context.
     */
    "serviceInstanceGuid": string;
}

/**
 * This is the base object indicating who is the support provider, and what is the userId within the support provider. 
 */
export interface SupportAccount {
    /**
     * The userID used within a support provider.
     */
    "supportUserID": string;
    /**
     * The name of the support provider. 
     */
    "supportProvider": SupportAccountSupportProviderEnum;
}

export type SupportAccountSupportProviderEnum = "MOS";
/**
 * The support accounts that an OCI user can links to. An OCI user may links to different `SupportAccount`s from different support provider. The OCI user can only link to one support account from a a particular support provider. 
 */
export interface SupportAccounts {
    "mos"?: MosSupportAccount;
}

/**
 * **Deprecated. Use [AuthToken](#/en/identity/20160918/AuthToken/) instead.**  Swift is the OpenStack object storage service. A `SwiftPassword` is an Oracle-provided password for using a Swift client with the Object Storage Service. This password is associated with the user's Console login. Swift passwords never expire. A user can have up to two Swift passwords at a time.  **Note:** The password is always an Oracle-generated string; you can't change it to a string of your choice.  For more information, see [Managing User Credentials](/Content/Identity/Tasks/managingcredentials.htm). 
 */
export interface SwiftPassword {
    /**
     * The Swift password. The value is available only in the response for `CreateSwiftPassword`, and not for `ListSwiftPasswords` or `UpdateSwiftPassword`. 
     */
    "password"?: string;
    /**
     * The OCID of the Swift password.
     */
    "id"?: string;
    /**
     * The OCID of the user the password belongs to.
     */
    "userId"?: string;
    /**
     * The description you assign to the Swift password. Does not have to be unique, and it's changeable.
     */
    "description"?: string;
    /**
     * Date and time the `SwiftPassword` object was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated"?: Date;
    /**
     * Date and time when this password will expire, in the format defined by RFC3339. Null if it never expires.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "expiresOn"?: Date;
    /**
     * The password's current state. After creating a password, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState"?: SwiftPasswordLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "inactiveStatus"?: number;
}

export type SwiftPasswordLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * A tag definition that belongs to a specific tag namespace.  \"Defined tags\" must be set up in your tenancy before you can apply them to resources. For more information, see [Managing Tags and Tag Namespaces](/Content/Identity/Concepts/taggingoverview.htm).  **Warning:** Oracle recommends that you avoid using any confidential information when you supply string values using the API. 
 */
export interface Tag {
    /**
     * The OCID of the compartment that contains the tag definition.
     */
    "compartmentId": string;
    /**
     * The OCID of the namespace that contains the tag definition.
     */
    "tagNamespaceId": string;
    /**
     * The name of the tag namespace that contains the tag definition. 
     */
    "tagNamespaceName": string;
    /**
     * The OCID of the tag definition.
     */
    "id": string;
    /**
     * The name assigned to the tag during creation. This is the tag key definition. The name must be unique within the tag namespace and cannot be changed. 
     */
    "name": string;
    /**
     * The description you assign to the tag.
     */
    "description": string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm).  Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm).  Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
    /**
     * Indicates whether the tag is retired. See [Retiring Key Definitions and Namespace Definitions](/Content/Identity/Concepts/taggingoverview.htm#Retiring). 
     */
    "isRetired": boolean;
    /**
     * The tag's current state. After creating a tag, make sure its `lifecycleState` is ACTIVE before using it. After retiring a tag, make sure its `lifecycleState` is INACTIVE before using it. If you delete a tag, you cannot delete another tag until the deleted tag's `lifecycleState` changes from DELETING to DELETED.
     */
    "lifecycleState"?: TagLifecycleStateEnum;
    /**
     * Date and time the tag was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
    /**
     * Indicates whether the tag is enabled for cost tracking. 
     */
    "isCostTracking"?: boolean;
    "validator"?: BaseTagDefinitionValidator;
}

export type TagLifecycleStateEnum = "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * Tag defaults let you specify a default tag (tagnamespace.tag=\"value\") to apply to all resource types in a specified compartment. The tag default is applied at the time the resource is created. Resources that exist in the compartment before you create the tag default are not tagged. The `TagDefault` object specifies the tag and compartment details.  Tag defaults are inherited by child compartments. This means that if you set a tag default on the root compartment for a tenancy, all resources that are created in the tenancy are tagged. For more information about using tag defaults, see [Managing Tag Defaults](/Content/Identity/Tasks/managingtagdefaults.htm).  To use any of the API operations, you must be authorized in an IAM policy. If you're not authorized, talk to an administrator. 
 */
export interface TagDefault {
    /**
     * The OCID of the tag default.
     */
    "id": string;
    /**
     * The OCID of the compartment. The tag default applies to all new resources that get created in the compartment. Resources that existed before the tag default was created are not tagged. 
     */
    "compartmentId": string;
    /**
     * The OCID of the tag namespace that contains the tag definition. 
     */
    "tagNamespaceId": string;
    /**
     * The OCID of the tag definition. The tag default will always assign a default value for this tag definition. 
     */
    "tagDefinitionId": string;
    /**
     * The name used in the tag definition. This field is informational in the context of the tag default. 
     */
    "tagDefinitionName": string;
    /**
     * The default value for the tag definition. This will be applied to all resources created in the compartment. 
     */
    "value": string;
    /**
     * Date and time the `TagDefault` object was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
    /**
     * The tag default's current state. After creating a `TagDefault`, make sure its `lifecycleState` is ACTIVE before using it. 
     */
    "lifecycleState"?: TagDefaultLifecycleStateEnum;
    /**
     * If you specify that a value is required, a value is set during resource creation (either by the user creating the resource or another tag defualt). If no value is set, resource creation is blocked.  * If the `isRequired` flag is set to \"true\", the value is set during resource creation. * If the `isRequired` flag is set to \"false\", the value you enter is set during resource creation.  Example: `false` 
     */
    "isRequired": boolean;
}

export type TagDefaultLifecycleStateEnum = "ACTIVE";
/**
 * Summary information for the specified tag default. 
 */
export interface TagDefaultSummary {
    /**
     * The OCID of the tag default.
     */
    "id": string;
    /**
     * The OCID of the compartment. The tag default will apply to all new resources that are created in the compartment. 
     */
    "compartmentId": string;
    /**
     * The OCID of the tag namespace that contains the tag definition. 
     */
    "tagNamespaceId": string;
    /**
     * The OCID of the tag definition. The tag default will always assign a default value for this tag definition. 
     */
    "tagDefinitionId": string;
    /**
     * The name used in the tag definition. This field is informational in the context of the tag default. 
     */
    "tagDefinitionName": string;
    /**
     * The default value for the tag definition. This will be applied to all new resources created in the compartment. 
     */
    "value": string;
    /**
     * Date and time the `TagDefault` object was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
    /**
     * The tag default's current state. After creating a `TagDefault`, make sure its `lifecycleState` is ACTIVE before using it. 
     */
    "lifecycleState"?: TagDefaultSummaryLifecycleStateEnum;
    /**
     * If you specify that a value is required, a value is set during resource creation (either by the user creating the resource or another tag defualt). If no value is set, resource creation is blocked.  * If the `isRequired` flag is set to \"true\", the value is set during resource creation. * If the `isRequired` flag is set to \"false\", the value you enter is set during resource creation.  Example: `false` 
     */
    "isRequired": boolean;
}

export type TagDefaultSummaryLifecycleStateEnum = "ACTIVE";
/**
 * A managed container for defined tags. A tag namespace is unique in a tenancy. For more information, see [Managing Tags and Tag Namespaces](/Content/Identity/Concepts/taggingoverview.htm).  **Warning:** Oracle recommends that you avoid using any confidential information when you supply string values using the API. 
 */
export interface TagNamespace {
    /**
     * The OCID of the tag namespace.
     */
    "id": string;
    /**
     * The OCID of the compartment that contains the tag namespace.
     */
    "compartmentId": string;
    /**
     * The name of the tag namespace. It must be unique across all tag namespaces in the tenancy and cannot be changed. 
     */
    "name": string;
    /**
     * The description you assign to the tag namespace.
     */
    "description": string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
    /**
     * Whether the tag namespace is retired. See [Retiring Key Definitions and Namespace Definitions](/Content/Identity/Concepts/taggingoverview.htm#Retiring). 
     */
    "isRetired": boolean;
    /**
     * The tagnamespace's current state. After creating a tagnamespace, make sure its `lifecycleState` is ACTIVE before using it. After retiring a tagnamespace, make sure its `lifecycleState` is INACTIVE before using it.
     */
    "lifecycleState"?: TagNamespaceLifecycleStateEnum;
    /**
     * Date and time the tagNamespace was created, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
}

export type TagNamespaceLifecycleStateEnum = "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * A container for defined tags. 
 */
export interface TagNamespaceSummary {
    /**
     * The OCID of the tag namespace.
     */
    "id"?: string;
    /**
     * The OCID of the compartment that contains the tag namespace.
     */
    "compartmentId"?: string;
    /**
     * The name of the tag namespace. It must be unique across all tag namespaces in the tenancy and cannot be changed. 
     */
    "name"?: string;
    /**
     * The description you assign to the tag namespace.
     */
    "description"?: string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
    /**
     * Whether the tag namespace is retired. For more information, see [Retiring Key Definitions and Namespace Definitions](/Content/Identity/Concepts/taggingoverview.htm#Retiring). 
     */
    "isRetired"?: boolean;
    /**
     * The tagnamespace's current state. After creating a tagnamespace, make sure its `lifecycleState` is ACTIVE before using it. After retiring a tagnamespace, make sure its `lifecycleState` is INACTIVE before using it.
     */
    "lifecycleState"?: string;
    /**
     * Date and time the tag namespace was created, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated"?: Date;
}

/**
 * A tag definition that belongs to a specific tag namespace. 
 */
export interface TagSummary {
    /**
     * The OCID of the compartment that contains the tag definition.
     */
    "compartmentId"?: string;
    /**
     * The OCID of the tag definition.
     */
    "id"?: string;
    /**
     * The name assigned to the tag during creation. This is the tag key definition. The name must be unique within the tag namespace and cannot be changed. 
     */
    "name"?: string;
    /**
     * The description you assign to the tag.
     */
    "description"?: string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
    /**
     * Whether the tag is retired. See [Retiring Key Definitions and Namespace Definitions](/Content/Identity/Concepts/taggingoverview.htm#Retiring). 
     */
    "isRetired"?: boolean;
    /**
     * The tag's current state. After creating a tag, make sure its `lifecycleState` is ACTIVE before using it. After retiring a tag, make sure its `lifecycleState` is INACTIVE before using it. If you delete a tag, you cannot delete another tag until the deleted tag's `lifecycleState` changes from DELETING to DELETED.
     */
    "lifecycleState"?: string;
    /**
     * Date and time the tag was created, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated"?: Date;
    /**
     * Indicates whether the tag is enabled for cost tracking. 
     */
    "isCostTracking"?: boolean;
    /**
     * The OCID of the namespace that contains the tag definition.
     */
    "tagNamespaceId"?: string;
    /**
     * The name of the tag namespace that contains the tag definition. 
     */
    "tagNamespaceName"?: string;
}

/**
 * The asynchronous API request does not take effect immediately. This request spawns an asynchronous workflow to fulfill the request. WorkRequest objects provide visibility for in-progress workflows. 
 */
export interface TaggingWorkRequest {
    /**
     * The OCID of the work request.
     */
    "id": string;
    /**
     * An enum-like description of the type of work the work request is doing.
     */
    "operationType": TaggingWorkRequestOperationTypeEnum;
    /**
     * The OCID of the compartment that contains the work request.
     */
    "compartmentId"?: string;
    /**
     * The current status of the work request.
     */
    "status": TaggingWorkRequestStatusEnum;
    /**
     * The resources this work request affects. 
     */
    "resources"?: Array<WorkRequestResource>;
    /**
     * Date and time the work was accepted, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeAccepted"?: Date;
    /**
     * Date and time the work started, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeStarted"?: Date;
    /**
     * Date and time the work completed, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeFinished"?: Date;
    /**
     * How much progress the operation has made. 
     */
    "percentComplete"?: number;
}

export type TaggingWorkRequestOperationTypeEnum = "DELETE_TAG_DEFINITION" | "DELETE_NON_EMPTY_TAG_NAMESPACE" | "BULK_DELETE_TAG_DEFINITION" | "BULK_EDIT_OF_TAGS" | "BULK_IMPORT_STANDARD_TAG_NAMESPACES";
export type TaggingWorkRequestStatusEnum = "ACCEPTED" | "IN_PROGRESS" | "FAILED" | "SUCCEEDED" | "PARTIALLY_SUCCEEDED" | "CANCELING" | "CANCELED";
/**
 * The error entity. 
 */
export interface TaggingWorkRequestErrorSummary {
    /**
     * A machine-usable code for the error that occured.
     */
    "code": string;
    /**
     * A human-readable error string.
     */
    "message": string;
    /**
     * Date and time the error happened, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timestamp"?: Date;
}

/**
 * The log entity. 
 */
export interface TaggingWorkRequestLogSummary {
    /**
     * A human-readable error string.
     */
    "message": string;
    /**
     * Date and time the log was written, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timestamp"?: Date;
}

/**
 * The work request summary. Tracks the status of the asynchronous operation. 
 */
export interface TaggingWorkRequestSummary {
    /**
     * The OCID of the work request.
     */
    "id": string;
    /**
     * An enum-like description of the type of work the work request is doing.
     */
    "operationType": TaggingWorkRequestSummaryOperationTypeEnum;
    /**
     * The OCID of the compartment that contains the work request.
     */
    "compartmentId"?: string;
    /**
     * The current status of the work request.
     */
    "status": TaggingWorkRequestSummaryStatusEnum;
    /**
     * The resources this work request affects. 
     */
    "resources"?: Array<WorkRequestResource>;
    /**
     * Date and time the work was accepted, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeAccepted"?: Date;
    /**
     * Date and time the work started, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeStarted"?: Date;
    /**
     * Date and time the work completed, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeFinished"?: Date;
    /**
     * How much progress the operation has made. 
     */
    "percentComplete"?: number;
}

export type TaggingWorkRequestSummaryOperationTypeEnum = "DELETE_TAG_DEFINITION" | "DELETE_NON_EMPTY_TAG_NAMESPACE" | "BULK_DELETE_TAG_DEFINITION" | "BULK_EDIT_OF_TAGS" | "BULK_IMPORT_STANDARD_TAG_NAMESPACES";
export type TaggingWorkRequestSummaryStatusEnum = "ACCEPTED" | "IN_PROGRESS" | "FAILED" | "SUCCEEDED" | "PARTIALLY_SUCCEEDED" | "CANCELING" | "CANCELED";
/**
 * The root compartment that contains all of your organization's compartments and other Oracle Cloud Infrastructure cloud resources. When you sign up for Oracle Cloud Infrastructure, Oracle creates a tenancy for your company, which is a secure and isolated partition where you can create, organize, and administer your cloud resources.  To use any of the API operations, you must be authorized in an IAM policy. If you're not authorized, talk to an administrator. If you're an administrator who needs to write policies to give users access, see [Getting Started with Policies](/Content/Identity/Concepts/policygetstarted.htm). 
 */
export interface Tenancy {
    /**
     * The OCID of the tenancy.
     */
    "id"?: string;
    /**
     * The name of the tenancy.
     */
    "name"?: string;
    /**
     * The description of the tenancy.
     */
    "description"?: string;
    /**
     * The region key for the tenancy's home region. For the full list of supported regions, see [Regions and Availability Domains](/Content/General/Concepts/regions.htm).  Example: `PHX` 
     */
    "homeRegionKey"?: string;
    /**
     * OracleMyServicesIdentifier is Oracle MyServices Cloud Account Identifier.
     */
    "oracleMyServicesIdentifier"?: string;
    /**
     * Url which refers to the UPI IDCS compatibility layer endpoint configured for this Tenant's home region.
     */
    "upiIdcsCompatibilityLayerEndpoint"?: string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

/**
 * A text password that enables a user to sign in to the Console, the user interface for interacting with Oracle Cloud Infrastructure.  For more information about user credentials, see [User Credentials](/Content/Identity/Concepts/usercredentials.htm). 
 */
export interface UIPassword {
    /**
     * The user's password for the Console.
     */
    "password"?: string;
    /**
     * The OCID of the user.
     */
    "userId"?: string;
    /**
     * Date and time the password was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated"?: Date;
    /**
     * The password's current state. After creating a password, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState"?: UIPasswordLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "inactiveStatus"?: number;
}

export type UIPasswordLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * Information about the UIPassword, which is a text password that enables a user to sign in to the Console, the user interface for interacting with Oracle Cloud Infrastructure.  For more information about user credentials, see [User Credentials](/Content/Identity/Concepts/usercredentials.htm). 
 */
export interface UIPasswordInformation {
    /**
     * The OCID of the user.
     */
    "userId"?: string;
    /**
     * Date and time the password was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated"?: Date;
    /**
     * The password's current state. After creating a password, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState"?: UIPasswordInformationLifecycleStateEnum;
}

export type UIPasswordInformationLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * Request object to unlink a support account. 
 */
export interface UnlinkSupportAccountDetails {
    /**
     * The name of the support provider 
     */
    "supportProvider"?: string;
}

export interface UpdateAuthTokenDetails {
    /**
     * The description you assign to the auth token. Does not have to be unique, and it's changeable.
     */
    "description"?: string;
}

/**
 * Update request for authentication policy, describes set of validation rules and their parameters to be updated. 
 */
export interface UpdateAuthenticationPolicyDetails {
    "passwordPolicy"?: PasswordPolicy;
    "networkPolicy"?: NetworkPolicy;
}

export interface UpdateAuthenticationRecordDetails {
    /**
     * The OCID of the user. Either userId must be set or both userName and tenantName.
     */
    "userId"?: string;
    /**
     * The name of the user. Either userId must be set or both userName and tenantName.
     */
    "userName"?: string;
    /**
     * The name of the tenant the user belongs to. Either userId must be set or both userName and tenantName.
     */
    "tenantName"?: string;
    /**
     * Authentication type (SOUP_LOGIN, SWIFT_LOGIN, API_LOGIN, DB_LOGIN)
     */
    "authenticationType": string;
    /**
     * Is authentication success
     */
    "isAuthenticationSuccess": boolean;
    /**
     * Last successful login timestamp.
     */
    "lastSuccessfulLoginTimestamp": number;
}

export interface UpdateCompartmentDetails {
    /**
     * The description you assign to the compartment. Does not have to be unique, and it's changeable.
     */
    "description"?: string;
    /**
     * The new name you assign to the compartment. The name must be unique across all compartments in the parent compartment. Avoid entering confidential information. 
     */
    "name"?: string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export interface UpdateCustomerSecretKeyDetails {
    /**
     * The description you assign to the secret key. Does not have to be unique, and it's changeable.
     */
    "displayName"?: string;
}

/**
 * Update domain details
 */
export interface UpdateDomainDetails {
    /**
     * The domain description
     */
    "description"?: string;
    /**
     * The mutable display name of the domain
     */
    "displayName"?: string;
    /**
     * Indicates whether domain is hidden on login screen or not. 
     */
    "isHiddenOnLogin"?: boolean;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

/**
 * Properties for updating a dynamic group.
 */
export interface UpdateDynamicGroupDetails {
    /**
     * The description you assign to the dynamic group. Does not have to be unique, and it's changeable.
     */
    "description"?: string;
    /**
     * The matching rule to dynamically match an instance certificate to this dynamic group. For rule syntax, see [Managing Dynamic Groups](/Content/Identity/Tasks/managingdynamicgroups.htm). 
     */
    "matchingRule"?: string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export interface UpdateGroupDetails {
    /**
     * The description you assign to the group. Does not have to be unique, and it's changeable.
     */
    "description"?: string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export interface UpdateIdentityProviderDetails {
    /**
     * The protocol used for federation.  Example: `SAML2` 
     */
    "protocol": UpdateIdentityProviderDetailsProtocolEnum;
    /**
     * The description you assign to the `IdentityProvider`. Does not have to be unique, and it's changeable. 
     */
    "description"?: string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export type UpdateIdentityProviderDetailsProtocolEnum = "SAML2";
export interface UpdateIdpGroupMappingDetails {
    /**
     * The idp group name.
     */
    "idpGroupName"?: string;
    /**
     * The OCID of the group.
     */
    "groupId"?: string;
}

export interface UpdateNetworkSourceDetails {
    /**
     * The description you assign to the network source. Does not have to be unique, and it's changeable.
     */
    "description"?: string;
    /**
     * A list of allowed public IP addresses and CIDR ranges. 
     */
    "publicSourceList"?: Array<string>;
    /**
     * A list of allowed VCN OCID and IP range pairs. Example:`\"vcnId\": \"ocid1.vcn.oc1.iad.aaaaaaaaexampleuniqueID\", \"ipRanges\": [ \"129.213.39.0/24\" ]` 
     */
    "virtualSourceList"?: Array<NetworkSourcesVirtualSourceList>;
    /**
     * A list of services allowed to make on-behalf-of requests. These requests can have different source IPs than those specified in the network source. Currently, only `all` and `none` are supported. The default is `all`. 
     */
    "services"?: Array<string>;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export interface UpdateOAuth2ClientCredentialDetails {
    /**
     * Description of the oauth credential to help user differentiate them.
     */
    "description": string;
    /**
     * Allowed scopes for the given oauth credential.
     */
    "scopes": Array<FullyQualifiedScope>;
    /**
     * Indicate if the password to be reset or not in the update.
     */
    "isResetPassword"?: boolean;
}

/**
 * OpenID Connect Client metadata that can be updated. For any property not specified, old value will be kept. 
 */
export interface UpdateOidcClientDetails {
    /**
     * Human-readable OpenID Connect client display name.
     */
    "name"?: string;
    /**
     * Array of response types the OpenID Connect client is restricted to use.
     */
    "responseTypes"?: Array<string>;
    /**
     * Name of the service principal used for signing requests.
     */
    "servicePrincipalName"?: string;
    /**
     * Array of URIs where SOUP will redirect a user after successful authentication to tha app.
     */
    "redirectUris"?: Array<string>;
    /**
     * Array of domains where SOUP will redirect a user after successful authentication to the app.
     */
    "redirectDomains"?: Array<string>;
    /**
     * URI for a user to log out of the app.
     */
    "frontChannelLogoutUri"?: string;
    /**
     * Array of URIs where SOUP will redirect a user after logging out of the app.
     */
    "postLogoutRedirectUris"?: Array<string>;
    /**
     * Array of resources the access tokens grant access to.
     */
    "resources"?: Array<string>;
    /**
     * Array of affix-based registered redirect URI values.
     */
    "affixes"?: Array<AffixBasedUri>;
}

/**
 * The information to be updated.
 */
export interface UpdateOnPremSiteDetails {
    "address"?: Address;
    /**
     * The contact information about the OnPremSite.
     */
    "contacts"?: Array<Contact>;
    /**
     * The description you assign to the OnPremSite during creation
     */
    "description"?: string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export interface UpdatePolicyDetails {
    /**
     * The description you assign to the policy. Does not have to be unique, and it's changeable.
     */
    "description"?: string;
    /**
     * An array of policy statements written in the policy language. See [How Policies Work](/Content/Identity/Concepts/policies.htm) and [Common Policies](/Content/Identity/Concepts/commonpolicies.htm). 
     */
    "statements"?: Array<string>;
    /**
     * The version of the policy. If null or set to an empty string, when a request comes in for authorization, the policy will be evaluated according to the current behavior of the services at that moment. If set to a particular date (YYYY-MM-DD), the policy will be evaluated according to the behavior of the services on that date. 
     */
    "versionDate"?: Date;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

/**
 * Metadata to update a service manager. 
 */
export interface UpdateServiceManagerDetails {
    /**
     * The new name of the service manager.
     */
    "serviceName"?: string;
    /**
     * The CM link for updating service manager.
     */
    "cmLink": string;
    /**
     * The team's alias email.
     */
    "ownerEmail"?: string;
    /**
     * The tenancy id physically hosting your service manager.
     */
    "hostingTenantId"?: string;
    /**
     * The OCID of the tenant that is already associated with your service name.
     */
    "associatedTenantId"?: string;
    /**
     * Override duplicate.
     */
    "overrideDuplicate"?: boolean;
    /**
     * key-value pair of the service manager.
     */
    "properties"?: { [key: string]: string; };
}

export interface UpdateSmtpCredentialDetails {
    /**
     * The description you assign to the SMTP credential. Does not have to be unique, and it's changeable.
     */
    "description"?: string;
}

export interface UpdateStateDetails {
    /**
     * Update state to blocked or unblocked. Only \"false\" is supported (for changing the state to unblocked). 
     */
    "blocked"?: boolean;
}

export interface UpdateSwiftPasswordDetails {
    /**
     * The description you assign to the Swift password. Does not have to be unique, and it's changeable.
     */
    "description"?: string;
}

export interface UpdateTagDefaultDetails {
    /**
     * The default value for the tag definition. This will be applied to all resources created in the Compartment. 
     */
    "value": string;
    /**
     * If you specify that a value is required, a value is set during resource creation (either by the user creating the resource or another tag defualt). If no value is set, resource creation is blocked.  * If the `isRequired` flag is set to \"true\", the value is set during resource creation. * If the `isRequired` flag is set to \"false\", the value you enter is set during resource creation.  Example: `false` 
     */
    "isRequired"?: boolean;
}

export interface UpdateTagDetails {
    /**
     * The description you assign to the tag during creation.
     */
    "description"?: string;
    /**
     * Whether the tag is retired. See [Retiring Key Definitions and Namespace Definitions](/Content/Identity/Concepts/taggingoverview.htm#Retiring). 
     */
    "isRetired"?: boolean;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm).  Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm).  Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
    /**
     * Indicates whether the tag is enabled for cost tracking. 
     */
    "isCostTracking"?: boolean;
    "validator"?: BaseTagDefinitionValidator;
}

export interface UpdateTagNamespaceDetails {
    /**
     * The description you assign to the tag namespace.
     */
    "description"?: string;
    /**
     * Whether the tag namespace is retired. See [Retiring Key Definitions and Namespace Definitions](/Content/Identity/Concepts/taggingoverview.htm#Retiring). 
     */
    "isRetired"?: boolean;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

/**
 * Update Tas domain details
 */
export interface UpdateTasDomainDetails {
    /**
     * The domain description
     */
    "description"?: string;
    /**
     * The mutable display name of the domain
     */
    "displayName"?: string;
    /**
     * Indicates whether domain is hidden on login screen or not. 
     */
    "isHiddenOnLogin"?: boolean;
    /**
     * entitlement Id of the service
     */
    "opcServiceEntitlementId"?: string;
    /**
     * Cloud Account id
     */
    "tasAccountGuid"?: string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
    /**
     * My Services URL
     */
    "myServicesUrl"?: string;
    /**
     * The admin password
     */
    "adminPassword"?: string;
    /**
     * Base64 encoded keystore of tenant
     */
    "keyStore"?: string;
    /**
     * To decrypt the keystore passed in the payload
     */
    "keyStorePassword"?: string;
    /**
     * Base64 encoded signingKey of tenant in JWK format
     */
    "signingKeyAsJwk"?: string;
    /**
     * Admin User Prompt Password Change Flag
     */
    "isPromptPasswordChange"?: boolean;
    /**
     * To identify if the order is promotional or not
     */
    "isPromotion"?: string;
    /**
     * The source of the order Eg- GSI, CLOUD_PORTAL etc
     */
    "orderSource"?: string;
    /**
     * To identify if it's a Fusion Apps order type
     */
    "purpose"?: string;
}

export interface UpdateUiPasswordDetails {
    /**
     * The current password of the user.
     */
    "currentPassword"?: string;
    /**
     * The new password of the user.
     */
    "newPassword": string;
    /**
     * The reset token sent by email.
     */
    "resetToken"?: string;
}

export interface UpdateUpiGroupDetails {
    "idcsLastModifiedBy"?: IdcsLastModifiedBy;
    /**
     * DESCRIPTION
     */
    "tags"?: Array<UpiTags>;
}

export interface UpdateUpiUserDetails {
    /**
     * The description you assign to the user. Does not have to be unique, and it's changeable.
     */
    "displayName"?: string;
    /**
     * DESCRIPTION
     */
    "password"?: string;
    /**
     * DESCRIPTION
     */
    "active"?: boolean;
    "idcsLastModifiedBy"?: IdcsLastModifiedBy;
    "name"?: UpiName;
    /**
     * DESCRIPTION
     */
    "title"?: string;
    /**
     * DESCRIPTION
     */
    "locale"?: string;
    /**
     * DESCRIPTION
     */
    "preferredLanguage"?: string;
    /**
     * DESCRIPTION
     */
    "timezone"?: string;
    /**
     * DESCRIPTION
     */
    "tags"?: Array<UpiTags>;
    "email"?: UpiEmail;
    /**
     * DESCRIPTION
     */
    "phoneNumbers"?: Array<UpiPhoneNumbers>;
    /**
     * DESCRIPTION
     */
    "photos"?: Array<UpiPhotos>;
    /**
     * DESCRIPTION
     */
    "addresses"?: Array<UpiAddresses>;
    /**
     * DESCRIPTION
     */
    "manager"?: string;
}

export interface UpdateUserCapabilitiesDetails {
    /**
     * Indicates if the user can log in to the console. 
     */
    "canUseConsolePassword"?: boolean;
    /**
     * Indicates if the user can use API keys. 
     */
    "canUseApiKeys"?: boolean;
    /**
     * Indicates if the user can use SWIFT passwords / auth tokens. 
     */
    "canUseAuthTokens"?: boolean;
    /**
     * Indicates if the user can use SMTP passwords. 
     */
    "canUseSmtpCredentials"?: boolean;
    /**
     * Indicates if the user can use DB passwords. 
     */
    "canUseDbCredentials"?: boolean;
    /**
     * Indicates if the user can use SigV4 symmetric keys. 
     */
    "canUseCustomerSecretKeys"?: boolean;
    /**
     * Indicates if the user can use OAuth2 credentials and tokens. 
     */
    "canUseOAuth2ClientCredentials"?: boolean;
}

export interface UpdateUserDetails {
    /**
     * The description you assign to the user. Does not have to be unique, and it's changeable.
     */
    "description"?: string;
    /**
     * The email address you assign to the user. Has to be unique across the tenancy.
     */
    "email"?: string;
    /**
     * DB username of the DB credential. Has to be unique across the tenancy.
     */
    "dbUserName"?: string;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
}

export interface UpiAddresses {
    /**
     * DESCRIPTION
     */
    "type"?: string;
    /**
     * DESCRIPTION
     */
    "formatted"?: string;
    /**
     * DESCRIPTION
     */
    "streetAddress"?: string;
    /**
     * DESCRIPTION
     */
    "locality"?: string;
    /**
     * DESCRIPTION
     */
    "region"?: string;
    /**
     * DESCRIPTION
     */
    "postalCode"?: string;
    /**
     * DESCRIPTION
     */
    "country"?: string;
    /**
     * DESCRIPTION
     */
    "primary"?: boolean;
}

export interface UpiEmail {
    /**
     * DESCRIPTION
     */
    "value"?: string;
    /**
     * DESCRIPTION
     */
    "verified"?: boolean;
    /**
     * DESCRIPTION
     */
    "type"?: string;
}

/**
 * The Internal representation of a Group for UPI compatibility: https://confluence.oci.oraclecorp.com/display/ID/User%2C+Group+and+Tenant+Schema+Extension+Design+Doc 
 */
export interface UpiGroup {
    /**
     * The IDCS id of the group.
     */
    "id": string;
    /**
     * The OCID of the group.
     */
    "ocid"?: string;
    /**
     * DESCRIPTION
     */
    "displayName"?: string;
    "idcsCreatedBy"?: IdcsCreatedBy;
    "idcsLastModifiedBy"?: IdcsLastModifiedBy;
    /**
     * DESCRIPTION
     */
    "tags"?: Array<UpiTags>;
    /**
     * The UPI group's current state. 
     */
    "lifecycleState"?: UpiGroupLifecycleStateEnum;
}

export type UpiGroupLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
export interface UpiLocked {
    /**
     * DESCRIPTION
     */
    "true"?: boolean;
    /**
     * DESCRIPTION
     */
    "reason"?: number;
}

export interface UpiManager {
    /**
     * DESCRIPTION
     */
    "value"?: string;
}

export interface UpiMeta {
    /**
     * DESCRIPTION
     */
    "created"?: string;
    /**
     * DESCRIPTION
     */
    "lastModified"?: string;
}

export interface UpiName {
    /**
     * DESCRIPTION
     */
    "givenName"?: string;
    /**
     * DESCRIPTION
     */
    "middleName"?: string;
    /**
     * DESCRIPTION
     */
    "familyName"?: string;
}

export interface UpiPhoneNumbers {
    /**
     * DESCRIPTION
     */
    "type"?: string;
    /**
     * DESCRIPTION
     */
    "value"?: string;
    /**
     * DESCRIPTION
     */
    "display"?: string;
    /**
     * DESCRIPTION
     */
    "primary"?: boolean;
}

export interface UpiPhotos {
    /**
     * DESCRIPTION
     */
    "type"?: string;
    /**
     * DESCRIPTION
     */
    "value"?: string;
    /**
     * DESCRIPTION
     */
    "display"?: string;
    /**
     * DESCRIPTION
     */
    "primary"?: string;
}

export interface UpiTags {
    /**
     * DESCRIPTION
     */
    "key"?: string;
    /**
     * DESCRIPTION
     */
    "value"?: string;
}

/**
 * The Internal representation of a User for UPI compatibility: https://confluence.oci.oraclecorp.com/display/ID/User%2C+Group+and+Tenant+Schema+Extension+Design+Doc 
 */
export interface UpiUser {
    /**
     * The IDCS id of the user.
     */
    "id": string;
    /**
     * The OCID of the user.
     */
    "ocid"?: string;
    /**
     * The name you assign to the user during creation. This is the user's login for the Console. The name must be unique across all users in the tenancy and cannot be changed. 
     */
    "userName"?: string;
    /**
     * The description you assign to the user. Does not have to be unique, and it's changeable.
     */
    "displayName"?: string;
    /**
     * DESCRIPTION
     */
    "mfaStatus"?: UpiUserMfaStatusEnum;
    /**
     * DESCRIPTION
     */
    "isUserFederated"?: boolean;
    "meta"?: UpiMeta;
    /**
     * DESCRIPTION
     */
    "active"?: boolean;
    "locked"?: UpiLocked;
    "email"?: UpiEmail;
    "idcsCreatedBy"?: IdcsCreatedBy;
    "idcsLastModifiedBy"?: IdcsLastModifiedBy;
    "name"?: UpiName;
    /**
     * DESCRIPTION
     */
    "title"?: string;
    /**
     * DESCRIPTION
     */
    "locale"?: string;
    /**
     * DESCRIPTION
     */
    "preferredLanguage"?: string;
    /**
     * DESCRIPTION
     */
    "timezone"?: string;
    /**
     * DESCRIPTION
     */
    "tags"?: Array<UpiTags>;
    /**
     * DESCRIPTION
     */
    "phoneNumbers"?: Array<UpiPhoneNumbers>;
    /**
     * DESCRIPTION
     */
    "photos"?: Array<UpiPhotos>;
    /**
     * DESCRIPTION
     */
    "addresses"?: Array<UpiAddresses>;
    "manager"?: UpiManager;
    /**
     * The UPI user's current state. 
     */
    "lifecycleState"?: UpiUserLifecycleStateEnum;
}

export type UpiUserMfaStatusEnum = "ENROLLED" | "UN_ENROLLED" | "DISABLED";
export type UpiUserLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * An individual employee or system that needs to manage or use your company's Oracle Cloud Infrastructure resources. Users might need to launch instances, manage remote disks, work with your cloud network, etc. Users have one or more IAM Service credentials ([ApiKey](#/en/identity/20160918/ApiKey/), [UIPassword](#/en/identity/20160918/UIPassword/), [SwiftPassword](#/en/identity/20160918/SwiftPassword/) and [AuthToken](#/en/identity/20160918/AuthToken/)). For more information, see [User Credentials](/Content/Identity/Concepts/usercredentials.htm)). End users of your application are not typically IAM Service users. For conceptual information about users and other IAM Service components, see [Overview of the IAM Service](/Content/Identity/Concepts/overview.htm).  These users are created directly within the Oracle Cloud Infrastructure system, via the IAM service. They are different from *federated users*, who authenticate themselves to the Oracle Cloud Infrastructure Console via an identity provider. For more information, see [Identity Providers and Federation](/Content/Identity/Concepts/federation.htm).  To use any of the API operations, you must be authorized in an IAM policy. If you're not authorized, talk to an administrator. If you're an administrator who needs to write policies to give users access, see [Getting Started with Policies](/Content/Identity/Concepts/policygetstarted.htm).  **Warning:** Oracle recommends that you avoid using any confidential information when you supply string values using the API. 
 */
export interface User {
    /**
     * The OCID of the user.
     */
    "id": string;
    /**
     * The OCID of the tenancy containing the user.
     */
    "compartmentId": string;
    /**
     * The name you assign to the user during creation. This is the user's login for the Console. The name must be unique across all users in the tenancy and cannot be changed. 
     */
    "name": string;
    /**
     * The description you assign to the user. Does not have to be unique, and it's changeable.
     */
    "description": string;
    /**
     * The email address you assign to the user. The email address must be unique across all users in the tenancy. 
     */
    "email"?: string;
    /**
     * Whether the email address has been validated.
     */
    "emailVerified"?: boolean;
    /**
     * DB username of the DB credential. Has to be unique across the tenancy.
     */
    "dbUserName"?: string;
    /**
     * The OCID of the `IdentityProvider` this user belongs to.
     */
    "identityProviderId"?: string;
    /**
     * Identifier of the user in the identity provider
     */
    "externalIdentifier"?: string;
    /**
     * Date and time the user was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
    /**
     * The user's current state. After creating a user, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState": UserLifecycleStateEnum;
    /**
     * Returned only if the user's `lifecycleState` is INACTIVE. A 16-bit value showing the reason why the user is inactive:  - bit 0: SUSPENDED (reserved for future use) - bit 1: DISABLED (reserved for future use) - bit 2: BLOCKED (the user has exceeded the maximum number of failed login attempts for the Console) 
     */
    "inactiveStatus"?: number;
    /**
     * Free-form tags for this resource. Each tag is a simple key-value pair with no predefined name, type, or namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm).  Example: `{\"Department\": \"Finance\"}` 
     */
    "freeformTags"?: { [key: string]: string; };
    /**
     * Defined tags for this resource. Each key is predefined and scoped to a namespace. For more information, see [Resource Tags](/Content/General/Concepts/resourcetags.htm). Example: `{\"Operations\": {\"CostCenter\": \"42\"}}` 
     */
    "definedTags"?: { [key: string]: { [key: string]: any; }; };
    "capabilities"?: UserCapabilities;
    /**
     * Flag indicates if MFA has been activated for the user.
     */
    "isMfaActivated": boolean;
    /**
     * The date and time of when the user most recently logged in the format defined by RFC3339 (ex. `2016-08-25T21:10:29.600Z`). If there is no login history, this field is null.  For illustrative purposes, suppose we have a user who has logged in at July 1st, 2020 at 1200 PST and logged out 30 minutes later. They then login again on July 2nd, 2020 at 1500 PST.  Their previousSuccessfulLoginTime would be `2020-07-01:19:00.000Z`.  Their lastSuccessfulLoginTime would be `2020-07-02:22:00.000Z`. 
     */
    "lastSuccessfulLoginTime"?: Date;
    /**
     * The date and time of when the user most recently logged in the format defined by RFC3339 (ex. `2016-08-25T21:10:29.600Z`). If there is no login history, this field is null.  For illustrative purposes, suppose we have a user who has logged in at July 1st, 2020 at 1200 PST and logged out 30 minutes later. They then login again on July 2nd, 2020 at 1500 PST.  Their previousSuccessfulLoginTime would be `2020-07-01:19:00.000Z`.  Their lastSuccessfulLoginTime would be `2020-07-02:22:00.000Z`. 
     */
    "previousSuccessfulLoginTime"?: Date;
    "userSupportAccounts"?: SupportAccounts;
}

export type UserLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * Properties indicating how the user is allowed to authenticate.
 */
export interface UserCapabilities {
    /**
     * Indicates if the user can log in to the console.
     */
    "canUseConsolePassword"?: boolean;
    /**
     * Indicates if the user can use API keys.
     */
    "canUseApiKeys"?: boolean;
    /**
     * Indicates if the user can use SWIFT passwords / auth tokens.
     */
    "canUseAuthTokens"?: boolean;
    /**
     * Indicates if the user can use SMTP passwords.
     */
    "canUseSmtpCredentials"?: boolean;
    /**
     * Indicates if the user can use DB passwords. 
     */
    "canUseDbCredentials"?: boolean;
    /**
     * Indicates if the user can use SigV4 symmetric keys.
     */
    "canUseCustomerSecretKeys"?: boolean;
    /**
     * Indicates if the user can use OAuth2 credentials and tokens. 
     */
    "canUseOAuth2ClientCredentials"?: boolean;
}

/**
 * An object that represents the membership of a user in a group. When you add a user to a group, the result is a `UserGroupMembership` with its own OCID. To remove a user from a group, you delete the `UserGroupMembership` object. 
 */
export interface UserGroupMembership {
    /**
     * The OCID of the membership.
     */
    "id": string;
    /**
     * The OCID of the tenancy containing the user, group, and membership object.
     */
    "compartmentId": string;
    /**
     * The OCID of the group.
     */
    "groupId": string;
    /**
     * The OCID of the user.
     */
    "userId": string;
    /**
     * Date and time the membership was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
    /**
     * The membership's current state.  After creating a membership object, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState": UserGroupMembershipLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "inactiveStatus"?: number;
}

export type UserGroupMembershipLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * An object that represents the membership of a user in a group. When you add a user to a group, the result is a `UserIdpGroupMembership` with its own OCID. To remove a user from a group, you delete the `UserIdpGroupMembership` object. 
 */
export interface UserIdpGroupMembership {
    /**
     * The OCID of the membership.
     */
    "id": string;
    /**
     * The OCID of the tenancy containing the user, group, and membership object.
     */
    "compartmentId": string;
    /**
     * The OCID of the group.
     */
    "groupId": string;
    /**
     * The OCID of the user.
     */
    "userId": string;
    /**
     * Date and time the membership was created, in the format defined by RFC3339.  Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeCreated": Date;
    /**
     * The membership's current state.  After creating a membership object, make sure its `lifecycleState` changes from CREATING to ACTIVE before using it. 
     */
    "lifecycleState": UserIdpGroupMembershipLifecycleStateEnum;
    /**
     * The detailed status of INACTIVE lifecycleState.
     */
    "inactiveStatus"?: number;
}

export type UserIdpGroupMembershipLifecycleStateEnum = "CREATING" | "ACTIVE" | "INACTIVE" | "DELETING" | "DELETED";
/**
 * The asynchronous API request does not take effect immediately. This request spawns an asynchronous workflow to fulfill the request. WorkRequest objects provide visibility for in-progress workflows. 
 */
export interface WorkRequest {
    /**
     * The OCID of the work request.
     */
    "id": string;
    /**
     * An enum-like description of the type of work the work request is doing.
     */
    "operationType": WorkRequestOperationTypeEnum;
    /**
     * The OCID of the compartment that contains the work request.
     */
    "compartmentId"?: string;
    /**
     * The current status of the work request.
     */
    "status": WorkRequestStatusEnum;
    /**
     * The resources this work request affects. 
     */
    "resources"?: Array<WorkRequestResource>;
    /**
     * The errors for work request. 
     */
    "errors"?: Array<WorkRequestError>;
    /**
     * The logs for work request. 
     */
    "logs"?: Array<WorkRequestLogEntry>;
    /**
     * Date and time the work was accepted, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeAccepted"?: Date;
    /**
     * Date and time the work started, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeStarted"?: Date;
    /**
     * Date and time the work completed, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeFinished"?: Date;
    /**
     * How much progress the operation has made. 
     */
    "percentComplete"?: number;
}

export type WorkRequestOperationTypeEnum = "DELETE_COMPARTMENT" | "DELETE_TAG_DEFINITION";
export type WorkRequestStatusEnum = "ACCEPTED" | "IN_PROGRESS" | "FAILED" | "SUCCEEDED" | "CANCELING" | "CANCELED";
/**
 * The error entity. 
 */
export interface WorkRequestError {
    /**
     * A machine-usable code for the error that occured.
     */
    "code": string;
    /**
     * A human-readable error string.
     */
    "message": string;
    /**
     * Date and time the error happened, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timestamp"?: Date;
}

/**
 * The log entity. 
 */
export interface WorkRequestLogEntry {
    /**
     * A human-readable error string.
     */
    "message": string;
    /**
     * Date and time the log was written, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timestamp"?: Date;
}

/**
 * The resource entity. 
 */
export interface WorkRequestResource {
    /**
     * The resource identifier the work request affects.
     */
    "identifier": string;
    /**
     * The resource type the work request is affects.
     */
    "entityType": string;
    /**
     * The way in which this resource was affected by the work tracked by the work request.
     */
    "actionType": WorkRequestResourceActionTypeEnum;
    /**
     * The URI path that the user can do a GET on to access the resource metadata.
     */
    "entityUri"?: string;
}

export type WorkRequestResourceActionTypeEnum = "CREATED" | "UPDATED" | "DELETED" | "RELATED" | "IN_PROGRESS" | "FAILED";
/**
 * Possible Metadata keys for workRequest resource metadata
 */
export type WorkRequestResourceMetadataKey = "domainUrl" | "stripeName";
export enum WorkRequestResourceMetadataKeyValues {
    DomainUrl = "domainUrl",
    StripeName = "stripeName"
}

/**
 * The work request summary. Tracks the status of the asynchronous operation. 
 */
export interface WorkRequestSummary {
    /**
     * The OCID of the work request.
     */
    "id": string;
    /**
     * An enum-like description of the type of work the work request is doing.
     */
    "operationType": WorkRequestSummaryOperationTypeEnum;
    /**
     * The OCID of the compartment that contains the work request.
     */
    "compartmentId"?: string;
    /**
     * The current status of the work request.
     */
    "status": WorkRequestSummaryStatusEnum;
    /**
     * The resources this work request affects. 
     */
    "resources"?: Array<WorkRequestResource>;
    /**
     * The errors for work request. 
     */
    "errors"?: Array<WorkRequestError>;
    /**
     * Date and time the work was accepted, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeAccepted"?: Date;
    /**
     * Date and time the work started, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeStarted"?: Date;
    /**
     * Date and time the work completed, in the format defined by RFC3339. Example: `2016-08-25T21:10:29.600Z` 
     */
    "timeFinished"?: Date;
    /**
     * How much progress the operation has made. 
     */
    "percentComplete"?: number;
}

export type WorkRequestSummaryOperationTypeEnum = "DELETE_COMPARTMENT" | "DELETE_TAG_DEFINITION";
export type WorkRequestSummaryStatusEnum = "ACCEPTED" | "IN_PROGRESS" | "FAILED" | "SUCCEEDED" | "CANCELING" | "CANCELED";
/**
 * Workflow task 
 */
export interface WorkflowTask {
    /**
     * Id of the workflow task.
     */
    "id": string;
    /**
     * Time in milliseconds. Workflow task won't be executed before this time.
     */
    "executeNoEarlierThan": string;
    /**
     * Type of workflow.
     */
    "type": string;
    /**
     * Status of the workflow task.
     */
    "status": string;
    /**
     * Name of the host assigned to the workflow task.
     */
    "hostname": string;
    /**
     * Last heartbeat time of the host for this workflow task.
     */
    "heartbeatTime": string;
    /**
     * Payload of the workflow task.
     */
    "payload": string;
    /**
     * false if status of the workflow is either CLOSED or FAILED. Otherwise true.
     */
    "open": string;
}

export interface CreateMigrationWorkflowTaskDetails extends CreateWorkflowTaskDetails {
    /**
     * The type of migration. 'native' OR 'federation' OR 'federations'
     */
    "migrationType": string;
    /**
     * Tenant id in case of Native entity migration or tenant based federation migration. Identity Provider id in case of IDP based federation migration. 
     */
    "id": string;
}

export interface CreateSaml2IdentityProviderDetails extends CreateIdentityProviderDetails {
    /**
     * The URL for retrieving the identity provider's metadata, which contains information required for federating. 
     */
    "metadataUrl": string;
    /**
     * The XML that contains the information required for federating. 
     */
    "metadata": string;
    /**
     * Extra name value pairs associated with this identity provider. Example: `{\"clientId\": \"app_sf3kdjf3\"}` 
     */
    "freeformAttributes"?: { [key: string]: string; };
    /**
     * When set to true, the service provider expects the SAML assertion to be encrypted by the identity provider, using the service provider's encryption key. In this case, the service provider is Oracle Cloud Infrastructure Authentication service. 
     */
    "encryptAssertion"?: boolean;
    /**
     * If set to true, when the user is redirected to the identity provider, the identity provider forces the user to provide credentials and re-authenticate, even if there is an active login session. 
     */
    "forceAuthentication"?: boolean;
    /**
     * Authentication contexts requested when sending a SAML request to the identity provider. There could be one or more requested contexts. Usually identity provider uses the one that has the highest authentication strength. Example: `[\"urn:oasis:names:tc:SAML:2.0:ac:classes:PasswordProtectedTransport\", \"urn:oasis:names:tc:SAML:2.0:ac:classes:TLSClient\"]` 
     */
    "authnContextClassRefs"?: Array<string>;
}

/**
 * Use this validator to clear any existing validator on the tag key definition with the UpdateTag operation. Using this `validatorType` is the same as not setting any value on the validator field. The resultant value for `validatorType` returned in the response body is `null`. 
 */
export interface DefaultTagDefinitionValidator extends BaseTagDefinitionValidator {
}

/**
 * Used to validate the value set for a defined tag and contains the list of allowable `values`.  You must specify at least one valid value in the `values` array. You can't have blank or or empty strings (`\"\"`). Duplicate values are not allowed. 
 */
export interface EnumTagDefinitionValidator extends BaseTagDefinitionValidator {
    /**
     * The list of allowed values for a definedTag value. 
     */
    "values"?: Array<string>;
}

/**
 * Derived object from `SupportAccount`. The support provider is `MOS` 
 */
export interface MosSupportAccount extends SupportAccount {
}

/**
 * A special type of [IdentityProvider](#/en/identity/20160918/IdentityProvider/) that supports the SAML 2.0 protocol. For more information, see [Identity Providers and Federation](/Content/Identity/Concepts/federation.htm). 
 */
export interface Saml2IdentityProvider extends IdentityProvider {
    /**
     * The URL for retrieving the identity provider's metadata, which contains information required for federating. 
     */
    "metadataUrl": string;
    /**
     * The XML that contains the information required for federating Identity with SAML2 Identity Provider. 
     */
    "metadata"?: string;
    /**
     * The identity provider's signing certificate used by the IAM Service to validate the SAML2 token. 
     */
    "signingCertificate": string;
    /**
     * The URL to redirect federated users to for authentication with the identity provider. 
     */
    "redirectUrl": string;
    /**
     * Extra name value pairs associated with this identity provider. Example: `{\"clientId\": \"app_sf3kdjf3\"}` 
     */
    "freeformAttributes"?: { [key: string]: string; };
    /**
     * When set to true, the service provider expects the SAML assertion to be encrypted by the identity provider, using the service provider's encryption key. In this case, the service provider is Oracle Cloud Infrastructure Authentication service. 
     */
    "encryptAssertion"?: boolean;
    /**
     * If set to true, when the user is redirected to the identity provider, the identity provider forces the user to provide credentials and re-authenticate, even if there is an active login session. 
     */
    "forceAuthentication"?: boolean;
    /**
     * Authentication contexts requested when sending a SAML request to the identity provider. There could be one or more requested contexts. Usually identity provider uses the one that has the highest authentication strength. Example: `[\"urn:oasis:names:tc:SAML:2.0:ac:classes:PasswordProtectedTransport\", \"urn:oasis:names:tc:SAML:2.0:ac:classes:TLSClient\"]` 
     */
    "authnContextClassRefs"?: Array<string>;
    /**
     * A status message for this identity provider. Example: SAML metadata for this identity provider has expired. 
     */
    "statusMessage"?: string;
}

export interface UpdateSaml2IdentityProviderDetails extends UpdateIdentityProviderDetails {
    /**
     * The URL for retrieving the identity provider's metadata, which contains information required for federating. 
     */
    "metadataUrl"?: string;
    /**
     * The XML that contains the information required for federating. 
     */
    "metadata"?: string;
    /**
     * Extra name value pairs associated with this identity provider. Example: `{\"clientId\": \"app_sf3kdjf3\"}` 
     */
    "freeformAttributes"?: { [key: string]: string; };
    /**
     * When set to true, the service provider expects the SAML assertion to be encrypted by the identity provider, using the service provider's encryption key. In this case, the service provider is Oracle Cloud Infrastructure Authentication service. 
     */
    "encryptAssertion"?: boolean;
    /**
     * If set to true, when the user is redirected to the identity provider, the identity provider forces the user to provide credentials and re-authenticate, even if there is an active login session. 
     */
    "forceAuthentication"?: boolean;
    /**
     * Authentication contexts requested when sending a SAML request to the identity provider. There could be one or more requested contexts. Usually identity provider uses the one that has the highest authentication strength. Example: `[\"urn:oasis:names:tc:SAML:2.0:ac:classes:PasswordProtectedTransport\", \"urn:oasis:names:tc:SAML:2.0:ac:classes:TLSClient\"]` 
     */
    "authnContextClassRefs"?: Array<string>;
}


export interface ActivateDomainArgs {
     "domainId": string;
     "opcRequestId"?: string;
     "opcRetryToken"?: string;
     "ifMatch"?: string
}
export type ActivateDomainReturnType = Response;

export interface ActivateMfaTotpDeviceArgs {
     "userId": string;
     "mfaTotpDeviceId": string;
     "mfaTotpToken": MfaTotpToken;
     "ifMatch"?: string;
     "opcRetryToken"?: string
}
export type ActivateMfaTotpDeviceReturnType = { response: Response, data: MfaTotpDeviceSummary };

export interface ActivateTasDomainArgs {
     "tasDomainId": string;
     "opcRequestId"?: string;
     "opcRetryToken"?: string;
     "ifMatch"?: string
}
export type ActivateTasDomainReturnType = Response;

export interface AddUserToGroupArgs {
     "addUserToGroupDetails": AddUserToGroupDetails;
     "opcRetryToken"?: string
}
export type AddUserToGroupReturnType = { response: Response, data: UserGroupMembership };

export interface AddUserToIdpGroupArgs {
     "identityProviderId": string;
     "groupId": string;
     "addUserToIdpGroupDetails": AddUserToIdpGroupDetails;
     "ifMatch"?: string
}
export type AddUserToIdpGroupReturnType = { response: Response, data: IdentityProviderGroupSummary };

export interface AssembleEffectiveTagSetArgs {
     "compartmentId": string;
     "lifecycleState"?: string
}
export type AssembleEffectiveTagSetReturnType = { response: Response, data: Array<TagDefaultSummary> };

export interface BootstrapDefaultDomainArgs {
     "bootstrapDefaultDomainDetails": BootstrapDefaultDomainDetails;
     "opcRetryToken"?: string;
     "ifMatch"?: string;
     "opcRequestId"?: string
}
export type BootstrapDefaultDomainReturnType = Response;

export interface BootstrapLightweightDomainArgs {
     "bootstrapLightweightDomainDetails": BootstrapLightweightDomainDetails;
     "opcRetryToken"?: string;
     "ifMatch"?: string;
     "opcRequestId"?: string
}
export type BootstrapLightweightDomainReturnType = { response: Response, data: BootstrapDomainResponse };

export interface BulkDeleteResourcesArgs {
     "compartmentId": string;
     "bulkDeleteResourcesDetails": BulkDeleteResourcesDetails;
     "opcRequestId"?: string;
     "opcRetryToken"?: string
}
export type BulkDeleteResourcesReturnType = Response;

export interface BulkDeleteTagsArgs {
     "bulkDeleteTagsDetails": BulkDeleteTagsDetails;
     "opcRequestId"?: string;
     "opcRetryToken"?: string
}
export type BulkDeleteTagsReturnType = Response;

export interface BulkEditTagsArgs {
     "opcRequestId"?: string;
     "opcRetryToken"?: string;
     "bulkEditTagsDetails"?: BulkEditTagsDetails
}
export type BulkEditTagsReturnType = Response;

export interface BulkMoveResourcesArgs {
     "compartmentId": string;
     "bulkMoveResourcesDetails": BulkMoveResourcesDetails;
     "opcRequestId"?: string;
     "opcRetryToken"?: string
}
export type BulkMoveResourcesReturnType = Response;

export interface CascadeDeleteTagNamespaceArgs {
     "tagNamespaceId": string;
     "ifMatch"?: string;
     "opcRequestId"?: string;
     "opcRetryToken"?: string
}
export type CascadeDeleteTagNamespaceReturnType = Response;

export interface ChangeDomainCompartmentArgs {
     "domainId": string;
     "changeDomainCompartmentDetails": ChangeDomainCompartmentDetails;
     "opcRequestId"?: string;
     "opcRetryToken"?: string;
     "ifMatch"?: string
}
export type ChangeDomainCompartmentReturnType = Response;

export interface ChangeDomainLicenseTypeArgs {
     "domainId": string;
     "changeDomainLicenseTypeDetails": ChangeDomainLicenseTypeDetails;
     "opcRequestId"?: string;
     "opcRetryToken"?: string;
     "ifMatch"?: string
}
export type ChangeDomainLicenseTypeReturnType = Response;

export interface ChangeTagNamespaceCompartmentArgs {
     "tagNamespaceId": string;
     "changeTagNamespaceCompartmentDetail": ChangeTagNamespaceCompartmentDetail;
     "opcRetryToken"?: string
}
export type ChangeTagNamespaceCompartmentReturnType = Response;

export interface ChangeTasDomainLicenseTypeArgs {
     "tasDomainId": string;
     "changeTasDomainLicenseTypeDetails": ChangeTasDomainLicenseTypeDetails;
     "opcRequestId"?: string;
     "opcRetryToken"?: string;
     "ifMatch"?: string
}
export type ChangeTasDomainLicenseTypeReturnType = Response;

export interface ClaimStripeArgs {
     "claimStripeDetails": ClaimStripeDetails;
     "opcRetryToken"?: string;
     "opcRequestId"?: string;
     "ifMatch"?: string
}
export type ClaimStripeReturnType = { response: Response, data: ClaimStripeDomainResponse };

export interface CreateAuthTokenArgs {
     "createAuthTokenDetails": CreateAuthTokenDetails;
     "userId": string;
     "opcRetryToken"?: string
}
export type CreateAuthTokenReturnType = { response: Response, data: AuthToken };

export interface CreateAuthenticationRecordArgs {
     "createAuthenticationRecordDetails": CreateAuthenticationRecordDetails;
     "opcRequestId"?: string;
     "opcRetryToken"?: string
}
export type CreateAuthenticationRecordReturnType = Response;

export interface CreateCompartmentArgs {
     "createCompartmentDetails": CreateCompartmentDetails;
     "opcRetryToken"?: string
}
export type CreateCompartmentReturnType = { response: Response, data: Compartment };

export interface CreateCustomerSecretKeyArgs {
     "createCustomerSecretKeyDetails": CreateCustomerSecretKeyDetails;
     "userId": string;
     "opcRetryToken"?: string
}
export type CreateCustomerSecretKeyReturnType = { response: Response, data: CustomerSecretKey };

export interface CreateDbCredentialArgs {
     "createDbCredentialDetails": CreateDbCredentialDetails;
     "userId": string;
     "opcRequestId"?: string;
     "opcRetryToken"?: string
}
export type CreateDbCredentialReturnType = { response: Response, data: DbCredential };

export interface CreateDomainArgs {
     "createDomainDetails": CreateDomainDetails;
     "opcRetryToken"?: string;
     "opcRequestId"?: string
}
export type CreateDomainReturnType = Response;

export interface CreateDynamicGroupArgs {
     "createDynamicGroupDetails": CreateDynamicGroupDetails;
     "opcRetryToken"?: string
}
export type CreateDynamicGroupReturnType = { response: Response, data: DynamicGroup };

export interface CreateGroupArgs {
     "createGroupDetails": CreateGroupDetails;
     "opcRetryToken"?: string
}
export type CreateGroupReturnType = { response: Response, data: Group };

export interface CreateIdentityProviderArgs {
     "createIdentityProviderDetails": CreateIdentityProviderDetails;
     "opcRetryToken"?: string
}
export type CreateIdentityProviderReturnType = { response: Response, data: IdentityProvider };

export interface CreateIdentityProviderGroupArgs {
     "identityProviderId": string;
     "createIdpGroupDetails": CreateIdpGroupDetails;
     "opcRetryToken"?: string
}
export type CreateIdentityProviderGroupReturnType = { response: Response, data: IdentityProviderGroupSummary };

export interface CreateIdpGroupMappingArgs {
     "createIdpGroupMappingDetails": CreateIdpGroupMappingDetails;
     "identityProviderId": string;
     "opcRetryToken"?: string
}
export type CreateIdpGroupMappingReturnType = { response: Response, data: IdpGroupMapping };

export interface CreateIdpUserArgs {
     "identityProviderId": string;
     "createIdpUserDetails": CreateIdpUserDetails;
     "opcRetryToken"?: string
}
export type CreateIdpUserReturnType = { response: Response, data: User };

export interface CreateManagedCompartmentArgs {
     "createManagedCompartmentDetails": CreateManagedCompartmentDetails;
     "opcRetryToken"?: string
}
export type CreateManagedCompartmentReturnType = { response: Response, data: Compartment };

export interface CreateMfaTotpDeviceArgs {
     "userId": string;
     "opcRetryToken"?: string
}
export type CreateMfaTotpDeviceReturnType = { response: Response, data: MfaTotpDevice };

export interface CreateNetworkSourceArgs {
     "createNetworkSourceDetails": CreateNetworkSourceDetails;
     "opcRetryToken"?: string
}
export type CreateNetworkSourceReturnType = { response: Response, data: NetworkSources };

export interface CreateOAuthClientCredentialArgs {
     "userId": string;
     "createOAuth2ClientCredentialDetails": CreateOAuth2ClientCredentialDetails;
     "opcRetryToken"?: string
}
export type CreateOAuthClientCredentialReturnType = { response: Response, data: OAuth2ClientCredential };

export interface CreateOidcClientArgs {
     "createOidcClientDetails": CreateOidcClientDetails;
     "opcRetryToken"?: string
}
export type CreateOidcClientReturnType = { response: Response, data: OidcClient };

export interface CreateOnPremSiteArgs {
     "createOnPremSiteDetails": CreateOnPremSiteDetails;
     "opcRetryToken"?: string;
     "opcRequestId"?: string
}
export type CreateOnPremSiteReturnType = { response: Response, data: OnPremSite };

export interface CreateOrResetUIPasswordArgs {
     "userId": string;
     "opcRetryToken"?: string
}
export type CreateOrResetUIPasswordReturnType = { response: Response, data: UIPassword };

export interface CreatePolicyArgs {
     "createPolicyDetails": CreatePolicyDetails;
     "opcRetryToken"?: string
}
export type CreatePolicyReturnType = { response: Response, data: Policy };

export interface CreateRegionSubscriptionArgs {
     "createRegionSubscriptionDetails": CreateRegionSubscriptionDetails;
     "tenancyId": string;
     "opcRetryToken"?: string
}
export type CreateRegionSubscriptionReturnType = { response: Response, data: RegionSubscription };

export interface CreateServiceManagerArgs {
     "createServiceManagerDetails": CreateServiceManagerDetails;
     "opcRetryToken"?: string
}
export type CreateServiceManagerReturnType = { response: Response, data: ServiceManager };

export interface CreateSmtpCredentialArgs {
     "createSmtpCredentialDetails": CreateSmtpCredentialDetails;
     "userId": string;
     "opcRetryToken"?: string
}
export type CreateSmtpCredentialReturnType = { response: Response, data: SmtpCredential };

export interface CreateStripeArgs {
     "createStripeDetails": CreateStripeDetails;
     "opcRetryToken"?: string
}
export type CreateStripeReturnType = { response: Response, data: Stripe };

export interface CreateSwiftPasswordArgs {
     "createSwiftPasswordDetails": CreateSwiftPasswordDetails;
     "userId": string;
     "opcRetryToken"?: string
}
export type CreateSwiftPasswordReturnType = { response: Response, data: SwiftPassword };

export interface CreateTagArgs {
     "tagNamespaceId": string;
     "createTagDetails": CreateTagDetails;
     "opcRetryToken"?: string
}
export type CreateTagReturnType = { response: Response, data: Tag };

export interface CreateTagDefaultArgs {
     "createTagDefaultDetails": CreateTagDefaultDetails;
     "opcRetryToken"?: string;
     "opcRequestId"?: string
}
export type CreateTagDefaultReturnType = { response: Response, data: TagDefault };

export interface CreateTagNamespaceArgs {
     "createTagNamespaceDetails": CreateTagNamespaceDetails;
     "opcRetryToken"?: string
}
export type CreateTagNamespaceReturnType = { response: Response, data: TagNamespace };

export interface CreateTasDomainArgs {
     "createTasDomainDetails": CreateTasDomainDetails;
     "opcRetryToken"?: string;
     "opcRequestId"?: string
}
export type CreateTasDomainReturnType = Response;

export interface CreateUpiGroupArgs {
     "createUpiGroupDetails": CreateUpiGroupDetails;
     "opcRetryToken"?: string
}
export type CreateUpiGroupReturnType = { response: Response, data: UpiGroup };

export interface CreateUpiUserArgs {
     "createUpiUserDetails": CreateUpiUserDetails;
     "opcRetryToken"?: string
}
export type CreateUpiUserReturnType = { response: Response, data: UpiUser };

export interface CreateUserArgs {
     "createUserDetails": CreateUserDetails;
     "opcRetryToken"?: string
}
export type CreateUserReturnType = { response: Response, data: User };

export interface CreateWorkflowTaskArgs {
     "createWorkflowTaskDetails": CreateWorkflowTaskDetails
}
export type CreateWorkflowTaskReturnType = { response: Response, data: Array<WorkflowTask> };

export interface DeactivatTasDomainArgs {
     "tasDomainId": string;
     "opcRequestId"?: string;
     "opcRetryToken"?: string;
     "ifMatch"?: string
}
export type DeactivatTasDomainReturnType = Response;

export interface DeactivateDomainArgs {
     "domainId": string;
     "opcRequestId"?: string;
     "opcRetryToken"?: string;
     "ifMatch"?: string
}
export type DeactivateDomainReturnType = Response;

export interface DeleteApiKeyArgs {
     "userId": string;
     "fingerprint": string;
     "ifMatch"?: string
}
export type DeleteApiKeyReturnType = Response;

export interface DeleteAuthTokenArgs {
     "userId": string;
     "authTokenId": string;
     "ifMatch"?: string
}
export type DeleteAuthTokenReturnType = Response;

export interface DeleteCompartmentArgs {
     "compartmentId": string;
     "ifMatch"?: string
}
export type DeleteCompartmentReturnType = Response;

export interface DeleteCustomerSecretKeyArgs {
     "userId": string;
     "customerSecretKeyId": string;
     "ifMatch"?: string
}
export type DeleteCustomerSecretKeyReturnType = Response;

export interface DeleteDbCredentialArgs {
     "userId": string;
     "dbCredentialId": string;
     "opcRequestId"?: string;
     "ifMatch"?: string
}
export type DeleteDbCredentialReturnType = Response;

export interface DeleteDomainArgs {
     "domainId": string;
     "ifMatch"?: string;
     "opcRequestId"?: string
}
export type DeleteDomainReturnType = Response;

export interface DeleteDynamicGroupArgs {
     "dynamicGroupId": string;
     "ifMatch"?: string
}
export type DeleteDynamicGroupReturnType = Response;

export interface DeleteGroupArgs {
     "groupId": string;
     "ifMatch"?: string
}
export type DeleteGroupReturnType = Response;

export interface DeleteIdentityProviderArgs {
     "identityProviderId": string;
     "ifMatch"?: string
}
export type DeleteIdentityProviderReturnType = Response;

export interface DeleteIdentityProviderGroupArgs {
     "identityProviderId": string;
     "groupId": string;
     "ifMatch"?: string
}
export type DeleteIdentityProviderGroupReturnType = Response;

export interface DeleteIdpGroupMappingArgs {
     "identityProviderId": string;
     "mappingId": string;
     "ifMatch"?: string
}
export type DeleteIdpGroupMappingReturnType = Response;

export interface DeleteIdpUserArgs {
     "identityProviderId": string;
     "userId": string;
     "ifMatch"?: string
}
export type DeleteIdpUserReturnType = Response;

export interface DeleteMfaTotpDeviceArgs {
     "userId": string;
     "mfaTotpDeviceId": string;
     "ifMatch"?: string
}
export type DeleteMfaTotpDeviceReturnType = Response;

export interface DeleteNetworkSourceArgs {
     "networkSourceId": string;
     "ifMatch"?: string
}
export type DeleteNetworkSourceReturnType = Response;

export interface DeleteOAuthClientCredentialArgs {
     "userId": string;
     "oauth2ClientCredentialId": string;
     "ifMatch"?: string
}
export type DeleteOAuthClientCredentialReturnType = Response;

export interface DeleteOidcClientArgs {
     "oidcClientId": string;
     "ifMatch"?: string
}
export type DeleteOidcClientReturnType = Response;

export interface DeleteOnPremSiteArgs {
     "onPremSiteId": string;
     "ifMatch"?: string;
     "opcRequestId"?: string
}
export type DeleteOnPremSiteReturnType = Response;

export interface DeletePolicyArgs {
     "policyId": string;
     "ifMatch"?: string
}
export type DeletePolicyReturnType = Response;

export interface DeleteServiceManagerArgs {
     "tenantId": string;
     "ifMatch"?: string
}
export type DeleteServiceManagerReturnType = Response;

export interface DeleteSmtpCredentialArgs {
     "userId": string;
     "smtpCredentialId": string;
     "ifMatch"?: string
}
export type DeleteSmtpCredentialReturnType = Response;

export interface DeleteSwiftPasswordArgs {
     "userId": string;
     "swiftPasswordId": string;
     "ifMatch"?: string
}
export type DeleteSwiftPasswordReturnType = Response;

export interface DeleteTagArgs {
     "tagNamespaceId": string;
     "tagName": string;
     "ifMatch"?: string
}
export type DeleteTagReturnType = Response;

export interface DeleteTagDefaultArgs {
     "tagDefaultId": string;
     "opcRequestId"?: string;
     "ifMatch"?: string
}
export type DeleteTagDefaultReturnType = Response;

export interface DeleteTagNamespaceArgs {
     "tagNamespaceId": string;
     "ifMatch"?: string;
     "opcRequestId"?: string
}
export type DeleteTagNamespaceReturnType = Response;

export interface DeleteTasDomainArgs {
     "tasDomainId": string;
     "ifMatch"?: string;
     "opcRequestId"?: string
}
export type DeleteTasDomainReturnType = Response;

export interface DeleteUpiGroupArgs {
     "idcsId": string;
     "ifMatch"?: string
}
export type DeleteUpiGroupReturnType = Response;

export interface DeleteUpiUserArgs {
     "idcsId": string;
     "ifMatch"?: string
}
export type DeleteUpiUserReturnType = Response;

export interface DeleteUserArgs {
     "userId": string;
     "ifMatch"?: string
}
export type DeleteUserReturnType = Response;

export interface EmailVerificationArgs {
     "userId": string;
     "emailVerificationTokenDetails": EmailVerificationTokenDetails
}
export type EmailVerificationReturnType = Response;

export interface EnableReplicationToRegionArgs {
     "domainId": string;
     "enableReplicationToRegionDetails": EnableReplicationToRegionDetails;
     "opcRequestId"?: string;
     "opcRetryToken"?: string;
     "ifMatch"?: string
}
export type EnableReplicationToRegionReturnType = Response;

export interface GeneratePasswordResetEmailArgs {
     "sendPasswordResetRequest": SendPasswordResetRequest
}
export type GeneratePasswordResetEmailReturnType = Response;

export interface GenerateTotpSeedArgs {
     "userId": string;
     "mfaTotpDeviceId": string;
     "ifMatch"?: string
}
export type GenerateTotpSeedReturnType = { response: Response, data: MfaTotpDevice };

export interface GetAccountByEntitlementIdArgs {
     "serviceName": string;
     "entitlementId": string
}
export type GetAccountByEntitlementIdReturnType = { response: Response, data: Account };

export interface GetAuthenticationPolicyArgs {
     "compartmentId": string
}
export type GetAuthenticationPolicyReturnType = { response: Response, data: AuthenticationPolicy };

export interface GetCompartmentArgs {
     "compartmentId": string;
     "verboseLevel"?: string
}
export type GetCompartmentReturnType = { response: Response, data: Compartment };

export interface GetDomainArgs {
     "domainId": string;
     "opcRequestId"?: string;
     "isIdentityProviderIdRequired"?: string
}
export type GetDomainReturnType = { response: Response, data: Domain };

export interface GetDomainReplicationStatesArgs {
     "homeRegionShardId": string;
     "lastTxnSeq": number;
     "limit": number;
     "opcWatermark"?: string;
     "opcRequestId"?: string
}
export type GetDomainReplicationStatesReturnType = { response: Response, data: DomainReplication };

export interface GetDynamicGroupArgs {
     "dynamicGroupId": string
}
export type GetDynamicGroupReturnType = { response: Response, data: DynamicGroup };

export interface GetGroupArgs {
     "groupId": string
}
export type GetGroupReturnType = { response: Response, data: Group };

export interface GetIamWorkRequestArgs {
     "iamWorkRequestId": string;
     "opcRequestId"?: string
}
export type GetIamWorkRequestReturnType = { response: Response, data: IamWorkRequest };

export interface GetIdentityProviderArgs {
     "identityProviderId": string
}
export type GetIdentityProviderReturnType = { response: Response, data: IdentityProvider };

export interface GetIdentityProviderGroupArgs {
     "identityProviderId": string;
     "groupId": string
}
export type GetIdentityProviderGroupReturnType = { response: Response, data: IdentityProviderGroupSummary };

export interface GetIdpGroupMappingArgs {
     "identityProviderId": string;
     "mappingId": string
}
export type GetIdpGroupMappingReturnType = { response: Response, data: IdpGroupMapping };

export interface GetIdpUserArgs {
     "identityProviderId": string;
     "userId": string
}
export type GetIdpUserReturnType = { response: Response, data: User };

export interface GetLastProcessedInboxSequenceNumberArgs {
     "serviceId": string
}
export type GetLastProcessedInboxSequenceNumberReturnType = { response: Response, data: LastProcessedSequenceNumberResult };

export interface GetMfaTotpDeviceArgs {
     "userId": string;
     "mfaTotpDeviceId": string
}
export type GetMfaTotpDeviceReturnType = { response: Response, data: MfaTotpDeviceSummary };

export interface GetNetworkSourceArgs {
     "networkSourceId": string
}
export type GetNetworkSourceReturnType = { response: Response, data: NetworkSources };

export interface GetOidcClientArgs {
     "oidcClientId": string
}
export type GetOidcClientReturnType = { response: Response, data: OidcClient };

export interface GetOnPremSiteArgs {
     "onPremSiteId": string;
     "opcRequestId"?: string
}
export type GetOnPremSiteReturnType = { response: Response, data: OnPremSite };

export interface GetPolicyArgs {
     "policyId": string
}
export type GetPolicyReturnType = { response: Response, data: Policy };

export interface GetReplicationLogsArgs {
     "lastReplicatedSequenceNumber": number;
     "limit": number
}
export type GetReplicationLogsReturnType = { response: Response, data: ReplicationLogResult };

export interface GetServiceManagerArgs {
     "tenantId": string
}
export type GetServiceManagerReturnType = { response: Response, data: ServiceManager };

export interface GetStandardTagTemplateArgs {
     "compartmentId": string;
     "standardTagNamespaceName": string
}
export type GetStandardTagTemplateReturnType = { response: Response, data: StandardTagNamespaceTemplate };

export interface GetTagArgs {
     "tagNamespaceId": string;
     "tagName": string
}
export type GetTagReturnType = { response: Response, data: Tag };

export interface GetTagDefaultArgs {
     "tagDefaultId": string
}
export type GetTagDefaultReturnType = { response: Response, data: TagDefault };

export interface GetTagNamespaceArgs {
     "tagNamespaceId": string
}
export type GetTagNamespaceReturnType = { response: Response, data: TagNamespace };

export interface GetTaggingWorkRequestArgs {
     "workRequestId": string
}
export type GetTaggingWorkRequestReturnType = { response: Response, data: TaggingWorkRequest };

export interface GetTenancyArgs {
     "tenancyId": string
}
export type GetTenancyReturnType = { response: Response, data: Tenancy };

export interface GetUpiGroupArgs {
     "idcsId": string
}
export type GetUpiGroupReturnType = { response: Response, data: UpiGroup };

export interface GetUpiUserArgs {
     "idcsId": string
}
export type GetUpiUserReturnType = { response: Response, data: UpiUser };

export interface GetUserArgs {
     "userId": string
}
export type GetUserReturnType = { response: Response, data: User };

export interface GetUserGroupMembershipArgs {
     "userGroupMembershipId": string
}
export type GetUserGroupMembershipReturnType = { response: Response, data: UserGroupMembership };

export interface GetUserUIPasswordInformationArgs {
     "userId": string
}
export type GetUserUIPasswordInformationReturnType = { response: Response, data: UIPasswordInformation };

export interface GetWorkRequestArgs {
     "workRequestId": string
}
export type GetWorkRequestReturnType = { response: Response, data: WorkRequest };

export interface GetWorkflowTaskArgs {
     "workflowTaskId": string
}
export type GetWorkflowTaskReturnType = { response: Response, data: WorkflowTask };

export interface ImportStandardTagsArgs {
     "opcRequestId"?: string;
     "opcRetryToken"?: string;
     "importStandardTagsDetails"?: ImportStandardTagsDetails
}
export type ImportStandardTagsReturnType = Response;

export interface LinkSupportAccountArgs {
     "userId": string;
     "linkSupportAccountDetails": LinkSupportAccountDetails;
     "opcRequestId"?: string
}
export type LinkSupportAccountReturnType = Response;

export interface ListAllowedDomainLicenseTypesArgs {
     "currentLicenseTypeName"?: string;
     "opcRequestId"?: string
}
export type ListAllowedDomainLicenseTypesReturnType = { response: Response, data: Array<AllowedDomainLicenseTypeSummary> };

export interface ListApiKeysArgs {
     "userId": string
}
export type ListApiKeysReturnType = { response: Response, data: Array<ApiKey> };

export interface ListAuthTokensArgs {
     "userId": string
}
export type ListAuthTokensReturnType = { response: Response, data: Array<AuthToken> };

export interface ListAvailabilityDomainsArgs {
     "compartmentId": string
}
export type ListAvailabilityDomainsReturnType = { response: Response, data: Array<AvailabilityDomain> };

export interface ListBulkActionResourceTypesArgs {
     "bulkActionType": string;
     "page"?: string;
     "limit"?: number
}
export type ListBulkActionResourceTypesReturnType = { response: Response, data: BulkActionResourceTypeCollection };

export interface ListBulkEditTagsResourceTypesArgs {
     "page"?: string;
     "limit"?: number
}
export type ListBulkEditTagsResourceTypesReturnType = { response: Response, data: BulkEditTagsResourceTypeCollection };

export interface ListCompartmentsArgs {
     "compartmentId": string;
     "page"?: string;
     "limit"?: number;
     "accessLevel"?: string;
     "compartmentIdInSubtree"?: boolean;
     "verboseLevel"?: string;
     "name"?: string;
     "sortBy"?: string;
     "sortOrder"?: string;
     "lifecycleState"?: string
}
export type ListCompartmentsReturnType = { response: Response, data: Array<Compartment> };

export interface ListCostTrackingTagsArgs {
     "compartmentId": string;
     "page"?: string;
     "limit"?: number
}
export type ListCostTrackingTagsReturnType = { response: Response, data: Array<Tag> };

export interface ListCustomerSecretKeysArgs {
     "userId": string
}
export type ListCustomerSecretKeysReturnType = { response: Response, data: Array<CustomerSecretKeySummary> };

export interface ListDbCredentialsArgs {
     "userId": string;
     "opcRequestId"?: string;
     "page"?: string;
     "limit"?: number;
     "name"?: string;
     "sortBy"?: string;
     "sortOrder"?: string;
     "lifecycleState"?: string
}
export type ListDbCredentialsReturnType = { response: Response, data: Array<DbCredentialSummary> };

export interface ListDomainMigrationsArgs {
     "workflowTaskId": string;
     "page"?: string;
     "limit"?: number;
     "sortBy"?: string;
     "sortOrder"?: string
}
export type ListDomainMigrationsReturnType = { response: Response, data: Array<DomainMigration> };

export interface ListDomainsArgs {
     "compartmentId": string;
     "displayName"?: string;
     "url"?: string;
     "homeRegionUrl"?: string;
     "type"?: string;
     "licenseType"?: string;
     "isHiddenOnLogin"?: boolean;
     "page"?: string;
     "limit"?: number;
     "name"?: string;
     "sortBy"?: string;
     "sortOrder"?: string;
     "opcRequestId"?: string;
     "lifecycleState"?: string
}
export type ListDomainsReturnType = { response: Response, data: Array<DomainSummary> };

export interface ListDynamicGroupsArgs {
     "compartmentId": string;
     "page"?: string;
     "limit"?: number;
     "name"?: string;
     "sortBy"?: string;
     "sortOrder"?: string;
     "lifecycleState"?: string
}
export type ListDynamicGroupsReturnType = { response: Response, data: Array<DynamicGroup> };

export interface ListFaultDomainsArgs {
     "compartmentId": string;
     "availabilityDomain": string
}
export type ListFaultDomainsReturnType = { response: Response, data: Array<FaultDomain> };

export interface ListGroupsArgs {
     "compartmentId": string;
     "page"?: string;
     "limit"?: number;
     "name"?: string;
     "sortBy"?: string;
     "sortOrder"?: string;
     "lifecycleState"?: string
}
export type ListGroupsReturnType = { response: Response, data: Array<Group> };

export interface ListIamWorkRequestErrorsArgs {
     "iamWorkRequestId": string;
     "limit"?: number;
     "page"?: string;
     "sortOrder"?: string;
     "opcRequestId"?: string
}
export type ListIamWorkRequestErrorsReturnType = { response: Response, data: Array<IamWorkRequestErrorSummary> };

export interface ListIamWorkRequestLogsArgs {
     "iamWorkRequestId": string;
     "limit"?: number;
     "page"?: string;
     "sortOrder"?: string;
     "opcRequestId"?: string
}
export type ListIamWorkRequestLogsReturnType = { response: Response, data: Array<IamWorkRequestLogSummary> };

export interface ListIamWorkRequestsArgs {
     "compartmentId": string;
     "page"?: string;
     "limit"?: number;
     "resourceIdentifier"?: string;
     "opcRequestId"?: string
}
export type ListIamWorkRequestsReturnType = { response: Response, data: Array<IamWorkRequestSummary> };

export interface ListIdentityProviderGroupsArgs {
     "identityProviderId": string;
     "page"?: string;
     "limit"?: number;
     "name"?: string;
     "lifecycleState"?: string
}
export type ListIdentityProviderGroupsReturnType = { response: Response, data: Array<IdentityProviderGroupSummary> };

export interface ListIdentityProvidersArgs {
     "protocol": string;
     "compartmentId": string;
     "page"?: string;
     "limit"?: number;
     "name"?: string;
     "sortBy"?: string;
     "sortOrder"?: string;
     "lifecycleState"?: string
}
export type ListIdentityProvidersReturnType = { response: Response, data: Array<IdentityProvider> };

export interface ListIdpGroupMappingsArgs {
     "identityProviderId": string;
     "page"?: string;
     "limit"?: number
}
export type ListIdpGroupMappingsReturnType = { response: Response, data: Array<IdpGroupMapping> };

export interface ListManagedCompartmentsArgs {
     "serviceName": string;
     "tenancyId": string;
     "page"?: string;
     "limit"?: number
}
export type ListManagedCompartmentsReturnType = { response: Response, data: Array<Compartment> };

export interface ListMfaTotpDevicesArgs {
     "userId": string;
     "page"?: string;
     "limit"?: number;
     "sortBy"?: string;
     "sortOrder"?: string
}
export type ListMfaTotpDevicesReturnType = { response: Response, data: Array<MfaTotpDeviceSummary> };

export interface ListNetworkSourcesArgs {
     "compartmentId": string;
     "page"?: string;
     "limit"?: number;
     "name"?: string;
     "sortBy"?: string;
     "sortOrder"?: string;
     "lifecycleState"?: string
}
export type ListNetworkSourcesReturnType = { response: Response, data: Array<NetworkSourcesSummary> };

export interface ListOAuthClientCredentialsArgs {
     "userId": string;
     "page"?: string;
     "limit"?: number;
     "lifecycleState"?: string
}
export type ListOAuthClientCredentialsReturnType = { response: Response, data: Array<OAuth2ClientCredentialSummary> };

export interface ListOidcClientsArgs {
     "oidcClientId"?: string;
     "page"?: string;
     "limit"?: number;
     "servicePrincipalName"?: string;
     "responseType"?: string;
     "name"?: string;
     "sortBy"?: string;
     "sortOrder"?: string;
     "lifecycleState"?: string
}
export type ListOidcClientsReturnType = { response: Response, data: Array<OidcClient> };

export interface ListOnPremSitesArgs {
     "compartmentId": string;
     "name"?: string;
     "limit"?: number;
     "page"?: string;
     "sortOrder"?: string;
     "sortBy"?: string;
     "lifecycleState"?: string
}
export type ListOnPremSitesReturnType = { response: Response, data: OnPremSiteCollection };

export interface ListPermissionsArgs {
     "serviceName": string;
     "resourceKind"?: string;
     "permissionString"?: string;
     "metaverb"?: string;
     "metanoun"?: string
}
export type ListPermissionsReturnType = { response: Response, data: Array<Permission> };

export interface ListPoliciesArgs {
     "compartmentId": string;
     "page"?: string;
     "limit"?: number;
     "name"?: string;
     "sortBy"?: string;
     "sortOrder"?: string;
     "lifecycleState"?: string
}
export type ListPoliciesReturnType = { response: Response, data: Array<Policy> };

export interface ListRegionSubscriptionsArgs {
     "tenancyId": string
}
export type ListRegionSubscriptionsReturnType = { response: Response, data: Array<RegionSubscription> };


export interface ListResourceKindsArgs {
     "serviceName": string;
     "resourceKind"?: string
}
export type ListResourceKindsReturnType = { response: Response, data: Array<ResourceKindSummary> };

export interface ListServiceLimitGroupsArgs {
     "compartmentId": string
}
export type ListServiceLimitGroupsReturnType = { response: Response, data: Array<LimitGroup> };

export interface ListServiceLimitsArgs {
     "group": string;
     "compartmentId": string
}
export type ListServiceLimitsReturnType = { response: Response, data: Array<ServiceLimits> };


export interface ListSmtpCredentialsArgs {
     "userId": string
}
export type ListSmtpCredentialsReturnType = { response: Response, data: Array<SmtpCredentialSummary> };

export interface ListStandardTagNamespacesArgs {
     "compartmentId": string;
     "page"?: string;
     "limit"?: number
}
export type ListStandardTagNamespacesReturnType = { response: Response, data: Array<StandardTagNamespaceTemplateSummary> };

export interface ListSwiftPasswordsArgs {
     "userId": string
}
export type ListSwiftPasswordsReturnType = { response: Response, data: Array<SwiftPassword> };

export interface ListTagDefaultsArgs {
     "page"?: string;
     "limit"?: number;
     "id"?: string;
     "compartmentId"?: string;
     "tagDefinitionId"?: string;
     "lifecycleState"?: string
}
export type ListTagDefaultsReturnType = { response: Response, data: Array<TagDefaultSummary> };

export interface ListTagNamespacesArgs {
     "compartmentId": string;
     "page"?: string;
     "limit"?: number;
     "includeSubcompartments"?: boolean;
     "lifecycleState"?: string
}
export type ListTagNamespacesReturnType = { response: Response, data: Array<TagNamespaceSummary> };

export interface ListTaggingWorkRequestErrorsArgs {
     "workRequestId": string;
     "page"?: string;
     "limit"?: number
}
export type ListTaggingWorkRequestErrorsReturnType = { response: Response, data: Array<TaggingWorkRequestErrorSummary> };

export interface ListTaggingWorkRequestLogsArgs {
     "workRequestId": string;
     "page"?: string;
     "limit"?: number
}
export type ListTaggingWorkRequestLogsReturnType = { response: Response, data: Array<TaggingWorkRequestLogSummary> };

export interface ListTaggingWorkRequestsArgs {
     "compartmentId": string;
     "page"?: string;
     "limit"?: number;
     "resourceIdentifier"?: string
}
export type ListTaggingWorkRequestsReturnType = { response: Response, data: Array<TaggingWorkRequestSummary> };

export interface ListTagsArgs {
     "tagNamespaceId": string;
     "page"?: string;
     "limit"?: number;
     "lifecycleState"?: string
}
export type ListTagsReturnType = { response: Response, data: Array<TagSummary> };

export interface ListTenanciesArgs {
     "serviceName": string;
     "serviceEntitlementId": string;
     "page"?: string;
     "limit"?: number
}
export type ListTenanciesReturnType = { response: Response, data: Array<Tenancy> };

export interface ListUpiGroupsArgs {
     "compartmentId": string;
     "page"?: string;
     "limit"?: number;
     "name"?: string;
     "sortBy"?: string;
     "sortOrder"?: string
}
export type ListUpiGroupsReturnType = { response: Response, data: Array<UpiGroup> };

export interface ListUpiUsersArgs {
     "compartmentId": string;
     "page"?: string;
     "limit"?: number;
     "name"?: string;
     "sortBy"?: string;
     "sortOrder"?: string
}
export type ListUpiUsersReturnType = { response: Response, data: Array<UpiUser> };

export interface ListUserGroupMembershipsArgs {
     "compartmentId": string;
     "userId"?: string;
     "groupId"?: string;
     "page"?: string;
     "limit"?: number
}
export type ListUserGroupMembershipsReturnType = { response: Response, data: Array<UserGroupMembership> };

export interface ListUserIdpGroupMembershipsArgs {
     "identityProviderId": string;
     "userId"?: string;
     "groupId"?: string;
     "page"?: string;
     "limit"?: number
}
export type ListUserIdpGroupMembershipsReturnType = { response: Response, data: Array<UserIdpGroupMembership> };

export interface ListUsersArgs {
     "compartmentId": string;
     "page"?: string;
     "limit"?: number;
     "identityProviderId"?: string;
     "externalIdentifier"?: string;
     "name"?: string;
     "sortBy"?: string;
     "sortOrder"?: string;
     "lifecycleState"?: string
}
export type ListUsersReturnType = { response: Response, data: Array<User> };

export interface ListWorkRequestsArgs {
     "compartmentId": string;
     "page"?: string;
     "limit"?: number;
     "resourceIdentifier"?: string
}
export type ListWorkRequestsReturnType = { response: Response, data: Array<WorkRequestSummary> };

export interface MoveCompartmentArgs {
     "compartmentId": string;
     "moveCompartmentDetails": MoveCompartmentDetails;
     "ifMatch"?: string;
     "opcRequestId"?: string;
     "opcRetryToken"?: string
}
export type MoveCompartmentReturnType = Response;

export interface PatchUpiGroupArgs {
     "idcsId": string;
     "patchUpiGroupDetails": PatchUpiGroupDetails;
     "ifMatch"?: string
}
export type PatchUpiGroupReturnType = { response: Response, data: UpiGroup };

export interface PatchUpiUserArgs {
     "idcsId": string;
     "patchUpiUserDetails": PatchUpiUserDetails;
     "ifMatch"?: string
}
export type PatchUpiUserReturnType = { response: Response, data: UpiUser };

export interface RecoverCompartmentArgs {
     "compartmentId": string;
     "ifMatch"?: string;
     "opcRequestId"?: string
}
export type RecoverCompartmentReturnType = { response: Response, data: Compartment };

export interface RemoveUserFromGroupArgs {
     "userGroupMembershipId": string;
     "ifMatch"?: string
}
export type RemoveUserFromGroupReturnType = Response;

export interface RemoveUserFromIdpGroupArgs {
     "identityProviderId": string;
     "groupId": string;
     "removeUserFromIdpGroupDetails": RemoveUserFromIdpGroupDetails;
     "ifMatch"?: string
}
export type RemoveUserFromIdpGroupReturnType = { response: Response, data: IdentityProviderGroupSummary };

export interface ReplicateDefaultDomainToRegionArgs {
     "replicateDefaultDomainToRegionDetails": ReplicateDefaultDomainToRegionDetails;
     "opcRetryToken"?: string;
     "opcRequestId"?: string;
     "ifMatch"?: string
}
export type ReplicateDefaultDomainToRegionReturnType = Response;

export interface ResetAdminPasswordArgs {
     "resetAdminPasswordDetails": ResetAdminPasswordDetails
}
export type ResetAdminPasswordReturnType = Response;

export interface ResetIdpScimClientArgs {
     "identityProviderId": string
}
export type ResetIdpScimClientReturnType = { response: Response, data: ScimClientCredentials };

export interface SendVerificationEmailArgs {
     "userId": string
}
export type SendVerificationEmailReturnType = Response;

export interface SetReplicationEnabledArgs {
     "domainId": string;
     "setReplicationEnabledDetails": SetReplicationEnabledDetails;
     "opcRequestId"?: string;
     "opcRetryToken"?: string;
     "ifMatch"?: string
}
export type SetReplicationEnabledReturnType = Response;

export interface UnlinkSupportAccountArgs {
     "userId": string;
     "unlinkSupportAccountDetails": UnlinkSupportAccountDetails;
     "opcRequestId"?: string
}
export type UnlinkSupportAccountReturnType = Response;

export interface UpdateAuthRecordArgs {
     "updateAuthenticationRecordDetails": UpdateAuthenticationRecordDetails
}
export type UpdateAuthRecordReturnType = Response;

export interface UpdateAuthTokenArgs {
     "userId": string;
     "authTokenId": string;
     "updateAuthTokenDetails": UpdateAuthTokenDetails;
     "ifMatch"?: string
}
export type UpdateAuthTokenReturnType = { response: Response, data: AuthToken };

export interface UpdateAuthenticationPolicyArgs {
     "compartmentId": string;
     "updateAuthenticationPolicyDetails": UpdateAuthenticationPolicyDetails;
     "ifMatch"?: string
}
export type UpdateAuthenticationPolicyReturnType = { response: Response, data: AuthenticationPolicy };

export interface UpdateCompartmentArgs {
     "compartmentId": string;
     "updateCompartmentDetails": UpdateCompartmentDetails;
     "ifMatch"?: string
}
export type UpdateCompartmentReturnType = { response: Response, data: Compartment };

export interface UpdateCustomerSecretKeyArgs {
     "userId": string;
     "customerSecretKeyId": string;
     "updateCustomerSecretKeyDetails": UpdateCustomerSecretKeyDetails;
     "ifMatch"?: string
}
export type UpdateCustomerSecretKeyReturnType = { response: Response, data: CustomerSecretKeySummary };

export interface UpdateDomainArgs {
     "domainId": string;
     "updateDomainDetails": UpdateDomainDetails;
     "ifMatch"?: string;
     "opcRequestId"?: string
}
export type UpdateDomainReturnType = Response;

export interface UpdateDynamicGroupArgs {
     "dynamicGroupId": string;
     "updateDynamicGroupDetails": UpdateDynamicGroupDetails;
     "ifMatch"?: string
}
export type UpdateDynamicGroupReturnType = { response: Response, data: DynamicGroup };

export interface UpdateGroupArgs {
     "groupId": string;
     "updateGroupDetails": UpdateGroupDetails;
     "ifMatch"?: string
}
export type UpdateGroupReturnType = { response: Response, data: Group };

export interface UpdateIdentityProviderArgs {
     "identityProviderId": string;
     "updateIdentityProviderDetails": UpdateIdentityProviderDetails;
     "ifMatch"?: string
}
export type UpdateIdentityProviderReturnType = { response: Response, data: IdentityProvider };

export interface UpdateIdpGroupMappingArgs {
     "identityProviderId": string;
     "mappingId": string;
     "updateIdpGroupMappingDetails": UpdateIdpGroupMappingDetails;
     "ifMatch"?: string
}
export type UpdateIdpGroupMappingReturnType = { response: Response, data: IdpGroupMapping };

export interface UpdateNetworkSourceArgs {
     "networkSourceId": string;
     "updateNetworkSourceDetails": UpdateNetworkSourceDetails;
     "ifMatch"?: string
}
export type UpdateNetworkSourceReturnType = { response: Response, data: NetworkSources };

export interface UpdateOAuthClientCredentialArgs {
     "userId": string;
     "oauth2ClientCredentialId": string;
     "updateOAuth2ClientCredentialDetails": UpdateOAuth2ClientCredentialDetails;
     "ifMatch"?: string
}
export type UpdateOAuthClientCredentialReturnType = { response: Response, data: OAuth2ClientCredential };

export interface UpdateOidcClientArgs {
     "oidcClientId": string;
     "updateOidcClientDetails": UpdateOidcClientDetails;
     "ifMatch"?: string
}
export type UpdateOidcClientReturnType = { response: Response, data: OidcClient };

export interface UpdateOnPremSiteArgs {
     "onPremSiteId": string;
     "updateOnPremSiteDetails": UpdateOnPremSiteDetails;
     "ifMatch"?: string;
     "opcRequestId"?: string
}
export type UpdateOnPremSiteReturnType = { response: Response, data: OnPremSite };

export interface UpdatePolicyArgs {
     "policyId": string;
     "updatePolicyDetails": UpdatePolicyDetails;
     "ifMatch"?: string
}
export type UpdatePolicyReturnType = { response: Response, data: Policy };

export interface UpdateServiceManagerArgs {
     "tenantId": string;
     "updateServiceManagerDetails": UpdateServiceManagerDetails;
     "ifMatch"?: string
}
export type UpdateServiceManagerReturnType = { response: Response, data: ServiceManager };

export interface UpdateSmtpCredentialArgs {
     "userId": string;
     "smtpCredentialId": string;
     "updateSmtpCredentialDetails": UpdateSmtpCredentialDetails;
     "ifMatch"?: string
}
export type UpdateSmtpCredentialReturnType = { response: Response, data: SmtpCredentialSummary };

export interface UpdateSwiftPasswordArgs {
     "userId": string;
     "swiftPasswordId": string;
     "updateSwiftPasswordDetails": UpdateSwiftPasswordDetails;
     "ifMatch"?: string
}
export type UpdateSwiftPasswordReturnType = { response: Response, data: SwiftPassword };

export interface UpdateTagArgs {
     "tagNamespaceId": string;
     "tagName": string;
     "updateTagDetails": UpdateTagDetails;
     "ifMatch"?: string
}
export type UpdateTagReturnType = { response: Response, data: Tag };

export interface UpdateTagDefaultArgs {
     "tagDefaultId": string;
     "updateTagDefaultDetails": UpdateTagDefaultDetails;
     "ifMatch"?: string;
     "opcRequestId"?: string
}
export type UpdateTagDefaultReturnType = { response: Response, data: TagDefault };

export interface UpdateTagNamespaceArgs {
     "tagNamespaceId": string;
     "updateTagNamespaceDetails": UpdateTagNamespaceDetails
}
export type UpdateTagNamespaceReturnType = { response: Response, data: TagNamespace };

export interface UpdateTasDomainArgs {
     "tasDomainId": string;
     "updateTasDomainDetails": UpdateTasDomainDetails;
     "ifMatch"?: string;
     "opcRequestId"?: string
}
export type UpdateTasDomainReturnType = Response;

export interface UpdateUpiGroupArgs {
     "idcsId": string;
     "updateUpiGroupDetails": UpdateUpiGroupDetails;
     "ifMatch"?: string
}
export type UpdateUpiGroupReturnType = { response: Response, data: UpiGroup };

export interface UpdateUpiUserArgs {
     "idcsId": string;
     "updateUpiUserDetails": UpdateUpiUserDetails;
     "ifMatch"?: string
}
export type UpdateUpiUserReturnType = { response: Response, data: UpiUser };

export interface UpdateUserArgs {
     "userId": string;
     "updateUserDetails": UpdateUserDetails;
     "ifMatch"?: string
}
export type UpdateUserReturnType = { response: Response, data: User };

export interface UpdateUserCapabilitiesArgs {
     "userId": string;
     "updateUserCapabilitiesDetails": UpdateUserCapabilitiesDetails;
     "ifMatch"?: string
}
export type UpdateUserCapabilitiesReturnType = { response: Response, data: User };

export interface UpdateUserStateArgs {
     "userId": string;
     "updateStateDetails": UpdateStateDetails;
     "ifMatch"?: string
}
export type UpdateUserStateReturnType = { response: Response, data: User };

export interface UpdateUserUIPasswordArgs {
     "userId": string;
     "updateUIPasswordRequest": UpdateUiPasswordDetails;
     "opcRetryToken"?: string
}
export type UpdateUserUIPasswordReturnType = { response: Response, data: UIPasswordInformation };

export interface UploadApiKeyArgs {
     "userId": string;
     "createApiKeyDetails": CreateApiKeyDetails;
     "opcRetryToken"?: string
}
export type UploadApiKeyReturnType = { response: Response, data: ApiKey };


/**
 * IdentityApi - object-oriented interface
 */
export class IdentityApi extends base.BaseAPI {
    public static createFromEndpointTemplate(fetch: base.Fetch, region: string, secondLevelDomain: string, config?: base.BaseApiConfig): IdentityApi {
        const endpoint = base.buildEndpointFromTemplate(
            "https://identity.{region}.oci.{secondLevelDomain}",
            "/20160918",
            region,
            secondLevelDomain
        );

        return new IdentityApi(fetch, endpoint, config);
    }

    /** 
     * Activate a deactivated domain
     * If the domain&#39;s {@code lifecycleState} is INACTIVE, 1. Set the {@code lifecycleDetails} to ACTIVATING and asynchronously starts enabling    the domain and return 202 ACCEPTED.     1.1 Sets the domain status to ENABLED and set specified domain&#39;s         {@code lifecycleState} to ACTIVE and set the {@code lifecycleDetails} to null.  To track progress, HTTP GET on /iamWorkRequests/{iamWorkRequestsId} endpoint will provide the async operation&#39;s status. Deactivate a domain can be done using HTTP POST /domains/{domainId}/actions/deactivate.  - If the domain&#39;s {@code lifecycleState} is ACTIVE, returns 202 ACCEPTED with no action   taken on service side. - If domain is of {@code type} DEFAULT or DEFAULT_LIGHTWEIGHT or domain&#39;s {@code lifecycleState} is not INACTIVE,   returns 400 BAD REQUEST. - If the domain doesn&#39;t exists, returns 404 NOT FOUND. - If the authenticated user is part of the domain to be activated, returns 400 BAD REQUEST - If error occurs while activating domain, returns 500 INTERNAL SERVER ERROR. 
     * @param domainId The OCID of the domain
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public activateDomain(params: {  "domainId": string; "opcRequestId"?: string; "opcRetryToken"?: string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "domainId",
        ], "activateDomain", params);

        const path = `${this.basePath}/domains/{domainId}/actions/activate`
            .replace(`{${"domainId"}}`, `${ params["domainId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"],
                "if-match":  params["ifMatch"]
            },



            operationName: "activateDomain",
            httpMethod: "POST"
        });
    }
    /** 
     * ActivateMfaTotpDevice
     * Activates the specified MFA TOTP device for the user. Activation requires manual interaction with the Console. 
     * @param userId The OCID of the user.
     * @param mfaTotpDeviceId The OCID of the MFA TOTP device.
     * @param mfaTotpToken MFA TOTP token
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public activateMfaTotpDevice(params: {  "userId": string; "mfaTotpDeviceId": string; "mfaTotpToken": MfaTotpToken; "ifMatch"?: string; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: MfaTotpDeviceSummary }> {
        base.validateRequiredParameters([
            "userId",
            "mfaTotpDeviceId",
            "mfaTotpToken",
        ], "activateMfaTotpDevice", params);

        const path = `${this.basePath}/users/{userId}/mfaTotpDevices/{mfaTotpDeviceId}/actions/activate`
            .replace(`{${"userId"}}`, `${ params["userId"] }`)
            .replace(`{${"mfaTotpDeviceId"}}`, `${ params["mfaTotpDeviceId"] }`);

        return this.request<MfaTotpDeviceSummary>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"],
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["mfaTotpToken"]
                    },

            parseResponseBody: true,

            operationName: "activateMfaTotpDevice",
            httpMethod: "POST"
        });
    }
    /** 
     * Activate a deactivated domain
     * If the domain&#39;s {@code lifecycleState} is INACTIVE,   1. Set the {@code lifecycleDetails} to ACTIVATING and asynchronously starts enabling      the domain and return 202 ACCEPTED.         1.1 Sets the domain status to ENABLED and set specified domain&#39;s             {@code lifecycleState} to ACTIVE and set the {@code lifecycleDetails} to null.  To track progress, HTTP GET on /iamWorkRequests/{iamWorkRequestsId} endpoint will provide the async operation&#39;s status. Deactivate a domain can be done using HTTP POST /tasDomains/{tasDomainId}/actions/deactivate.  - If the domain&#39;s {@code lifecycleState} is ACTIVE, returns 202 ACCEPTED with no action   taken on service side. - If domain is of {@code type} DEFAULT or DEFAULT_LIGHTWEIGHT or domain&#39;s {@code lifecycleState} is not INACTIVE,   returns 400 BAD REQUEST. - If the domain doesn&#39;t exists, returns 404 NOT FOUND. - If the authenticated user is part of the domain to be activated, returns 400 BAD REQUEST - If error occurs while activating domain, returns 500 INTERNAL SERVER ERROR. 
     * @param tasDomainId The OCID of the domain
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public activateTasDomain(params: {  "tasDomainId": string; "opcRequestId"?: string; "opcRetryToken"?: string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "tasDomainId",
        ], "activateTasDomain", params);

        const path = `${this.basePath}/tasDomains/{tasDomainId}/actions/activate`
            .replace(`{${"tasDomainId"}}`, `${ params["tasDomainId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"],
                "if-match":  params["ifMatch"]
            },



            operationName: "activateTasDomain",
            httpMethod: "POST"
        });
    }
    /** 
     * AddUserToGroup
     * Adds the specified user to the specified group and returns a &#x60;UserGroupMembership&#x60; object with its own OCID.  After you send your request, the new object&#39;s &#x60;lifecycleState&#x60; will temporarily be CREATING. Before using the object, first make sure its &#x60;lifecycleState&#x60; has changed to ACTIVE. 
     * @param addUserToGroupDetails Request object for adding a user to a group.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public addUserToGroup(params: {  "addUserToGroupDetails": AddUserToGroupDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: UserGroupMembership }> {
        base.validateRequiredParameters([
            "addUserToGroupDetails",
        ], "addUserToGroup", params);

        const path = `${this.basePath}/userGroupMemberships/`;

        return this.request<UserGroupMembership>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["addUserToGroupDetails"]
                    },

            parseResponseBody: true,

            operationName: "addUserToGroup",
            httpMethod: "POST"
        });
    }
    /** 
     * AddUserToIdpGroup
     * Adds the specified user to the identity provider group. 
     * @param identityProviderId The OCID of the identity provider.
     * @param groupId The OCID of the group.
     * @param addUserToIdpGroupDetails Request object for adding a user to an identity provider group
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public addUserToIdpGroup(params: {  "identityProviderId": string; "groupId": string; "addUserToIdpGroupDetails": AddUserToIdpGroupDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: IdentityProviderGroupSummary }> {
        base.validateRequiredParameters([
            "identityProviderId",
            "groupId",
            "addUserToIdpGroupDetails",
        ], "addUserToIdpGroup", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}/groups/{groupId}/actions/addUser`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`)
            .replace(`{${"groupId"}}`, `${ params["groupId"] }`);

        return this.request<IdentityProviderGroupSummary>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["addUserToIdpGroupDetails"]
                    },

            parseResponseBody: true,

            operationName: "addUserToIdpGroup",
            httpMethod: "POST"
        });
    }
    /** 
     * AssembleEffectiveTagSet
     * Assembles tag defaults in the specified compartment and any parent compartments to determine the tags to apply. Tag defaults from parent compartments do not override tag defaults referencing the same tag in a compartment lower down the hierarchy. This set of tag defaults includes all tag defaults from the current compartment back to the root compartment. 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param lifecycleState A filter to only return resources that match the given lifecycle state.  The state value is case-insensitive. 
     */
    public assembleEffectiveTagSet(params: {  "compartmentId": string; "lifecycleState"?: string; }, options?: any): Promise<{ response: Response, data: Array<TagDefaultSummary> }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "assembleEffectiveTagSet", params);

        const path = `${this.basePath}/tagDefaults/actions/assembleEffectiveTagSet`;

        return this.request<Array<TagDefaultSummary>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "lifecycleState": { values: params["lifecycleState"] }
            },



            parseResponseBody: true,

            operationName: "assembleEffectiveTagSet",
            httpMethod: "GET"
        });
    }
    /** 
     * Bootstrap user, groups, policy and default domain
     * This API expects that tenancy OCID to be created before calling it. Accounts will call this API, after creating a root compartment, to bootstrap admin users, admin groups, policy and default domain. Default domain&#39;s {@code licenseType} is set to FREE and {@code displayName} is set to &#39;Default&#39;. A primordial stripe is only created if primordialStripeName is not null or empty. {@code homeRegion} is expected to be same as tenancy home region in region name format.  This is an asynchronous call where the domain status can be queried by calling GET /domains/{domainId} API until the Domain has {@code lifecycleState} set to ACTIVE.  If a default domain already exists, returns 400 Bad Request. If anyone of admin related fields are provided and one of the following 4 fields - {@code adminEmail}, {@code adminLastName}, {@code adminUserName} and {@code adminPassword} - is not provided, returns 400 Bad Request 
     * @param bootstrapDefaultDomainDetails The request object for bootstrap identity entities user, groups, policy and domain 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public bootstrapDefaultDomain(params: {  "bootstrapDefaultDomainDetails": BootstrapDefaultDomainDetails; "opcRetryToken"?: string; "ifMatch"?: string; "opcRequestId"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "bootstrapDefaultDomainDetails",
        ], "bootstrapDefaultDomain", params);

        const path = `${this.basePath}/bootstrapDefaultDomain`;

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"],
                "if-match":  params["ifMatch"],
                "opc-request-id":  params["opcRequestId"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["bootstrapDefaultDomainDetails"]
                    },


            operationName: "bootstrapDefaultDomain",
            httpMethod: "POST"
        });
    }
    /** 
     * Create user, groups, policy and lightweight domain
     * This API expects a compartment for a tenancy created. Accounts will call this API, after creating a compartment, to bootstrap admin users, admin groups, policy and lightweight domain - all these entities are created in IDCP kiev. This API is called only for BOAT or tenancies required during region-bootstrap. 
     * @param bootstrapLightweightDomainDetails The request object for bootstrap identity entities user, groups, policy and domain 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public bootstrapLightweightDomain(params: {  "bootstrapLightweightDomainDetails": BootstrapLightweightDomainDetails; "opcRetryToken"?: string; "ifMatch"?: string; "opcRequestId"?: string; }, options?: any): Promise<{ response: Response, data: BootstrapDomainResponse }> {
        base.validateRequiredParameters([
            "bootstrapLightweightDomainDetails",
        ], "bootstrapLightweightDomain", params);

        const path = `${this.basePath}/bootstrapLightweightDomain`;

        return this.request<BootstrapDomainResponse>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"],
                "if-match":  params["ifMatch"],
                "opc-request-id":  params["opcRequestId"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["bootstrapLightweightDomainDetails"]
                    },

            parseResponseBody: true,

            operationName: "bootstrapLightweightDomain",
            httpMethod: "POST"
        });
    }
    /** 
     * Bulk delete resources in the compartment
     * Deletes multiple resources in the compartment. All resources must be in the same compartment. You must have the appropriate permissions to delete the resources in the request. This API can only be invoked from the tenancy&#39;s [home region](/Content/Identity/Tasks/managingregions.htm#Home). This operation creates a [WorkRequest](#/en/workrequests/20160918/WorkRequest/). Use the [GetWorkRequest](#/en/workrequests/20160918/WorkRequest/GetWorkRequest) API to monitor the status of the bulk action. 
     * @param compartmentId The OCID of the compartment.
     * @param bulkDeleteResourcesDetails Request object for bulk delete resources in a compartment.
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public bulkDeleteResources(params: {  "compartmentId": string; "bulkDeleteResourcesDetails": BulkDeleteResourcesDetails; "opcRequestId"?: string; "opcRetryToken"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "compartmentId",
            "bulkDeleteResourcesDetails",
        ], "bulkDeleteResources", params);

        const path = `${this.basePath}/compartments/{compartmentId}/actions/bulkDeleteResources`
            .replace(`{${"compartmentId"}}`, `${ params["compartmentId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["bulkDeleteResourcesDetails"]
                    },


            operationName: "bulkDeleteResources",
            httpMethod: "POST"
        });
    }
    /** 
     * Delete multiple tag key definitions at the same time
     * Deletes the specified tag key definitions. This operation triggers a process that removes the tags from all resources in your tenancy. The tag key definitions must be within the same tag namespace.  The following actions happen immediately:     * If the tag is a cost-tracking tag, the tag no longer counts against your   10 cost-tracking tags limit, even if you do not disable the tag before running this operation.   * If the tag is used with dynamic groups, the rules that contain the tag are no longer   evaluated against the tag.  After you start this operation, the state of the tag changes to DELETING, and tag removal from resources begins. This process can take up to 48 hours depending on the number of resources that are tagged and the regions in which those resources reside.  When all tags have been removed, the state changes to DELETED. You cannot restore a deleted tag. After the tag state changes to DELETED, you can use the same tag name again.  After you start this operation, you cannot start either the [DeleteTag](#/en/identity/20160918/Tag/DeleteTag) or the [CascadeDeleteTagNamespace](#/en/identity/20160918/TagNamespace/CascadeDeleteTagNamespace) operation until this process completes.  In order to delete tags, you must first retire the tags. Use [UpdateTag](#/en/identity/20160918/Tag/UpdateTag) to retire a tag. 
     * @param bulkDeleteTagsDetails Request object for deleting tags in bulk.
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public bulkDeleteTags(params: {  "bulkDeleteTagsDetails": BulkDeleteTagsDetails; "opcRequestId"?: string; "opcRetryToken"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "bulkDeleteTagsDetails",
        ], "bulkDeleteTags", params);

        const path = `${this.basePath}/tags/actions/bulkDelete`;

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["bulkDeleteTagsDetails"]
                    },


            operationName: "bulkDeleteTags",
            httpMethod: "POST"
        });
    }
    /** 
     * Edit multiple tag key definitions on resources
     * Edits the specified list of tag key definitions for the selected resources.  This operation triggers a process that edits the tags on all selected resources. The possible actions are:    * Add a defined tag when the tag does not already exist on the resource.   * Update the value for a defined tag when the tag is present on the resource.   * Add a defined tag when it does not already exist on the resource or update the value for a defined tag when the tag is present on the resource.   * Remove a defined tag from a resource. The tag is removed from the resource regardless of the tag value.  See [BulkEditOperationDetails](#/en/identity/latest/datatypes/BulkEditOperationDetails) for more information.  The edits can include a combination of operations and tag sets.  However, multiple operations cannot apply to one key definition in the same request. For example, if one request adds &#x60;tag set-1&#x60; to a resource and sets a tag value to &#x60;tag set-2&#x60;,  &#x60;tag set-1&#x60; and &#x60;tag set-2&#x60; cannot have any common tag definitions. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param bulkEditTagsDetails The request object for bulk editing tags on resources in the compartment.
     */
    public bulkEditTags(params: {  "opcRequestId"?: string; "opcRetryToken"?: string; "bulkEditTagsDetails"?: BulkEditTagsDetails; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
        ], "bulkEditTags", params);

        const path = `${this.basePath}/tags/actions/bulkEdit`;

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: !params["bulkEditTagsDetails"] ? undefined : 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["bulkEditTagsDetails"]
                    },


            operationName: "bulkEditTags",
            httpMethod: "POST"
        });
    }
    /** 
     * Move multiple resources at once to a different compartment.
     * Moves multiple resources from one compartment to another. All resources must be in the same compartment. This API can only be invoked from the tenancy&#39;s [home region](/Content/Identity/Tasks/managingregions.htm#Home). To move resources, you must have the appropriate permissions to move the resource in both the source and target compartments. This operation creates a [WorkRequest](#/en/workrequests/20160918/WorkRequest/). Use the [GetWorkRequest](#/en/workrequests/20160918/WorkRequest/GetWorkRequest) API to monitor the status of the bulk action. 
     * @param compartmentId The OCID of the compartment.
     * @param bulkMoveResourcesDetails Request object for bulk move resources in the compartment.
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public bulkMoveResources(params: {  "compartmentId": string; "bulkMoveResourcesDetails": BulkMoveResourcesDetails; "opcRequestId"?: string; "opcRetryToken"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "compartmentId",
            "bulkMoveResourcesDetails",
        ], "bulkMoveResources", params);

        const path = `${this.basePath}/compartments/{compartmentId}/actions/bulkMoveResources`
            .replace(`{${"compartmentId"}}`, `${ params["compartmentId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["bulkMoveResourcesDetails"]
                    },


            operationName: "bulkMoveResources",
            httpMethod: "POST"
        });
    }
    /** 
     * Delete tag namespace that contains tags
     * Deletes the specified tag namespace. This operation triggers a process that removes all of the tags defined in the specified tag namespace from all resources in your tenancy and then deletes the tag namespace.  After you start the delete operation:    * New tag key definitions cannot be created under the namespace.   * The state of the tag namespace changes to DELETING.   * Tag removal from the resources begins.  This process can take up to 48 hours depending on the number of tag definitions in the namespace, the number of resources that are tagged, and the locations of the regions in which those resources reside.  After all tags are removed, the state changes to DELETED. You cannot restore a deleted tag namespace. After the deleted tag namespace changes its state to DELETED, you can use the name of the deleted tag namespace again.  After you start this operation, you cannot start either the [DeleteTag](#/en/identity/20160918/Tag/DeleteTag) or the [BulkDeleteTags](#/en/identity/20160918/Tag/BulkDeleteTags) operation until this process completes.  To delete a tag namespace, you must first retire it. Use [UpdateTagNamespace](#/en/identity/20160918/TagNamespace/UpdateTagNamespace) to retire a tag namespace. 
     * @param tagNamespaceId The OCID of the tag namespace. 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public cascadeDeleteTagNamespace(params: {  "tagNamespaceId": string; "ifMatch"?: string; "opcRequestId"?: string; "opcRetryToken"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "tagNamespaceId",
        ], "cascadeDeleteTagNamespace", params);

        const path = `${this.basePath}/tagNamespaces/{tagNamespaceId}/actions/cascadeDelete`
            .replace(`{${"tagNamespaceId"}}`, `${ params["tagNamespaceId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"],
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"]
            },



            operationName: "cascadeDeleteTagNamespace",
            httpMethod: "POST"
        });
    }
    /** 
     * Change domain compartment
     * Change the containing compartment for a domain.  This is an asynchronous call where the Domain&#39;s compartment is changed and is updated with the new compartment information. To track progress, HTTP GET on /iamWorkRequests/{iamWorkRequestsId} endpoint will provide the async operation&#39;s status.  The compartment change is complete when accessed via domain URL and also returns new compartment OCID. - If the domain doesn&#39;t exists, returns 404 NOT FOUND. - If Domain {@code type} is DEFAULT or DEFAULT_LIGHTWEIGHT, return 400 BAD Request - If Domain is not active or being updated, returns 400 BAD REQUEST. - If error occurs while changing compartment for domain, return 500 INTERNAL SERVER ERROR. 
     * @param domainId The OCID of the domain
     * @param changeDomainCompartmentDetails the request object for moving compartment of a domain
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public changeDomainCompartment(params: {  "domainId": string; "changeDomainCompartmentDetails": ChangeDomainCompartmentDetails; "opcRequestId"?: string; "opcRetryToken"?: string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "domainId",
            "changeDomainCompartmentDetails",
        ], "changeDomainCompartment", params);

        const path = `${this.basePath}/domains/{domainId}/actions/changeCompartment`
            .replace(`{${"domainId"}}`, `${ params["domainId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"],
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["changeDomainCompartmentDetails"]
                    },


            operationName: "changeDomainCompartment",
            httpMethod: "POST"
        });
    }
    /** 
     * Change the LicenseType of a domain
     * If the domain&#39;s {@code lifecycleState} is ACTIVE, validates the requested {@code licenseType} update is allowed and 1. Set the {@code lifecycleDetails} to UPDATING 2. Asynchronously starts updating the domain and return 202 ACCEPTED.     2.1 Successfully updates specified domain&#39;s {@code licenseType}. 3. On completion set the {@code lifecycleDetails} to null. To track progress, HTTP GET on /iamWorkRequests/{iamWorkRequestsId} endpoint will provide the async operation&#39;s status.  - If license type update is successful, return 202 ACCEPTED - If requested {@code licenseType} validation fails, returns 400 Bad request. - If Domain is not active or being updated, returns 400 BAD REQUEST. - If Domain {@code type} is DEFAULT or DEFAULT_LIGHTWEIGHT, return 400 BAD Request - If the domain doesn&#39;t exists, returns 404 NOT FOUND - If any internal error occurs, returns 500 INTERNAL SERVER ERROR. 
     * @param domainId The OCID of the domain
     * @param changeDomainLicenseTypeDetails the request object for domain license type update
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public changeDomainLicenseType(params: {  "domainId": string; "changeDomainLicenseTypeDetails": ChangeDomainLicenseTypeDetails; "opcRequestId"?: string; "opcRetryToken"?: string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "domainId",
            "changeDomainLicenseTypeDetails",
        ], "changeDomainLicenseType", params);

        const path = `${this.basePath}/domains/{domainId}/actions/changeLicenseType`
            .replace(`{${"domainId"}}`, `${ params["domainId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"],
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["changeDomainLicenseTypeDetails"]
                    },


            operationName: "changeDomainLicenseType",
            httpMethod: "POST"
        });
    }
    /** 
     * changes compartment of a tag namespace.
     * Moves the specified tag namespace to the specified compartment within the same tenancy.  To move the tag namespace, you must have the manage tag-namespaces permission on both compartments. For more information about IAM policies, see [Details for IAM](/Content/Identity/Reference/iampolicyreference.htm).  Moving a tag namespace moves all the tag key definitions contained in the tag namespace. 
     * @param tagNamespaceId The OCID of the tag namespace. 
     * @param changeTagNamespaceCompartmentDetail Request object for changing the compartment of a tag namespace.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public changeTagNamespaceCompartment(params: {  "tagNamespaceId": string; "changeTagNamespaceCompartmentDetail": ChangeTagNamespaceCompartmentDetail; "opcRetryToken"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "tagNamespaceId",
            "changeTagNamespaceCompartmentDetail",
        ], "changeTagNamespaceCompartment", params);

        const path = `${this.basePath}/tagNamespaces/{tagNamespaceId}/actions/changeCompartment`
            .replace(`{${"tagNamespaceId"}}`, `${ params["tagNamespaceId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["changeTagNamespaceCompartmentDetail"]
                    },


            operationName: "changeTagNamespaceCompartment",
            httpMethod: "POST"
        });
    }
    /** 
     * Change the LicenseType of a domain
     * If the domain&#39;s {@code lifecycleState} is ACTIVE, validates the requested {@code licenseType} update is allowed and     1. Set the {@code lifecycleDetails} to UPDATING     2. Asynchronously starts updating the domain and return 202 ACCEPTED.         2.1 Successfully  updates specified domain&#39;s {@code licenseType}.     3. On completion set the {@code lifecycleDetails} to null.        To track progress, HTTP GET on /iamWorkRequests/{iamWorkRequestsId} endpoint will provide        the async operation&#39;s status.  - If license type update is successful, return 202 ACCEPTED - If requested {@code licenseType} validation fails, returns 400 Bad request. - If Domain is not active or being updated, returns 400 BAD REQUEST. - If Domain {@code type} is DEFAULT or DEFAULT_LIGHTWEIGHT, return 400 BAD Request - If the domain doesn&#39;t exists, returns 404 NOT FOUND - If any internal error occurs, returns 500 INTERNAL SERVER ERROR. 
     * @param tasDomainId The OCID of the domain
     * @param changeTasDomainLicenseTypeDetails the request object for domain license type update
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public changeTasDomainLicenseType(params: {  "tasDomainId": string; "changeTasDomainLicenseTypeDetails": ChangeTasDomainLicenseTypeDetails; "opcRequestId"?: string; "opcRetryToken"?: string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "tasDomainId",
            "changeTasDomainLicenseTypeDetails",
        ], "changeTasDomainLicenseType", params);

        const path = `${this.basePath}/tasDomains/{tasDomainId}/actions/changeLicenseType`
            .replace(`{${"tasDomainId"}}`, `${ params["tasDomainId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"],
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["changeTasDomainLicenseTypeDetails"]
                    },


            operationName: "changeTasDomainLicenseType",
            httpMethod: "POST"
        });
    }
    /** 
     * Claim a stripe
     * Claim a stripe with a new domain. A secondary domain is created and associated with given stripe. This is an asynchronous call - where, at start, {@code lifecycleState} of this domain is set to CREATING and after stripe association the Domain&#39;s {@code lifecycleState} will be set to set to ACTIVE.  The domain status can be queried by calling GET /domains/{domainId} API until the Domain has {@code lifecycleState} set to ACTIVE. 
     * @param claimStripeDetails The request object for claiming stripe
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public claimStripe(params: {  "claimStripeDetails": ClaimStripeDetails; "opcRetryToken"?: string; "opcRequestId"?: string; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: ClaimStripeDomainResponse }> {
        base.validateRequiredParameters([
            "claimStripeDetails",
        ], "claimStripe", params);

        const path = `${this.basePath}/claimStripe`;

        return this.request<ClaimStripeDomainResponse>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"],
                "opc-request-id":  params["opcRequestId"],
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["claimStripeDetails"]
                    },

            parseResponseBody: true,

            operationName: "claimStripe",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateAuthToken
     * Creates a new auth token for the specified user. For information about what auth tokens are for, see [Managing User Credentials](/Content/Identity/Tasks/managingcredentials.htm).  You must specify a *description* for the auth token (although it can be an empty string). It does not have to be unique, and you can change it anytime with [UpdateAuthToken](#/en/identity/20160918/AuthToken/UpdateAuthToken).  Every user has permission to create an auth token for *their own user ID*. An administrator in your organization does not need to write a policy to give users this ability. To compare, administrators who have permission to the tenancy can use this operation to create an auth token for any user, including themselves. 
     * @param createAuthTokenDetails Request object for creating a new auth token.
     * @param userId The OCID of the user.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createAuthToken(params: {  "createAuthTokenDetails": CreateAuthTokenDetails; "userId": string; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: AuthToken }> {
        base.validateRequiredParameters([
            "createAuthTokenDetails",
            "userId",
        ], "createAuthToken", params);

        const path = `${this.basePath}/users/{userId}/authTokens/`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<AuthToken>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createAuthTokenDetails"]
                    },

            parseResponseBody: true,

            operationName: "createAuthToken",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateAuthenticationRecord
     * Created a user&#39;s authentication record. 
     * @param createAuthenticationRecordDetails Request object for updating authentication record.
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createAuthenticationRecord(params: {  "createAuthenticationRecordDetails": CreateAuthenticationRecordDetails; "opcRequestId"?: string; "opcRetryToken"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "createAuthenticationRecordDetails",
        ], "createAuthenticationRecord", params);

        const path = `${this.basePath}/authenticationRecord/`;

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createAuthenticationRecordDetails"]
                    },


            operationName: "createAuthenticationRecord",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateCompartment
     * Creates a new compartment in the specified compartment.  **Important:** Compartments cannot be deleted.  Specify the parent compartment&#39;s OCID as the compartment ID in the request object. Remember that the tenancy is simply the root compartment. For information about OCIDs, see [Resource Identifiers](/Content/General/Concepts/identifiers.htm).  You must also specify a *name* for the compartment, which must be unique across all compartments in your tenancy. You can use this name or the OCID when writing policies that apply to the compartment. For more information about policies, see [How Policies Work](/Content/Identity/Concepts/policies.htm).  You must also specify a *description* for the compartment (although it can be an empty string). It does not have to be unique, and you can change it anytime with [UpdateCompartment](#/en/identity/20160918/Compartment/UpdateCompartment).  After you send your request, the new object&#39;s &#x60;lifecycleState&#x60; will temporarily be CREATING. Before using the object, first make sure its &#x60;lifecycleState&#x60; has changed to ACTIVE. 
     * @param createCompartmentDetails Request object for creating a new compartment.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createCompartment(params: {  "createCompartmentDetails": CreateCompartmentDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: Compartment }> {
        base.validateRequiredParameters([
            "createCompartmentDetails",
        ], "createCompartment", params);

        const path = `${this.basePath}/compartments/`;

        return this.request<Compartment>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createCompartmentDetails"]
                    },

            parseResponseBody: true,

            operationName: "createCompartment",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateCustomerSecretKey
     * Creates a new secret key for the specified user. Secret keys are used for authentication with the Object Storage Service&#39;s Amazon S3 compatible API. The secret key consists of an Access Key/Secret Key pair. For information, see [Managing User Credentials](/Content/Identity/Tasks/managingcredentials.htm).  You must specify a *description* for the secret key (although it can be an empty string). It does not have to be unique, and you can change it anytime with [UpdateCustomerSecretKey](#/en/identity/20160918/CustomerSecretKeySummary/UpdateCustomerSecretKey).  Every user has permission to create a secret key for *their own user ID*. An administrator in your organization does not need to write a policy to give users this ability. To compare, administrators who have permission to the tenancy can use this operation to create a secret key for any user, including themselves. 
     * @param createCustomerSecretKeyDetails Request object for creating a new secret key.
     * @param userId The OCID of the user.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createCustomerSecretKey(params: {  "createCustomerSecretKeyDetails": CreateCustomerSecretKeyDetails; "userId": string; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: CustomerSecretKey }> {
        base.validateRequiredParameters([
            "createCustomerSecretKeyDetails",
            "userId",
        ], "createCustomerSecretKey", params);

        const path = `${this.basePath}/users/{userId}/customerSecretKeys/`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<CustomerSecretKey>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createCustomerSecretKeyDetails"]
                    },

            parseResponseBody: true,

            operationName: "createCustomerSecretKey",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateDbCredential
     * Creates a new DB credential for the specified user. 
     * @param createDbCredentialDetails Request object for creating a new DB credential with the user.
     * @param userId The OCID of the user.
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createDbCredential(params: {  "createDbCredentialDetails": CreateDbCredentialDetails; "userId": string; "opcRequestId"?: string; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: DbCredential }> {
        base.validateRequiredParameters([
            "createDbCredentialDetails",
            "userId",
        ], "createDbCredential", params);

        const path = `${this.basePath}/users/{userId}/dbCredentials/`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<DbCredential>({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createDbCredentialDetails"]
                    },

            parseResponseBody: true,

            operationName: "createDbCredential",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateDomain
     * Creates a new domain in the tenancy with domain home in {@code homeRegion}. This is an asynchronous call - where, at start, {@code lifecycleState} of this domain is set to CREATING and {@code lifecycleDetails} to UPDATING. On domain creation completion this Domain&#39;s {@code lifecycleState} will be set to ACTIVE and {@code lifecycleDetails} to null.  To track progress, HTTP GET on /iamWorkRequests/{iamWorkRequestsId} endpoint will provide the async operation&#39;s status.  After creating a &#x60;Domain&#x60;, make sure its &#x60;lifecycleState&#x60; changes from CREATING to ACTIVE before using it. If the domain&#39;s {@code displayName} already exists, returns 400 BAD REQUEST. If any one of admin related fields are provided and one of the following 3 fields - {@code adminEmail}, {@code adminLastName} and {@code adminUserName} - is not provided, returns 400 BAD REQUEST. - If {@code isNotificationBypassed} is NOT provided when admin information is provided, returns 400 BAD REQUEST. - If any internal error occurs, return 500 INTERNAL SERVER ERROR. 
     * @param createDomainDetails The request object for creating a new domain
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public createDomain(params: {  "createDomainDetails": CreateDomainDetails; "opcRetryToken"?: string; "opcRequestId"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "createDomainDetails",
        ], "createDomain", params);

        const path = `${this.basePath}/domains/`;

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"],
                "opc-request-id":  params["opcRequestId"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createDomainDetails"]
                    },


            operationName: "createDomain",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateDynamicGroup
     * Creates a new dynamic group in your tenancy.  You must specify your tenancy&#39;s OCID as the compartment ID in the request object (remember that the tenancy is simply the root compartment). Notice that IAM resources (users, groups, compartments, and some policies) reside within the tenancy itself, unlike cloud resources such as compute instances, which typically reside within compartments inside the tenancy. For information about OCIDs, see [Resource Identifiers](/Content/General/Concepts/identifiers.htm).  You must also specify a *name* for the dynamic group, which must be unique across all dynamic groups in your tenancy, and cannot be changed. Note that this name has to be also unique across all groups in your tenancy. You can use this name or the OCID when writing policies that apply to the dynamic group. For more information about policies, see [How Policies Work](/Content/Identity/Concepts/policies.htm).  You must also specify a *description* for the dynamic group (although it can be an empty string). It does not have to be unique, and you can change it anytime with [UpdateDynamicGroup](#/en/identity/20160918/DynamicGroup/UpdateDynamicGroup).  After you send your request, the new object&#39;s &#x60;lifecycleState&#x60; will temporarily be CREATING. Before using the object, first make sure its &#x60;lifecycleState&#x60; has changed to ACTIVE. 
     * @param createDynamicGroupDetails Request object for creating a new dynamic group.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createDynamicGroup(params: {  "createDynamicGroupDetails": CreateDynamicGroupDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: DynamicGroup }> {
        base.validateRequiredParameters([
            "createDynamicGroupDetails",
        ], "createDynamicGroup", params);

        const path = `${this.basePath}/dynamicGroups/`;

        return this.request<DynamicGroup>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createDynamicGroupDetails"]
                    },

            parseResponseBody: true,

            operationName: "createDynamicGroup",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateGroup
     * Creates a new group in your tenancy.  You must specify your tenancy&#39;s OCID as the compartment ID in the request object (remember that the tenancy is simply the root compartment). Notice that IAM resources (users, groups, compartments, and some policies) reside within the tenancy itself, unlike cloud resources such as compute instances, which typically reside within compartments inside the tenancy. For information about OCIDs, see [Resource Identifiers](/Content/General/Concepts/identifiers.htm).  You must also specify a *name* for the group, which must be unique across all groups in your tenancy and cannot be changed. You can use this name or the OCID when writing policies that apply to the group. For more information about policies, see [How Policies Work](/Content/Identity/Concepts/policies.htm).  You must also specify a *description* for the group (although it can be an empty string). It does not have to be unique, and you can change it anytime with [UpdateGroup](#/en/identity/20160918/Group/UpdateGroup).  After you send your request, the new object&#39;s &#x60;lifecycleState&#x60; will temporarily be CREATING. Before using the object, first make sure its &#x60;lifecycleState&#x60; has changed to ACTIVE.  After creating the group, you need to put users in it and write policies for it. See [AddUserToGroup](#/en/identity/20160918/UserGroupMembership/AddUserToGroup) and [CreatePolicy](#/en/identity/20160918/Policy/CreatePolicy). 
     * @param createGroupDetails Request object for creating a new group.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createGroup(params: {  "createGroupDetails": CreateGroupDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: Group }> {
        base.validateRequiredParameters([
            "createGroupDetails",
        ], "createGroup", params);

        const path = `${this.basePath}/groups/`;

        return this.request<Group>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createGroupDetails"]
                    },

            parseResponseBody: true,

            operationName: "createGroup",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateIdentityProvider
     * **Deprecated.** For more information, see [Deprecated IAM Service APIs](/Content/Identity/Reference/deprecatediamapis.htm).  Creates a new identity provider in your tenancy. For more information, see [Identity Providers and Federation](/Content/Identity/Concepts/federation.htm).  You must specify your tenancy&#39;s OCID as the compartment ID in the request object. Remember that the tenancy is simply the root compartment. For information about OCIDs, see [Resource Identifiers](/Content/General/Concepts/identifiers.htm).  You must also specify a *name* for the &#x60;IdentityProvider&#x60;, which must be unique across all &#x60;IdentityProvider&#x60; objects in your tenancy and cannot be changed.  You must also specify a *description* for the &#x60;IdentityProvider&#x60; (although it can be an empty string). It does not have to be unique, and you can change it anytime with [UpdateIdentityProvider](#/en/identity/20160918/IdentityProvider/UpdateIdentityProvider).  After you send your request, the new object&#39;s &#x60;lifecycleState&#x60; will temporarily be CREATING. Before using the object, first make sure its &#x60;lifecycleState&#x60; has changed to ACTIVE. 
     * @param createIdentityProviderDetails Request object for creating a new SAML2 identity provider.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createIdentityProvider(params: {  "createIdentityProviderDetails": CreateIdentityProviderDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: IdentityProvider }> {
        base.validateRequiredParameters([
            "createIdentityProviderDetails",
        ], "createIdentityProvider", params);

        const path = `${this.basePath}/identityProviders/`;

        return this.request<IdentityProvider>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createIdentityProviderDetails"]
                    },

            parseResponseBody: true,

            operationName: "createIdentityProvider",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateIdentityProviderGroup
     * Create an identity provider group. 
     * @param identityProviderId The OCID of the identity provider.
     * @param createIdpGroupDetails Request object for creating a new identity provider group
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createIdentityProviderGroup(params: {  "identityProviderId": string; "createIdpGroupDetails": CreateIdpGroupDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: IdentityProviderGroupSummary }> {
        base.validateRequiredParameters([
            "identityProviderId",
            "createIdpGroupDetails",
        ], "createIdentityProviderGroup", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}/groups/`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`);

        return this.request<IdentityProviderGroupSummary>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createIdpGroupDetails"]
                    },

            parseResponseBody: true,

            operationName: "createIdentityProviderGroup",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateIdpGroupMapping
     * **Deprecated.** For more information, see [Deprecated IAM Service APIs](/Content/Identity/Reference/deprecatediamapis.htm).  Creates a single mapping between an IdP group and an IAM Service [group](#/en/identity/20160918/Group/). 
     * @param createIdpGroupMappingDetails Add a mapping from an SAML2.0 identity provider group to a BMC group.
     * @param identityProviderId The OCID of the identity provider.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createIdpGroupMapping(params: {  "createIdpGroupMappingDetails": CreateIdpGroupMappingDetails; "identityProviderId": string; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: IdpGroupMapping }> {
        base.validateRequiredParameters([
            "createIdpGroupMappingDetails",
            "identityProviderId",
        ], "createIdpGroupMapping", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}/groupMappings/`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`);

        return this.request<IdpGroupMapping>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createIdpGroupMappingDetails"]
                    },

            parseResponseBody: true,

            operationName: "createIdpGroupMapping",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateIdpUser
     * Create an identity provider user. 
     * @param identityProviderId The OCID of the identity provider.
     * @param createIdpUserDetails Request object for creating a new identity provider user
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createIdpUser(params: {  "identityProviderId": string; "createIdpUserDetails": CreateIdpUserDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: User }> {
        base.validateRequiredParameters([
            "identityProviderId",
            "createIdpUserDetails",
        ], "createIdpUser", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}/users`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`);

        return this.request<User>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createIdpUserDetails"]
                    },

            parseResponseBody: true,

            operationName: "createIdpUser",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateManagedCompartment
     * Creates a new managed compartment in your tenancy.  **Important:** Managed Compartments can only be created by whitelisted service callers.  You must specify tenancy&#39;s OCID as the value for the compartment ID (remember that the tenancy is simply the root compartment). You also must specify compartment name, description, service name and service entitlement id in the request object.  After you send your request, the new object&#39;s &#x60;lifecycleState&#x60; will temporarily be CREATING. Before using the object, first make sure its &#x60;lifecycleState&#x60; has changed to ACTIVE. 
     * @param createManagedCompartmentDetails Request object for creating a new managed compartment.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createManagedCompartment(params: {  "createManagedCompartmentDetails": CreateManagedCompartmentDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: Compartment }> {
        base.validateRequiredParameters([
            "createManagedCompartmentDetails",
        ], "createManagedCompartment", params);

        const path = `${this.basePath}/managedCompartments/`;

        return this.request<Compartment>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createManagedCompartmentDetails"]
                    },

            parseResponseBody: true,

            operationName: "createManagedCompartment",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateMfaTotpDevice
     * Creates a new MFA TOTP device for the user. A user can have one MFA TOTP device. 
     * @param userId The OCID of the user.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createMfaTotpDevice(params: {  "userId": string; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: MfaTotpDevice }> {
        base.validateRequiredParameters([
            "userId",
        ], "createMfaTotpDevice", params);

        const path = `${this.basePath}/users/{userId}/mfaTotpDevices`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<MfaTotpDevice>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },


            parseResponseBody: true,

            operationName: "createMfaTotpDevice",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateNetworkSource
     * Creates a new network source in your tenancy.  You must specify your tenancy&#39;s OCID as the compartment ID in the request object (remember that the tenancy is simply the root compartment). Notice that IAM resources (users, groups, compartments, and some policies) reside within the tenancy itself, unlike cloud resources such as compute instances, which typically reside within compartments inside the tenancy. For information about OCIDs, see [Resource Identifiers](/Content/General/Concepts/identifiers.htm).  You must also specify a *name* for the network source, which must be unique across all network sources in your tenancy, and cannot be changed. You can use this name or the OCID when writing policies that apply to the network source. For more information about policies, see [How Policies Work](/Content/Identity/Concepts/policies.htm).  You must also specify a *description* for the network source (although it can be an empty string). It does not have to be unique, and you can change it anytime with [UpdateNetworkSource](#/en/identity/20160918/NetworkSource/UpdateNetworkSource).  After you send your request, the new object&#39;s &#x60;lifecycleState&#x60; will temporarily be CREATING. Before using the object, first make sure its &#x60;lifecycleState&#x60; has changed to ACTIVE.  After your network resource is created, you can use it in policy to restrict access to only requests made from an allowed IP address specified in your network source. For more information, see [Managing Network Sources](/Content/Identity/Tasks/managingnetworksources.htm). 
     * @param createNetworkSourceDetails Request object for creating a new network source.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createNetworkSource(params: {  "createNetworkSourceDetails": CreateNetworkSourceDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: NetworkSources }> {
        base.validateRequiredParameters([
            "createNetworkSourceDetails",
        ], "createNetworkSource", params);

        const path = `${this.basePath}/networkSources`;

        return this.request<NetworkSources>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createNetworkSourceDetails"]
                    },

            parseResponseBody: true,

            operationName: "createNetworkSource",
            httpMethod: "POST"
        });
    }
    /** 
     * Creates Oauth token for the user
     * Creates Oauth token for the user 
     * @param userId The OCID of the user.
     * @param createOAuth2ClientCredentialDetails Request object containing the information required to generate an Oauth token.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createOAuthClientCredential(params: {  "userId": string; "createOAuth2ClientCredentialDetails": CreateOAuth2ClientCredentialDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: OAuth2ClientCredential }> {
        base.validateRequiredParameters([
            "userId",
            "createOAuth2ClientCredentialDetails",
        ], "createOAuthClientCredential", params);

        const path = `${this.basePath}/users/{userId}/oauth2ClientCredentials`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<OAuth2ClientCredential>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createOAuth2ClientCredentialDetails"]
                    },

            parseResponseBody: true,

            operationName: "createOAuthClientCredential",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateOidcClient
     * Creates a Identity OpenID Connect client, a.k.a. OpenID Connect client registration. 
     * @param createOidcClientDetails Request object for creating a new OpenID Connect client.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createOidcClient(params: {  "createOidcClientDetails": CreateOidcClientDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: OidcClient }> {
        base.validateRequiredParameters([
            "createOidcClientDetails",
        ], "createOidcClient", params);

        const path = `${this.basePath}/oidcClients/`;

        return this.request<OidcClient>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createOidcClientDetails"]
                    },

            parseResponseBody: true,

            operationName: "createOidcClient",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateOnPremSite
     * Creates a new onPremSite in the specified tenant.  You must use tenant id as the *compartmentId*.  You must also specify a *name* for the onPremSite, which must be unique across in your tenancy. *description* is also required. However, it does not have to be unique.  You must also specify *address*, which is the details of the OnPremSite physical address.  You must define at least one *contact* in *contacts*. You must have exactly one primary contact (i.e isPrimary&#x3D;true). You can have at most 10 total contacts (including primary). 
     * @param createOnPremSiteDetails Request details for creating a new compartment.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public createOnPremSite(params: {  "createOnPremSiteDetails": CreateOnPremSiteDetails; "opcRetryToken"?: string; "opcRequestId"?: string; }, options?: any): Promise<{ response: Response, data: OnPremSite }> {
        base.validateRequiredParameters([
            "createOnPremSiteDetails",
        ], "createOnPremSite", params);

        const path = `${this.basePath}/onPremSites`;

        return this.request<OnPremSite>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"],
                "opc-request-id":  params["opcRequestId"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createOnPremSiteDetails"]
                    },

            parseResponseBody: true,

            operationName: "createOnPremSite",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateOrResetUIPassword
     * Creates a new Console one-time password for the specified user. For more information about user credentials, see [User Credentials](/Content/Identity/Concepts/usercredentials.htm).  Use this operation after creating a new user, or if a user forgets their password. The new one-time password is returned to you in the response, and you must securely deliver it to the user. They&#39;ll be prompted to change this password the next time they sign in to the Console. If they don&#39;t change it within 7 days, the password will expire and you&#39;ll need to create a new one-time password for the user.  **Note:** The user&#39;s Console login is the unique name you specified when you created the user (see [CreateUser](#/en/identity/20160918/User/CreateUser)). 
     * @param userId The OCID of the user.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createOrResetUIPassword(params: {  "userId": string; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: UIPassword }> {
        base.validateRequiredParameters([
            "userId",
        ], "createOrResetUIPassword", params);

        const path = `${this.basePath}/users/{userId}/uiPassword`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<UIPassword>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },


            parseResponseBody: true,

            operationName: "createOrResetUIPassword",
            httpMethod: "POST"
        });
    }
    /** 
     * CreatePolicy
     * Creates a new policy in the specified compartment (either the tenancy or another of your compartments). If you&#39;re new to policies, see [Getting Started with Policies](/Content/Identity/Concepts/policygetstarted.htm).  You must specify a *name* for the policy, which must be unique across all policies in your tenancy and cannot be changed.  You must also specify a *description* for the policy (although it can be an empty string). It does not have to be unique, and you can change it anytime with [UpdatePolicy](#/en/identity/20160918/Policy/UpdatePolicy).  You must specify one or more policy statements in the statements array. For information about writing policies, see [How Policies Work](/Content/Identity/Concepts/policies.htm) and [Common Policies](/Content/Identity/Concepts/commonpolicies.htm).  After you send your request, the new object&#39;s &#x60;lifecycleState&#x60; will temporarily be CREATING. Before using the object, first make sure its &#x60;lifecycleState&#x60; has changed to ACTIVE.  New policies take effect typically within 10 seconds. 
     * @param createPolicyDetails Request object for creating a new policy.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createPolicy(params: {  "createPolicyDetails": CreatePolicyDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: Policy }> {
        base.validateRequiredParameters([
            "createPolicyDetails",
        ], "createPolicy", params);

        const path = `${this.basePath}/policies/`;

        return this.request<Policy>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createPolicyDetails"]
                    },

            parseResponseBody: true,

            operationName: "createPolicy",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateRegionSubscription
     * Creates a subscription to a region for a tenancy. 
     * @param createRegionSubscriptionDetails Request object for activate a new region.
     * @param tenancyId The OCID of the tenancy.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createRegionSubscription(params: {  "createRegionSubscriptionDetails": CreateRegionSubscriptionDetails; "tenancyId": string; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: RegionSubscription }> {
        base.validateRequiredParameters([
            "createRegionSubscriptionDetails",
            "tenancyId",
        ], "createRegionSubscription", params);

        const path = `${this.basePath}/tenancies/{tenancyId}/regionSubscriptions`
            .replace(`{${"tenancyId"}}`, `${ params["tenancyId"] }`);

        return this.request<RegionSubscription>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createRegionSubscriptionDetails"]
                    },

            parseResponseBody: true,

            operationName: "createRegionSubscription",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateServiceManager
     * Create a service manager. 
     * @param createServiceManagerDetails Request object for creating a new service manager.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createServiceManager(params: {  "createServiceManagerDetails": CreateServiceManagerDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: ServiceManager }> {
        base.validateRequiredParameters([
            "createServiceManagerDetails",
        ], "createServiceManager", params);

        const path = `${this.basePath}/serviceManagers/`;

        return this.request<ServiceManager>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createServiceManagerDetails"]
                    },

            parseResponseBody: true,

            operationName: "createServiceManager",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateSmtpCredential
     * Creates a new SMTP credential for the specified user. An SMTP credential has an SMTP user name and an SMTP password. You must specify a *description* for the SMTP credential (although it can be an empty string). It does not have to be unique, and you can change it anytime with [UpdateSmtpCredential](#/en/identity/20160918/SmtpCredentialSummary/UpdateSmtpCredential). 
     * @param createSmtpCredentialDetails Request object for creating a new SMTP credential with the user.
     * @param userId The OCID of the user.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createSmtpCredential(params: {  "createSmtpCredentialDetails": CreateSmtpCredentialDetails; "userId": string; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: SmtpCredential }> {
        base.validateRequiredParameters([
            "createSmtpCredentialDetails",
            "userId",
        ], "createSmtpCredential", params);

        const path = `${this.basePath}/users/{userId}/smtpCredentials/`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<SmtpCredential>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createSmtpCredentialDetails"]
                    },

            parseResponseBody: true,

            operationName: "createSmtpCredential",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateStripe
     * Creates a new stripe in your tenancy. For conceptual information about stripes, your tenancy, and other IAM Service components, see [Overview of the IAM Service](/Content/Identity/Concepts/overview.htm).  Your tenancy&#39;s OCID as the value for the compartment ID (remember that the tenancy is simply the root compartment) and region to create stripe. 
     * @param createStripeDetails Request object for creating a new stripe.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createStripe(params: {  "createStripeDetails": CreateStripeDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: Stripe }> {
        base.validateRequiredParameters([
            "createStripeDetails",
        ], "createStripe", params);

        const path = `${this.basePath}/stripes/`;

        return this.request<Stripe>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createStripeDetails"]
                    },

            parseResponseBody: true,

            operationName: "createStripe",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateSwiftPassword
     * **Deprecated. Use [CreateAuthToken](#/en/identity/20160918/AuthToken/CreateAuthToken) instead.**  Creates a new Swift password for the specified user. For information about what Swift passwords are for, see [Managing User Credentials](/Content/Identity/Tasks/managingcredentials.htm).  You must specify a *description* for the Swift password (although it can be an empty string). It does not have to be unique, and you can change it anytime with [UpdateSwiftPassword](#/en/identity/20160918/SwiftPassword/UpdateSwiftPassword).  Every user has permission to create a Swift password for *their own user ID*. An administrator in your organization does not need to write a policy to give users this ability. To compare, administrators who have permission to the tenancy can use this operation to create a Swift password for any user, including themselves. 
     * @param createSwiftPasswordDetails Request object for creating a new swift password.
     * @param userId The OCID of the user.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createSwiftPassword(params: {  "createSwiftPasswordDetails": CreateSwiftPasswordDetails; "userId": string; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: SwiftPassword }> {
        base.validateRequiredParameters([
            "createSwiftPasswordDetails",
            "userId",
        ], "createSwiftPassword", params);

        const path = `${this.basePath}/users/{userId}/swiftPasswords/`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<SwiftPassword>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createSwiftPasswordDetails"]
                    },

            parseResponseBody: true,

            operationName: "createSwiftPassword",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateTag
     * Creates a new tag in the specified tag namespace.  The tag requires either the OCID or the name of the tag namespace that will contain this tag definition.  You must specify a *name* for the tag, which must be unique across all tags in the tag namespace and cannot be changed. The name can contain any ASCII character except the space (_) or period (.) characters. Names are case insensitive. That means, for example, \&quot;myTag\&quot; and \&quot;mytag\&quot; are not allowed in the same namespace. If you specify a name that&#39;s already in use in the tag namespace, a 409 error is returned.  The tag must have a *description*. It does not have to be unique, and you can change it with [UpdateTag](#/en/identity/latest/Tag/UpdateTag).  The tag must have a value type, which is specified with a validator. Tags can use either a static value or a list of possible values. Static values are entered by a user applying the tag to a resource. Lists are created by you and the user must apply a value from the list. Lists are validiated.  * If no &#x60;validator&#x60; is set, the user applying the tag to a resource can type in a static value or leave the tag value empty. * If a &#x60;validator&#x60; is set, the user applying the tag to a resource must select from a list of values that you supply with [EnumTagDefinitionValidator](#/en/identity/latest/datatypes/EnumTagDefinitionValidator). 
     * @param tagNamespaceId The OCID of the tag namespace. 
     * @param createTagDetails Request object for creating a new tag in the specified tag namespace.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createTag(params: {  "tagNamespaceId": string; "createTagDetails": CreateTagDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: Tag }> {
        base.validateRequiredParameters([
            "tagNamespaceId",
            "createTagDetails",
        ], "createTag", params);

        const path = `${this.basePath}/tagNamespaces/{tagNamespaceId}/tags`
            .replace(`{${"tagNamespaceId"}}`, `${ params["tagNamespaceId"] }`);

        return this.request<Tag>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createTagDetails"]
                    },

            parseResponseBody: true,

            operationName: "createTag",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateTagDefault
     * Creates a new tag default in the specified compartment for the specified tag definition.  If you specify that a value is required, a value is set during resource creation (either by the user creating the resource or another tag defualt). If no value is set, resource creation is blocked.  * If the &#x60;isRequired&#x60; flag is set to \&quot;true\&quot;, the value is set during resource creation. * If the &#x60;isRequired&#x60; flag is set to \&quot;false\&quot;, the value you enter is set during resource creation. 
     * @param createTagDefaultDetails Request object for creating a new tag default.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public createTagDefault(params: {  "createTagDefaultDetails": CreateTagDefaultDetails; "opcRetryToken"?: string; "opcRequestId"?: string; }, options?: any): Promise<{ response: Response, data: TagDefault }> {
        base.validateRequiredParameters([
            "createTagDefaultDetails",
        ], "createTagDefault", params);

        const path = `${this.basePath}/tagDefaults`;

        return this.request<TagDefault>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"],
                "opc-request-id":  params["opcRequestId"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createTagDefaultDetails"]
                    },

            parseResponseBody: true,

            operationName: "createTagDefault",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateTagNamespace
     * Creates a new tag namespace in the specified compartment.  You must specify the compartment ID in the request object (remember that the tenancy is simply the root compartment).  You must also specify a *name* for the namespace, which must be unique across all namespaces in your tenancy and cannot be changed. The name can contain any ASCII character except the space (_) or period (.). Names are case insensitive. That means, for example, \&quot;myNamespace\&quot; and \&quot;mynamespace\&quot; are not allowed in the same tenancy. Once you created a namespace, you cannot change the name. If you specify a name that&#39;s already in use in the tenancy, a 409 error is returned.  You must also specify a *description* for the namespace. It does not have to be unique, and you can change it with [UpdateTagNamespace](#/en/identity/latest/TagNamespace/UpdateTagNamespace). 
     * @param createTagNamespaceDetails Request object for creating a new tag namespace.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createTagNamespace(params: {  "createTagNamespaceDetails": CreateTagNamespaceDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: TagNamespace }> {
        base.validateRequiredParameters([
            "createTagNamespaceDetails",
        ], "createTagNamespace", params);

        const path = `${this.basePath}/tagNamespaces`;

        return this.request<TagNamespace>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createTagNamespaceDetails"]
                    },

            parseResponseBody: true,

            operationName: "createTagNamespace",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateTasDomain
     * This api is specific to tas domain.  Creates a new domain in the tenancy. This is an asynchronous call - where, at start, {@code lifecycleState} of this domain is set to CREATING. On domain creation completion this Domain&#39;s lifecycleState will be set to ACTIVE. Called only by sm/v1/Tenants.  To track progress, HTTP GET on /iamWorkRequests/{iamWorkRequestsId} endpoint will provide the async operation&#39;s status.  After creating a &#x60;Domain&#x60;, make sure its &#x60;lifecycleState&#x60; changes from CREATING to ACTIVE before using it. If the domain&#39;s {@code displayName} already exists, returns 400 BAD REQUEST. 
     * @param createTasDomainDetails The request object for creating a new domain
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public createTasDomain(params: {  "createTasDomainDetails": CreateTasDomainDetails; "opcRetryToken"?: string; "opcRequestId"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "createTasDomainDetails",
        ], "createTasDomain", params);

        const path = `${this.basePath}/tasDomains`;

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"],
                "opc-request-id":  params["opcRequestId"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createTasDomainDetails"]
                    },


            operationName: "createTasDomain",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateUpiGroup
     * @param createUpiGroupDetails Request object for creating a new group.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createUpiGroup(params: {  "createUpiGroupDetails": CreateUpiGroupDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: UpiGroup }> {
        base.validateRequiredParameters([
            "createUpiGroupDetails",
        ], "createUpiGroup", params);

        const path = `${this.basePath}/upi/groups/`;

        return this.request<UpiGroup>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createUpiGroupDetails"]
                    },

            parseResponseBody: true,

            operationName: "createUpiGroup",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateUpiUser
     * @param createUpiUserDetails Request object for creating a new user.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createUpiUser(params: {  "createUpiUserDetails": CreateUpiUserDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: UpiUser }> {
        base.validateRequiredParameters([
            "createUpiUserDetails",
        ], "createUpiUser", params);

        const path = `${this.basePath}/upi/users/`;

        return this.request<UpiUser>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createUpiUserDetails"]
                    },

            parseResponseBody: true,

            operationName: "createUpiUser",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateUser
     * Creates a new user in your tenancy. For conceptual information about users, your tenancy, and other IAM Service components, see [Overview of the IAM Service](/Content/Identity/Concepts/overview.htm).  You must specify your tenancy&#39;s OCID as the compartment ID in the request object (remember that the tenancy is simply the root compartment). Notice that IAM resources (users, groups, compartments, and some policies) reside within the tenancy itself, unlike cloud resources such as compute instances, which typically reside within compartments inside the tenancy. For information about OCIDs, see [Resource Identifiers](/Content/General/Concepts/identifiers.htm).  You must also specify a *name* for the user, which must be unique across all users in your tenancy and cannot be changed. Allowed characters: No spaces. Only letters, numerals, hyphens, periods, underscores, +, and @. If you specify a name that&#39;s already in use, you&#39;ll get a 409 error. This name will be the user&#39;s login to the Console. You might want to pick a name that your company&#39;s own identity system (e.g., Active Directory, LDAP, etc.) already uses. If you delete a user and then create a new user with the same name, they&#39;ll be considered different users because they have different OCIDs.  You must also specify a *description* for the user (although it can be an empty string). It does not have to be unique, and you can change it anytime with [UpdateUser](#/en/identity/20160918/User/UpdateUser). You can use the field to provide the user&#39;s full name, a description, a nickname, or other information to generally identify the user.  After you send your request, the new object&#39;s &#x60;lifecycleState&#x60; will temporarily be CREATING. Before using the object, first make sure its &#x60;lifecycleState&#x60; has changed to ACTIVE.  A new user has no permissions until you place the user in one or more groups (see [AddUserToGroup](#/en/identity/20160918/UserGroupMembership/AddUserToGroup)). If the user needs to access the Console, you need to provide the user a password (see [CreateOrResetUIPassword](#/en/identity/20160918/UIPassword/CreateOrResetUIPassword)). If the user needs to access the Oracle Cloud Infrastructure REST API, you need to upload a public API signing key for that user (see [Required Keys and OCIDs](/Content/API/Concepts/apisigningkey.htm) and also [UploadApiKey](#/en/identity/20160918/ApiKey/UploadApiKey)).  **Important:** Make sure to inform the new user which compartment(s) they have access to. 
     * @param createUserDetails Request object for creating a new user.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public createUser(params: {  "createUserDetails": CreateUserDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: User }> {
        base.validateRequiredParameters([
            "createUserDetails",
        ], "createUser", params);

        const path = `${this.basePath}/users/`;

        return this.request<User>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createUserDetails"]
                    },

            parseResponseBody: true,

            operationName: "createUser",
            httpMethod: "POST"
        });
    }
    /** 
     * CreateWorkflowTask
     * Creates a new workflow task. 
     * @param createWorkflowTaskDetails Request object for creating new workflow task(s).
     */
    public createWorkflowTask(params: {  "createWorkflowTaskDetails": CreateWorkflowTaskDetails; }, options?: any): Promise<{ response: Response, data: Array<WorkflowTask> }> {
        base.validateRequiredParameters([
            "createWorkflowTaskDetails"
        ], "createWorkflowTask", params);

        const path = `${this.basePath}/workflowTasks/`;

        return this.request<Array<WorkflowTask>>({
            options,
            path,



                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createWorkflowTaskDetails"]
                    },

            parseResponseBody: true,

            operationName: "createWorkflowTask",
            httpMethod: "POST"
        });
    }
    /** 
     * Deactivate a active domain
     * If the domain&#39;s {@code lifecycleState} is ACTIVE and no active Apps are present in domain,     1. Set the {@code lifecycleDetails} to DEACTIVATING and asynchronously starts disabling        the domain and return 202 ACCEPTED.           1.1 Sets the domain status to DISABLED and set specified domain&#39;s               {@code lifecycleState} to INACTIVE and set the {@code lifecycleDetails} to null.  To track progress, HTTP GET on /iamWorkRequests/{iamWorkRequestsId} endpoint will provide the async operation&#39;s status. Activate a domain can be done using HTTP POST /tasDomains/{tasDomainId}/actions/activate.  - If the domain&#39;s {@code lifecycleState} is INACTIVE, returns 202 ACCEPTED with no action   taken on service side. - If domain is of {@code type} DEFAULT or DEFAULT_LIGHTWEIGHT or domain&#39;s {@code lifecycleState}   is not ACTIVE, returns 400 BAD REQUEST. - If the domain doesn&#39;t exists, returns 404 NOT FOUND. - If any active Apps in domain, returns 400 BAD REQUEST. - If the authenticated user is part of the domain to be activated, returns 400 BAD REQUEST - If error occurs while deactivating domain, returns 500 INTERNAL SERVER ERROR. 
     * @param tasDomainId The OCID of the domain
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deactivatTasDomain(params: {  "tasDomainId": string; "opcRequestId"?: string; "opcRetryToken"?: string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "tasDomainId",
        ], "deactivatTasDomain", params);

        const path = `${this.basePath}/tasDomains/{tasDomainId}/actions/deactivate`
            .replace(`{${"tasDomainId"}}`, `${ params["tasDomainId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"],
                "if-match":  params["ifMatch"]
            },



            operationName: "deactivatTasDomain",
            httpMethod: "POST"
        });
    }
    /** 
     * Deactivate a active domain
     * If the domain&#39;s {@code lifecycleState} is ACTIVE and no active Apps are present in domain, 1. Set the {@code lifecycleDetails} to DEACTIVATING and asynchronously starts disabling    the domain and return 202 ACCEPTED.     1.1 Sets the domain status to DISABLED and set specified domain&#39;s         {@code lifecycleState} to INACTIVE and set the {@code lifecycleDetails} to null.  To track progress, HTTP GET on /iamWorkRequests/{iamWorkRequestsId} endpoint will provide the async operation&#39;s status. Activate a domain can be done using HTTP POST /domains/{domainId}/actions/activate.  - If the domain&#39;s {@code lifecycleState} is INACTIVE, returns 202 ACCEPTED with no action   taken on service side. - If domain is of {@code type} DEFAULT or DEFAULT_LIGHTWEIGHT or domain&#39;s {@code lifecycleState}   is not ACTIVE, returns 400 BAD REQUEST. - If the domain doesn&#39;t exists, returns 404 NOT FOUND. - If any active Apps in domain, returns 400 BAD REQUEST. - If the authenticated user is part of the domain to be activated, returns 400 BAD REQUEST - If error occurs while deactivating domain, returns 500 INTERNAL SERVER ERROR. 
     * @param domainId The OCID of the domain
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deactivateDomain(params: {  "domainId": string; "opcRequestId"?: string; "opcRetryToken"?: string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "domainId",
        ], "deactivateDomain", params);

        const path = `${this.basePath}/domains/{domainId}/actions/deactivate`
            .replace(`{${"domainId"}}`, `${ params["domainId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"],
                "if-match":  params["ifMatch"]
            },



            operationName: "deactivateDomain",
            httpMethod: "POST"
        });
    }
    /** 
     * DeleteApiKey
     * Deletes the specified API signing key for the specified user.  Every user has permission to use this operation to delete a key for *their own user ID*. An administrator in your organization does not need to write a policy to give users this ability. To compare, administrators who have permission to the tenancy can use this operation to delete a key for any user, including themselves. 
     * @param userId The OCID of the user.
     * @param fingerprint The key&#39;s fingerprint.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteApiKey(params: {  "userId": string; "fingerprint": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "userId",
            "fingerprint",
        ], "deleteApiKey", params);

        const path = `${this.basePath}/users/{userId}/apiKeys/{fingerprint}`
            .replace(`{${"userId"}}`, `${ params["userId"] }`)
            .replace(`{${"fingerprint"}}`, `${ params["fingerprint"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteApiKey",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteAuthToken
     * Deletes the specified auth token for the specified user. 
     * @param userId The OCID of the user.
     * @param authTokenId The OCID of the auth token.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteAuthToken(params: {  "userId": string; "authTokenId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "userId",
            "authTokenId",
        ], "deleteAuthToken", params);

        const path = `${this.basePath}/users/{userId}/authTokens/{authTokenId}`
            .replace(`{${"userId"}}`, `${ params["userId"] }`)
            .replace(`{${"authTokenId"}}`, `${ params["authTokenId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteAuthToken",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteCompartment
     * Deletes the specified compartment. The compartment must be empty. 
     * @param compartmentId The OCID of the compartment.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteCompartment(params: {  "compartmentId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "deleteCompartment", params);

        const path = `${this.basePath}/compartments/{compartmentId}`
            .replace(`{${"compartmentId"}}`, `${ params["compartmentId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteCompartment",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteCustomerSecretKey
     * Deletes the specified secret key for the specified user. 
     * @param userId The OCID of the user.
     * @param customerSecretKeyId The OCID of the secret key.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteCustomerSecretKey(params: {  "userId": string; "customerSecretKeyId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "userId",
            "customerSecretKeyId",
        ], "deleteCustomerSecretKey", params);

        const path = `${this.basePath}/users/{userId}/customerSecretKeys/{customerSecretKeyId}`
            .replace(`{${"userId"}}`, `${ params["userId"] }`)
            .replace(`{${"customerSecretKeyId"}}`, `${ params["customerSecretKeyId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteCustomerSecretKey",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteDbCredential
     * Deletes the specified DB credential for the specified user. 
     * @param userId The OCID of the user.
     * @param dbCredentialId The OCID of the DB credential.
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteDbCredential(params: {  "userId": string; "dbCredentialId": string; "opcRequestId"?: string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "userId",
            "dbCredentialId",
        ], "deleteDbCredential", params);

        const path = `${this.basePath}/users/{userId}/dbCredentials/{dbCredentialId}`
            .replace(`{${"userId"}}`, `${ params["userId"] }`)
            .replace(`{${"dbCredentialId"}}`, `${ params["dbCredentialId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteDbCredential",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteDomain
     * Soft Deletes a domain.  This is an asynchronous API, where, if the domain&#39;s {@code lifecycleState} is INACTIVE and no active Apps are present in underlying stripe,   1. Sets the specified domain&#39;s {@code lifecycleState} to DELETING.   2. Domains marked as DELETING will be cleaned up by a periodic task unless customer request it to be undo via ticket.   3. Work request is created and returned as opc-work-request-id along with 202 ACCEPTED. To track progress, HTTP GET on /iamWorkRequests/{iamWorkRequestsId} endpoint will provide the async operation&#39;s status.  - If the domain&#39;s {@code lifecycleState} is DELETING, returns 202 Accepted as a deletion   is already in progress for this domain. - If the domain doesn&#39;t exists, returns 404 NOT FOUND. - If domain is of {@code type} DEFAULT or DEFAULT_LIGHTWEIGHT, returns 400 BAD REQUEST. - If any active Apps in domain, returns 400 BAD REQUEST. - If the authenticated user is part of the domain to be deleted, returns 400 BAD REQUEST. - If any internal error occurs, return 500 INTERNAL SERVER ERROR. 
     * @param domainId The OCID of the domain
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public deleteDomain(params: {  "domainId": string; "ifMatch"?: string; "opcRequestId"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "domainId",
        ], "deleteDomain", params);

        const path = `${this.basePath}/domains/{domainId}`
            .replace(`{${"domainId"}}`, `${ params["domainId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"],
                "opc-request-id":  params["opcRequestId"]
            },



            operationName: "deleteDomain",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteDynamicGroup
     * Deletes the specified dynamic group. 
     * @param dynamicGroupId The OCID of the dynamic group.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteDynamicGroup(params: {  "dynamicGroupId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "dynamicGroupId",
        ], "deleteDynamicGroup", params);

        const path = `${this.basePath}/dynamicGroups/{dynamicGroupId}`
            .replace(`{${"dynamicGroupId"}}`, `${ params["dynamicGroupId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteDynamicGroup",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteGroup
     * Deletes the specified group. The group must be empty. 
     * @param groupId The OCID of the group.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteGroup(params: {  "groupId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "groupId",
        ], "deleteGroup", params);

        const path = `${this.basePath}/groups/{groupId}`
            .replace(`{${"groupId"}}`, `${ params["groupId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteGroup",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteIdentityProvider
     * **Deprecated.** For more information, see [Deprecated IAM Service APIs](/Content/Identity/Reference/deprecatediamapis.htm).  Deletes the specified identity provider. The identity provider must not have any group mappings (see [IdpGroupMapping](#/en/identity/20160918/IdpGroupMapping/)). 
     * @param identityProviderId The OCID of the identity provider.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteIdentityProvider(params: {  "identityProviderId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "identityProviderId",
        ], "deleteIdentityProvider", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteIdentityProvider",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteIdentityProviderGroup
     * Deletes the specified identity provider group. The group must be empty. 
     * @param identityProviderId The OCID of the identity provider.
     * @param groupId The OCID of the group.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteIdentityProviderGroup(params: {  "identityProviderId": string; "groupId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "identityProviderId",
            "groupId",
        ], "deleteIdentityProviderGroup", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}/groups/{groupId}`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`)
            .replace(`{${"groupId"}}`, `${ params["groupId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteIdentityProviderGroup",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteIdpGroupMapping
     * **Deprecated.** For more information, see [Deprecated IAM Service APIs](/Content/Identity/Reference/deprecatediamapis.htm).  Deletes the specified group mapping. 
     * @param identityProviderId The OCID of the identity provider.
     * @param mappingId The OCID of the group mapping.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteIdpGroupMapping(params: {  "identityProviderId": string; "mappingId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "identityProviderId",
            "mappingId",
        ], "deleteIdpGroupMapping", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}/groupMappings/{mappingId}`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`)
            .replace(`{${"mappingId"}}`, `${ params["mappingId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteIdpGroupMapping",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteIdpUser
     * Deletes the specified identity provider user. The user must not be in any groups.
     * @param identityProviderId The OCID of the identity provider.
     * @param userId The OCID of the user.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteIdpUser(params: {  "identityProviderId": string; "userId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "identityProviderId",
            "userId",
        ], "deleteIdpUser", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}/users/{userId}`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`)
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteIdpUser",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteMfaTotpDevice
     * Deletes the specified MFA TOTP device for the specified user. 
     * @param userId The OCID of the user.
     * @param mfaTotpDeviceId The OCID of the MFA TOTP device.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteMfaTotpDevice(params: {  "userId": string; "mfaTotpDeviceId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "userId",
            "mfaTotpDeviceId",
        ], "deleteMfaTotpDevice", params);

        const path = `${this.basePath}/users/{userId}/mfaTotpDevices/{mfaTotpDeviceId}`
            .replace(`{${"userId"}}`, `${ params["userId"] }`)
            .replace(`{${"mfaTotpDeviceId"}}`, `${ params["mfaTotpDeviceId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteMfaTotpDevice",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteNetworkSource
     * Deletes the specified network source 
     * @param networkSourceId The OCID of the network source.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteNetworkSource(params: {  "networkSourceId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "networkSourceId",
        ], "deleteNetworkSource", params);

        const path = `${this.basePath}/networkSources/{networkSourceId}`
            .replace(`{${"networkSourceId"}}`, `${ params["networkSourceId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteNetworkSource",
            httpMethod: "DELETE"
        });
    }
    /** 
     * Delete Oauth token for the user
     * Delete Oauth token for the user 
     * @param userId The OCID of the user.
     * @param oauth2ClientCredentialId The ID of the Oauth credential.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteOAuthClientCredential(params: {  "userId": string; "oauth2ClientCredentialId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "userId",
            "oauth2ClientCredentialId",
        ], "deleteOAuthClientCredential", params);

        const path = `${this.basePath}/users/{userId}/oauth2ClientCredentials/{oauth2ClientCredentialId}`
            .replace(`{${"userId"}}`, `${ params["userId"] }`)
            .replace(`{${"oauth2ClientCredentialId"}}`, `${ params["oauth2ClientCredentialId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteOAuthClientCredential",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteOidcClient
     * Deletes the specified OpenID Connect client.
     * @param oidcClientId The id of the OpenID Connect client.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteOidcClient(params: {  "oidcClientId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "oidcClientId",
        ], "deleteOidcClient", params);

        const path = `${this.basePath}/oidcClients/{oidcClientId}`
            .replace(`{${"oidcClientId"}}`, `${ params["oidcClientId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteOidcClient",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteOnPremSite
     * Delete a provisioned OnPremSite by Id. The OnPremSite must not be associated with any resources. 
     * @param onPremSiteId unique OnPremSite identifier
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public deleteOnPremSite(params: {  "onPremSiteId": string; "ifMatch"?: string; "opcRequestId"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "onPremSiteId",
        ], "deleteOnPremSite", params);

        const path = `${this.basePath}/onPremSites/{onPremSiteId}`
            .replace(`{${"onPremSiteId"}}`, `${ params["onPremSiteId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"],
                "opc-request-id":  params["opcRequestId"]
            },



            operationName: "deleteOnPremSite",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeletePolicy
     * Deletes the specified policy. The deletion takes effect typically within 10 seconds.
     * @param policyId The OCID of the policy.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deletePolicy(params: {  "policyId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "policyId",
        ], "deletePolicy", params);

        const path = `${this.basePath}/policies/{policyId}`
            .replace(`{${"policyId"}}`, `${ params["policyId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deletePolicy",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteServiceManager
     * Deletes the specified service manager. 
     * @param tenantId The OCID of the tenancy.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteServiceManager(params: {  "tenantId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "tenantId",
        ], "deleteServiceManager", params);

        const path = `${this.basePath}/serviceManagers/{tenantId}`
            .replace(`{${"tenantId"}}`, `${ params["tenantId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteServiceManager",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteSmtpCredential
     * Deletes the specified SMTP credential for the specified user. 
     * @param userId The OCID of the user.
     * @param smtpCredentialId The OCID of the SMTP credential.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteSmtpCredential(params: {  "userId": string; "smtpCredentialId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "userId",
            "smtpCredentialId",
        ], "deleteSmtpCredential", params);

        const path = `${this.basePath}/users/{userId}/smtpCredentials/{smtpCredentialId}`
            .replace(`{${"userId"}}`, `${ params["userId"] }`)
            .replace(`{${"smtpCredentialId"}}`, `${ params["smtpCredentialId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteSmtpCredential",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteSwiftPassword
     * **Deprecated. Use [DeleteAuthToken](#/en/identity/20160918/AuthToken/DeleteAuthToken) instead.**  Deletes the specified Swift password for the specified user. 
     * @param userId The OCID of the user.
     * @param swiftPasswordId The OCID of the Swift password.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteSwiftPassword(params: {  "userId": string; "swiftPasswordId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "userId",
            "swiftPasswordId",
        ], "deleteSwiftPassword", params);

        const path = `${this.basePath}/users/{userId}/swiftPasswords/{swiftPasswordId}`
            .replace(`{${"userId"}}`, `${ params["userId"] }`)
            .replace(`{${"swiftPasswordId"}}`, `${ params["swiftPasswordId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteSwiftPassword",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteTag
     * Deletes the specified tag definition. This operation triggers a process that removes the tag from all resources in your tenancy.  These things happen immediately:     * If the tag was a cost-tracking tag, it no longer counts against your 10 cost-tracking   tags limit, whether you first disabled it or not.   * If the tag was used with dynamic groups, none of the rules that contain the tag will   be evaluated against the tag.  When you start the delete operation, the state of the tag changes to DELETING and tag removal from resources begins. This can take up to 48 hours depending on the number of resources that were tagged as well as the regions in which those resources reside.  When all tags have been removed, the state changes to DELETED. You cannot restore a deleted tag. Once the deleted tag changes its state to DELETED, you can use the same tag name again.  After you start this operation, you cannot start either the [BulkDeleteTags](#/en/identity/20160918/Tag/BulkDeleteTags) or the [CascadeDeleteTagNamespace](#/en/identity/20160918/TagNamespace/CascadeDeleteTagNamespace) operation until this process completes.  To delete a tag, you must first retire it. Use [UpdateTag](#/en/identity/latest/Tag/UpdateTag) to retire a tag. 
     * @param tagNamespaceId The OCID of the tag namespace. 
     * @param tagName The name of the tag. 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteTag(params: {  "tagNamespaceId": string; "tagName": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "tagNamespaceId",
            "tagName",
        ], "deleteTag", params);

        const path = `${this.basePath}/tagNamespaces/{tagNamespaceId}/tags/{tagName}`
            .replace(`{${"tagNamespaceId"}}`, `${ params["tagNamespaceId"] }`)
            .replace(`{${"tagName"}}`, `${ params["tagName"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteTag",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteTagDefault
     * Deletes the the specified tag default. 
     * @param tagDefaultId The OCID of the tag default.
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteTagDefault(params: {  "tagDefaultId": string; "opcRequestId"?: string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "tagDefaultId",
        ], "deleteTagDefault", params);

        const path = `${this.basePath}/tagDefaults/{tagDefaultId}`
            .replace(`{${"tagDefaultId"}}`, `${ params["tagDefaultId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteTagDefault",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteTagNamespace
     * Deletes the specified tag namespace. Only an empty tag namespace can be deleted with this operation. To use this operation to delete a tag namespace that contains tag definitions, first delete all of its tag definitions.  Use [CascadeDeleteTagNamespace](#/en/identity/20160918/TagNamespace/CascadeDeleteTagNamespace) to delete a tag namespace along with all of the tag definitions contained within that namespace.  Use [DeleteTag](#/en/identity/latest/Tag/DeleteTag) to delete a tag definition. 
     * @param tagNamespaceId The OCID of the tag namespace. 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public deleteTagNamespace(params: {  "tagNamespaceId": string; "ifMatch"?: string; "opcRequestId"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "tagNamespaceId",
        ], "deleteTagNamespace", params);

        const path = `${this.basePath}/tagNamespaces/{tagNamespaceId}`
            .replace(`{${"tagNamespaceId"}}`, `${ params["tagNamespaceId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"],
                "opc-request-id":  params["opcRequestId"]
            },



            operationName: "deleteTagNamespace",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteTasDomain
     * Delete a tas domain is a hard delete of domain. This API can&#39;t be invoked on secondary domains, that are not created by TAS      This is an asynchronous API, where, if the domain&#39;s {@code lifecycleState} is INACTIVE and     no active Apps are present in domain,     1. Sets the specified domain&#39;s {@code lifecycleState} to DELETING     2. Subscription information for domains will also be cleaned up.     3. Hard deletes domain and returns 202 ACCEPTED. The delete operation is not reversible.     To track progress, HTTP GET on /iamWorkRequests/{iamWorkRequestsId} endpoint will provide     the async operation&#39;s status.      - If the domain&#39;s {@code lifecycleState} is DELETING, returns 202 Accepted as a deletion       is already in progress for this domain.     - If the domain doesn&#39;t exists, returns 404 NOT FOUND.     - If domain is of {@code type} DEFAULT or DEFAULT_LIGHTWEIGHT, returns 400 BAD REQUEST.     - If any active Apps in domain, returns 400 BAD REQUEST.     - If the authenticated user is part of the domain to be deleted, returns 400 BAD REQUEST.     - If error occurs while deleting domains, return 500 INTERNAL SERVER ERROR. 
     * @param tasDomainId The OCID of the domain
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public deleteTasDomain(params: {  "tasDomainId": string; "ifMatch"?: string; "opcRequestId"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "tasDomainId",
        ], "deleteTasDomain", params);

        const path = `${this.basePath}/tasDomains/{tasDomainId}`
            .replace(`{${"tasDomainId"}}`, `${ params["tasDomainId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"],
                "opc-request-id":  params["opcRequestId"]
            },



            operationName: "deleteTasDomain",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteUpiGroup
     * Deletes the specified group. The group must be empty. 
     * @param idcsId The IDCS ID of the group.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteUpiGroup(params: {  "idcsId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "idcsId",
        ], "deleteUpiGroup", params);

        const path = `${this.basePath}/upi/groups/{idcsId}`
            .replace(`{${"idcsId"}}`, `${ params["idcsId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteUpiGroup",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteUpiUser
     * Deletes the specified user. The user must not be in any groups.
     * @param idcsId The IDCS ID of the user.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteUpiUser(params: {  "idcsId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "idcsId",
        ], "deleteUpiUser", params);

        const path = `${this.basePath}/upi/users/{idcsId}`
            .replace(`{${"idcsId"}}`, `${ params["idcsId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteUpiUser",
            httpMethod: "DELETE"
        });
    }
    /** 
     * DeleteUser
     * Deletes the specified user. The user must not be in any groups.
     * @param userId The OCID of the user.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public deleteUser(params: {  "userId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "userId",
        ], "deleteUser", params);

        const path = `${this.basePath}/users/{userId}`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "deleteUser",
            httpMethod: "DELETE"
        });
    }
    /** 
     * Validates and redeems the email verification token
     * Verifies the email if the token provided is valid. 
     * @param userId The OCID of the user.
     * @param emailVerificationTokenDetails Request object containing the token used to verify email.
     */
    public emailVerification(params: {  "userId": string; "emailVerificationTokenDetails": EmailVerificationTokenDetails; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "userId",
            "emailVerificationTokenDetails"
        ], "emailVerification", params);

        const path = `${this.basePath}/users/{userId}/actions/verifyEmail`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request({
            options,
            path,



                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["emailVerificationTokenDetails"]
                    },


            operationName: "emailVerification",
            httpMethod: "POST"
        });
    }
    /** 
     * Replicate domain to a new region
     * Replicate domain to a new region. This is an asynchronous call - where, at start, {@code state} of this domain in replica region is set to ENABLING_REPLICATION. On domain replication completion the {@code state} will be set to REPLICATION_ENABLED.  To track progress, HTTP GET on /iamWorkRequests/{iamWorkRequestsId} endpoint will provide the async operation&#39;s status.  If the replica region&#39;s {@code state} is already ENABLING_REPLICATION or REPLICATION_ENABLED, returns 409 CONFLICT. - If the domain doesn&#39;t exists, returns 404 NOT FOUND. - If home region is same as replication region, return 400 BAD REQUEST. - If Domain is not active or being updated, returns 400 BAD REQUEST. - If any internal error occurs, return 500 INTERNAL SERVER ERROR. 
     * @param domainId The OCID of the domain
     * @param enableReplicationToRegionDetails the request object for region we are replicating domain region
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public enableReplicationToRegion(params: {  "domainId": string; "enableReplicationToRegionDetails": EnableReplicationToRegionDetails; "opcRequestId"?: string; "opcRetryToken"?: string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "domainId",
            "enableReplicationToRegionDetails",
        ], "enableReplicationToRegion", params);

        const path = `${this.basePath}/domains/{domainId}/actions/enableReplicationToRegion`
            .replace(`{${"domainId"}}`, `${ params["domainId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"],
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["enableReplicationToRegionDetails"]
                    },


            operationName: "enableReplicationToRegion",
            httpMethod: "POST"
        });
    }
    /** 
     * Requests a password reset email be generated and sent to the user with a matching email in that tenant.
     * Creates a password reset token and sends that to the user by email.  If no user under the root compartment is found to have a matching verified email, then no email is sent.  This call is throttled on the server side based on the last time a token was created for the given compartmentId and email combination. 
     * @param sendPasswordResetRequest Request object for creating a password reset by email.
     */
    public generatePasswordResetEmail(params: {  "sendPasswordResetRequest": SendPasswordResetRequest; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "sendPasswordResetRequest"
        ], "generatePasswordResetEmail", params);

        const path = `${this.basePath}/users/actions/sendPasswordReset`;

        return this.request({
            options,
            path,



                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["sendPasswordResetRequest"]
                    },


            operationName: "generatePasswordResetEmail",
            httpMethod: "POST"
        });
    }
    /** 
     * GenerateTotpSeed
     * Generate seed for the MFA TOTP device. 
     * @param userId The OCID of the user.
     * @param mfaTotpDeviceId The OCID of the MFA TOTP device.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public generateTotpSeed(params: {  "userId": string; "mfaTotpDeviceId": string; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: MfaTotpDevice }> {
        base.validateRequiredParameters([
            "userId",
            "mfaTotpDeviceId",
        ], "generateTotpSeed", params);

        const path = `${this.basePath}/users/{userId}/mfaTotpDevices/{mfaTotpDeviceId}/actions/generateSeed`
            .replace(`{${"userId"}}`, `${ params["userId"] }`)
            .replace(`{${"mfaTotpDeviceId"}}`, `${ params["mfaTotpDeviceId"] }`);

        return this.request<MfaTotpDevice>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },


            parseResponseBody: true,

            operationName: "generateTotpSeed",
            httpMethod: "POST"
        });
    }
    /** 
     * GetAccountByEntitlementId
     * Get account information for a service entitlement ID
     * @param serviceName The name of the whitelisted service caller. Such as &#39;PSM&#39;
     * @param entitlementId The service entitlement Id for OCI resources.
     */
    public getAccountByEntitlementId(params: {  "serviceName": string; "entitlementId": string; }, options?: any): Promise<{ response: Response, data: Account }> {
        base.validateRequiredParameters([
            "serviceName",
            "entitlementId"
        ], "getAccountByEntitlementId", params);

        const path = `${this.basePath}/entitlements/{entitlementId}`
            .replace(`{${"entitlementId"}}`, `${ params["entitlementId"] }`);

        return this.request<Account>({
            options,
            path,

            queryParameters: {
                    "serviceName": { values: params["serviceName"] }
            },



            parseResponseBody: true,

            operationName: "getAccountByEntitlementId",
            httpMethod: "GET"
        });
    }
    /** 
     * GetAuthenticationPolicy
     * Gets the authentication policy for the given tenancy. You must specify your tenant’s OCID as the value for the compartment ID (remember that the tenancy is simply the root compartment). 
     * @param compartmentId The OCID of the compartment.
     */
    public getAuthenticationPolicy(params: {  "compartmentId": string; }, options?: any): Promise<{ response: Response, data: AuthenticationPolicy }> {
        base.validateRequiredParameters([
            "compartmentId"
        ], "getAuthenticationPolicy", params);

        const path = `${this.basePath}/authenticationPolicies/{compartmentId}`
            .replace(`{${"compartmentId"}}`, `${ params["compartmentId"] }`);

        return this.request<AuthenticationPolicy>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getAuthenticationPolicy",
            httpMethod: "GET"
        });
    }
    /** 
     * GetCompartment
     * Gets the specified compartment&#39;s information.  This operation does not return a list of all the resources inside the compartment. There is no single API operation that does that. Compartments can contain multiple types of resources (instances, block storage volumes, etc.). To find out what&#39;s in a compartment, you must call the \&quot;List\&quot; operation for each resource type and specify the compartment&#39;s OCID as a query parameter in the request. For example, call the [ListInstances](#/en/iaas/20160918/Instance/ListInstances) operation in the Cloud Compute Service or the [ListVolumes](#/en/iaas/20160918/Volume/ListVolumes) operation in Cloud Block Storage. 
     * @param compartmentId The OCID of the compartment.
     * @param verboseLevel This parameter is required to retrieve securityZoneId associated with the compartment. 
     */
    public getCompartment(params: {  "compartmentId": string; "verboseLevel"?: string; }, options?: any): Promise<{ response: Response, data: Compartment }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "getCompartment", params);

        const path = `${this.basePath}/compartments/{compartmentId}`
            .replace(`{${"compartmentId"}}`, `${ params["compartmentId"] }`);

        return this.request<Compartment>({
            options,
            path,

            queryParameters: {
                    "verboseLevel": { values: params["verboseLevel"] }
            },



            parseResponseBody: true,

            operationName: "getCompartment",
            httpMethod: "GET"
        });
    }
    /** 
     * GetDomain
     * Get the specified domain&#39;s information.  - If the domain doesn&#39;t exists, returns 404 NOT FOUND. - If any internal error occurs, returns 500 INTERNAL SERVER ERROR. 
     * @param domainId The OCID of the domain
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param isIdentityProviderIdRequired Indicates if the response payload needs to include Identity provider. Valid values are true or false. Defaults to false. 
     */
    public getDomain(params: {  "domainId": string; "opcRequestId"?: string; "isIdentityProviderIdRequired"?: string; }, options?: any): Promise<{ response: Response, data: Domain }> {
        base.validateRequiredParameters([
            "domainId",
        ], "getDomain", params);

        const path = `${this.basePath}/domains/{domainId}`
            .replace(`{${"domainId"}}`, `${ params["domainId"] }`);

        return this.request<Domain>({
            options,
            path,

            queryParameters: {
                    "isIdentityProviderIdRequired": { values: params["isIdentityProviderIdRequired"] }
            },

            headerParameters: {
                "opc-request-id":  params["opcRequestId"]
            },


            parseResponseBody: true,

            operationName: "getDomain",
            httpMethod: "GET"
        });
    }
    /** 
     * Get domain replication states
     * Get all domain replication states for an IDCS shard
     * @param homeRegionShardId The domain&#39;s home region shardId
     * @param lastTxnSeq Custom value defining the order of records with same kievTxnId
     * @param limit The number of values to scan
     * @param opcWatermark Optional version number.  If not specified, all domains are returned. Otherwise only domains that have been modified after the version number are returned. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public getDomainReplicationStates(params: {  "homeRegionShardId": string; "lastTxnSeq": number; "limit": number; "opcWatermark"?: string; "opcRequestId"?: string; }, options?: any): Promise<{ response: Response, data: DomainReplication }> {
        base.validateRequiredParameters([
            "homeRegionShardId",
            "lastTxnSeq",
            "limit",
        ], "getDomainReplicationStates", params);

        const path = `${this.basePath}/domainReplicationStates`;

        return this.request<DomainReplication>({
            options,
            path,

            queryParameters: {
                    "homeRegionShardId": { values: params["homeRegionShardId"] },
                    "opcWatermark": { values: params["opcWatermark"] },
                    "lastTxnSeq": { values: params["lastTxnSeq"] },
                    "limit": { values: params["limit"] }
            },

            headerParameters: {
                "opc-request-id":  params["opcRequestId"]
            },


            parseResponseBody: true,

            operationName: "getDomainReplicationStates",
            httpMethod: "GET"
        });
    }
    /** 
     * GetDynamicGroup
     * Gets the specified dynamic group&#39;s information. 
     * @param dynamicGroupId The OCID of the dynamic group.
     */
    public getDynamicGroup(params: {  "dynamicGroupId": string; }, options?: any): Promise<{ response: Response, data: DynamicGroup }> {
        base.validateRequiredParameters([
            "dynamicGroupId"
        ], "getDynamicGroup", params);

        const path = `${this.basePath}/dynamicGroups/{dynamicGroupId}`
            .replace(`{${"dynamicGroupId"}}`, `${ params["dynamicGroupId"] }`);

        return this.request<DynamicGroup>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getDynamicGroup",
            httpMethod: "GET"
        });
    }
    /** 
     * GetGroup
     * Gets the specified group&#39;s information.  This operation does not return a list of all the users in the group. To do that, use [ListUserGroupMemberships](#/en/identity/20160918/UserGroupMembership/ListUserGroupMemberships) and provide the group&#39;s OCID as a query parameter in the request. 
     * @param groupId The OCID of the group.
     */
    public getGroup(params: {  "groupId": string; }, options?: any): Promise<{ response: Response, data: Group }> {
        base.validateRequiredParameters([
            "groupId"
        ], "getGroup", params);

        const path = `${this.basePath}/groups/{groupId}`
            .replace(`{${"groupId"}}`, `${ params["groupId"] }`);

        return this.request<Group>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getGroup",
            httpMethod: "GET"
        });
    }
    /** 
     * Gets IAM work request
     * Gets details on a specified IAM work request. For asynchronous operations in Identity and Access Management service, opc-work-request-id header values contains iam work request id that can be provided in this API to track the current status of the operation.  - If workrequest exists, returns 202 ACCEPTED - If workrequest does not exist, returns 404 NOT FOUND 
     * @param iamWorkRequestId The OCID of the IAM work request.
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public getIamWorkRequest(params: {  "iamWorkRequestId": string; "opcRequestId"?: string; }, options?: any): Promise<{ response: Response, data: IamWorkRequest }> {
        base.validateRequiredParameters([
            "iamWorkRequestId",
        ], "getIamWorkRequest", params);

        const path = `${this.basePath}/iamWorkRequests/{iamWorkRequestId}`
            .replace(`{${"iamWorkRequestId"}}`, `${ params["iamWorkRequestId"] }`);

        return this.request<IamWorkRequest>({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"]
            },


            parseResponseBody: true,

            operationName: "getIamWorkRequest",
            httpMethod: "GET"
        });
    }
    /** 
     * GetIdentityProvider
     * **Deprecated.** For more information, see [Deprecated IAM Service APIs](/Content/Identity/Reference/deprecatediamapis.htm).  Gets the specified identity provider&#39;s information. 
     * @param identityProviderId The OCID of the identity provider.
     */
    public getIdentityProvider(params: {  "identityProviderId": string; }, options?: any): Promise<{ response: Response, data: IdentityProvider }> {
        base.validateRequiredParameters([
            "identityProviderId"
        ], "getIdentityProvider", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`);

        return this.request<IdentityProvider>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getIdentityProvider",
            httpMethod: "GET"
        });
    }
    /** 
     * GetIdentityProviderGroup
     * Gets the specified identity provider group&#39;s information. 
     * @param identityProviderId The OCID of the identity provider.
     * @param groupId The OCID of the group.
     */
    public getIdentityProviderGroup(params: {  "identityProviderId": string; "groupId": string; }, options?: any): Promise<{ response: Response, data: IdentityProviderGroupSummary }> {
        base.validateRequiredParameters([
            "identityProviderId",
            "groupId"
        ], "getIdentityProviderGroup", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}/groups/{groupId}`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`)
            .replace(`{${"groupId"}}`, `${ params["groupId"] }`);

        return this.request<IdentityProviderGroupSummary>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getIdentityProviderGroup",
            httpMethod: "GET"
        });
    }
    /** 
     * GetIdpGroupMapping
     * **Deprecated.** For more information, see [Deprecated IAM Service APIs](/Content/Identity/Reference/deprecatediamapis.htm).  Gets the specified group mapping. 
     * @param identityProviderId The OCID of the identity provider.
     * @param mappingId The OCID of the group mapping.
     */
    public getIdpGroupMapping(params: {  "identityProviderId": string; "mappingId": string; }, options?: any): Promise<{ response: Response, data: IdpGroupMapping }> {
        base.validateRequiredParameters([
            "identityProviderId",
            "mappingId"
        ], "getIdpGroupMapping", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}/groupMappings/{mappingId}`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`)
            .replace(`{${"mappingId"}}`, `${ params["mappingId"] }`);

        return this.request<IdpGroupMapping>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getIdpGroupMapping",
            httpMethod: "GET"
        });
    }
    /** 
     * GetIdpUser
     * Gets the specified identity provider user&#39;s information.
     * @param identityProviderId The OCID of the identity provider.
     * @param userId The OCID of the user.
     */
    public getIdpUser(params: {  "identityProviderId": string; "userId": string; }, options?: any): Promise<{ response: Response, data: User }> {
        base.validateRequiredParameters([
            "identityProviderId",
            "userId"
        ], "getIdpUser", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}/users/{userId}`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`)
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<User>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getIdpUser",
            httpMethod: "GET"
        });
    }
    /** 
     * GetLastProcessedInboxSequenceNumber
     * Get last processed inbox sequence number in Identity so that Replication can delete some logs in the ID inbox. 
     * @param serviceId The id of the target service。
     */
    public getLastProcessedInboxSequenceNumber(params: {  "serviceId": string; }, options?: any): Promise<{ response: Response, data: LastProcessedSequenceNumberResult }> {
        base.validateRequiredParameters([
            "serviceId"
        ], "getLastProcessedInboxSequenceNumber", params);

        const path = `${this.basePath}/replication/lastProcessedInboxSequenceNumber/`;

        return this.request<LastProcessedSequenceNumberResult>({
            options,
            path,

            queryParameters: {
                    "serviceId": { values: params["serviceId"] }
            },



            parseResponseBody: true,

            operationName: "getLastProcessedInboxSequenceNumber",
            httpMethod: "GET"
        });
    }
    /** 
     * GetMfaTotpDevice
     * Get the specified MFA TOTP device for the specified user. 
     * @param userId The OCID of the user.
     * @param mfaTotpDeviceId The OCID of the MFA TOTP device.
     */
    public getMfaTotpDevice(params: {  "userId": string; "mfaTotpDeviceId": string; }, options?: any): Promise<{ response: Response, data: MfaTotpDeviceSummary }> {
        base.validateRequiredParameters([
            "userId",
            "mfaTotpDeviceId"
        ], "getMfaTotpDevice", params);

        const path = `${this.basePath}/users/{userId}/mfaTotpDevices/{mfaTotpDeviceId}`
            .replace(`{${"userId"}}`, `${ params["userId"] }`)
            .replace(`{${"mfaTotpDeviceId"}}`, `${ params["mfaTotpDeviceId"] }`);

        return this.request<MfaTotpDeviceSummary>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getMfaTotpDevice",
            httpMethod: "GET"
        });
    }
    /** 
     * GetNetworkSource
     * Gets the specified network source&#39;s information. 
     * @param networkSourceId The OCID of the network source.
     */
    public getNetworkSource(params: {  "networkSourceId": string; }, options?: any): Promise<{ response: Response, data: NetworkSources }> {
        base.validateRequiredParameters([
            "networkSourceId"
        ], "getNetworkSource", params);

        const path = `${this.basePath}/networkSources/{networkSourceId}`
            .replace(`{${"networkSourceId"}}`, `${ params["networkSourceId"] }`);

        return this.request<NetworkSources>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getNetworkSource",
            httpMethod: "GET"
        });
    }
    /** 
     * GetOidcClient
     * Gets the OpenID Connect client metadata corresponding to the OpenID Connect client of the specified identifier.
     * @param oidcClientId The id of the OpenID Connect client.
     */
    public getOidcClient(params: {  "oidcClientId": string; }, options?: any): Promise<{ response: Response, data: OidcClient }> {
        base.validateRequiredParameters([
            "oidcClientId"
        ], "getOidcClient", params);

        const path = `${this.basePath}/oidcClients/{oidcClientId}`
            .replace(`{${"oidcClientId"}}`, `${ params["oidcClientId"] }`);

        return this.request<OidcClient>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getOidcClient",
            httpMethod: "GET"
        });
    }
    /** 
     * GetOnPremSite
     * Gets the specifified OnPremSite.  This operation does not return a list of all the resources associated with the OnPremSite. 
     * @param onPremSiteId unique OnPremSite identifier
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public getOnPremSite(params: {  "onPremSiteId": string; "opcRequestId"?: string; }, options?: any): Promise<{ response: Response, data: OnPremSite }> {
        base.validateRequiredParameters([
            "onPremSiteId",
        ], "getOnPremSite", params);

        const path = `${this.basePath}/onPremSites/{onPremSiteId}`
            .replace(`{${"onPremSiteId"}}`, `${ params["onPremSiteId"] }`);

        return this.request<OnPremSite>({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"]
            },


            parseResponseBody: true,

            operationName: "getOnPremSite",
            httpMethod: "GET"
        });
    }
    /** 
     * GetPolicy
     * Gets the specified policy&#39;s information.
     * @param policyId The OCID of the policy.
     */
    public getPolicy(params: {  "policyId": string; }, options?: any): Promise<{ response: Response, data: Policy }> {
        base.validateRequiredParameters([
            "policyId"
        ], "getPolicy", params);

        const path = `${this.basePath}/policies/{policyId}`
            .replace(`{${"policyId"}}`, `${ params["policyId"] }`);

        return this.request<Policy>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getPolicy",
            httpMethod: "GET"
        });
    }
    /** 
     * GetReplicationLogs
     * Get replication logs 
     * @param lastReplicatedSequenceNumber The last replicated sequence number
     * @param limit The limit till which replication logs are to be fetched
     */
    public getReplicationLogs(params: {  "lastReplicatedSequenceNumber": number; "limit": number; }, options?: any): Promise<{ response: Response, data: ReplicationLogResult }> {
        base.validateRequiredParameters([
            "lastReplicatedSequenceNumber",
            "limit"
        ], "getReplicationLogs", params);

        const path = `${this.basePath}/replication/replicationLogs/`;

        return this.request<ReplicationLogResult>({
            options,
            path,

            queryParameters: {
                    "lastReplicatedSequenceNumber": { values: params["lastReplicatedSequenceNumber"] },
                    "limit": { values: params["limit"] }
            },



            parseResponseBody: true,

            operationName: "getReplicationLogs",
            httpMethod: "GET"
        });
    }
    /** 
     * GetServiceManager
     * Gets the specified service manager&#39;s information.
     * @param tenantId The OCID of the tenancy.
     */
    public getServiceManager(params: {  "tenantId": string; }, options?: any): Promise<{ response: Response, data: ServiceManager }> {
        base.validateRequiredParameters([
            "tenantId"
        ], "getServiceManager", params);

        const path = `${this.basePath}/serviceManagers/{tenantId}`
            .replace(`{${"tenantId"}}`, `${ params["tenantId"] }`);

        return this.request<ServiceManager>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getServiceManager",
            httpMethod: "GET"
        });
    }
    /** 
     * GetStandardTagTemplate
     * Retrieve the standard tag namespace template given the standard tag namespace name. 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param standardTagNamespaceName The name of the standard tag namespace tempate that is requested 
     */
    public getStandardTagTemplate(params: {  "compartmentId": string; "standardTagNamespaceName": string; }, options?: any): Promise<{ response: Response, data: StandardTagNamespaceTemplate }> {
        base.validateRequiredParameters([
            "compartmentId",
            "standardTagNamespaceName"
        ], "getStandardTagTemplate", params);

        const path = `${this.basePath}/tags/standardTagNamespaceTemplates/{standardTagNamespaceName}`
            .replace(`{${"standardTagNamespaceName"}}`, `${ params["standardTagNamespaceName"] }`);

        return this.request<StandardTagNamespaceTemplate>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] }
            },



            parseResponseBody: true,

            operationName: "getStandardTagTemplate",
            httpMethod: "GET"
        });
    }
    /** 
     * GetTag
     * Gets the specified tag&#39;s information.
     * @param tagNamespaceId The OCID of the tag namespace. 
     * @param tagName The name of the tag. 
     */
    public getTag(params: {  "tagNamespaceId": string; "tagName": string; }, options?: any): Promise<{ response: Response, data: Tag }> {
        base.validateRequiredParameters([
            "tagNamespaceId",
            "tagName"
        ], "getTag", params);

        const path = `${this.basePath}/tagNamespaces/{tagNamespaceId}/tags/{tagName}`
            .replace(`{${"tagNamespaceId"}}`, `${ params["tagNamespaceId"] }`)
            .replace(`{${"tagName"}}`, `${ params["tagName"] }`);

        return this.request<Tag>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getTag",
            httpMethod: "GET"
        });
    }
    /** 
     * GetTagDefault
     * Retrieves the specified tag default. 
     * @param tagDefaultId The OCID of the tag default.
     */
    public getTagDefault(params: {  "tagDefaultId": string; }, options?: any): Promise<{ response: Response, data: TagDefault }> {
        base.validateRequiredParameters([
            "tagDefaultId"
        ], "getTagDefault", params);

        const path = `${this.basePath}/tagDefaults/{tagDefaultId}`
            .replace(`{${"tagDefaultId"}}`, `${ params["tagDefaultId"] }`);

        return this.request<TagDefault>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getTagDefault",
            httpMethod: "GET"
        });
    }
    /** 
     * GetTagNamespace
     * Gets the specified tag namespace&#39;s information. 
     * @param tagNamespaceId The OCID of the tag namespace. 
     */
    public getTagNamespace(params: {  "tagNamespaceId": string; }, options?: any): Promise<{ response: Response, data: TagNamespace }> {
        base.validateRequiredParameters([
            "tagNamespaceId"
        ], "getTagNamespace", params);

        const path = `${this.basePath}/tagNamespaces/{tagNamespaceId}`
            .replace(`{${"tagNamespaceId"}}`, `${ params["tagNamespaceId"] }`);

        return this.request<TagNamespace>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getTagNamespace",
            httpMethod: "GET"
        });
    }
    /** 
     * GetTaggingWorkRequest
     * Gets details on a specified work request. The workRequestID is returned in the opc-workrequest-id header for any asynchronous operation in tagging service. 
     * @param workRequestId The OCID of the work request.
     */
    public getTaggingWorkRequest(params: {  "workRequestId": string; }, options?: any): Promise<{ response: Response, data: TaggingWorkRequest }> {
        base.validateRequiredParameters([
            "workRequestId"
        ], "getTaggingWorkRequest", params);

        const path = `${this.basePath}/taggingWorkRequests/{workRequestId}`
            .replace(`{${"workRequestId"}}`, `${ params["workRequestId"] }`);

        return this.request<TaggingWorkRequest>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getTaggingWorkRequest",
            httpMethod: "GET"
        });
    }
    /** 
     * GetTenancy
     * Get the specified tenancy&#39;s information.
     * @param tenancyId The OCID of the tenancy.
     */
    public getTenancy(params: {  "tenancyId": string; }, options?: any): Promise<{ response: Response, data: Tenancy }> {
        base.validateRequiredParameters([
            "tenancyId"
        ], "getTenancy", params);

        const path = `${this.basePath}/tenancies/{tenancyId}`
            .replace(`{${"tenancyId"}}`, `${ params["tenancyId"] }`);

        return this.request<Tenancy>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getTenancy",
            httpMethod: "GET"
        });
    }
    /** 
     * GetUpiGroup
     * Gets the specified group&#39;s information.  This operation does not return a list of all the users in the group. To do that, use [ListUserGroupMemberships](#/en/identity/20160918/UserGroupMembership/ListUserGroupMemberships) and provide the group&#39;s OCID as a query parameter in the request. 
     * @param idcsId The IDCS ID of the group.
     */
    public getUpiGroup(params: {  "idcsId": string; }, options?: any): Promise<{ response: Response, data: UpiGroup }> {
        base.validateRequiredParameters([
            "idcsId"
        ], "getUpiGroup", params);

        const path = `${this.basePath}/upi/groups/{idcsId}`
            .replace(`{${"idcsId"}}`, `${ params["idcsId"] }`);

        return this.request<UpiGroup>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getUpiGroup",
            httpMethod: "GET"
        });
    }
    /** 
     * GetUpiUser
     * Gets the specified upi user&#39;s information.
     * @param idcsId The IDCS ID of the user.
     */
    public getUpiUser(params: {  "idcsId": string; }, options?: any): Promise<{ response: Response, data: UpiUser }> {
        base.validateRequiredParameters([
            "idcsId"
        ], "getUpiUser", params);

        const path = `${this.basePath}/upi/users/{idcsId}`
            .replace(`{${"idcsId"}}`, `${ params["idcsId"] }`);

        return this.request<UpiUser>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getUpiUser",
            httpMethod: "GET"
        });
    }
    /** 
     * GetUser
     * Gets the specified user&#39;s information.
     * @param userId The OCID of the user.
     */
    public getUser(params: {  "userId": string; }, options?: any): Promise<{ response: Response, data: User }> {
        base.validateRequiredParameters([
            "userId"
        ], "getUser", params);

        const path = `${this.basePath}/users/{userId}`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<User>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getUser",
            httpMethod: "GET"
        });
    }
    /** 
     * GetUserGroupMembership
     * Gets the specified UserGroupMembership&#39;s information.
     * @param userGroupMembershipId The OCID of the userGroupMembership.
     */
    public getUserGroupMembership(params: {  "userGroupMembershipId": string; }, options?: any): Promise<{ response: Response, data: UserGroupMembership }> {
        base.validateRequiredParameters([
            "userGroupMembershipId"
        ], "getUserGroupMembership", params);

        const path = `${this.basePath}/userGroupMemberships/{userGroupMembershipId}`
            .replace(`{${"userGroupMembershipId"}}`, `${ params["userGroupMembershipId"] }`);

        return this.request<UserGroupMembership>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getUserGroupMembership",
            httpMethod: "GET"
        });
    }
    /** 
     * GetUserUIPasswordInformation
     * Gets the specified user&#39;s console password information. The returned object contains the user&#39;s OCID, but not the password itself. The actual password is returned only when created or reset. 
     * @param userId The OCID of the user.
     */
    public getUserUIPasswordInformation(params: {  "userId": string; }, options?: any): Promise<{ response: Response, data: UIPasswordInformation }> {
        base.validateRequiredParameters([
            "userId"
        ], "getUserUIPasswordInformation", params);

        const path = `${this.basePath}/users/{userId}/uiPassword`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<UIPasswordInformation>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getUserUIPasswordInformation",
            httpMethod: "GET"
        });
    }
    /** 
     * GetWorkRequest
     * Gets details on a specified work request. The workRequestID is returned in the opc-workrequest-id header for any asynchronous operation in the compartment service. 
     * @param workRequestId The OCID of the work request.
     */
    public getWorkRequest(params: {  "workRequestId": string; }, options?: any): Promise<{ response: Response, data: WorkRequest }> {
        base.validateRequiredParameters([
            "workRequestId"
        ], "getWorkRequest", params);

        const path = `${this.basePath}/workRequests/{workRequestId}`
            .replace(`{${"workRequestId"}}`, `${ params["workRequestId"] }`);

        return this.request<WorkRequest>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getWorkRequest",
            httpMethod: "GET"
        });
    }
    /** 
     * GetWorkflowTask
     * Gets the specified workflow task. 
     * @param workflowTaskId The id of the workflow task.
     */
    public getWorkflowTask(params: {  "workflowTaskId": string; }, options?: any): Promise<{ response: Response, data: WorkflowTask }> {
        base.validateRequiredParameters([
            "workflowTaskId"
        ], "getWorkflowTask", params);

        const path = `${this.basePath}/workflowTasks/{workflowTaskId}`
            .replace(`{${"workflowTaskId"}}`, `${ params["workflowTaskId"] }`);

        return this.request<WorkflowTask>({
            options,
            path,




            parseResponseBody: true,

            operationName: "getWorkflowTask",
            httpMethod: "GET"
        });
    }
    /** 
     * Create or update tag namespace and their tag definitions if a given tag namespace is a standard tag namespace. If the tag namespace already exists, any missing tag definitions will be added. For existing enum tags, any new enum values will be added. Deleting tagging entities nor removing enum values are not supported. 
     * OCI will release Tag Namespaces that our customers can import. These Tag Namespaces will provide Tags for our customers and Partners to provide consistency and enable data reporting. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param importStandardTagsDetails The request object for creating or updating standard tag namespace.
     */
    public importStandardTags(params: {  "opcRequestId"?: string; "opcRetryToken"?: string; "importStandardTagsDetails"?: ImportStandardTagsDetails; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
        ], "importStandardTags", params);

        const path = `${this.basePath}/tags/actions/importStandardTags`;

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: !params["importStandardTagsDetails"] ? undefined : 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["importStandardTagsDetails"]
                    },


            operationName: "importStandardTags",
            httpMethod: "POST"
        });
    }
    /** 
     * LinkSupportAccount
     * Link a support account for the user. Link requires manual interaction with the Console. The tenancy admin needs define policy to allow users to link a support account. Users with permission to link support account authenticate themselves via the IdP from its support provider. 
     * @param userId The OCID of the user.
     * @param linkSupportAccountDetails the request object to link a support account
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public linkSupportAccount(params: {  "userId": string; "linkSupportAccountDetails": LinkSupportAccountDetails; "opcRequestId"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "userId",
            "linkSupportAccountDetails",
        ], "linkSupportAccount", params);

        const path = `${this.basePath}/users/{userId}/actions/linkSupportAccount`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["linkSupportAccountDetails"]
                    },


            operationName: "linkSupportAccount",
            httpMethod: "POST"
        });
    }
    /** 
     * List allowed Domain License Types
     * List the allowed domain license types supported by OCI If {@code currentLicenseTypeName} provided, returns allowed license types a domain with the specified license type name can migrate to. If {@code name} is provided, it filters and returns resources that match the given license type name. Otherwise, returns all valid license types that are currently supported.  - If license type details are retrieved sucessfully, return 202 ACCEPTED. - If any internal error occurs, return 500 INTERNAL SERVER ERROR. 
     * @param currentLicenseTypeName The domain license type
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public listAllowedDomainLicenseTypes(params: {  "currentLicenseTypeName"?: string; "opcRequestId"?: string; }, options?: any): Promise<{ response: Response, data: Array<AllowedDomainLicenseTypeSummary> }> {
        base.validateRequiredParameters([
        ], "listAllowedDomainLicenseTypes", params);

        const path = `${this.basePath}/allowedDomainLicenseTypes`;

        return this.request<Array<AllowedDomainLicenseTypeSummary>>({
            options,
            path,

            queryParameters: {
                    "currentLicenseTypeName": { values: params["currentLicenseTypeName"] }
            },

            headerParameters: {
                "opc-request-id":  params["opcRequestId"]
            },


            parseResponseBody: true,

            operationName: "listAllowedDomainLicenseTypes",
            httpMethod: "GET"
        });
    }
    /** 
     * ListApiKeys
     * Lists the API signing keys for the specified user. A user can have a maximum of three keys.  Every user has permission to use this API call for *their own user ID*.  An administrator in your organization does not need to write a policy to give users this ability. 
     * @param userId The OCID of the user.
     */
    public listApiKeys(params: {  "userId": string; }, options?: any): Promise<{ response: Response, data: Array<ApiKey> }> {
        base.validateRequiredParameters([
            "userId"
        ], "listApiKeys", params);

        const path = `${this.basePath}/users/{userId}/apiKeys/`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<Array<ApiKey>>({
            options,
            path,




            parseResponseBody: true,

            operationName: "listApiKeys",
            httpMethod: "GET"
        });
    }
    /** 
     * ListAuthTokens
     * Lists the auth tokens for the specified user. The returned object contains the token&#39;s OCID, but not the token itself. The actual token is returned only upon creation. 
     * @param userId The OCID of the user.
     */
    public listAuthTokens(params: {  "userId": string; }, options?: any): Promise<{ response: Response, data: Array<AuthToken> }> {
        base.validateRequiredParameters([
            "userId"
        ], "listAuthTokens", params);

        const path = `${this.basePath}/users/{userId}/authTokens/`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<Array<AuthToken>>({
            options,
            path,




            parseResponseBody: true,

            operationName: "listAuthTokens",
            httpMethod: "GET"
        });
    }
    /** 
     * ListAvailabilityDomains
     * Lists the availability domains in your tenancy. Specify the OCID of either the tenancy or another of your compartments as the value for the compartment ID (remember that the tenancy is simply the root compartment). See [Where to Get the Tenancy&#39;s OCID and User&#39;s OCID](/Content/API/Concepts/apisigningkey.htm#five). Note that the order of the results returned can change if availability domains are added or removed; therefore, do not create a dependency on the list order. 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     */
    public listAvailabilityDomains(params: {  "compartmentId": string; }, options?: any): Promise<{ response: Response, data: Array<AvailabilityDomain> }> {
        base.validateRequiredParameters([
            "compartmentId"
        ], "listAvailabilityDomains", params);

        const path = `${this.basePath}/availabilityDomains/`;

        return this.request<Array<AvailabilityDomain>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] }
            },



            parseResponseBody: true,

            operationName: "listAvailabilityDomains",
            httpMethod: "GET"
        });
    }
    /** 
     * ListBulkActionResourceTypes
     * Lists the resource-types supported by compartment bulk actions. Use this API to help you provide the correct resource-type information to the [BulkDeleteResources](#/en/identity/20160918/Compartment/BulkDeleteResources/) and [BulkMoveResources](#/en/identity/20160918/Compartment/BulkMoveResources/) operations. The returned list of resource-types provides the appropriate resource-type names to use with the bulk action operations along with the type of identifying information you&#39;ll need to provide for each resource-type. Most resource-types just require an [OCID](/Content/General/Concepts/identifiers.htm) to identify a specific resource, but some resource-types, such as buckets, require you to provide other identifying information. 
     * @param bulkActionType The type of bulk action. 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     */
    public listBulkActionResourceTypes(params: {  "bulkActionType": string; "page"?: string; "limit"?: number; }, options?: any): Promise<{ response: Response, data: BulkActionResourceTypeCollection }> {
        base.validateRequiredParameters([
            "bulkActionType",
        ], "listBulkActionResourceTypes", params);

        const path = `${this.basePath}/compartments/bulkActionResourceTypes`;

        return this.request<BulkActionResourceTypeCollection>({
            options,
            path,

            queryParameters: {
                    "bulkActionType": { values: params["bulkActionType"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] }
            },



            parseResponseBody: true,

            operationName: "listBulkActionResourceTypes",
            httpMethod: "GET"
        });
    }
    /** 
     * ListBulkEditTagsResourceTypes
     * Lists the resource types that support bulk tag editing. 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     */
    public listBulkEditTagsResourceTypes(params: {  "page"?: string; "limit"?: number; }, options?: any): Promise<{ response: Response, data: BulkEditTagsResourceTypeCollection }> {
        base.validateRequiredParameters([
        ], "listBulkEditTagsResourceTypes", params);

        const path = `${this.basePath}/tags/bulkEditResourceTypes`;

        return this.request<BulkEditTagsResourceTypeCollection>({
            options,
            path,

            queryParameters: {
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] }
            },



            parseResponseBody: true,

            operationName: "listBulkEditTagsResourceTypes",
            httpMethod: "GET"
        });
    }
    /** 
     * ListCompartments
     * Lists the compartments in a specified compartment. The members of the list returned depends on the values set for several parameters.  With the exception of the tenancy (root compartment), the ListCompartments operation returns only the first-level child compartments in the parent compartment specified in &#x60;compartmentId&#x60;. The list does not include any subcompartments of the child compartments (grandchildren).  The parameter &#x60;accessLevel&#x60; specifies whether to return only those compartments for which the requestor has INSPECT permissions on at least one resource directly or indirectly (the resource can be in a subcompartment).  The parameter &#x60;compartmentIdInSubtree&#x60; applies only when you perform ListCompartments on the tenancy (root compartment). When set to true, the entire hierarchy of compartments can be returned. To get a full list of all compartments and subcompartments in the tenancy (root compartment), set the parameter &#x60;compartmentIdInSubtree&#x60; to true and &#x60;accessLevel&#x60; to ANY.  See [Where to Get the Tenancy&#39;s OCID and User&#39;s OCID](/Content/API/Concepts/apisigningkey.htm#five). 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param accessLevel Valid values are &#x60;ANY&#x60; and &#x60;ACCESSIBLE&#x60;. Default is &#x60;ANY&#x60;. Setting this to &#x60;ACCESSIBLE&#x60; returns only those compartments for which the user has INSPECT permissions directly or indirectly (permissions can be on a resource in a subcompartment). For the compartments on which the user indirectly has INSPECT permissions, a restricted set of fields is returned.  When set to &#x60;ANY&#x60; permissions are not checked. 
     * @param compartmentIdInSubtree Default is false. Can only be set to true when performing ListCompartments on the tenancy (root compartment). When set to true, the hierarchy of compartments is traversed and all compartments and subcompartments in the tenancy are returned depending on the the setting of &#x60;accessLevel&#x60;. 
     * @param verboseLevel This parameter is required to retrieve securityZoneId associated with the compartment. 
     * @param name A filter to only return resources that match the given name exactly. 
     * @param sortBy The field to sort by. You can provide one sort order (&#x60;sortOrder&#x60;). Default order for TIMECREATED is descending. Default order for NAME is ascending. The NAME sort order is case sensitive.  **Note:** In general, some \&quot;List\&quot; operations (for example, &#x60;ListInstances&#x60;) let you optionally filter by Availability Domain if the scope of the resource type is within a single Availability Domain. If you call one of these \&quot;List\&quot; operations without specifying an Availability Domain, the resources are grouped by Availability Domain, then sorted. 
     * @param sortOrder The sort order to use, either ascending (&#x60;ASC&#x60;) or descending (&#x60;DESC&#x60;). The NAME sort order is case sensitive. 
     * @param lifecycleState A filter to only return resources that match the given lifecycle state.  The state value is case-insensitive. 
     */
    public listCompartments(params: {  "compartmentId": string; "page"?: string; "limit"?: number; "accessLevel"?: string; "compartmentIdInSubtree"?: boolean; "verboseLevel"?: string; "name"?: string; "sortBy"?: string; "sortOrder"?: string; "lifecycleState"?: string; }, options?: any): Promise<{ response: Response, data: Array<Compartment> }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "listCompartments", params);

        const path = `${this.basePath}/compartments/`;

        return this.request<Array<Compartment>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "accessLevel": { values: params["accessLevel"] },
                    "compartmentIdInSubtree": { values: params["compartmentIdInSubtree"] },
                    "verboseLevel": { values: params["verboseLevel"] },
                    "name": { values: params["name"] },
                    "sortBy": { values: params["sortBy"] },
                    "sortOrder": { values: params["sortOrder"] },
                    "lifecycleState": { values: params["lifecycleState"] }
            },



            parseResponseBody: true,

            operationName: "listCompartments",
            httpMethod: "GET"
        });
    }
    /** 
     * ListCostTrackingTags
     * Lists all the tags enabled for cost-tracking in the specified tenancy. For information about cost-tracking tags, see [Using Cost-tracking Tags](/Content/Identity/Concepts/taggingoverview.htm#costs). 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     */
    public listCostTrackingTags(params: {  "compartmentId": string; "page"?: string; "limit"?: number; }, options?: any): Promise<{ response: Response, data: Array<Tag> }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "listCostTrackingTags", params);

        const path = `${this.basePath}/tagNamespaces/actions/listCostTrackingTags`;

        return this.request<Array<Tag>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] }
            },



            parseResponseBody: true,

            operationName: "listCostTrackingTags",
            httpMethod: "GET"
        });
    }
    /** 
     * ListCustomerSecretKeys
     * Lists the secret keys for the specified user. The returned object contains the secret key&#39;s OCID, but not the secret key itself. The actual secret key is returned only upon creation. 
     * @param userId The OCID of the user.
     */
    public listCustomerSecretKeys(params: {  "userId": string; }, options?: any): Promise<{ response: Response, data: Array<CustomerSecretKeySummary> }> {
        base.validateRequiredParameters([
            "userId"
        ], "listCustomerSecretKeys", params);

        const path = `${this.basePath}/users/{userId}/customerSecretKeys/`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<Array<CustomerSecretKeySummary>>({
            options,
            path,




            parseResponseBody: true,

            operationName: "listCustomerSecretKeys",
            httpMethod: "GET"
        });
    }
    /** 
     * ListDbCredentials
     * Lists the DB credentials for the specified user. The returned object contains the credential&#39;s OCID 
     * @param userId The OCID of the user.
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param name A filter to only return resources that match the given name exactly. 
     * @param sortBy The field to sort by. You can provide one sort order (&#x60;sortOrder&#x60;). Default order for TIMECREATED is descending. Default order for NAME is ascending. The NAME sort order is case sensitive.  **Note:** In general, some \&quot;List\&quot; operations (for example, &#x60;ListInstances&#x60;) let you optionally filter by Availability Domain if the scope of the resource type is within a single Availability Domain. If you call one of these \&quot;List\&quot; operations without specifying an Availability Domain, the resources are grouped by Availability Domain, then sorted. 
     * @param sortOrder The sort order to use, either ascending (&#x60;ASC&#x60;) or descending (&#x60;DESC&#x60;). The NAME sort order is case sensitive. 
     * @param lifecycleState A filter to only return resources that match the given lifecycle state.  The state value is case-insensitive. 
     */
    public listDbCredentials(params: {  "userId": string; "opcRequestId"?: string; "page"?: string; "limit"?: number; "name"?: string; "sortBy"?: string; "sortOrder"?: string; "lifecycleState"?: string; }, options?: any): Promise<{ response: Response, data: Array<DbCredentialSummary> }> {
        base.validateRequiredParameters([
            "userId",
        ], "listDbCredentials", params);

        const path = `${this.basePath}/users/{userId}/dbCredentials/`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<Array<DbCredentialSummary>>({
            options,
            path,

            queryParameters: {
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "name": { values: params["name"] },
                    "sortBy": { values: params["sortBy"] },
                    "sortOrder": { values: params["sortOrder"] },
                    "lifecycleState": { values: params["lifecycleState"] }
            },

            headerParameters: {
                "opc-request-id":  params["opcRequestId"]
            },


            parseResponseBody: true,

            operationName: "listDbCredentials",
            httpMethod: "GET"
        });
    }
    /** 
     * ListDomainMigrations
     * List all domain migration workflow job records 
     * @param workflowTaskId The id of the workflow task.
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param sortBy The field to sort by. You can provide one sort order (&#x60;sortOrder&#x60;). Default order for TIMECREATED is descending. Default order for NAME is ascending. The NAME sort order is case sensitive.  **Note:** In general, some \&quot;List\&quot; operations (for example, &#x60;ListInstances&#x60;) let you optionally filter by Availability Domain if the scope of the resource type is within a single Availability Domain. If you call one of these \&quot;List\&quot; operations without specifying an Availability Domain, the resources are grouped by Availability Domain, then sorted. 
     * @param sortOrder The sort order to use, either ascending (&#x60;ASC&#x60;) or descending (&#x60;DESC&#x60;). The NAME sort order is case sensitive. 
     */
    public listDomainMigrations(params: {  "workflowTaskId": string; "page"?: string; "limit"?: number; "sortBy"?: string; "sortOrder"?: string; }, options?: any): Promise<{ response: Response, data: Array<DomainMigration> }> {
        base.validateRequiredParameters([
            "workflowTaskId",
        ], "listDomainMigrations", params);

        const path = `${this.basePath}/domainMigrations/{workflowTaskId}/`
            .replace(`{${"workflowTaskId"}}`, `${ params["workflowTaskId"] }`);

        return this.request<Array<DomainMigration>>({
            options,
            path,

            queryParameters: {
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "sortBy": { values: params["sortBy"] },
                    "sortOrder": { values: params["sortOrder"] }
            },



            parseResponseBody: true,

            operationName: "listDomainMigrations",
            httpMethod: "GET"
        });
    }
    /** 
     * ListDomains
     * List all domains that are homed or have a replica region in current region. - If any internal error occurs, return 500 INTERNAL SERVER ERROR. 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param displayName The mutable display name of the domain
     * @param url The region agnostic domain URL
     * @param homeRegionUrl The region specific domain URL
     * @param type The domain type
     * @param licenseType The domain license type
     * @param isHiddenOnLogin Indicate if the domain is visible at login screen or not
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param name A filter to only return resources that match the given name exactly. 
     * @param sortBy The field to sort by. You can provide one sort order (&#x60;sortOrder&#x60;). Default order for TIMECREATED is descending. Default order for NAME is ascending. The NAME sort order is case sensitive.  **Note:** In general, some \&quot;List\&quot; operations (for example, &#x60;ListInstances&#x60;) let you optionally filter by Availability Domain if the scope of the resource type is within a single Availability Domain. If you call one of these \&quot;List\&quot; operations without specifying an Availability Domain, the resources are grouped by Availability Domain, then sorted. 
     * @param sortOrder The sort order to use, either ascending (&#x60;ASC&#x60;) or descending (&#x60;DESC&#x60;). The NAME sort order is case sensitive. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param lifecycleState A filter to only return resources that match the given lifecycle state.  The state value is case-insensitive. 
     */
    public listDomains(params: {  "compartmentId": string; "displayName"?: string; "url"?: string; "homeRegionUrl"?: string; "type"?: string; "licenseType"?: string; "isHiddenOnLogin"?: boolean; "page"?: string; "limit"?: number; "name"?: string; "sortBy"?: string; "sortOrder"?: string; "opcRequestId"?: string; "lifecycleState"?: string; }, options?: any): Promise<{ response: Response, data: Array<DomainSummary> }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "listDomains", params);

        const path = `${this.basePath}/domains/`;

        return this.request<Array<DomainSummary>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "displayName": { values: params["displayName"] },
                    "url": { values: params["url"] },
                    "homeRegionUrl": { values: params["homeRegionUrl"] },
                    "type": { values: params["type"] },
                    "licenseType": { values: params["licenseType"] },
                    "isHiddenOnLogin": { values: params["isHiddenOnLogin"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "name": { values: params["name"] },
                    "sortBy": { values: params["sortBy"] },
                    "sortOrder": { values: params["sortOrder"] },
                    "lifecycleState": { values: params["lifecycleState"] }
            },

            headerParameters: {
                "opc-request-id":  params["opcRequestId"]
            },


            parseResponseBody: true,

            operationName: "listDomains",
            httpMethod: "GET"
        });
    }
    /** 
     * ListDynamicGroups
     * Lists the dynamic groups in your tenancy. You must specify your tenancy&#39;s OCID as the value for the compartment ID (remember that the tenancy is simply the root compartment). See [Where to Get the Tenancy&#39;s OCID and User&#39;s OCID](/Content/API/Concepts/apisigningkey.htm#five). 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param name A filter to only return resources that match the given name exactly. 
     * @param sortBy The field to sort by. You can provide one sort order (&#x60;sortOrder&#x60;). Default order for TIMECREATED is descending. Default order for NAME is ascending. The NAME sort order is case sensitive.  **Note:** In general, some \&quot;List\&quot; operations (for example, &#x60;ListInstances&#x60;) let you optionally filter by Availability Domain if the scope of the resource type is within a single Availability Domain. If you call one of these \&quot;List\&quot; operations without specifying an Availability Domain, the resources are grouped by Availability Domain, then sorted. 
     * @param sortOrder The sort order to use, either ascending (&#x60;ASC&#x60;) or descending (&#x60;DESC&#x60;). The NAME sort order is case sensitive. 
     * @param lifecycleState A filter to only return resources that match the given lifecycle state.  The state value is case-insensitive. 
     */
    public listDynamicGroups(params: {  "compartmentId": string; "page"?: string; "limit"?: number; "name"?: string; "sortBy"?: string; "sortOrder"?: string; "lifecycleState"?: string; }, options?: any): Promise<{ response: Response, data: Array<DynamicGroup> }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "listDynamicGroups", params);

        const path = `${this.basePath}/dynamicGroups/`;

        return this.request<Array<DynamicGroup>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "name": { values: params["name"] },
                    "sortBy": { values: params["sortBy"] },
                    "sortOrder": { values: params["sortOrder"] },
                    "lifecycleState": { values: params["lifecycleState"] }
            },



            parseResponseBody: true,

            operationName: "listDynamicGroups",
            httpMethod: "GET"
        });
    }
    /** 
     * ListFaultDomains
     * Lists the Fault Domains in your tenancy. Specify the OCID of either the tenancy or another of your compartments as the value for the compartment ID (remember that the tenancy is simply the root compartment). See [Where to Get the Tenancy&#39;s OCID and User&#39;s OCID](/Content/API/Concepts/apisigningkey.htm#five). 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param availabilityDomain The name of the availibilityDomain. 
     */
    public listFaultDomains(params: {  "compartmentId": string; "availabilityDomain": string; }, options?: any): Promise<{ response: Response, data: Array<FaultDomain> }> {
        base.validateRequiredParameters([
            "compartmentId",
            "availabilityDomain"
        ], "listFaultDomains", params);

        const path = `${this.basePath}/faultDomains/`;

        return this.request<Array<FaultDomain>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "availabilityDomain": { values: params["availabilityDomain"] }
            },



            parseResponseBody: true,

            operationName: "listFaultDomains",
            httpMethod: "GET"
        });
    }
    /** 
     * ListGroups
     * Lists the groups in your tenancy. You must specify your tenancy&#39;s OCID as the value for the compartment ID (remember that the tenancy is simply the root compartment). See [Where to Get the Tenancy&#39;s OCID and User&#39;s OCID](/Content/API/Concepts/apisigningkey.htm#five). 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param name A filter to only return resources that match the given name exactly. 
     * @param sortBy The field to sort by. You can provide one sort order (&#x60;sortOrder&#x60;). Default order for TIMECREATED is descending. Default order for NAME is ascending. The NAME sort order is case sensitive.  **Note:** In general, some \&quot;List\&quot; operations (for example, &#x60;ListInstances&#x60;) let you optionally filter by Availability Domain if the scope of the resource type is within a single Availability Domain. If you call one of these \&quot;List\&quot; operations without specifying an Availability Domain, the resources are grouped by Availability Domain, then sorted. 
     * @param sortOrder The sort order to use, either ascending (&#x60;ASC&#x60;) or descending (&#x60;DESC&#x60;). The NAME sort order is case sensitive. 
     * @param lifecycleState A filter to only return resources that match the given lifecycle state.  The state value is case-insensitive. 
     */
    public listGroups(params: {  "compartmentId": string; "page"?: string; "limit"?: number; "name"?: string; "sortBy"?: string; "sortOrder"?: string; "lifecycleState"?: string; }, options?: any): Promise<{ response: Response, data: Array<Group> }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "listGroups", params);

        const path = `${this.basePath}/groups/`;

        return this.request<Array<Group>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "name": { values: params["name"] },
                    "sortBy": { values: params["sortBy"] },
                    "sortOrder": { values: params["sortOrder"] },
                    "lifecycleState": { values: params["lifecycleState"] }
            },



            parseResponseBody: true,

            operationName: "listGroups",
            httpMethod: "GET"
        });
    }
    /** 
     * Lists work request errors
     * Gets error details for a specified IAM work request. For asynchronous operations in Identity and Access Management service, opc-work-request-id header values contains iam work request id that can be provided in this API to track the current status of the operation.  - If workrequest exists, returns 202 ACCEPTED - If workrequest does not exist, returns 404 NOT FOUND 
     * @param iamWorkRequestId The OCID of the IAM work request.
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param sortOrder The sort order to use, either ascending (&#x60;ASC&#x60;) or descending (&#x60;DESC&#x60;). The NAME sort order is case sensitive. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public listIamWorkRequestErrors(params: {  "iamWorkRequestId": string; "limit"?: number; "page"?: string; "sortOrder"?: string; "opcRequestId"?: string; }, options?: any): Promise<{ response: Response, data: Array<IamWorkRequestErrorSummary> }> {
        base.validateRequiredParameters([
            "iamWorkRequestId",
        ], "listIamWorkRequestErrors", params);

        const path = `${this.basePath}/iamWorkRequests/{iamWorkRequestId}/errors`
            .replace(`{${"iamWorkRequestId"}}`, `${ params["iamWorkRequestId"] }`);

        return this.request<Array<IamWorkRequestErrorSummary>>({
            options,
            path,

            queryParameters: {
                    "limit": { values: params["limit"] },
                    "page": { values: params["page"] },
                    "sortOrder": { values: params["sortOrder"] }
            },

            headerParameters: {
                "opc-request-id":  params["opcRequestId"]
            },


            parseResponseBody: true,

            operationName: "listIamWorkRequestErrors",
            httpMethod: "GET"
        });
    }
    /** 
     * List IAM workrequest logs
     * Gets logs for a specified IAM work request. For asynchronous operations in Identity and Access Management service, opc-work-request-id header values contains iam work request id that can be provided in this API to track the current status of the operation.  - If workrequest exists, returns 202 ACCEPTED - If workrequest does not exist, returns 404 NOT FOUND 
     * @param iamWorkRequestId The OCID of the IAM work request.
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param sortOrder The sort order to use, either ascending (&#x60;ASC&#x60;) or descending (&#x60;DESC&#x60;). The NAME sort order is case sensitive. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public listIamWorkRequestLogs(params: {  "iamWorkRequestId": string; "limit"?: number; "page"?: string; "sortOrder"?: string; "opcRequestId"?: string; }, options?: any): Promise<{ response: Response, data: Array<IamWorkRequestLogSummary> }> {
        base.validateRequiredParameters([
            "iamWorkRequestId",
        ], "listIamWorkRequestLogs", params);

        const path = `${this.basePath}/iamWorkRequests/{iamWorkRequestId}/logs`
            .replace(`{${"iamWorkRequestId"}}`, `${ params["iamWorkRequestId"] }`);

        return this.request<Array<IamWorkRequestLogSummary>>({
            options,
            path,

            queryParameters: {
                    "limit": { values: params["limit"] },
                    "page": { values: params["page"] },
                    "sortOrder": { values: params["sortOrder"] }
            },

            headerParameters: {
                "opc-request-id":  params["opcRequestId"]
            },


            parseResponseBody: true,

            operationName: "listIamWorkRequestLogs",
            httpMethod: "GET"
        });
    }
    /** 
     * List IAM work requests
     * List the IAM work requests in compartment  - If IAM workrequest  details are retrieved sucessfully, return 202 ACCEPTED. - If any internal error occurs, return 500 INTERNAL SERVER ERROR. 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param resourceIdentifier The identifier of the resource the work request affects.
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public listIamWorkRequests(params: {  "compartmentId": string; "page"?: string; "limit"?: number; "resourceIdentifier"?: string; "opcRequestId"?: string; }, options?: any): Promise<{ response: Response, data: Array<IamWorkRequestSummary> }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "listIamWorkRequests", params);

        const path = `${this.basePath}/iamWorkRequests`;

        return this.request<Array<IamWorkRequestSummary>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "resourceIdentifier": { values: params["resourceIdentifier"] }
            },

            headerParameters: {
                "opc-request-id":  params["opcRequestId"]
            },


            parseResponseBody: true,

            operationName: "listIamWorkRequests",
            httpMethod: "GET"
        });
    }
    /** 
     * Gets the identity provider groups.
     * **Deprecated.** For more information, see [Deprecated IAM Service APIs](/Content/Identity/Reference/deprecatediamapis.htm).  Lists the identity provider groups. 
     * @param identityProviderId The OCID of the identity provider.
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param name A filter to only return resources that match the given name exactly. 
     * @param lifecycleState A filter to only return resources that match the given lifecycle state.  The state value is case-insensitive. 
     */
    public listIdentityProviderGroups(params: {  "identityProviderId": string; "page"?: string; "limit"?: number; "name"?: string; "lifecycleState"?: string; }, options?: any): Promise<{ response: Response, data: Array<IdentityProviderGroupSummary> }> {
        base.validateRequiredParameters([
            "identityProviderId",
        ], "listIdentityProviderGroups", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}/groups/`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`);

        return this.request<Array<IdentityProviderGroupSummary>>({
            options,
            path,

            queryParameters: {
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "name": { values: params["name"] },
                    "lifecycleState": { values: params["lifecycleState"] }
            },



            parseResponseBody: true,

            operationName: "listIdentityProviderGroups",
            httpMethod: "GET"
        });
    }
    /** 
     * ListIdentityProviders
     * **Deprecated.** For more information, see [Deprecated IAM Service APIs](/Content/Identity/Reference/deprecatediamapis.htm).  Lists all the identity providers in your tenancy. You must specify the identity provider type (e.g., &#x60;SAML2&#x60; for identity providers using the SAML2.0 protocol). You must specify your tenancy&#39;s OCID as the value for the compartment ID (remember that the tenancy is simply the root compartment). See [Where to Get the Tenancy&#39;s OCID and User&#39;s OCID](/Content/API/Concepts/apisigningkey.htm#five). 
     * @param protocol The protocol used for federation.
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param name A filter to only return resources that match the given name exactly. 
     * @param sortBy The field to sort by. You can provide one sort order (&#x60;sortOrder&#x60;). Default order for TIMECREATED is descending. Default order for NAME is ascending. The NAME sort order is case sensitive.  **Note:** In general, some \&quot;List\&quot; operations (for example, &#x60;ListInstances&#x60;) let you optionally filter by Availability Domain if the scope of the resource type is within a single Availability Domain. If you call one of these \&quot;List\&quot; operations without specifying an Availability Domain, the resources are grouped by Availability Domain, then sorted. 
     * @param sortOrder The sort order to use, either ascending (&#x60;ASC&#x60;) or descending (&#x60;DESC&#x60;). The NAME sort order is case sensitive. 
     * @param lifecycleState A filter to only return resources that match the given lifecycle state.  The state value is case-insensitive. 
     */
    public listIdentityProviders(params: {  "protocol": string; "compartmentId": string; "page"?: string; "limit"?: number; "name"?: string; "sortBy"?: string; "sortOrder"?: string; "lifecycleState"?: string; }, options?: any): Promise<{ response: Response, data: Array<IdentityProvider> }> {
        base.validateRequiredParameters([
            "protocol",
            "compartmentId",
        ], "listIdentityProviders", params);

        const path = `${this.basePath}/identityProviders/`;

        return this.request<Array<IdentityProvider>>({
            options,
            path,

            queryParameters: {
                    "protocol": { values: params["protocol"] },
                    "compartmentId": { values: params["compartmentId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "name": { values: params["name"] },
                    "sortBy": { values: params["sortBy"] },
                    "sortOrder": { values: params["sortOrder"] },
                    "lifecycleState": { values: params["lifecycleState"] }
            },



            parseResponseBody: true,

            operationName: "listIdentityProviders",
            httpMethod: "GET"
        });
    }
    /** 
     * ListIdpGroupMappings
     * **Deprecated.** For more information, see [Deprecated IAM Service APIs](/Content/Identity/Reference/deprecatediamapis.htm).  Lists the group mappings for the specified identity provider. 
     * @param identityProviderId The OCID of the identity provider.
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     */
    public listIdpGroupMappings(params: {  "identityProviderId": string; "page"?: string; "limit"?: number; }, options?: any): Promise<{ response: Response, data: Array<IdpGroupMapping> }> {
        base.validateRequiredParameters([
            "identityProviderId",
        ], "listIdpGroupMappings", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}/groupMappings/`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`);

        return this.request<Array<IdpGroupMapping>>({
            options,
            path,

            queryParameters: {
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] }
            },



            parseResponseBody: true,

            operationName: "listIdpGroupMappings",
            httpMethod: "GET"
        });
    }
    /** 
     * ListManagedCompartments
     * List the managed compartments under the specific tenancy and specific service name. You must specify tenancy&#39;s OCID and service name as the value 
     * @param serviceName The name of the whitelisted service caller. Such as &#39;PSM&#39;
     * @param tenancyId The OCID of the tenancy.
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     */
    public listManagedCompartments(params: {  "serviceName": string; "tenancyId": string; "page"?: string; "limit"?: number; }, options?: any): Promise<{ response: Response, data: Array<Compartment> }> {
        base.validateRequiredParameters([
            "serviceName",
            "tenancyId",
        ], "listManagedCompartments", params);

        const path = `${this.basePath}/managedCompartments/`;

        return this.request<Array<Compartment>>({
            options,
            path,

            queryParameters: {
                    "serviceName": { values: params["serviceName"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "tenancyId": { values: params["tenancyId"] }
            },



            parseResponseBody: true,

            operationName: "listManagedCompartments",
            httpMethod: "GET"
        });
    }
    /** 
     * ListMfaTotpDevices
     * Lists the MFA TOTP devices for the specified user. The returned object contains the device&#39;s OCID, but not the seed. The seed is returned only upon creation or when the IAM service regenerates the MFA seed for the device. 
     * @param userId The OCID of the user.
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param sortBy The field to sort by. You can provide one sort order (&#x60;sortOrder&#x60;). Default order for TIMECREATED is descending. Default order for NAME is ascending. The NAME sort order is case sensitive.  **Note:** In general, some \&quot;List\&quot; operations (for example, &#x60;ListInstances&#x60;) let you optionally filter by Availability Domain if the scope of the resource type is within a single Availability Domain. If you call one of these \&quot;List\&quot; operations without specifying an Availability Domain, the resources are grouped by Availability Domain, then sorted. 
     * @param sortOrder The sort order to use, either ascending (&#x60;ASC&#x60;) or descending (&#x60;DESC&#x60;). The NAME sort order is case sensitive. 
     */
    public listMfaTotpDevices(params: {  "userId": string; "page"?: string; "limit"?: number; "sortBy"?: string; "sortOrder"?: string; }, options?: any): Promise<{ response: Response, data: Array<MfaTotpDeviceSummary> }> {
        base.validateRequiredParameters([
            "userId",
        ], "listMfaTotpDevices", params);

        const path = `${this.basePath}/users/{userId}/mfaTotpDevices`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<Array<MfaTotpDeviceSummary>>({
            options,
            path,

            queryParameters: {
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "sortBy": { values: params["sortBy"] },
                    "sortOrder": { values: params["sortOrder"] }
            },



            parseResponseBody: true,

            operationName: "listMfaTotpDevices",
            httpMethod: "GET"
        });
    }
    /** 
     * ListNetworkSources
     * Lists the network sources in your tenancy. You must specify your tenancy&#39;s OCID as the value for the compartment ID (remember that the tenancy is simply the root compartment). See [Where to Get the Tenancy&#39;s OCID and User&#39;s OCID](/Content/API/Concepts/apisigningkey.htm#five). 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param name A filter to only return resources that match the given name exactly. 
     * @param sortBy The field to sort by. You can provide one sort order (&#x60;sortOrder&#x60;). Default order for TIMECREATED is descending. Default order for NAME is ascending. The NAME sort order is case sensitive.  **Note:** In general, some \&quot;List\&quot; operations (for example, &#x60;ListInstances&#x60;) let you optionally filter by Availability Domain if the scope of the resource type is within a single Availability Domain. If you call one of these \&quot;List\&quot; operations without specifying an Availability Domain, the resources are grouped by Availability Domain, then sorted. 
     * @param sortOrder The sort order to use, either ascending (&#x60;ASC&#x60;) or descending (&#x60;DESC&#x60;). The NAME sort order is case sensitive. 
     * @param lifecycleState A filter to only return resources that match the given lifecycle state.  The state value is case-insensitive. 
     */
    public listNetworkSources(params: {  "compartmentId": string; "page"?: string; "limit"?: number; "name"?: string; "sortBy"?: string; "sortOrder"?: string; "lifecycleState"?: string; }, options?: any): Promise<{ response: Response, data: Array<NetworkSourcesSummary> }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "listNetworkSources", params);

        const path = `${this.basePath}/networkSources`;

        return this.request<Array<NetworkSourcesSummary>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "name": { values: params["name"] },
                    "sortBy": { values: params["sortBy"] },
                    "sortOrder": { values: params["sortOrder"] },
                    "lifecycleState": { values: params["lifecycleState"] }
            },



            parseResponseBody: true,

            operationName: "listNetworkSources",
            httpMethod: "GET"
        });
    }
    /** 
     * List of Oauth tokens for the user
     * List of Oauth tokens for the user 
     * @param userId The OCID of the user.
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param lifecycleState A filter to only return resources that match the given lifecycle state.  The state value is case-insensitive. 
     */
    public listOAuthClientCredentials(params: {  "userId": string; "page"?: string; "limit"?: number; "lifecycleState"?: string; }, options?: any): Promise<{ response: Response, data: Array<OAuth2ClientCredentialSummary> }> {
        base.validateRequiredParameters([
            "userId",
        ], "listOAuthClientCredentials", params);

        const path = `${this.basePath}/users/{userId}/oauth2ClientCredentials`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<Array<OAuth2ClientCredentialSummary>>({
            options,
            path,

            queryParameters: {
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "lifecycleState": { values: params["lifecycleState"] }
            },



            parseResponseBody: true,

            operationName: "listOAuthClientCredentials",
            httpMethod: "GET"
        });
    }
    /** 
     * ListOidcClients
     * Lists OpenID Connect clients. 
     * @param oidcClientId The id of the OpenID Connect client.
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param servicePrincipalName The service principal name of the OpenID Connect client.
     * @param responseType The response type of the OpenID Connect client.
     * @param name A filter to only return resources that match the given name exactly. 
     * @param sortBy The field to sort by. You can provide one sort order (&#x60;sortOrder&#x60;). Default order for TIMECREATED is descending. Default order for NAME is ascending. The NAME sort order is case sensitive.  **Note:** In general, some \&quot;List\&quot; operations (for example, &#x60;ListInstances&#x60;) let you optionally filter by Availability Domain if the scope of the resource type is within a single Availability Domain. If you call one of these \&quot;List\&quot; operations without specifying an Availability Domain, the resources are grouped by Availability Domain, then sorted. 
     * @param sortOrder The sort order to use, either ascending (&#x60;ASC&#x60;) or descending (&#x60;DESC&#x60;). The NAME sort order is case sensitive. 
     * @param lifecycleState A filter to only return resources that match the given lifecycle state.  The state value is case-insensitive. 
     */
    public listOidcClients(params: {  "oidcClientId"?: string; "page"?: string; "limit"?: number; "servicePrincipalName"?: string; "responseType"?: string; "name"?: string; "sortBy"?: string; "sortOrder"?: string; "lifecycleState"?: string; }, options?: any): Promise<{ response: Response, data: Array<OidcClient> }> {
        base.validateRequiredParameters([
        ], "listOidcClients", params);

        const path = `${this.basePath}/oidcClients/`;

        return this.request<Array<OidcClient>>({
            options,
            path,

            queryParameters: {
                    "oidcClientId": { values: params["oidcClientId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "servicePrincipalName": { values: params["servicePrincipalName"] },
                    "responseType": { values: params["responseType"] },
                    "name": { values: params["name"] },
                    "sortBy": { values: params["sortBy"] },
                    "sortOrder": { values: params["sortOrder"] },
                    "lifecycleState": { values: params["lifecycleState"] }
            },



            parseResponseBody: true,

            operationName: "listOidcClients",
            httpMethod: "GET"
        });
    }
    /** 
     * ListOnPremSites
     * Lists the OnPremSites in a specified compartment. The members of the list returned depends on the values set for several parameters. OnPremSites can only be created under the tenancy (root compartment). So ListOnPremSites will return empty result if the compartment id is not the tenancy id.
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param name A filter to only return resources that match the given name exactly. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param sortOrder The sort order to use, either ascending (&#x60;ASC&#x60;) or descending (&#x60;DESC&#x60;). The NAME sort order is case sensitive. 
     * @param sortBy The field to sort by. You can provide one sort order (&#x60;sortOrder&#x60;). Default order for TIMECREATED is descending. Default order for NAME is ascending. The NAME sort order is case sensitive.  **Note:** In general, some \&quot;List\&quot; operations (for example, &#x60;ListInstances&#x60;) let you optionally filter by Availability Domain if the scope of the resource type is within a single Availability Domain. If you call one of these \&quot;List\&quot; operations without specifying an Availability Domain, the resources are grouped by Availability Domain, then sorted. 
     * @param lifecycleState A filter to only return resources that match the given lifecycle state.  The state value is case-insensitive. 
     */
    public listOnPremSites(params: {  "compartmentId": string; "name"?: string; "limit"?: number; "page"?: string; "sortOrder"?: string; "sortBy"?: string; "lifecycleState"?: string; }, options?: any): Promise<{ response: Response, data: OnPremSiteCollection }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "listOnPremSites", params);

        const path = `${this.basePath}/onPremSites`;

        return this.request<OnPremSiteCollection>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "name": { values: params["name"] },
                    "limit": { values: params["limit"] },
                    "page": { values: params["page"] },
                    "sortOrder": { values: params["sortOrder"] },
                    "sortBy": { values: params["sortBy"] },
                    "lifecycleState": { values: params["lifecycleState"] }
            },



            parseResponseBody: true,

            operationName: "listOnPremSites",
            httpMethod: "GET"
        });
    }
    /** 
     * ListPermissions
     * List permissions request for a given resource kind, service, permission string or metaverb. 
     * @param serviceName The name of the whitelisted service caller. Such as &#39;PSM&#39;
     * @param resourceKind The resource kind name.
     * @param permissionString The permission string for the resource.
     * @param metaverb The meta verb for the resource.
     * @param metanoun The meta noun for the resource.
     */
    public listPermissions(params: {  "serviceName": string; "resourceKind"?: string; "permissionString"?: string; "metaverb"?: string; "metanoun"?: string; }, options?: any): Promise<{ response: Response, data: Array<Permission> }> {
        base.validateRequiredParameters([
            "serviceName",
        ], "listPermissions", params);

        const path = `${this.basePath}/permissions/`;

        return this.request<Array<Permission>>({
            options,
            path,

            queryParameters: {
                    "resourceKind": { values: params["resourceKind"] },
                    "permissionString": { values: params["permissionString"] },
                    "metaverb": { values: params["metaverb"] },
                    "serviceName": { values: params["serviceName"] },
                    "metanoun": { values: params["metanoun"] }
            },



            parseResponseBody: true,

            operationName: "listPermissions",
            httpMethod: "GET"
        });
    }
    /** 
     * ListPolicies
     * Lists the policies in the specified compartment (either the tenancy or another of your compartments). See [Where to Get the Tenancy&#39;s OCID and User&#39;s OCID](/Content/API/Concepts/apisigningkey.htm#five).  To determine which policies apply to a particular group or compartment, you must view the individual statements inside all your policies. There isn&#39;t a way to automatically obtain that information via the API. 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param name A filter to only return resources that match the given name exactly. 
     * @param sortBy The field to sort by. You can provide one sort order (&#x60;sortOrder&#x60;). Default order for TIMECREATED is descending. Default order for NAME is ascending. The NAME sort order is case sensitive.  **Note:** In general, some \&quot;List\&quot; operations (for example, &#x60;ListInstances&#x60;) let you optionally filter by Availability Domain if the scope of the resource type is within a single Availability Domain. If you call one of these \&quot;List\&quot; operations without specifying an Availability Domain, the resources are grouped by Availability Domain, then sorted. 
     * @param sortOrder The sort order to use, either ascending (&#x60;ASC&#x60;) or descending (&#x60;DESC&#x60;). The NAME sort order is case sensitive. 
     * @param lifecycleState A filter to only return resources that match the given lifecycle state.  The state value is case-insensitive. 
     */
    public listPolicies(params: {  "compartmentId": string; "page"?: string; "limit"?: number; "name"?: string; "sortBy"?: string; "sortOrder"?: string; "lifecycleState"?: string; }, options?: any): Promise<{ response: Response, data: Array<Policy> }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "listPolicies", params);

        const path = `${this.basePath}/policies/`;

        return this.request<Array<Policy>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "name": { values: params["name"] },
                    "sortBy": { values: params["sortBy"] },
                    "sortOrder": { values: params["sortOrder"] },
                    "lifecycleState": { values: params["lifecycleState"] }
            },



            parseResponseBody: true,

            operationName: "listPolicies",
            httpMethod: "GET"
        });
    }
    /** 
     * ListRegionSubscriptions
     * Lists the region subscriptions for the specified tenancy.
     * @param tenancyId The OCID of the tenancy.
     */
    public listRegionSubscriptions(params: {  "tenancyId": string; }, options?: any): Promise<{ response: Response, data: Array<RegionSubscription> }> {
        base.validateRequiredParameters([
            "tenancyId"
        ], "listRegionSubscriptions", params);

        const path = `${this.basePath}/tenancies/{tenancyId}/regionSubscriptions`
            .replace(`{${"tenancyId"}}`, `${ params["tenancyId"] }`);

        return this.request<Array<RegionSubscription>>({
            options,
            path,




            parseResponseBody: true,

            operationName: "listRegionSubscriptions",
            httpMethod: "GET"
        });
    }
    /** 
     * ListRegions
     * Lists all the regions offered by Oracle Cloud Infrastructure.
     */
    public listRegions(options?: any): Promise<{ response: Response, data: Array<Region> }> {

        const path = `${this.basePath}/regions`;

        return this.request<Array<Region>>({
            options,
            path,




            parseResponseBody: true,

            operationName: "listRegions",
            httpMethod: "GET"
        });
    }
    /** 
     * ListResourceKinds
     * List resource kinds for a given resource kind or service. 
     * @param serviceName The name of the whitelisted service caller. Such as &#39;PSM&#39;
     * @param resourceKind The resource kind name.
     */
    public listResourceKinds(params: {  "serviceName": string; "resourceKind"?: string; }, options?: any): Promise<{ response: Response, data: Array<ResourceKindSummary> }> {
        base.validateRequiredParameters([
            "serviceName",
        ], "listResourceKinds", params);

        const path = `${this.basePath}/resourceKinds/`;

        return this.request<Array<ResourceKindSummary>>({
            options,
            path,

            queryParameters: {
                    "resourceKind": { values: params["resourceKind"] },
                    "serviceName": { values: params["serviceName"] }
            },



            parseResponseBody: true,

            operationName: "listResourceKinds",
            httpMethod: "GET"
        });
    }
    /** 
     * Returns service limit groups
     * Returns list of groups availible for limits values lookup. 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     */
    public listServiceLimitGroups(params: {  "compartmentId": string; }, options?: any): Promise<{ response: Response, data: Array<LimitGroup> }> {
        base.validateRequiredParameters([
            "compartmentId"
        ], "listServiceLimitGroups", params);

        const path = `${this.basePath}/serviceLimitGroups/`;

        return this.request<Array<LimitGroup>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] }
            },



            parseResponseBody: true,

            operationName: "listServiceLimitGroups",
            httpMethod: "GET"
        });
    }
    /** 
     * Returns limits in the specified service limit group.
     * Lists the service limits in your tenancy. You must specify your compartment&#39;s OCID as the value for the tenent ID (remember that the tenancy is simply the root compartment). 
     * @param group The service group of the service limit 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     */
    public listServiceLimits(params: {  "group": string; "compartmentId": string; }, options?: any): Promise<{ response: Response, data: Array<ServiceLimits> }> {
        base.validateRequiredParameters([
            "group",
            "compartmentId"
        ], "listServiceLimits", params);

        const path = `${this.basePath}/serviceLimits/`;

        return this.request<Array<ServiceLimits>>({
            options,
            path,

            queryParameters: {
                    "group": { values: params["group"] },
                    "compartmentId": { values: params["compartmentId"] }
            },



            parseResponseBody: true,

            operationName: "listServiceLimits",
            httpMethod: "GET"
        });
    }
    /** 
     * ListServiceManagers
     * Lists the service managers. 
     */
    public listServiceManagers(options?: any): Promise<{ response: Response, data: Array<ServiceManager> }> {

        const path = `${this.basePath}/serviceManagers/`;

        return this.request<Array<ServiceManager>>({
            options,
            path,




            parseResponseBody: true,

            operationName: "listServiceManagers",
            httpMethod: "GET"
        });
    }
    /** 
     * ListSmtpCredentials
     * Lists the SMTP credentials for the specified user. The returned object contains the credential&#39;s OCID, the SMTP user name but not the SMTP password. The SMTP password is returned only upon creation. 
     * @param userId The OCID of the user.
     */
    public listSmtpCredentials(params: {  "userId": string; }, options?: any): Promise<{ response: Response, data: Array<SmtpCredentialSummary> }> {
        base.validateRequiredParameters([
            "userId"
        ], "listSmtpCredentials", params);

        const path = `${this.basePath}/users/{userId}/smtpCredentials/`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<Array<SmtpCredentialSummary>>({
            options,
            path,




            parseResponseBody: true,

            operationName: "listSmtpCredentials",
            httpMethod: "GET"
        });
    }
    /** 
     * ListStandardTagNamespaceTemplates
     * Lists available standard tag namespaces that users can create. 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     */
    public listStandardTagNamespaces(params: {  "compartmentId": string; "page"?: string; "limit"?: number; }, options?: any): Promise<{ response: Response, data: Array<StandardTagNamespaceTemplateSummary> }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "listStandardTagNamespaces", params);

        const path = `${this.basePath}/tags/standardTagNamespaceTemplates`;

        return this.request<Array<StandardTagNamespaceTemplateSummary>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] }
            },



            parseResponseBody: true,

            operationName: "listStandardTagNamespaces",
            httpMethod: "GET"
        });
    }
    /** 
     * ListSwiftPasswords
     * **Deprecated. Use [ListAuthTokens](#/en/identity/20160918/AuthToken/ListAuthTokens) instead.**  Lists the Swift passwords for the specified user. The returned object contains the password&#39;s OCID, but not the password itself. The actual password is returned only upon creation. 
     * @param userId The OCID of the user.
     */
    public listSwiftPasswords(params: {  "userId": string; }, options?: any): Promise<{ response: Response, data: Array<SwiftPassword> }> {
        base.validateRequiredParameters([
            "userId"
        ], "listSwiftPasswords", params);

        const path = `${this.basePath}/users/{userId}/swiftPasswords/`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<Array<SwiftPassword>>({
            options,
            path,




            parseResponseBody: true,

            operationName: "listSwiftPasswords",
            httpMethod: "GET"
        });
    }
    /** 
     * ListTagDefaults
     * Lists the tag defaults for tag definitions in the specified compartment. 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param id A filter to only return resources that match the specified OCID exactly. 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param tagDefinitionId The OCID of the tag definition. 
     * @param lifecycleState A filter to only return resources that match the given lifecycle state.  The state value is case-insensitive. 
     */
    public listTagDefaults(params: {  "page"?: string; "limit"?: number; "id"?: string; "compartmentId"?: string; "tagDefinitionId"?: string; "lifecycleState"?: string; }, options?: any): Promise<{ response: Response, data: Array<TagDefaultSummary> }> {
        base.validateRequiredParameters([
        ], "listTagDefaults", params);

        const path = `${this.basePath}/tagDefaults`;

        return this.request<Array<TagDefaultSummary>>({
            options,
            path,

            queryParameters: {
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "id": { values: params["id"] },
                    "compartmentId": { values: params["compartmentId"] },
                    "tagDefinitionId": { values: params["tagDefinitionId"] },
                    "lifecycleState": { values: params["lifecycleState"] }
            },



            parseResponseBody: true,

            operationName: "listTagDefaults",
            httpMethod: "GET"
        });
    }
    /** 
     * ListTagNamespaces
     * Lists the tag namespaces in the specified compartment. 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param includeSubcompartments An optional boolean parameter indicating whether to retrieve all tag namespaces in subcompartments. If this parameter is not specified, only the tag namespaces defined in the specified compartment are retrieved. 
     * @param lifecycleState A filter to only return resources that match the given lifecycle state.  The state value is case-insensitive. 
     */
    public listTagNamespaces(params: {  "compartmentId": string; "page"?: string; "limit"?: number; "includeSubcompartments"?: boolean; "lifecycleState"?: string; }, options?: any): Promise<{ response: Response, data: Array<TagNamespaceSummary> }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "listTagNamespaces", params);

        const path = `${this.basePath}/tagNamespaces`;

        return this.request<Array<TagNamespaceSummary>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "includeSubcompartments": { values: params["includeSubcompartments"] },
                    "lifecycleState": { values: params["lifecycleState"] }
            },



            parseResponseBody: true,

            operationName: "listTagNamespaces",
            httpMethod: "GET"
        });
    }
    /** 
     * ListTaggingWorkRequestErrors
     * Gets the errors for a work request. 
     * @param workRequestId The OCID of the work request.
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     */
    public listTaggingWorkRequestErrors(params: {  "workRequestId": string; "page"?: string; "limit"?: number; }, options?: any): Promise<{ response: Response, data: Array<TaggingWorkRequestErrorSummary> }> {
        base.validateRequiredParameters([
            "workRequestId",
        ], "listTaggingWorkRequestErrors", params);

        const path = `${this.basePath}/taggingWorkRequests/{workRequestId}/errors`
            .replace(`{${"workRequestId"}}`, `${ params["workRequestId"] }`);

        return this.request<Array<TaggingWorkRequestErrorSummary>>({
            options,
            path,

            queryParameters: {
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] }
            },



            parseResponseBody: true,

            operationName: "listTaggingWorkRequestErrors",
            httpMethod: "GET"
        });
    }
    /** 
     * ListTaggingWorkRequestLogs
     * Gets the logs for a work request. 
     * @param workRequestId The OCID of the work request.
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     */
    public listTaggingWorkRequestLogs(params: {  "workRequestId": string; "page"?: string; "limit"?: number; }, options?: any): Promise<{ response: Response, data: Array<TaggingWorkRequestLogSummary> }> {
        base.validateRequiredParameters([
            "workRequestId",
        ], "listTaggingWorkRequestLogs", params);

        const path = `${this.basePath}/taggingWorkRequests/{workRequestId}/logs`
            .replace(`{${"workRequestId"}}`, `${ params["workRequestId"] }`);

        return this.request<Array<TaggingWorkRequestLogSummary>>({
            options,
            path,

            queryParameters: {
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] }
            },



            parseResponseBody: true,

            operationName: "listTaggingWorkRequestLogs",
            httpMethod: "GET"
        });
    }
    /** 
     * ListTaggingWorkRequests
     * Lists the tagging work requests in compartment. 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param resourceIdentifier The identifier of the resource the work request affects.
     */
    public listTaggingWorkRequests(params: {  "compartmentId": string; "page"?: string; "limit"?: number; "resourceIdentifier"?: string; }, options?: any): Promise<{ response: Response, data: Array<TaggingWorkRequestSummary> }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "listTaggingWorkRequests", params);

        const path = `${this.basePath}/taggingWorkRequests/`;

        return this.request<Array<TaggingWorkRequestSummary>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "resourceIdentifier": { values: params["resourceIdentifier"] }
            },



            parseResponseBody: true,

            operationName: "listTaggingWorkRequests",
            httpMethod: "GET"
        });
    }
    /** 
     * ListTags
     * Lists the tag definitions in the specified tag namespace. 
     * @param tagNamespaceId The OCID of the tag namespace. 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param lifecycleState A filter to only return resources that match the given lifecycle state.  The state value is case-insensitive. 
     */
    public listTags(params: {  "tagNamespaceId": string; "page"?: string; "limit"?: number; "lifecycleState"?: string; }, options?: any): Promise<{ response: Response, data: Array<TagSummary> }> {
        base.validateRequiredParameters([
            "tagNamespaceId",
        ], "listTags", params);

        const path = `${this.basePath}/tagNamespaces/{tagNamespaceId}/tags`
            .replace(`{${"tagNamespaceId"}}`, `${ params["tagNamespaceId"] }`);

        return this.request<Array<TagSummary>>({
            options,
            path,

            queryParameters: {
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "lifecycleState": { values: params["lifecycleState"] }
            },



            parseResponseBody: true,

            operationName: "listTags",
            httpMethod: "GET"
        });
    }
    /** 
     * ListTenancies
     * Get the specified tenancy&#39;s information with BareMetal service entitlement.
     * @param serviceName The name of the whitelisted service caller. Such as &#39;PSM&#39;
     * @param serviceEntitlementId The BareMetal service entitlement Id.
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     */
    public listTenancies(params: {  "serviceName": string; "serviceEntitlementId": string; "page"?: string; "limit"?: number; }, options?: any): Promise<{ response: Response, data: Array<Tenancy> }> {
        base.validateRequiredParameters([
            "serviceName",
            "serviceEntitlementId",
        ], "listTenancies", params);

        const path = `${this.basePath}/tenancies/`;

        return this.request<Array<Tenancy>>({
            options,
            path,

            queryParameters: {
                    "serviceName": { values: params["serviceName"] },
                    "serviceEntitlementId": { values: params["serviceEntitlementId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] }
            },



            parseResponseBody: true,

            operationName: "listTenancies",
            httpMethod: "GET"
        });
    }
    /** 
     * ListUpiGroups
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param name A filter to only return resources that match the given name exactly. 
     * @param sortBy The field to sort by. You can provide one sort order (&#x60;sortOrder&#x60;). Default order for TIMECREATED is descending. Default order for NAME is ascending. The NAME sort order is case sensitive.  **Note:** In general, some \&quot;List\&quot; operations (for example, &#x60;ListInstances&#x60;) let you optionally filter by Availability Domain if the scope of the resource type is within a single Availability Domain. If you call one of these \&quot;List\&quot; operations without specifying an Availability Domain, the resources are grouped by Availability Domain, then sorted. 
     * @param sortOrder The sort order to use, either ascending (&#x60;ASC&#x60;) or descending (&#x60;DESC&#x60;). The NAME sort order is case sensitive. 
     */
    public listUpiGroups(params: {  "compartmentId": string; "page"?: string; "limit"?: number; "name"?: string; "sortBy"?: string; "sortOrder"?: string; }, options?: any): Promise<{ response: Response, data: Array<UpiGroup> }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "listUpiGroups", params);

        const path = `${this.basePath}/upi/groups/`;

        return this.request<Array<UpiGroup>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "name": { values: params["name"] },
                    "sortBy": { values: params["sortBy"] },
                    "sortOrder": { values: params["sortOrder"] }
            },



            parseResponseBody: true,

            operationName: "listUpiGroups",
            httpMethod: "GET"
        });
    }
    /** 
     * ListUpiUsers
     * Lists the UPI users in your tenancy. This is an internal only endpoint. 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param name A filter to only return resources that match the given name exactly. 
     * @param sortBy The field to sort by. You can provide one sort order (&#x60;sortOrder&#x60;). Default order for TIMECREATED is descending. Default order for NAME is ascending. The NAME sort order is case sensitive.  **Note:** In general, some \&quot;List\&quot; operations (for example, &#x60;ListInstances&#x60;) let you optionally filter by Availability Domain if the scope of the resource type is within a single Availability Domain. If you call one of these \&quot;List\&quot; operations without specifying an Availability Domain, the resources are grouped by Availability Domain, then sorted. 
     * @param sortOrder The sort order to use, either ascending (&#x60;ASC&#x60;) or descending (&#x60;DESC&#x60;). The NAME sort order is case sensitive. 
     */
    public listUpiUsers(params: {  "compartmentId": string; "page"?: string; "limit"?: number; "name"?: string; "sortBy"?: string; "sortOrder"?: string; }, options?: any): Promise<{ response: Response, data: Array<UpiUser> }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "listUpiUsers", params);

        const path = `${this.basePath}/upi/users/`;

        return this.request<Array<UpiUser>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "name": { values: params["name"] },
                    "sortBy": { values: params["sortBy"] },
                    "sortOrder": { values: params["sortOrder"] }
            },



            parseResponseBody: true,

            operationName: "listUpiUsers",
            httpMethod: "GET"
        });
    }
    /** 
     * ListUserGroupMemberships
     * Lists the &#x60;UserGroupMembership&#x60; objects in your tenancy. You must specify your tenancy&#39;s OCID as the value for the compartment ID (see [Where to Get the Tenancy&#39;s OCID and User&#39;s OCID](/Content/API/Concepts/apisigningkey.htm#five)). You must also then filter the list in one of these ways:  - You can limit the results to just the memberships for a given user by specifying a &#x60;userId&#x60;. - Similarly, you can limit the results to just the memberships for a given group by specifying a &#x60;groupId&#x60;. - You can set both the &#x60;userId&#x60; and &#x60;groupId&#x60; to determine if the specified user is in the specified group. If the answer is no, the response is an empty list. - Although&#x60;userId&#x60; and &#x60;groupId&#x60; are not individually required, you must set one of them. 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param userId The OCID of the user.
     * @param groupId The OCID of the group.
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     */
    public listUserGroupMemberships(params: {  "compartmentId": string; "userId"?: string; "groupId"?: string; "page"?: string; "limit"?: number; }, options?: any): Promise<{ response: Response, data: Array<UserGroupMembership> }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "listUserGroupMemberships", params);

        const path = `${this.basePath}/userGroupMemberships/`;

        return this.request<Array<UserGroupMembership>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "userId": { values: params["userId"] },
                    "groupId": { values: params["groupId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] }
            },



            parseResponseBody: true,

            operationName: "listUserGroupMemberships",
            httpMethod: "GET"
        });
    }
    /** 
     * ListUserIdpGroupMemberships
     * Lists the &#x60;UserGroupMembership&#x60; objects in your tenancy. You must also then filter the list in one of these ways:  - You can limit the results to just the memberships for a given user by specifying a &#x60;userId&#x60;. - Similarly, you can limit the results to just the memberships for a given group by specifying a &#x60;groupId&#x60;. - You can set both the &#x60;userId&#x60; and &#x60;groupId&#x60; to determine if the specified user is in the specified group. If the answer is no, the response is an empty list. - Although&#x60;userId&#x60; and &#x60;groupId&#x60; are not individually required, you must set one of them. 
     * @param identityProviderId The OCID of the identity provider.
     * @param userId The OCID of the user.
     * @param groupId The OCID of the group.
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     */
    public listUserIdpGroupMemberships(params: {  "identityProviderId": string; "userId"?: string; "groupId"?: string; "page"?: string; "limit"?: number; }, options?: any): Promise<{ response: Response, data: Array<UserIdpGroupMembership> }> {
        base.validateRequiredParameters([
            "identityProviderId",
        ], "listUserIdpGroupMemberships", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}/userIdpGroupMemberships/`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`);

        return this.request<Array<UserIdpGroupMembership>>({
            options,
            path,

            queryParameters: {
                    "userId": { values: params["userId"] },
                    "groupId": { values: params["groupId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] }
            },



            parseResponseBody: true,

            operationName: "listUserIdpGroupMemberships",
            httpMethod: "GET"
        });
    }
    /** 
     * ListUsers
     * Lists the users in your tenancy. You must specify your tenancy&#39;s OCID as the value for the compartment ID (remember that the tenancy is simply the root compartment). See [Where to Get the Tenancy&#39;s OCID and User&#39;s OCID](/Content/API/Concepts/apisigningkey.htm#five). 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param identityProviderId The id of the identity provider. 
     * @param externalIdentifier The id of a user in the identity provider. 
     * @param name A filter to only return resources that match the given name exactly. 
     * @param sortBy The field to sort by. You can provide one sort order (&#x60;sortOrder&#x60;). Default order for TIMECREATED is descending. Default order for NAME is ascending. The NAME sort order is case sensitive.  **Note:** In general, some \&quot;List\&quot; operations (for example, &#x60;ListInstances&#x60;) let you optionally filter by Availability Domain if the scope of the resource type is within a single Availability Domain. If you call one of these \&quot;List\&quot; operations without specifying an Availability Domain, the resources are grouped by Availability Domain, then sorted. 
     * @param sortOrder The sort order to use, either ascending (&#x60;ASC&#x60;) or descending (&#x60;DESC&#x60;). The NAME sort order is case sensitive. 
     * @param lifecycleState A filter to only return resources that match the given lifecycle state.  The state value is case-insensitive. 
     */
    public listUsers(params: {  "compartmentId": string; "page"?: string; "limit"?: number; "identityProviderId"?: string; "externalIdentifier"?: string; "name"?: string; "sortBy"?: string; "sortOrder"?: string; "lifecycleState"?: string; }, options?: any): Promise<{ response: Response, data: Array<User> }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "listUsers", params);

        const path = `${this.basePath}/users/`;

        return this.request<Array<User>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "identityProviderId": { values: params["identityProviderId"] },
                    "externalIdentifier": { values: params["externalIdentifier"] },
                    "name": { values: params["name"] },
                    "sortBy": { values: params["sortBy"] },
                    "sortOrder": { values: params["sortOrder"] },
                    "lifecycleState": { values: params["lifecycleState"] }
            },



            parseResponseBody: true,

            operationName: "listUsers",
            httpMethod: "GET"
        });
    }
    /** 
     * ListWorkRequests
     * Lists the work requests in compartment. 
     * @param compartmentId The OCID of the compartment (remember that the tenancy is simply the root compartment). 
     * @param page The value of the &#x60;opc-next-page&#x60; response header from the previous \&quot;List\&quot; call. 
     * @param limit The maximum number of items to return in a paginated \&quot;List\&quot; call. 
     * @param resourceIdentifier The identifier of the resource the work request affects.
     */
    public listWorkRequests(params: {  "compartmentId": string; "page"?: string; "limit"?: number; "resourceIdentifier"?: string; }, options?: any): Promise<{ response: Response, data: Array<WorkRequestSummary> }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "listWorkRequests", params);

        const path = `${this.basePath}/workRequests/`;

        return this.request<Array<WorkRequestSummary>>({
            options,
            path,

            queryParameters: {
                    "compartmentId": { values: params["compartmentId"] },
                    "page": { values: params["page"] },
                    "limit": { values: params["limit"] },
                    "resourceIdentifier": { values: params["resourceIdentifier"] }
            },



            parseResponseBody: true,

            operationName: "listWorkRequests",
            httpMethod: "GET"
        });
    }
    /** 
     * Moves a compartment tree to a different parent compartment. When provided, If-Match is checked against ETag values of the resource. 
     * Move the compartment to a different parent compartment in the same tenancy. When you move a compartment, all its contents (subcompartments and resources) are moved with it. Note that the &#x60;CompartmentId&#x60; that you specify in the path is the compartment that you want to move.  **IMPORTANT**: After you move a compartment to a new parent compartment, the access policies of the new parent take effect and the policies of the previous parent no longer apply. Ensure that you are aware of the implications for the compartment contents before you move it. For more information, see [Moving a Compartment](/Content/Identity/Tasks/managingcompartments.htm#MoveCompartment). 
     * @param compartmentId The OCID of the compartment.
     * @param moveCompartmentDetails Request object for moving a compartment.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public moveCompartment(params: {  "compartmentId": string; "moveCompartmentDetails": MoveCompartmentDetails; "ifMatch"?: string; "opcRequestId"?: string; "opcRetryToken"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "compartmentId",
            "moveCompartmentDetails",
        ], "moveCompartment", params);

        const path = `${this.basePath}/compartments/{compartmentId}/actions/moveCompartment`
            .replace(`{${"compartmentId"}}`, `${ params["compartmentId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"],
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["moveCompartmentDetails"]
                    },


            operationName: "moveCompartment",
            httpMethod: "POST"
        });
    }
    /** 
     * PatchUpiGroup
     * Patches the specified group.
     * @param idcsId The IDCS ID of the group.
     * @param patchUpiGroupDetails Request object for patching a group.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public patchUpiGroup(params: {  "idcsId": string; "patchUpiGroupDetails": PatchUpiGroupDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: UpiGroup }> {
        base.validateRequiredParameters([
            "idcsId",
            "patchUpiGroupDetails",
        ], "patchUpiGroup", params);

        const path = `${this.basePath}/upi/groups/{idcsId}/actions/patch`
            .replace(`{${"idcsId"}}`, `${ params["idcsId"] }`);

        return this.request<UpiGroup>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["patchUpiGroupDetails"]
                    },

            parseResponseBody: true,

            operationName: "patchUpiGroup",
            httpMethod: "POST"
        });
    }
    /** 
     * PatchUpiUser
     * Patch the specified user.
     * @param idcsId The IDCS ID of the user.
     * @param patchUpiUserDetails Request object for patching a user.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public patchUpiUser(params: {  "idcsId": string; "patchUpiUserDetails": PatchUpiUserDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: UpiUser }> {
        base.validateRequiredParameters([
            "idcsId",
            "patchUpiUserDetails",
        ], "patchUpiUser", params);

        const path = `${this.basePath}/upi/users/{idcsId}/actions/patch`
            .replace(`{${"idcsId"}}`, `${ params["idcsId"] }`);

        return this.request<UpiUser>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["patchUpiUserDetails"]
                    },

            parseResponseBody: true,

            operationName: "patchUpiUser",
            httpMethod: "POST"
        });
    }
    /** 
     * RecoverCompartment
     * Recover the compartment from DELETED state to ACTIVE state. 
     * @param compartmentId The OCID of the compartment.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public recoverCompartment(params: {  "compartmentId": string; "ifMatch"?: string; "opcRequestId"?: string; }, options?: any): Promise<{ response: Response, data: Compartment }> {
        base.validateRequiredParameters([
            "compartmentId",
        ], "recoverCompartment", params);

        const path = `${this.basePath}/compartments/{compartmentId}/actions/recoverCompartment`
            .replace(`{${"compartmentId"}}`, `${ params["compartmentId"] }`);

        return this.request<Compartment>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"],
                "opc-request-id":  params["opcRequestId"]
            },


            parseResponseBody: true,

            operationName: "recoverCompartment",
            httpMethod: "POST"
        });
    }
    /** 
     * RemoveUserFromGroup
     * Removes a user from a group by deleting the corresponding &#x60;UserGroupMembership&#x60;.
     * @param userGroupMembershipId The OCID of the userGroupMembership.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public removeUserFromGroup(params: {  "userGroupMembershipId": string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "userGroupMembershipId",
        ], "removeUserFromGroup", params);

        const path = `${this.basePath}/userGroupMemberships/{userGroupMembershipId}`
            .replace(`{${"userGroupMembershipId"}}`, `${ params["userGroupMembershipId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },



            operationName: "removeUserFromGroup",
            httpMethod: "DELETE"
        });
    }
    /** 
     * RemoveUserFromIdpGroup
     * Removes an identity provider user from a group by deleting the corresponding &#x60;UserIdpGroupMembership&#x60;.
     * @param identityProviderId The OCID of the identity provider.
     * @param groupId The OCID of the group.
     * @param removeUserFromIdpGroupDetails Request object for removing a user from an identity provider group
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public removeUserFromIdpGroup(params: {  "identityProviderId": string; "groupId": string; "removeUserFromIdpGroupDetails": RemoveUserFromIdpGroupDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: IdentityProviderGroupSummary }> {
        base.validateRequiredParameters([
            "identityProviderId",
            "groupId",
            "removeUserFromIdpGroupDetails",
        ], "removeUserFromIdpGroup", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}/groups/{groupId}/actions/removeUser`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`)
            .replace(`{${"groupId"}}`, `${ params["groupId"] }`);

        return this.request<IdentityProviderGroupSummary>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["removeUserFromIdpGroupDetails"]
                    },

            parseResponseBody: true,

            operationName: "removeUserFromIdpGroup",
            httpMethod: "POST"
        });
    }
    /** 
     * Trigger a default domain replication
     * Replicate default domain to a new region  Trigger a internal async workflow that primarily does two things - Get default domain for given tenantId: Same as API GET /domains?type&#x3D;DEFAULT&amp;compartmentId&#x3D;&lt;tenantId&gt; - Start replications process for obtained domain: Same as POST /enableReplicationToRegion using the domainId from   the workflow to replicate the domain to the new region 
     * @param replicateDefaultDomainToRegionDetails The request object for replicated default domain to new region
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public replicateDefaultDomainToRegion(params: {  "replicateDefaultDomainToRegionDetails": ReplicateDefaultDomainToRegionDetails; "opcRetryToken"?: string; "opcRequestId"?: string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "replicateDefaultDomainToRegionDetails",
        ], "replicateDefaultDomainToRegion", params);

        const path = `${this.basePath}/replicateDefaultDomainToRegion`;

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"],
                "opc-request-id":  params["opcRequestId"],
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["replicateDefaultDomainToRegionDetails"]
                    },


            operationName: "replicateDefaultDomainToRegion",
            httpMethod: "POST"
        });
    }
    /** 
     * Reset password of a tenant administrator.
     * Used to reset password of a tenant administrator. Additionally can be used to unblock users who have too many failed login attempts. 
     * @param resetAdminPasswordDetails Request object for resetting admin password.
     */
    public resetAdminPassword(params: {  "resetAdminPasswordDetails": ResetAdminPasswordDetails; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "resetAdminPasswordDetails"
        ], "resetAdminPassword", params);

        const path = `${this.basePath}/resetAdminPassword`;

        return this.request({
            options,
            path,



                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["resetAdminPasswordDetails"]
                    },


            operationName: "resetAdminPassword",
            httpMethod: "POST"
        });
    }
    /** 
     * ResetIdpScimClient
     * Resets the OAuth2 client credentials for the SCIM client associated with this identity provider. 
     * @param identityProviderId The OCID of the identity provider.
     */
    public resetIdpScimClient(params: {  "identityProviderId": string; }, options?: any): Promise<{ response: Response, data: ScimClientCredentials }> {
        base.validateRequiredParameters([
            "identityProviderId"
        ], "resetIdpScimClient", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}/actions/resetScimClient/`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`);

        return this.request<ScimClientCredentials>({
            options,
            path,




            parseResponseBody: true,

            operationName: "resetIdpScimClient",
            httpMethod: "POST"
        });
    }
    /** 
     * Requests an email verification token be generated and sent via email.
     * Creates an email verification token and sends that to the user via email.  This call is throttled on the server side based on the last time a token was created for the given compartmentId and email combination. 
     * @param userId The OCID of the user.
     */
    public sendVerificationEmail(params: {  "userId": string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "userId"
        ], "sendVerificationEmail", params);

        const path = `${this.basePath}/users/{userId}/actions/sendVerificationEmail`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request({
            options,
            path,





            operationName: "sendVerificationEmail",
            httpMethod: "POST"
        });
    }
    /** 
     * Set the replication of the domain to a region as done
     * Set {@code state} of this domain as REPLICATION_ENABLED.
     * @param domainId The OCID of the domain
     * @param setReplicationEnabledDetails The request object for setting domain state as REPLICATION_ENABLED
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public setReplicationEnabled(params: {  "domainId": string; "setReplicationEnabledDetails": SetReplicationEnabledDetails; "opcRequestId"?: string; "opcRetryToken"?: string; "ifMatch"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "domainId",
            "setReplicationEnabledDetails",
        ], "setReplicationEnabled", params);

        const path = `${this.basePath}/domains/{domainId}/actions/setReplicationEnabled`
            .replace(`{${"domainId"}}`, `${ params["domainId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"],
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["setReplicationEnabledDetails"]
                    },


            operationName: "setReplicationEnabled",
            httpMethod: "POST"
        });
    }
    /** 
     * UnlinkSupportAccount
     * Unlink a support account for the user. Unlink requires manual interaction with the Console. Every user has permission to use this operation to unlink a support account for *its own user ID*. An administrator in your organization does not need to write a policy to give users this ability. To compare, administrators who have permission to the tenancy can define policy and use this operation to unlink support account for any user. 
     * @param userId The OCID of the user.
     * @param unlinkSupportAccountDetails the support account to unlink
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public unlinkSupportAccount(params: {  "userId": string; "unlinkSupportAccountDetails": UnlinkSupportAccountDetails; "opcRequestId"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "userId",
            "unlinkSupportAccountDetails",
        ], "unlinkSupportAccount", params);

        const path = `${this.basePath}/users/{userId}/actions/unlinkSupportAccount`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["unlinkSupportAccountDetails"]
                    },


            operationName: "unlinkSupportAccount",
            httpMethod: "POST"
        });
    }
    /** 
     * UpdateAuthRecord
     * Updates a user&#39;s authentication record. 
     * @param updateAuthenticationRecordDetails Request object for updating authentication record.
     */
    public updateAuthRecord(params: {  "updateAuthenticationRecordDetails": UpdateAuthenticationRecordDetails; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "updateAuthenticationRecordDetails"
        ], "updateAuthRecord", params);

        const path = `${this.basePath}/authRecord/`;

        return this.request({
            options,
            path,



                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateAuthenticationRecordDetails"]
                    },


            operationName: "updateAuthRecord",
            httpMethod: "POST"
        });
    }
    /** 
     * UpdateAuthToken
     * Updates the specified auth token&#39;s description. 
     * @param userId The OCID of the user.
     * @param authTokenId The OCID of the auth token.
     * @param updateAuthTokenDetails Request object for updating an auth token.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateAuthToken(params: {  "userId": string; "authTokenId": string; "updateAuthTokenDetails": UpdateAuthTokenDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: AuthToken }> {
        base.validateRequiredParameters([
            "userId",
            "authTokenId",
            "updateAuthTokenDetails",
        ], "updateAuthToken", params);

        const path = `${this.basePath}/users/{userId}/authTokens/{authTokenId}`
            .replace(`{${"userId"}}`, `${ params["userId"] }`)
            .replace(`{${"authTokenId"}}`, `${ params["authTokenId"] }`);

        return this.request<AuthToken>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateAuthTokenDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateAuthToken",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateAuthenticationPolicy
     * Updates authentication policy for the specified tenancy 
     * @param compartmentId The OCID of the compartment.
     * @param updateAuthenticationPolicyDetails Request object for updating the authentication policy.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateAuthenticationPolicy(params: {  "compartmentId": string; "updateAuthenticationPolicyDetails": UpdateAuthenticationPolicyDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: AuthenticationPolicy }> {
        base.validateRequiredParameters([
            "compartmentId",
            "updateAuthenticationPolicyDetails",
        ], "updateAuthenticationPolicy", params);

        const path = `${this.basePath}/authenticationPolicies/{compartmentId}`
            .replace(`{${"compartmentId"}}`, `${ params["compartmentId"] }`);

        return this.request<AuthenticationPolicy>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateAuthenticationPolicyDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateAuthenticationPolicy",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateCompartment
     * Updates the specified compartment&#39;s description or name. You can&#39;t update the root compartment.
     * @param compartmentId The OCID of the compartment.
     * @param updateCompartmentDetails Request object for updating a compartment.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateCompartment(params: {  "compartmentId": string; "updateCompartmentDetails": UpdateCompartmentDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: Compartment }> {
        base.validateRequiredParameters([
            "compartmentId",
            "updateCompartmentDetails",
        ], "updateCompartment", params);

        const path = `${this.basePath}/compartments/{compartmentId}`
            .replace(`{${"compartmentId"}}`, `${ params["compartmentId"] }`);

        return this.request<Compartment>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateCompartmentDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateCompartment",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateCustomerSecretKey
     * Updates the specified secret key&#39;s description. 
     * @param userId The OCID of the user.
     * @param customerSecretKeyId The OCID of the secret key.
     * @param updateCustomerSecretKeyDetails Request object for updating a secret key.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateCustomerSecretKey(params: {  "userId": string; "customerSecretKeyId": string; "updateCustomerSecretKeyDetails": UpdateCustomerSecretKeyDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: CustomerSecretKeySummary }> {
        base.validateRequiredParameters([
            "userId",
            "customerSecretKeyId",
            "updateCustomerSecretKeyDetails",
        ], "updateCustomerSecretKey", params);

        const path = `${this.basePath}/users/{userId}/customerSecretKeys/{customerSecretKeyId}`
            .replace(`{${"userId"}}`, `${ params["userId"] }`)
            .replace(`{${"customerSecretKeyId"}}`, `${ params["customerSecretKeyId"] }`);

        return this.request<CustomerSecretKeySummary>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateCustomerSecretKeyDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateCustomerSecretKey",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateDomain
     * Updates domain information and associated stripe. This is an asynchronous call where the associated stripe and domain are updated.  To track progress, HTTP GET on /iamWorkRequests/{iamWorkRequestsId} endpoint will provide the async operation&#39;s status.  - If the {@code displayName} is not unique within the tenancy, returns 400 BAD REQUEST. - If any field other than {@code description} is requested to be updated for DEFAULT domain, returns 400 BAD REQUEST. - If Domain is not active or being updated, returns 400 BAD REQUEST. - If Domain {@code type} is DEFAULT or DEFAULT_LIGHTWEIGHT, return 400 BAD Request - If the domain doesn&#39;t exists, returns 404 NOT FOUND. 
     * @param domainId The OCID of the domain
     * @param updateDomainDetails Request object for updating the Domain.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public updateDomain(params: {  "domainId": string; "updateDomainDetails": UpdateDomainDetails; "ifMatch"?: string; "opcRequestId"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "domainId",
            "updateDomainDetails",
        ], "updateDomain", params);

        const path = `${this.basePath}/domains/{domainId}`
            .replace(`{${"domainId"}}`, `${ params["domainId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"],
                "opc-request-id":  params["opcRequestId"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateDomainDetails"]
                    },


            operationName: "updateDomain",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateDynamicGroup
     * Updates the specified dynamic group.
     * @param dynamicGroupId The OCID of the dynamic group.
     * @param updateDynamicGroupDetails Request object for updating an dynamic group.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateDynamicGroup(params: {  "dynamicGroupId": string; "updateDynamicGroupDetails": UpdateDynamicGroupDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: DynamicGroup }> {
        base.validateRequiredParameters([
            "dynamicGroupId",
            "updateDynamicGroupDetails",
        ], "updateDynamicGroup", params);

        const path = `${this.basePath}/dynamicGroups/{dynamicGroupId}`
            .replace(`{${"dynamicGroupId"}}`, `${ params["dynamicGroupId"] }`);

        return this.request<DynamicGroup>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateDynamicGroupDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateDynamicGroup",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateGroup
     * Updates the specified group.
     * @param groupId The OCID of the group.
     * @param updateGroupDetails Request object for updating a group.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateGroup(params: {  "groupId": string; "updateGroupDetails": UpdateGroupDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: Group }> {
        base.validateRequiredParameters([
            "groupId",
            "updateGroupDetails",
        ], "updateGroup", params);

        const path = `${this.basePath}/groups/{groupId}`
            .replace(`{${"groupId"}}`, `${ params["groupId"] }`);

        return this.request<Group>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateGroupDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateGroup",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateIdentityProvider
     * **Deprecated.** For more information, see [Deprecated IAM Service APIs](/Content/Identity/Reference/deprecatediamapis.htm).  Updates the specified identity provider. 
     * @param identityProviderId The OCID of the identity provider.
     * @param updateIdentityProviderDetails Request object for updating a identity provider.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateIdentityProvider(params: {  "identityProviderId": string; "updateIdentityProviderDetails": UpdateIdentityProviderDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: IdentityProvider }> {
        base.validateRequiredParameters([
            "identityProviderId",
            "updateIdentityProviderDetails",
        ], "updateIdentityProvider", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`);

        return this.request<IdentityProvider>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateIdentityProviderDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateIdentityProvider",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateIdpGroupMapping
     * **Deprecated.** For more information, see [Deprecated IAM Service APIs](/Content/Identity/Reference/deprecatediamapis.htm).  Updates the specified group mapping. 
     * @param identityProviderId The OCID of the identity provider.
     * @param mappingId The OCID of the group mapping.
     * @param updateIdpGroupMappingDetails Request object for updating an identity provider group mapping
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateIdpGroupMapping(params: {  "identityProviderId": string; "mappingId": string; "updateIdpGroupMappingDetails": UpdateIdpGroupMappingDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: IdpGroupMapping }> {
        base.validateRequiredParameters([
            "identityProviderId",
            "mappingId",
            "updateIdpGroupMappingDetails",
        ], "updateIdpGroupMapping", params);

        const path = `${this.basePath}/identityProviders/{identityProviderId}/groupMappings/{mappingId}`
            .replace(`{${"identityProviderId"}}`, `${ params["identityProviderId"] }`)
            .replace(`{${"mappingId"}}`, `${ params["mappingId"] }`);

        return this.request<IdpGroupMapping>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateIdpGroupMappingDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateIdpGroupMapping",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateNetworkSource
     * Updates the specified network source.
     * @param networkSourceId The OCID of the network source.
     * @param updateNetworkSourceDetails Request object for updating a network source.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateNetworkSource(params: {  "networkSourceId": string; "updateNetworkSourceDetails": UpdateNetworkSourceDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: NetworkSources }> {
        base.validateRequiredParameters([
            "networkSourceId",
            "updateNetworkSourceDetails",
        ], "updateNetworkSource", params);

        const path = `${this.basePath}/networkSources/{networkSourceId}`
            .replace(`{${"networkSourceId"}}`, `${ params["networkSourceId"] }`);

        return this.request<NetworkSources>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateNetworkSourceDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateNetworkSource",
            httpMethod: "PUT"
        });
    }
    /** 
     * Updates Oauth token for the user
     * Updates Oauth token for the user 
     * @param userId The OCID of the user.
     * @param oauth2ClientCredentialId The ID of the Oauth credential.
     * @param updateOAuth2ClientCredentialDetails Request object containing the information required to generate an Oauth token.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateOAuthClientCredential(params: {  "userId": string; "oauth2ClientCredentialId": string; "updateOAuth2ClientCredentialDetails": UpdateOAuth2ClientCredentialDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: OAuth2ClientCredential }> {
        base.validateRequiredParameters([
            "userId",
            "oauth2ClientCredentialId",
            "updateOAuth2ClientCredentialDetails",
        ], "updateOAuthClientCredential", params);

        const path = `${this.basePath}/users/{userId}/oauth2ClientCredentials/{oauth2ClientCredentialId}`
            .replace(`{${"userId"}}`, `${ params["userId"] }`)
            .replace(`{${"oauth2ClientCredentialId"}}`, `${ params["oauth2ClientCredentialId"] }`);

        return this.request<OAuth2ClientCredential>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateOAuth2ClientCredentialDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateOAuthClientCredential",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateOidcClient
     * Updates the metadata of the specified OpenID Connect client.
     * @param oidcClientId The id of the OpenID Connect client.
     * @param updateOidcClientDetails Request object for updating a OpenID Connect client.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateOidcClient(params: {  "oidcClientId": string; "updateOidcClientDetails": UpdateOidcClientDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: OidcClient }> {
        base.validateRequiredParameters([
            "oidcClientId",
            "updateOidcClientDetails",
        ], "updateOidcClient", params);

        const path = `${this.basePath}/oidcClients/{oidcClientId}`
            .replace(`{${"oidcClientId"}}`, `${ params["oidcClientId"] }`);

        return this.request<OidcClient>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateOidcClientDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateOidcClient",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateOnPremSite
     * Update the OnPremSite identified by the id.
     * @param onPremSiteId unique OnPremSite identifier
     * @param updateOnPremSiteDetails The information to be updated.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public updateOnPremSite(params: {  "onPremSiteId": string; "updateOnPremSiteDetails": UpdateOnPremSiteDetails; "ifMatch"?: string; "opcRequestId"?: string; }, options?: any): Promise<{ response: Response, data: OnPremSite }> {
        base.validateRequiredParameters([
            "onPremSiteId",
            "updateOnPremSiteDetails",
        ], "updateOnPremSite", params);

        const path = `${this.basePath}/onPremSites/{onPremSiteId}`
            .replace(`{${"onPremSiteId"}}`, `${ params["onPremSiteId"] }`);

        return this.request<OnPremSite>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"],
                "opc-request-id":  params["opcRequestId"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateOnPremSiteDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateOnPremSite",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdatePolicy
     * Updates the specified policy. You can update the description or the policy statements themselves.  Policy changes take effect typically within 10 seconds. 
     * @param policyId The OCID of the policy.
     * @param updatePolicyDetails Request object for updating a policy.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updatePolicy(params: {  "policyId": string; "updatePolicyDetails": UpdatePolicyDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: Policy }> {
        base.validateRequiredParameters([
            "policyId",
            "updatePolicyDetails",
        ], "updatePolicy", params);

        const path = `${this.basePath}/policies/{policyId}`
            .replace(`{${"policyId"}}`, `${ params["policyId"] }`);

        return this.request<Policy>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updatePolicyDetails"]
                    },

            parseResponseBody: true,

            operationName: "updatePolicy",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateServiceManager
     * Updates the specified service manager&#39;s information.
     * @param tenantId The OCID of the tenancy.
     * @param updateServiceManagerDetails Request object for updating a service manager.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateServiceManager(params: {  "tenantId": string; "updateServiceManagerDetails": UpdateServiceManagerDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: ServiceManager }> {
        base.validateRequiredParameters([
            "tenantId",
            "updateServiceManagerDetails",
        ], "updateServiceManager", params);

        const path = `${this.basePath}/serviceManagers/{tenantId}`
            .replace(`{${"tenantId"}}`, `${ params["tenantId"] }`);

        return this.request<ServiceManager>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateServiceManagerDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateServiceManager",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateSmtpCredential
     * Updates the specified SMTP credential&#39;s description. 
     * @param userId The OCID of the user.
     * @param smtpCredentialId The OCID of the SMTP credential.
     * @param updateSmtpCredentialDetails Request object for updating a SMTP credential.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateSmtpCredential(params: {  "userId": string; "smtpCredentialId": string; "updateSmtpCredentialDetails": UpdateSmtpCredentialDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: SmtpCredentialSummary }> {
        base.validateRequiredParameters([
            "userId",
            "smtpCredentialId",
            "updateSmtpCredentialDetails",
        ], "updateSmtpCredential", params);

        const path = `${this.basePath}/users/{userId}/smtpCredentials/{smtpCredentialId}`
            .replace(`{${"userId"}}`, `${ params["userId"] }`)
            .replace(`{${"smtpCredentialId"}}`, `${ params["smtpCredentialId"] }`);

        return this.request<SmtpCredentialSummary>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateSmtpCredentialDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateSmtpCredential",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateSwiftPassword
     * **Deprecated. Use [UpdateAuthToken](#/en/identity/20160918/AuthToken/UpdateAuthToken) instead.**  Updates the specified Swift password&#39;s description. 
     * @param userId The OCID of the user.
     * @param swiftPasswordId The OCID of the Swift password.
     * @param updateSwiftPasswordDetails Request object for updating a Swift password.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateSwiftPassword(params: {  "userId": string; "swiftPasswordId": string; "updateSwiftPasswordDetails": UpdateSwiftPasswordDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: SwiftPassword }> {
        base.validateRequiredParameters([
            "userId",
            "swiftPasswordId",
            "updateSwiftPasswordDetails",
        ], "updateSwiftPassword", params);

        const path = `${this.basePath}/users/{userId}/swiftPasswords/{swiftPasswordId}`
            .replace(`{${"userId"}}`, `${ params["userId"] }`)
            .replace(`{${"swiftPasswordId"}}`, `${ params["swiftPasswordId"] }`);

        return this.request<SwiftPassword>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateSwiftPasswordDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateSwiftPassword",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateTag
     * Updates the specified tag definition.  Setting &#x60;validator&#x60; determines the value type. Tags can use either a static value or a list of possible values. Static values are entered by a user applying the tag to a resource. Lists are created by you and the user must apply a value from the list. On update, any values in a list that were previously set do not change, but new values must pass validation. Values already applied to a resource do not change.  You cannot remove list values that appear in a TagDefault. To remove a list value that appears in a TagDefault, first update the TagDefault to use a different value. 
     * @param tagNamespaceId The OCID of the tag namespace. 
     * @param tagName The name of the tag. 
     * @param updateTagDetails Request object for updating a tag.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateTag(params: {  "tagNamespaceId": string; "tagName": string; "updateTagDetails": UpdateTagDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: Tag }> {
        base.validateRequiredParameters([
            "tagNamespaceId",
            "tagName",
            "updateTagDetails",
        ], "updateTag", params);

        const path = `${this.basePath}/tagNamespaces/{tagNamespaceId}/tags/{tagName}`
            .replace(`{${"tagNamespaceId"}}`, `${ params["tagNamespaceId"] }`)
            .replace(`{${"tagName"}}`, `${ params["tagName"] }`);

        return this.request<Tag>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateTagDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateTag",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateTagDefault
     * Updates the specified tag default. If you specify that a value is required, a value is set during resource creation (either by the user creating the resource or another tag defualt). If no value is set, resource creation is blocked.  * If the &#x60;isRequired&#x60; flag is set to \&quot;true\&quot;, the value is set during resource creation. * If the &#x60;isRequired&#x60; flag is set to \&quot;false\&quot;, the value you enter is set during resource creation. 
     * @param tagDefaultId The OCID of the tag default.
     * @param updateTagDefaultDetails Request object for updating a tag default.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public updateTagDefault(params: {  "tagDefaultId": string; "updateTagDefaultDetails": UpdateTagDefaultDetails; "ifMatch"?: string; "opcRequestId"?: string; }, options?: any): Promise<{ response: Response, data: TagDefault }> {
        base.validateRequiredParameters([
            "tagDefaultId",
            "updateTagDefaultDetails",
        ], "updateTagDefault", params);

        const path = `${this.basePath}/tagDefaults/{tagDefaultId}`
            .replace(`{${"tagDefaultId"}}`, `${ params["tagDefaultId"] }`);

        return this.request<TagDefault>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"],
                "opc-request-id":  params["opcRequestId"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateTagDefaultDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateTagDefault",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateTagNamespace
     * Updates the the specified tag namespace. You can&#39;t update the namespace name.  Updating &#x60;isRetired&#x60; to &#39;true&#39; retires the namespace and all the tag definitions in the namespace. Reactivating a namespace (changing &#x60;isRetired&#x60; from &#39;true&#39; to &#39;false&#39;) does not reactivate tag definitions. To reactivate the tag definitions, you must reactivate each one individually *after* you reactivate the namespace, using [UpdateTag](#/en/identity/20160918/Tag/UpdateTag). For more information about retiring tag namespaces, see [Retiring Key Definitions and Namespace Definitions](/Content/Identity/Concepts/taggingoverview.htm#Retiring).  You can&#39;t add a namespace with the same name as a retired namespace in the same tenancy. 
     * @param tagNamespaceId The OCID of the tag namespace. 
     * @param updateTagNamespaceDetails Request object for updating a namespace.
     */
    public updateTagNamespace(params: {  "tagNamespaceId": string; "updateTagNamespaceDetails": UpdateTagNamespaceDetails; }, options?: any): Promise<{ response: Response, data: TagNamespace }> {
        base.validateRequiredParameters([
            "tagNamespaceId",
            "updateTagNamespaceDetails"
        ], "updateTagNamespace", params);

        const path = `${this.basePath}/tagNamespaces/{tagNamespaceId}`
            .replace(`{${"tagNamespaceId"}}`, `${ params["tagNamespaceId"] }`);

        return this.request<TagNamespace>({
            options,
            path,



                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateTagNamespaceDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateTagNamespace",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateTasDomain
     * This api is specific to tas domain.  Updates domain information and associated stripe. This is an asynchronous call where the associated stripe and domain are updated.  To track progress, HTTP GET on /iamWorkRequests/{iamWorkRequestsId} endpoint will provide the async operation&#39;s status.  If the {@code displayName} is not unique within the tenancy, returns 400 BAD REQUEST. If any field other than {@code description} is requested to be updated for DEFAULT domain, returns 400 BAD REQUEST. If the domain doesn&#39;t exists, returns 404 NOT FOUND. 
     * @param tasDomainId The OCID of the domain
     * @param updateTasDomainDetails Request object for updating the Domain.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     */
    public updateTasDomain(params: {  "tasDomainId": string; "updateTasDomainDetails": UpdateTasDomainDetails; "ifMatch"?: string; "opcRequestId"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "tasDomainId",
            "updateTasDomainDetails",
        ], "updateTasDomain", params);

        const path = `${this.basePath}/tasDomains/{tasDomainId}`
            .replace(`{${"tasDomainId"}}`, `${ params["tasDomainId"] }`);

        return this.request({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"],
                "opc-request-id":  params["opcRequestId"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateTasDomainDetails"]
                    },


            operationName: "updateTasDomain",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateUpiGroup
     * Updates the specified group.
     * @param idcsId The IDCS ID of the group.
     * @param updateUpiGroupDetails Request object for updating a group.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateUpiGroup(params: {  "idcsId": string; "updateUpiGroupDetails": UpdateUpiGroupDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: UpiGroup }> {
        base.validateRequiredParameters([
            "idcsId",
            "updateUpiGroupDetails",
        ], "updateUpiGroup", params);

        const path = `${this.basePath}/upi/groups/{idcsId}`
            .replace(`{${"idcsId"}}`, `${ params["idcsId"] }`);

        return this.request<UpiGroup>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateUpiGroupDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateUpiGroup",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateUpiUser
     * Updates the description of the specified user.
     * @param idcsId The IDCS ID of the user.
     * @param updateUpiUserDetails Request object for updating a user.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateUpiUser(params: {  "idcsId": string; "updateUpiUserDetails": UpdateUpiUserDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: UpiUser }> {
        base.validateRequiredParameters([
            "idcsId",
            "updateUpiUserDetails",
        ], "updateUpiUser", params);

        const path = `${this.basePath}/upi/users/{idcsId}`
            .replace(`{${"idcsId"}}`, `${ params["idcsId"] }`);

        return this.request<UpiUser>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateUpiUserDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateUpiUser",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateUser
     * Updates the description of the specified user.
     * @param userId The OCID of the user.
     * @param updateUserDetails Request object for updating a user.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateUser(params: {  "userId": string; "updateUserDetails": UpdateUserDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: User }> {
        base.validateRequiredParameters([
            "userId",
            "updateUserDetails",
        ], "updateUser", params);

        const path = `${this.basePath}/users/{userId}`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<User>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateUserDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateUser",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateUserCapabilities
     * Updates the capabilities of the specified user. 
     * @param userId The OCID of the user.
     * @param updateUserCapabilitiesDetails Request object for updating user capabilities.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateUserCapabilities(params: {  "userId": string; "updateUserCapabilitiesDetails": UpdateUserCapabilitiesDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: User }> {
        base.validateRequiredParameters([
            "userId",
            "updateUserCapabilitiesDetails",
        ], "updateUserCapabilities", params);

        const path = `${this.basePath}/users/{userId}/capabilities/`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<User>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateUserCapabilitiesDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateUserCapabilities",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateUserState
     * Updates the state of the specified user. 
     * @param userId The OCID of the user.
     * @param updateStateDetails Request object for updating a user state.
     * @param ifMatch For optimistic concurrency control. In the PUT or DELETE call for a resource, set the &#x60;if-match&#x60; parameter to the value of the etag from a previous GET or POST response for that resource.  The resource will be updated or deleted only if the etag you provide matches the resource&#39;s current etag value. 
     */
    public updateUserState(params: {  "userId": string; "updateStateDetails": UpdateStateDetails; "ifMatch"?: string; }, options?: any): Promise<{ response: Response, data: User }> {
        base.validateRequiredParameters([
            "userId",
            "updateStateDetails",
        ], "updateUserState", params);

        const path = `${this.basePath}/users/{userId}/state/`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<User>({
            options,
            path,


            headerParameters: {
                "if-match":  params["ifMatch"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateStateDetails"]
                    },

            parseResponseBody: true,

            operationName: "updateUserState",
            httpMethod: "PUT"
        });
    }
    /** 
     * UpdateUserUIPassword
     * Updates the Console password for the specified user.  This can be done with either the current password or with a LOOM jwt token verifying authentication. 
     * @param userId The OCID of the user.
     * @param updateUIPasswordRequest Request object for password reset by either the existing password or password reset token.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public updateUserUIPassword(params: {  "userId": string; "updateUIPasswordRequest": UpdateUiPasswordDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: UIPasswordInformation }> {
        base.validateRequiredParameters([
            "userId",
            "updateUIPasswordRequest",
        ], "updateUserUIPassword", params);

        const path = `${this.basePath}/users/{userId}/uiPassword`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<UIPasswordInformation>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["updateUIPasswordRequest"]
                    },

            parseResponseBody: true,

            operationName: "updateUserUIPassword",
            httpMethod: "PUT"
        });
    }
    /** 
     * UploadApiKey
     * Uploads an API signing key for the specified user.  Every user has permission to use this operation to upload a key for *their own user ID*. An administrator in your organization does not need to write a policy to give users this ability. To compare, administrators who have permission to the tenancy can use this operation to upload a key for any user, including themselves.  **Important:** Even though you have permission to upload an API key, you might not yet have permission to do much else. If you try calling an operation unrelated to your own credential management (e.g., &#x60;ListUsers&#x60;, &#x60;LaunchInstance&#x60;) and receive an \&quot;unauthorized\&quot; error, check with an administrator to confirm which IAM Service group(s) you&#39;re in and what access you have. Also confirm you&#39;re working in the correct compartment.  After you send your request, the new object&#39;s &#x60;lifecycleState&#x60; will temporarily be CREATING. Before using the object, first make sure its &#x60;lifecycleState&#x60; has changed to ACTIVE. 
     * @param userId The OCID of the user.
     * @param createApiKeyDetails Request object for uploading an API key for a user.
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public uploadApiKey(params: {  "userId": string; "createApiKeyDetails": CreateApiKeyDetails; "opcRetryToken"?: string; }, options?: any): Promise<{ response: Response, data: ApiKey }> {
        base.validateRequiredParameters([
            "userId",
            "createApiKeyDetails",
        ], "uploadApiKey", params);

        const path = `${this.basePath}/users/{userId}/apiKeys/`
            .replace(`{${"userId"}}`, `${ params["userId"] }`);

        return this.request<ApiKey>({
            options,
            path,


            headerParameters: {
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["createApiKeyDetails"]
                    },

            parseResponseBody: true,

            operationName: "uploadApiKey",
            httpMethod: "POST"
        });
    }
};

export interface BootstrapTagsArgs {
     "bootstrapTagsDetails": BootstrapTagsDetails;
     "opcRequestId"?: string;
     "opcRetryToken"?: string
}
export type BootstrapTagsReturnType = Response;


/**
 * TaggingInternalApi - object-oriented interface
 */
export class TaggingInternalApi extends base.BaseAPI {
    public static createFromEndpointTemplate(fetch: base.Fetch, region: string, secondLevelDomain: string, config?: base.BaseApiConfig): TaggingInternalApi {
        const endpoint = base.buildEndpointFromTemplate(
            "https://identity.{region}.oci.{secondLevelDomain}",
            "/20160918",
            region,
            secondLevelDomain
        );

        return new TaggingInternalApi(fetch, endpoint, config);
    }

    /** 
     * This API is to provision tagging resources during account provisioning flow. 
     * The API is for provisioning tagging resources during account provisioning flow. Currently, three tagging resources are being bootstrapped by this API, which includes one default tag namespace, one cost tracking tag definition named \&quot;createdBy\&quot; and one tag default with variable \&quot;${iam.principal.name}\&quot; 
     * @param bootstrapTagsDetails Request object of tags bootstrapping for new accounts
     * @param opcRequestId Unique Oracle-assigned identifier for the request. If you need to contact Oracle about a particular request, please provide the request ID. 
     * @param opcRetryToken A token that uniquely identifies a request so it can be retried in case of a timeout or server error without risk of executing that same action again. Retry tokens expire after 24 hours, but can be invalidated before then due to conflicting operations (e.g., if a resource has been deleted and purged from the system, then a retry of the original creation request may be rejected). 
     */
    public bootstrapTags(params: {  "bootstrapTagsDetails": BootstrapTagsDetails; "opcRequestId"?: string; "opcRetryToken"?: string; }, options?: any): Promise<Response> {
        base.validateRequiredParameters([
            "bootstrapTagsDetails",
        ], "bootstrapTags", params);

        const path = `${this.basePath}/tags/bootstrap`;

        return this.request({
            options,
            path,


            headerParameters: {
                "opc-request-id":  params["opcRequestId"],
                "opc-retry-token":  params["opcRetryToken"]
            },

                    body: 
                    {
                        type: "content",
                        contentType: (params as any)["contentType"] ? (params as any)["contentType"] as string : "application/json",
                        content: params["bootstrapTagsDetails"]
                    },


            operationName: "bootstrapTags",
            httpMethod: "POST"
        });
    }
};

